import { tryLast, sort, last as last_1, tryFindIndex as tryFindIndex_1, initialize as initialize_1, replicate, indexed, truncate, zip, find, sortBy, minBy, iterateIndexed, tryFind, toArray as toArray_1, mapIndexed, sortByDescending, singleton, tryHead, tryItem, exists, choose, averageBy, max as max_1, sumBy, forAll, tail as tail_1, isEmpty, filter, collect, map, maxBy, length, item, contains, empty as empty_1, cons, fold, reverse, head, append, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString as toString_1, FSharpRef, Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, union_type, tuple_type, option_type, float64_type, bool_type, int32_type, record_type, list_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { toArray as toArray_2, orElse, filter as filter_1, value as value_4241, ofNullable, some, bind, map as map_2, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpMap__get_Count, isEmpty as isEmpty_1, add, tryFind as tryFind_1, FSharpMap__Remove, ofArray as ofArray_1, exists as exists_1, toList, FSharpMap__ContainsKey, ofList, empty, FSharpMap__Add, FSharpMap__TryFind } from "./fable_modules/fable-library-js.4.24.0/Map.js";
import { int32ToString, createObj, equalArrays, createAtom, defaultOf, numberHash, structuralHash, compareArrays, curry2, disposeSafe, getEnumerator, round as round_3, equals, stringHash, comparePrimitives } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { isNullOrWhiteSpace, join, split, substring, interpolate, toText, trimEnd } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { filter as filter_2, truncate as truncate_1, exists as exists_2, append as append_1, empty as empty_2, singleton as singleton_2, collect as collect_1, toList as toList_1, map as map_1, delay, toArray } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { rangeDouble, rangeChar } from "./fable_modules/fable-library-js.4.24.0/Range.js";
import { franchises, nationalityOf, franchiseOfPool, Franchise_$reflection, TeamPool, Player, TeamPool_$reflection, playerPositions, historicalRegistry, Player_$reflection } from "./Database.fs.js";
import { date as date_1, op_Subtraction, year as year_1, addDays, toString, now, dayOfYear } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { isEmpty as isEmpty_2, FSharpSet__Add, count as count_5, FSharpSet__Contains, ofList as ofList_1 } from "./fable_modules/fable-library-js.4.24.0/Set.js";
import { min, max } from "./fable_modules/fable-library-js.4.24.0/Double.js";
import { op_UnaryNegation_Int32, tryParse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { tryFind as tryFind_2, tryFindIndex, last, sortByDescending as sortByDescending_1, choose as choose_1, equalsWith, map as map_3, initialize, setItem, item as item_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { List_distinct, List_groupBy } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";
import { nonSeeded } from "./fable_modules/fable-library-js.4.24.0/Random.js";
import { createClient } from "@supabase/supabase-js";
import { isMatch } from "./fable_modules/fable-library-js.4.24.0/RegExp.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library-js.4.24.0/AsyncBuilder.js";
import { startImmediate, sleep, fromContinuations } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { useState, createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { defaultOf as defaultOf_1 } from "./fable_modules/Feliz.2.9.0/../.././fable_modules/fable-library-js.4.24.0/Util.js";
import { useEffectOnce, createDisposable, useEffectDisposableOnce } from "./fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { newGuid } from "./fable_modules/fable-library-js.4.24.0/Guid.js";
import { useEffect, useEffectWithDeps } from "./fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { PropHelpers_createOnKey } from "./fable_modules/Feliz.2.9.0/./Properties.fs.js";
import { key_enter } from "./fable_modules/Feliz.2.9.0/Key.fs.js";
import { minutes, hours } from "./fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { isDigit } from "./fable_modules/fable-library-js.4.24.0/Char.js";

export const starterSlots = ofArray(["PG", "SG", "SF", "PF", "C"]);

export const benchSlots = ofArray(["B1", "B2", "B3"]);

export const allSlots = append(starterSlots, benchSlots);

export class Blueprint extends Record {
    constructor(Name, Blurb, Starters) {
        super();
        this.Name = Name;
        this.Blurb = Blurb;
        this.Starters = Starters;
    }
}

export function Blueprint_$reflection() {
    return record_type("App.Blueprint", [], Blueprint, () => [["Name", string_type], ["Blurb", string_type], ["Starters", list_type(string_type)]]);
}

export const blueprints = ofArray([new Blueprint("Balanced", "The textbook five. One of everything, nothing missing.", ofArray(["PG", "SG", "SF", "PF", "C"])), new Blueprint("Twin Towers", "Two centers, one paint. Nothing easy at the rim.", ofArray(["PG", "SG", "SF", "C", "C"])), new Blueprint("Small Ball", "The five-out death lineup. Pace, space, and no slow feet.", ofArray(["PG", "SG", "SG", "SF", "PF"])), new Blueprint("Three-Guard Blitz", "Waves of ballhandlers and full-court chaos.", ofArray(["PG", "PG", "SG", "SF", "C"])), new Blueprint("Point-Forward", "No true point guard — a jumbo creator runs the show.", ofArray(["SG", "SF", "SF", "PF", "C"])), new Blueprint("Wing Kingdom", "Three switchable wings. Defense has no weak side.", ofArray(["PG", "SF", "SF", "SF", "C"])), new Blueprint("Grit Frontline", "Two bruising fours. Every rebound is a fistfight.", ofArray(["PG", "SG", "PF", "PF", "C"])), new Blueprint("Stretch Attack", "Shooting at four spots drags their big out of the paint.", ofArray(["PG", "SG", "SF", "SF", "PF"]))]);

export const defaultBlueprint = head(blueprints);

/**
 * Slot keys for a blueprint's starters: the first of each position keeps
 * the bare code, repeats take a numeric suffix — "PG"; "SG"; "SF"; "C";
 * "C2". Bench keys are unaffected.
 */
export function blueprintSlotIds(blueprint) {
    return reverse(fold((tupledArg, pos) => {
        const seen = tupledArg[0];
        const count = (defaultArg(FSharpMap__TryFind(seen, pos), 0) + 1) | 0;
        const slotId = (count === 1) ? pos : (`${pos}${count}`);
        return [FSharpMap__Add(seen, pos, count), cons(slotId, tupledArg[1])];
    }, [empty({
        Compare: comparePrimitives,
    }), empty_1()], blueprint.Starters)[1]);
}

/**
 * The position a slot key plays: bench keys pass through untouched,
 * starter keys drop the duplicate suffix ("C2" -> "C").
 */
export function positionOfSlot(slot) {
    if (contains(slot, benchSlots, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    })) {
        return slot;
    }
    else {
        return trimEnd(slot, ...toArray(rangeChar("0", "9")));
    }
}

/**
 * Spelled-out position name for the Position First flow's slot picker
 * and "FILLING POSITION" header, the reference game's "Striker (ST)".
 */
export function positionFullName(slot) {
    const matchValue = positionOfSlot(slot);
    switch (matchValue) {
        case "PG":
            return "Point Guard";
        case "SG":
            return "Shooting Guard";
        case "SF":
            return "Small Forward";
        case "PF":
            return "Power Forward";
        case "C":
            return "Center";
        default:
            if (contains(matchValue, benchSlots, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            })) {
                return "Bench";
            }
            else {
                return matchValue;
            }
    }
}

export class DailyRun extends Record {
    constructor(PoolId, Star) {
        super();
        this.PoolId = PoolId;
        this.Star = Star;
    }
}

export function DailyRun_$reflection() {
    return record_type("App.DailyRun", [], DailyRun, () => [["PoolId", string_type], ["Star", Player_$reflection()]]);
}

export class DailyProgress extends Record {
    constructor(Date$, AttemptsUsed, BestScore, Streak) {
        super();
        this.Date = Date$;
        this.AttemptsUsed = (AttemptsUsed | 0);
        this.BestScore = (BestScore | 0);
        this.Streak = (Streak | 0);
    }
}

export function DailyProgress_$reflection() {
    return record_type("App.DailyProgress", [], DailyProgress, () => [["Date", string_type], ["AttemptsUsed", int32_type], ["BestScore", int32_type], ["Streak", int32_type]]);
}

export const dailyAttemptsPerDay = 5;

/**
 * Today's featured pool — the same deterministic rotation the Daily
 * Challenge page advertises, so the menu and the mode can never
 * disagree about the puzzle.
 */
export function dailyFeaturedPool() {
    return item(dayOfYear(now()) % length(historicalRegistry), historicalRegistry);
}

export function dailyStarOf(pool) {
    return maxBy((p) => p.Ovr, pool.Options, {
        Compare: comparePrimitives,
    });
}

export class SeasonLine extends Record {
    constructor(Games, Points, Assists, Stocks) {
        super();
        this.Games = (Games | 0);
        this.Points = (Points | 0);
        this.Assists = (Assists | 0);
        this.Stocks = (Stocks | 0);
    }
}

export function SeasonLine_$reflection() {
    return record_type("App.SeasonLine", [], SeasonLine, () => [["Games", int32_type], ["Points", int32_type], ["Assists", int32_type], ["Stocks", int32_type]]);
}

export const emptySeasonLine = new SeasonLine(0, 0, 0, 0);

export class Coach extends Record {
    constructor(Name, System, Philosophy) {
        super();
        this.Name = Name;
        this.System = System;
        this.Philosophy = Philosophy;
    }
}

export function Coach_$reflection() {
    return record_type("App.Coach", [], Coach, () => [["Name", string_type], ["System", string_type], ["Philosophy", string_type]]);
}

export const headCoaches = ofArray([new Coach("Steve Kerr", "Pace & Space", "Move the ball until the defence breaks, then let it fly from deep."), new Coach("Pat Riley", "Grit & Grind", "Nothing comes easy. Every possession contested, every night."), new Coach("Phil Jackson", "Showtime", "The triangle. Read the floor, trust the spacing, everybody touches it."), new Coach("Doc Rivers", "Lob City", "Push the tempo and finish everything above the rim."), new Coach("Rudy Tomjanovich", "Post Dynasty", "Throw it inside, let the big man work, and crash the glass.")]);

export class TradeAsset extends Record {
    constructor(Name, Group, Tier, Badge, Franchise, MinOvr, MaxOvr) {
        super();
        this.Name = Name;
        this.Group = Group;
        this.Tier = Tier;
        this.Badge = Badge;
        this.Franchise = Franchise;
        this.MinOvr = (MinOvr | 0);
        this.MaxOvr = (MaxOvr | 0);
    }
}

export function TradeAsset_$reflection() {
    return record_type("App.TradeAsset", [], TradeAsset, () => [["Name", string_type], ["Group", string_type], ["Tier", string_type], ["Badge", string_type], ["Franchise", string_type], ["MinOvr", int32_type], ["MaxOvr", int32_type]]);
}

export const tradeAssets = ofArray([new TradeAsset("James Harden", "Guards", "Star", "HOF Space Creator", "Houston Rockets 2017/18", 89, 96), new TradeAsset("Russell Westbrook", "Guards", "Star", "HOF Ankle Breaker", "Oklahoma City Thunder 2016/17", 89, 96), new TradeAsset("Jimmer Fredette", "Guards", "Bust", "Bronze Volume Shooter", "Sacramento Kings 2011/12", 70, 75), new TradeAsset("Dion Waiters", "Guards", "Bust", "Bronze Volume Shooter", "Cleveland Cavaliers 2013/14", 70, 75), new TradeAsset("Marcus Smart", "Guards", "Shifter", "HOF Clamps", "Boston Celtics 2021/22", 79, 83), new TradeAsset("Kyle Korver", "Guards", "Shifter", "HOF Claymore", "Atlanta Hawks 2014/15", 79, 83), new TradeAsset("Kevin Durant", "Forwards", "Star", "HOF Deadeye", "Oklahoma City Thunder 2013/14", 89, 96), new TradeAsset("Giannis Antetokounmpo", "Forwards", "Star", "HOF Posterizer", "Milwaukee Bucks 2019/20", 89, 96), new TradeAsset("Andrea Bargnani", "Forwards", "Bust", "Bronze Dropstepper", "New York Knicks 2013/14", 70, 75), new TradeAsset("Thaddeus Young", "Forwards", "Bust", "Bronze Work Horse", "Brooklyn Nets 2015/16", 70, 75), new TradeAsset("Draymond Green", "Forwards", "Shifter", "HOF Anchor", "Golden State Warriors 2016/17", 79, 83), new TradeAsset("Robert Covington", "Forwards", "Shifter", "HOF Interceptor", "Philadelphia 76ers 2017/18", 79, 83), new TradeAsset("Anthony Davis", "Big Men", "Star", "HOF Anchor", "New Orleans Pelicans 2017/18", 89, 96), new TradeAsset("Dirk Nowitzki", "Big Men", "Star", "HOF Space Creator", "Dallas Mavericks 2006/07", 89, 96), new TradeAsset("Kwame Brown", "Big Men", "Bust", "Bronze Brick Wall", "Washington Wizards 2004/05", 70, 75), new TradeAsset("Julius Randle", "Big Men", "Bust", "Bronze Bully", "Los Angeles Lakers 2017/18", 70, 75), new TradeAsset("Rudy Gobert", "Big Men", "Shifter", "HOF Rim Protector", "Utah Jazz 2016/17", 79, 83), new TradeAsset("Brook Lopez", "Big Men", "Shifter", "HOF Anchor", "Milwaukee Bucks 2019/20", 79, 83)]);

export const poolById = ofList(map((pool) => [pool.Id, pool], historicalRegistry), {
    Compare: comparePrimitives,
});

export const playerById = ofList(map((p) => [p.Id, p], collect((pool) => pool.Options, historicalRegistry)), {
    Compare: comparePrimitives,
});

/**
 * Era marker for a roster row. An ordinal ramp on the brand hue rather
 * than seven unrelated colours: era is ordered, so shade should be too,
 * darkest for the oldest squads.
 */
export function eraDotClasses(seasonYear) {
    if (seasonYear < 1970) {
        return "bg-orange-900";
    }
    else if (seasonYear < 1980) {
        return "bg-orange-800";
    }
    else if (seasonYear < 1990) {
        return "bg-orange-700";
    }
    else if (seasonYear < 2000) {
        return "bg-orange-600";
    }
    else if (seasonYear < 2010) {
        return "bg-orange-500";
    }
    else if (seasonYear < 2020) {
        return "bg-orange-400";
    }
    else {
        return "bg-orange-300";
    }
}

/**
 * Court legend categories. Drives both the OVR badge tint and the
 * legend row beneath the court.
 */
export function positionCategory(pos) {
    switch (pos) {
        case "PG":
        case "SG":
            return "Guards";
        case "SF":
        case "PF":
            return "Forwards";
        default:
            return "Big Men";
    }
}

export function positionBadgeClasses(pos) {
    const matchValue = positionCategory(pos);
    switch (matchValue) {
        case "Guards":
            return "bg-orange-500 text-zinc-950";
        case "Forwards":
            return "bg-blue-500 text-white";
        default:
            return "bg-amber-700 text-white";
    }
}

/**
 * Open slots a player may legally occupy, given the run's slot list
 * (blueprint starters + bench).
 * 
 * - Starter slots demand a positional match against EVERY position the
 * player genuinely plays — their listed spot plus any curated
 * secondary positions (Database.secondaryPositions), the reference
 * game's multi-position eligibility. Duplicate-position blueprints
 * simply expose two slots with the same demand.
 * - Bench slots take anyone, as utility spots.
 * - Filled slots are never eligible — a placement is permanent.
 */
export function eligibleSlotsFor(slots, player, roster) {
    const positions = playerPositions(player);
    return filter((slot) => {
        if (!FSharpMap__ContainsKey(roster, slot)) {
            if (contains(slot, benchSlots, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            })) {
                return true;
            }
            else {
                return contains(positionOfSlot(slot), positions, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: stringHash,
                });
            }
        }
        else {
            return false;
        }
    }, slots);
}

export class LogEntry extends Record {
    constructor(GameNumber, Opponent, TeamScore, OppScore, Won, WinChance, StandoutLine, Note) {
        super();
        this.GameNumber = (GameNumber | 0);
        this.Opponent = Opponent;
        this.TeamScore = (TeamScore | 0);
        this.OppScore = (OppScore | 0);
        this.Won = Won;
        this.WinChance = WinChance;
        this.StandoutLine = StandoutLine;
        this.Note = Note;
    }
}

export function LogEntry_$reflection() {
    return record_type("App.LogEntry", [], LogEntry, () => [["GameNumber", int32_type], ["Opponent", string_type], ["TeamScore", int32_type], ["OppScore", int32_type], ["Won", bool_type], ["WinChance", float64_type], ["StandoutLine", string_type], ["Note", option_type(string_type)]]);
}

export class PlayoffGameLog extends Record {
    constructor(Game, TeamScore, OppScore, Won, Standout, HomeCourt) {
        super();
        this.Game = (Game | 0);
        this.TeamScore = (TeamScore | 0);
        this.OppScore = (OppScore | 0);
        this.Won = Won;
        this.Standout = Standout;
        this.HomeCourt = HomeCourt;
    }
}

export function PlayoffGameLog_$reflection() {
    return record_type("App.PlayoffGameLog", [], PlayoffGameLog, () => [["Game", int32_type], ["TeamScore", int32_type], ["OppScore", int32_type], ["Won", bool_type], ["Standout", string_type], ["HomeCourt", bool_type]]);
}

export class PlayoffSeries extends Record {
    constructor(Round, Opponent, OpponentSeed, OpponentWins82, MySeed, MyWins, OppWins, Games) {
        super();
        this.Round = (Round | 0);
        this.Opponent = Opponent;
        this.OpponentSeed = (OpponentSeed | 0);
        this.OpponentWins82 = (OpponentWins82 | 0);
        this.MySeed = (MySeed | 0);
        this.MyWins = (MyWins | 0);
        this.OppWins = (OppWins | 0);
        this.Games = Games;
    }
}

export function PlayoffSeries_$reflection() {
    return record_type("App.PlayoffSeries", [], PlayoffSeries, () => [["Round", int32_type], ["Opponent", string_type], ["OpponentSeed", int32_type], ["OpponentWins82", int32_type], ["MySeed", int32_type], ["MyWins", int32_type], ["OppWins", int32_type], ["Games", list_type(PlayoffGameLog_$reflection())]]);
}

export class PlayoffOutcome extends Record {
    constructor(WonRing, ExitRound, Records) {
        super();
        this.WonRing = WonRing;
        this.ExitRound = (ExitRound | 0);
        this.Records = Records;
    }
}

export function PlayoffOutcome_$reflection() {
    return record_type("App.PlayoffOutcome", [], PlayoffOutcome, () => [["WonRing", bool_type], ["ExitRound", int32_type], ["Records", list_type(tuple_type(int32_type, string_type, int32_type, int32_type))]]);
}

export class ConsolePhase extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Landing", "SystemSelect", "SpinningWheel", "WheelSpinning", "DraftChoice", "LineupSummary", "CoachReveal", "TradeDeadline", "DeadlineClosed", "PlayoffRoad", "PlayoffLive", "PlayoffSeriesDone", "PlayoffCrowned", "PlayoffEliminated", "TradeMarketChoice", "BargainBinOffer", "TradeReveal", "BlockbusterOffer", "BlockbusterSpinning", "BlockbusterReveal", "LiveSim", "SeasonComplete", "ProfilePage", "DraftGameGuidePage", "LineupBuilderGuidePage", "SeasonSimulatorGuidePage", "GreatestLineupGuidePage", "HowToPlayGuidePage", "MultiplayerHubPage", "LiveDraftSetupPage", "LeaguesSetupPage", "LeagueRulesConfigPage", "FranchiseModePage", "DailyChallengePage", "EraChallengePage", "LeaderboardPage", "StoryPage", "GetAppPage", "PartnersPage", "PrivacyPolicyPage", "TermsOfUsePage", "DiscordPage"];
    }
}

export function ConsolePhase_$reflection() {
    return union_type("App.ConsolePhase", [], ConsolePhase, () => [[], [], [], [["Landing", TeamPool_$reflection()]], [["Item", TeamPool_$reflection()]], [], [["Item", Coach_$reflection()]], [], [["Headline", string_type], ["Body", string_type]], [["MySeed", int32_type], ["Field", list_type(tuple_type(int32_type, string_type, int32_type))]], [["Series", PlayoffSeries_$reflection()], ["Alive", list_type(tuple_type(int32_type, string_type, int32_type))], ["Quarters", list_type(tuple_type(int32_type, int32_type))]], [["Series", PlayoffSeries_$reflection()], ["Alive", list_type(tuple_type(int32_type, string_type, int32_type))], ["Flavor", list_type(string_type)], ["Next", tuple_type(int32_type, string_type, int32_type)]], [["Outcome", PlayoffOutcome_$reflection()]], [["Series", PlayoffSeries_$reflection()], ["Outcome", PlayoffOutcome_$reflection()]], [["WeakestSlot", string_type], ["CurrentPlayerName", string_type], ["Choices", list_type(Player_$reflection())]], [["WeakestSlot", string_type], ["CurrentPlayerName", string_type], ["Hidden", Player_$reflection()]], [["SlotId", string_type], ["OutPlayer", Player_$reflection()], ["InPlayer", Player_$reflection()], ["OvrDiff", int32_type]], [["StarSlot", string_type], ["Star", Player_$reflection()]], [["Stage", int32_type], ["Deals", list_type(tuple_type(string_type, Player_$reflection(), Player_$reflection()))]], [["Deals", list_type(tuple_type(string_type, Player_$reflection(), Player_$reflection()))]], [], [["wins", int32_type], ["losses", int32_type]], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class UserProfile extends Record {
    constructor(IsSignedIn, UserId, Email, CurrentStreak, HighestStreak, Trophies) {
        super();
        this.IsSignedIn = IsSignedIn;
        this.UserId = UserId;
        this.Email = Email;
        this.CurrentStreak = (CurrentStreak | 0);
        this.HighestStreak = (HighestStreak | 0);
        this.Trophies = Trophies;
    }
}

export function UserProfile_$reflection() {
    return record_type("App.UserProfile", [], UserProfile, () => [["IsSignedIn", bool_type], ["UserId", option_type(string_type)], ["Email", option_type(string_type)], ["CurrentStreak", int32_type], ["HighestStreak", int32_type], ["Trophies", list_type(string_type)]]);
}

export class HistoricRun extends Record {
    constructor(Date$, TeamName, FranchiseId, Ovr, Record, Wins, Losses, Rank, PointsPerGame, Difficulty, RatingMode, Blueprint, Complete82_0) {
        super();
        this.Date = Date$;
        this.TeamName = TeamName;
        this.FranchiseId = FranchiseId;
        this.Ovr = (Ovr | 0);
        this.Record = Record;
        this.Wins = (Wins | 0);
        this.Losses = (Losses | 0);
        this.Rank = (Rank | 0);
        this.PointsPerGame = PointsPerGame;
        this.Difficulty = Difficulty;
        this.RatingMode = RatingMode;
        this.Blueprint = Blueprint;
        this.Complete82_0 = Complete82_0;
    }
}

export function HistoricRun_$reflection() {
    return record_type("App.HistoricRun", [], HistoricRun, () => [["Date", string_type], ["TeamName", string_type], ["FranchiseId", string_type], ["Ovr", int32_type], ["Record", string_type], ["Wins", int32_type], ["Losses", int32_type], ["Rank", int32_type], ["PointsPerGame", float64_type], ["Difficulty", string_type], ["RatingMode", string_type], ["Blueprint", string_type], ["Complete82_0", bool_type]]);
}

export const championshipWinThreshold = 50;

/**
 * Did this archived season win a ring? A flawless 82-0 always counts;
 * otherwise only finishing first does, with the win threshold as the
 * fallback for legacy runs whose finishing position was never stored.
 */
export function wonChampionship(run) {
    if (run.Complete82_0 ? true : (run.Rank === 1)) {
        return true;
    }
    else if (run.Rank === 0) {
        return run.Wins >= championshipWinThreshold;
    }
    else {
        return false;
    }
}

export const immortalityTrophy = "Immortality Trophy";

export class Accolade extends Record {
    constructor(Id, Title, Description) {
        super();
        this.Id = Id;
        this.Title = Title;
        this.Description = Description;
    }
}

export function Accolade_$reflection() {
    return record_type("App.Accolade", [], Accolade, () => [["Id", string_type], ["Title", string_type], ["Description", string_type]]);
}

export const franchiseRecordBreakerTrophy = "Franchise Record Breaker";

export const franchiseWorstEverTrophy = "Franchise Worst Ever";

export const accolades = ofArray([new Accolade(immortalityTrophy, "82-0 Immortality", "Go the whole season unbroken (82-0)."), new Accolade(franchiseRecordBreakerTrophy, "Franchise Record Breaker", "One-Franchise Roster: out-win your franchise\'s best-ever real season."), new Accolade(franchiseWorstEverTrophy, "Franchise Worst Ever", "One-Franchise Roster: finish below your franchise\'s worst-ever real season. For the brave."), new Accolade("Championship Ring", "Championship Ring", "Win the ultimate title in the simulation loop."), new Accolade("Cup Champions", "Cup Champions", "Sweep every game in December — the In-Season Tournament month."), new Accolade("The Triple Crown", "The Triple Crown", "The December sweep, 60+ wins, and the title — all in one run."), new Accolade("73-9 Golden Standard", "73-9 Golden Standard", "Beat the 2016 Warriors regular season win barrier."), new Accolade("Playoff Bound", "Playoff Bound", "Secure a top seed tier with 50+ season wins."), new Accolade("The Playoff Gauntlet", "The Playoff Gauntlet", "Survive three best-of-seven playoff rounds and win the ring."), new Accolade("Modern Dynasty", "Modern Dynasty", "Win consecutive titles back-to-back."), new Accolade("The Hard Way", "The Hard Way", "Finish top-four in the standings with a team rated 82 or lower."), new Accolade("Triple-Digit Firepower", "Triple-Digit Firepower", "Average 115.0+ PPG as a team across the 82 game logs."), new Accolade("The \'04 Pistons Matrix", "The \'04 Pistons Matrix", "Hold simulated opponents under 105 PPG across the whole season."), new Accolade("Defensive Lockdown", "Defensive Lockdown", "Draft 3+ players carrying Hall of Fame defensive badges."), new Accolade("The \'12 Bobcats Faint", "The \'12 Bobcats Faint", "Suffer the ultimate failure and finish with under 12 wins."), new Accolade("The Dream Team Effect", "The Dream Team Effect", "Assemble an unbeatable starting five where every single piece is 95+ OVR."), new Accolade("Twin Towers Alliance", "Twin Towers Alliance", "Win a title drafting two dominant Big Men (PF/C) rated 90+ OVR."), new Accolade("Out of Position Matrix", "Out of Position Matrix", "Start three or more players away from their natural positions."), new Accolade("Franchise Lifers", "Franchise Lifers", "Complete a run drafted entirely from one franchise\'s history."), new Accolade("The Veteran Guild", "The Veteran Guild", "Win 50+ games with three or more picks from 20th-century squads."), new Accolade("Global Domination", "Global Domination", "Field a starting five made entirely of international players (Giannis, Jokić, Dončić…)."), new Accolade("Multi-Era Continuum", "Multi-Era Continuum", "Successfully span 5 different draft decades inside one active 8-man roster unit."), new Accolade("All-Era Cult Heroes", "All-Era Cult Heroes", "Complete a simulation run drafting 3+ role-specialist assets rated under 78 OVR."), new Accolade("Wire-to-Wire Dominance", "Wire-to-Wire Dominance", "Win the title without your record ever dipping below .500."), new Accolade("Hardwood Homegrown", "Hardwood Homegrown", "Select an entire starting unit originating from the exact same NBA franchise seed."), new Accolade("Draft Lottery Sweepstakes", "Draft Lottery Sweepstakes", "Suffer a bottom-tier placement mapping to maximum draft lottery odds."), new Accolade("The Iron Man Unit", "The Iron Man Unit", "Finish all 82 with the starting five you tipped off with — no deadline surgery on your starters.")]);

const registryPoolIds = ofList_1(map((pool) => pool.Id, historicalRegistry), {
    Compare: comparePrimitives,
});

/**
 * Every franchise the player has won a ring with, by TeamPool.Id.
 */
export function franchiseRingsWon(runs) {
    return ofList_1(filter((value) => FSharpSet__Contains(registryPoolIds, value), map((run_1) => run_1.FranchiseId, filter(wonChampionship, runs))), {
        Compare: comparePrimitives,
    });
}

export const totalFranchises = length(historicalRegistry);

/**
 * Remaining secret accolades = total franchises − conquered franchises.
 * 
 * The subtraction is only sound because franchiseRingsWon is both
 * de-duplicated (a Set) and registry-validated, so the conquered set is
 * always a subset of the registry and the result cannot go negative.
 */
export function undiscoveredFranchiseAccolades(runs) {
    return totalFranchises - count_5(franchiseRingsWon(runs));
}

export const signedOutProfile = new UserProfile(false, undefined, undefined, 0, 0, empty_1());

export class SeasonFacts extends Record {
    constructor(Wins, Losses, Rank, TeamOvr, TeamPpg, OppPpg, DecemberSwept, NeverBelowFiveHundred, DeadlineTouchedStarters, Roster, PreviousRuns) {
        super();
        this.Wins = (Wins | 0);
        this.Losses = (Losses | 0);
        this.Rank = (Rank | 0);
        this.TeamOvr = (TeamOvr | 0);
        this.TeamPpg = TeamPpg;
        this.OppPpg = OppPpg;
        this.DecemberSwept = DecemberSwept;
        this.NeverBelowFiveHundred = NeverBelowFiveHundred;
        this.DeadlineTouchedStarters = DeadlineTouchedStarters;
        this.Roster = Roster;
        this.PreviousRuns = PreviousRuns;
    }
}

export function SeasonFacts_$reflection() {
    return record_type("App.SeasonFacts", [], SeasonFacts, () => [["Wins", int32_type], ["Losses", int32_type], ["Rank", int32_type], ["TeamOvr", int32_type], ["TeamPpg", float64_type], ["OppPpg", float64_type], ["DecemberSwept", bool_type], ["NeverBelowFiveHundred", bool_type], ["DeadlineTouchedStarters", bool_type], ["Roster", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Player_$reflection()])], ["PreviousRuns", list_type(HistoricRun_$reflection())]]);
}

export class Difficulty extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Easy", "Normal", "Hard"];
    }
}

export function Difficulty_$reflection() {
    return union_type("App.Difficulty", [], Difficulty, () => [[], [], []]);
}

export class RatingMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SeasonRatings", "PrimeRatings"];
    }
}

export function RatingMode_$reflection() {
    return union_type("App.RatingMode", [], RatingMode, () => [[], []]);
}

export class DraftConfig extends Record {
    constructor(Difficulty, RatingMode) {
        super();
        this.Difficulty = Difficulty;
        this.RatingMode = RatingMode;
    }
}

export function DraftConfig_$reflection() {
    return record_type("App.DraftConfig", [], DraftConfig, () => [["Difficulty", Difficulty_$reflection()], ["RatingMode", RatingMode_$reflection()]]);
}

export const defaultDraftConfig = new DraftConfig(new Difficulty(1, []), new RatingMode(0, []));

export const seasonTimeline = toArray(delay(() => map_1((startYear) => toText(interpolate("%d%P()/%02d%P()", [startYear, (startYear + 1) % 100])), rangeDouble(1946, 1, 2025))));

export const lastSeasonIndex = seasonTimeline.length - 1;

/**
 * Season END year for a timeline index — 1946/47 ends in 1947. Pool ids
 * encode the same end year ("CHI96" = the 1995/96 season), so this is
 * what range comparisons run against.
 */
export function seasonEndYear(index) {
    return 1947 + index;
}

/**
 * Clamp an index into the timeline.
 */
export function clampSeasonIndex(index) {
    return max(0, min(lastSeasonIndex, index));
}

export const eraPresets = ofArray([["All-Time", 0, lastSeasonIndex], ["Classic Bill/Wilt", 10, 22], ["Showtime 80s", 33, 42], ["Gritty 90s", 43, 52], ["Kobe/LeBron 00s", 53, 63], ["Three-Point Boom", 64, lastSeasonIndex]]);

/**
 * Rerolls granted at the start of a run.
 */
export function rerollsFor(difficulty) {
    switch (difficulty.tag) {
        case 1:
            return 1;
        case 2:
            return 0;
        default:
            return 3;
    }
}

/**
 * Hard mode hides OVR on every draft and roster card.
 */
export function hidesRatings(difficulty) {
    return equals(difficulty, new Difficulty(2, []));
}

/**
 * Season END year encoded in a pool id: "CHI96" -> 1996, "DET24" -> 2024.
 * Ids always end in two digits. The registry runs 1947-2024, so treating
 * <= 29 as 21st century is unambiguous for this data.
 */
export function poolSeasonYear(poolId) {
    if (poolId.length < 2) {
        return 0;
    }
    else {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(substring(poolId, poolId.length - 2), 511, false, 32, new FSharpRef(() => outArg, (v) => {
            outArg = (v | 0);
        })), outArg];
        if (matchValue[0]) {
            if (matchValue[1] <= 29) {
                return (2000 + matchValue[1]) | 0;
            }
            else {
                return (1900 + matchValue[1]) | 0;
            }
        }
        else {
            return 0;
        }
    }
}

/**
 * Full season label for a pool ("CHI96" -> "1995/96").
 */
export function seasonLabelForPool(poolId) {
    const index = (poolSeasonYear(poolId) - 1947) | 0;
    if ((index >= 0) && (index < seasonTimeline.length)) {
        return item_1(index, seasonTimeline);
    }
    else {
        return "";
    }
}

/**
 * Calendar date for a game number, on the real NBA rhythm: 82 games
 * spread evenly from opening night (Oct 21) to the season finale
 * (Apr 12) — a 173-day campaign. Game 51 lands in the first week of
 * February, which is what puts the trade deadline where the NBA
 * actually holds it.
 */
export function gameDateLabel(gameNumber) {
    const walk = (remaining_mut, startDay_mut, rest_mut) => {
        walk:
        while (true) {
            const remaining = remaining_mut, startDay = startDay_mut, rest = rest_mut;
            if (!isEmpty(rest)) {
                const len = head(rest)[1] | 0;
                if (remaining < len) {
                    return `${head(rest)[0]} ${startDay + remaining}`;
                }
                else {
                    remaining_mut = (remaining - len);
                    startDay_mut = 1;
                    rest_mut = tail_1(rest);
                    continue walk;
                }
            }
            else {
                return "Apr 12";
            }
            break;
        }
    };
    return walk(~~round_3(((gameNumber - 1) * 173) / 81), 21, ofArray([["Oct", 11], ["Nov", 30], ["Dec", 31], ["Jan", 31], ["Feb", 28], ["Mar", 31], ["Apr", 30]]));
}

/**
 * Deterministic sort key for shuffling the slot reel's decoy rows.
 * Seeded per spin (the landing's id), so every spin shows a different
 * decoy order — but stable across React re-renders within one spin,
 * which is what keeps the animating column from scrambling mid-drop.
 */
export function reelOrderKey(seed, id) {
    let hash = 17;
    const inputSequence = (seed + "/") + id;
    const enumerator = getEnumerator(inputSequence.split(""));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const ch = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            hash = ((((hash * 31) + ~~ch.charCodeAt(0)) % 1000003) | 0);
        }
    }
    finally {
        disposeSafe(enumerator);
    }
    return hash | 0;
}

/**
 * Drops the "'96 " prefix from a TeamName, leaving just the nickname.
 */
export function franchiseNickname(teamName) {
    if ((teamName.length > 4) && teamName.startsWith("\'")) {
        return substring(teamName, 4);
    }
    else {
        return teamName;
    }
}

/**
 * Period-correct full franchise name: "New Jersey Nets", "Seattle
 * SuperSonics". The season is shown separately, so the year prefix in
 * TeamName is dropped rather than repeated.
 */
export function fullFranchiseName(pool) {
    return `${pool.City} ${franchiseNickname(pool.TeamName)}`;
}

/**
 * Does a pool's season fall inside the selected slider range?
 */
export function seasonInRange(startIndex, endIndex, poolId) {
    const year = poolSeasonYear(poolId) | 0;
    if (year >= seasonEndYear(startIndex)) {
        return year <= seasonEndYear(endIndex);
    }
    else {
        return false;
    }
}

export const spoilerTopOvrCeiling = 80;

export function isSpoilerPool(pool) {
    return forAll((player) => (player.Ovr < spoilerTopOvrCeiling), pool.Options);
}

export const spoilerPools = filter(isSpoilerPool, historicalRegistry);

export const totalSpoilerPools = length(spoilerPools);

/**
 * Pools whose season falls inside the slider range. Strictly clamped —
 * nothing outside the endpoints is ever returned, so the on-screen range
 * is exactly what the wheel can draw from.
 */
export function poolsInSeasonRange(startIndex, endIndex) {
    return filter((pool) => seasonInRange(startIndex, endIndex, pool.Id), historicalRegistry);
}

/**
 * Draftable players inside the range. A roster needs eight, so this is
 * what decides whether a range can support a run at all.
 */
export function draftablePlayersInRange(startIndex, endIndex) {
    return sumBy((pool) => length(pool.Options), poolsInSeasonRange(startIndex, endIndex), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
}

export const peakOvrByName = ofList(map((tupledArg) => [tupledArg[0], max_1(map((p) => p.Ovr, tupledArg[1]), {
    Compare: comparePrimitives,
})], List_groupBy((player) => player.Name, collect((pool) => pool.Options, historicalRegistry), {
    Equals: (x, y) => (x === y),
    GetHashCode: stringHash,
})), {
    Compare: comparePrimitives,
});

/**
 * Re-rate a pool's options under the chosen rating mode. StatLine is
 * left alone: it still describes the season actually drawn.
 */
export function applyRatingMode(mode, pool) {
    if (mode.tag === 1) {
        return new TeamPool(pool.Id, pool.City, pool.TeamName, map((player) => {
            const matchValue = FSharpMap__TryFind(peakOvrByName, player.Name);
            let matchResult, peak_1;
            if (matchValue != null) {
                if (matchValue > player.Ovr) {
                    matchResult = 0;
                    peak_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new Player(player.Id, player.Name, player.Pos, peak_1, player.Badge, player.StatLine);
                default:
                    return player;
            }
        }, pool.Options));
    }
    else {
        return pool;
    }
}

export const draftModeSquadFirst = "SquadFirst";

export const draftModePositionFirst = "PositionFirst";

export class GameState extends Record {
    constructor(Phase, Roster, SystemArchetype, Config, RerollsAvailable, DrawnFranchiseIds, FranchiseLock, Blueprint, DailyRun, IsKnowledgeMode, DraftModeSetting, StartEraIndex, EndEraIndex, HeadCoachesEnabled, SelectedCoach, IsTradeResolved, TradeOutcome, IsInstantSkipActive, PlayerSeason, TradedInPlayerIds, DeadlineDeals, ProjectedWins, RivalStandings, PlayoffRecords, PlayoffOutcome, PlayoffsEnabled, TradeDeadlineEnabled, SeasonLuck, Wins, Losses, GameLog, Profile, UserRuns) {
        super();
        this.Phase = Phase;
        this.Roster = Roster;
        this.SystemArchetype = SystemArchetype;
        this.Config = Config;
        this.RerollsAvailable = (RerollsAvailable | 0);
        this.DrawnFranchiseIds = DrawnFranchiseIds;
        this.FranchiseLock = FranchiseLock;
        this.Blueprint = Blueprint;
        this.DailyRun = DailyRun;
        this.IsKnowledgeMode = IsKnowledgeMode;
        this.DraftModeSetting = DraftModeSetting;
        this.StartEraIndex = (StartEraIndex | 0);
        this.EndEraIndex = (EndEraIndex | 0);
        this.HeadCoachesEnabled = HeadCoachesEnabled;
        this.SelectedCoach = SelectedCoach;
        this.IsTradeResolved = IsTradeResolved;
        this.TradeOutcome = TradeOutcome;
        this.IsInstantSkipActive = IsInstantSkipActive;
        this.PlayerSeason = PlayerSeason;
        this.TradedInPlayerIds = TradedInPlayerIds;
        this.DeadlineDeals = DeadlineDeals;
        this.ProjectedWins = ProjectedWins;
        this.RivalStandings = RivalStandings;
        this.PlayoffRecords = PlayoffRecords;
        this.PlayoffOutcome = PlayoffOutcome;
        this.PlayoffsEnabled = PlayoffsEnabled;
        this.TradeDeadlineEnabled = TradeDeadlineEnabled;
        this.SeasonLuck = SeasonLuck;
        this.Wins = (Wins | 0);
        this.Losses = (Losses | 0);
        this.GameLog = GameLog;
        this.Profile = Profile;
        this.UserRuns = UserRuns;
    }
}

export function GameState_$reflection() {
    return record_type("App.GameState", [], GameState, () => [["Phase", ConsolePhase_$reflection()], ["Roster", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Player_$reflection()])], ["SystemArchetype", string_type], ["Config", DraftConfig_$reflection()], ["RerollsAvailable", int32_type], ["DrawnFranchiseIds", list_type(string_type)], ["FranchiseLock", option_type(Franchise_$reflection())], ["Blueprint", Blueprint_$reflection()], ["DailyRun", option_type(DailyRun_$reflection())], ["IsKnowledgeMode", bool_type], ["DraftModeSetting", string_type], ["StartEraIndex", int32_type], ["EndEraIndex", int32_type], ["HeadCoachesEnabled", bool_type], ["SelectedCoach", option_type(Coach_$reflection())], ["IsTradeResolved", bool_type], ["TradeOutcome", option_type(string_type)], ["IsInstantSkipActive", bool_type], ["PlayerSeason", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, SeasonLine_$reflection()])], ["TradedInPlayerIds", list_type(string_type)], ["DeadlineDeals", list_type(tuple_type(string_type, Player_$reflection(), Player_$reflection()))], ["ProjectedWins", option_type(int32_type)], ["RivalStandings", list_type(tuple_type(string_type, int32_type))], ["PlayoffRecords", list_type(tuple_type(int32_type, string_type, int32_type, int32_type))], ["PlayoffOutcome", option_type(PlayoffOutcome_$reflection())], ["PlayoffsEnabled", bool_type], ["TradeDeadlineEnabled", bool_type], ["SeasonLuck", float64_type], ["Wins", int32_type], ["Losses", int32_type], ["GameLog", list_type(LogEntry_$reflection())], ["Profile", UserProfile_$reflection()], ["UserRuns", list_type(HistoricRun_$reflection())]]);
}

export const initialState = new GameState(new ConsolePhase(0, []), empty({
    Compare: comparePrimitives,
}), "Balanced", defaultDraftConfig, rerollsFor(defaultDraftConfig.Difficulty), empty_1(), undefined, defaultBlueprint, undefined, false, draftModeSquadFirst, 0, lastSeasonIndex, true, undefined, false, undefined, false, empty({
    Compare: comparePrimitives,
}), empty_1(), empty_1(), undefined, empty_1(), empty_1(), undefined, true, true, 0, 0, 0, empty_1(), signedOutProfile, empty_1());

export const Engine_baselineOpponentOvr = 82;

export const Engine_minWinProbability = 0.1;

export const Engine_maxWinProbability = 0.94;

export const Engine_systemBadgeAffinity = ofList(ofArray([["Pace & Space", ofArray(["Limitless Range", "Catch & Shoot", "Deadeye", "Claymore", "Green Machine", "Space Creator"])], ["Grit & Grind", ofArray(["Clamps", "Glove", "Anchor", "Brick Wall", "Off-Ball Pest", "Defensive Leader", "Rim Protector", "Interceptor", "Ball Stripper", "Challenger", "Rebound Chaser", "Boxout Beast"])], ["Showtime", ofArray(["Dimer", "Needle Threader", "Floor General", "Break Starter", "Bail Out", "Killer Combos", "Handles for Days", "Ankle Breaker"])], ["Lob City", ofArray(["Posterizer", "Lob City Finisher", "Fearless Finisher", "Slithery", "Acrobat"])], ["Post Dynasty", ofArray(["Post Spin Technician", "Dream Shake", "Backdown Punisher", "Deep Hooks", "Work Horse", "Middy Magician"])]]), {
    Compare: comparePrimitives,
});

function Engine_averageOvr(players) {
    if (isEmpty(players)) {
        return 0;
    }
    else {
        return averageBy((p) => p.Ovr, players, {
            GetZero: () => 0,
            Add: (x_1, y) => (x_1 + y),
            DivideByInt: (x, i) => (x / i),
        });
    }
}

function Engine_playersInSlots(slots, roster) {
    return choose((slot) => FSharpMap__TryFind(roster, slot), slots);
}

function Engine_starterPlayers(roster) {
    return map((tuple) => tuple[1], filter((tupledArg) => !contains(tupledArg[0], benchSlots, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), toList(roster)));
}

/**
 * Team Overall Rating, Banner Season wholesale formula:
 * Starters (five-man average) x 0.85
 * + Bench    (B1/B2/B3 average) x 0.15
 * rounded to a single integer OVR.
 */
export function Engine_calculateTeamRatings(roster) {
    return ~~round_3((Engine_averageOvr(Engine_starterPlayers(roster)) * 0.85) + (Engine_averageOvr(Engine_playersInSlots(benchSlots, roster)) * 0.15));
}

const Engine_defensiveBadgeKeywords = (() => {
    const matchValue = FSharpMap__TryFind(Engine_systemBadgeAffinity, "Grit & Grind");
    return (matchValue == null) ? empty_1() : matchValue;
})();

const Engine_offensiveBadgeKeywords = collect((tuple) => tuple[1], filter((tupledArg) => (tupledArg[0] !== "Grit & Grind"), toList(Engine_systemBadgeAffinity)));

export const Engine_badgeTilt = 4;

function Engine_badgeSide(player) {
    if (exists((k) => (player.Badge.indexOf(k) >= 0), Engine_defensiveBadgeKeywords)) {
        return -1;
    }
    else if (exists((k_1) => (player.Badge.indexOf(k_1) >= 0), Engine_offensiveBadgeKeywords)) {
        return 1;
    }
    else {
        return 0;
    }
}

/**
 * Offense and defense ratings, on the same 85/15 starter/bench
 * weighting as the team OVR. Each player contributes their overall,
 * tilted toward whichever side of the ball their badge serves.
 */
export function Engine_calculateSideRatings(roster) {
    const sideValue = (forOffense, player) => {
        const side = Engine_badgeSide(player) | 0;
        return player.Ovr + ((side === 0) ? 0 : (((side === 1) === forOffense) ? Engine_badgeTilt : -Engine_badgeTilt));
    };
    const weighted = (score) => {
        const average = (players) => {
            if (isEmpty(players)) {
                return 0;
            }
            else {
                return averageBy(score, players, {
                    GetZero: () => 0,
                    Add: (x_1, y) => (x_1 + y),
                    DivideByInt: (x, i) => (x / i),
                });
            }
        };
        return (average(Engine_starterPlayers(roster)) * 0.85) + (average(Engine_playersInSlots(benchSlots, roster)) * 0.15);
    };
    const clamp = (value) => ~~round_3(max(0, min(99, value)));
    return [clamp(weighted(curry2(sideValue)(true))), clamp(weighted(curry2(sideValue)(false)))];
}

/**
 * The pool a drafted player came from. Database.fs ids follow a
 * "<poolid>-<surname>" convention ("chi96-jordan"), so the prefix
 * uppercased is the TeamPool.Id. Verified to hold for all 40 pools.
 */
export function Engine_franchiseOfPlayer(player) {
    const parts = split(player.Id, ["-"], undefined, 0);
    if (parts.length === 0) {
        return "";
    }
    else {
        return item_1(0, parts).toLocaleUpperCase();
    }
}

/**
 * The franchise a run is credited to: the one supplying the most
 * players, ties broken by the combined OVR it contributed. The
 * wheel hands out picks from up to eight different pools, so a
 * roster rarely belongs to a single team outright.
 */
export function Engine_primaryFranchise(roster) {
    const matchValue = map((tuple) => tuple[1], toList(roster));
    if (isEmpty(matchValue)) {
        return "";
    }
    else {
        return maxBy((tupledArg) => {
            const group = tupledArg[1];
            return [length(group), sumBy((p) => p.Ovr, group, {
                GetZero: () => 0,
                Add: (x_1, y_1) => (x_1 + y_1),
            })];
        }, List_groupBy(Engine_franchiseOfPlayer, matchValue, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }), {
            Compare: compareArrays,
        })[0];
    }
}

/**
 * Roster-aware synergy check for the sim loop / UI:
 * true when at least one rostered badge belongs to the selected
 * system's badge family. Compose it like so before each tick —
 * let sys = if rosterSynergyActive state.SystemArchetype state.Roster
 * then state.SystemArchetype else "Balanced"
 * calculateWinProbability teamOvr sys
 * — so the +2% only fires when the draft actually backs the system.
 */
export function Engine_rosterSynergyActive(systemArchetype, roster) {
    const matchValue = FSharpMap__TryFind(Engine_systemBadgeAffinity, systemArchetype);
    if (matchValue != null) {
        const keywords = matchValue;
        return exists_1((_arg, player) => exists((keyword) => (player.Badge.indexOf(keyword) >= 0), keywords), roster);
    }
    else {
        return false;
    }
}

/**
 * Per-game win probability.
 * - 50% baseline at exactly 82 OVR (the fixed opponent index)
 * - +/- 2.5% per OVR point above/below the baseline. The original
 * 4% slope made every well-drafted roster a 60-win juggernaut;
 * this keeps a great roster great (~92 OVR -> ~61 wins) while a
 * good one (~85) lands near 47-55 and actually has to sweat the
 * standings.
 * - +2% if the selected system is a specialized (badge-aligned)
 * archetype from systemBadgeAffinity
 * - strictly clipped to [10%, 94%] via Math.Max / Math.Min
 */
export function Engine_calculateWinProbability(teamOvr, systemArchetype) {
    return max(Engine_minWinProbability, min(Engine_maxWinProbability, (0.5 + (0.025 * (teamOvr - Engine_baselineOpponentOvr))) + (FSharpMap__ContainsKey(Engine_systemBadgeAffinity, systemArchetype) ? 0.02 : 0)));
}

/**
 * Fold the run's pre-rolled fortune into a probability, re-clamped
 * so luck can neither break the 94% ceiling nor sink the floor.
 */
export function Engine_applySeasonLuck(luck, probability) {
    return max(Engine_minWinProbability, min(Engine_maxWinProbability, probability + luck));
}

/**
 * Rostered players whose badge belongs to the defensive family —
 * the trophy cabinet's Defensive Lockdown check.
 */
export function Engine_defensiveBadgeCount(roster) {
    return length(filter((tupledArg) => (Engine_badgeSide(tupledArg[1]) === -1), toList(roster)));
}

export const Engine_coachWinBonus = 0.02;

/**
 * Win probability including the appointed coach.
 * 
 * The coach only pays out when their system matches the one the team
 * is actually running, and the result is re-clamped so the 94%
 * ceiling still holds — that cap is what keeps 82-0 hard, and a
 * coach must not be a way around it.
 */
export function Engine_calculateWinProbabilityWithCoach(teamOvr, systemArchetype, coach) {
    let c_1;
    return max(Engine_minWinProbability, min(Engine_maxWinProbability, Engine_calculateWinProbability(teamOvr, systemArchetype) + ((coach != null) ? ((coach.System === systemArchetype) ? ((c_1 = coach, Engine_coachWinBonus)) : 0) : 0)));
}

/**
 * Exact distribution of season win totals for a fixed per-game win
 * probability: index w holds P(exactly w wins across 82 games).
 * A binomial built by folding one game at a time — 82 × 83 float
 * ops, cheap enough to run on every render of the odds panel.
 */
export function Engine_winDistribution(winChance) {
    const dist = new Float64Array(83);
    setItem(dist, 0, 1);
    for (let game = 1; game <= 82; game++) {
        for (let w = game; w >= 1; w--) {
            setItem(dist, w, (item_1(w, dist) * (1 - winChance)) + (item_1(w - 1, dist) * winChance));
        }
        setItem(dist, 0, item_1(0, dist) * (1 - winChance));
    }
    return dist;
}

/**
 * P(at least `threshold` wins) under a winDistribution array.
 */
export function Engine_probAtLeast(dist, threshold) {
    const start = max(0, threshold) | 0;
    let total = 0;
    for (let w = start; w <= 82; w++) {
        total = (total + item_1(w, dist));
    }
    return total;
}

const LiveDraft_rng = nonSeeded();

export class LiveDraft_Member extends Record {
    constructor(Key, Handle, Roster) {
        super();
        this.Key = Key;
        this.Handle = Handle;
        this.Roster = Roster;
    }
}

export function LiveDraft_Member_$reflection() {
    return record_type("App.LiveDraft.Member", [], LiveDraft_Member, () => [["Key", string_type], ["Handle", string_type], ["Roster", list_type(tuple_type(string_type, string_type))]]);
}

export class LiveDraft_Room extends Record {
    constructor(Code, HostKey, Members, Started, TurnIndex, PoolId, TakenIds, Seed, TurnDeadline) {
        super();
        this.Code = Code;
        this.HostKey = HostKey;
        this.Members = Members;
        this.Started = Started;
        this.TurnIndex = (TurnIndex | 0);
        this.PoolId = PoolId;
        this.TakenIds = TakenIds;
        this.Seed = (Seed | 0);
        this.TurnDeadline = TurnDeadline;
    }
}

export function LiveDraft_Room_$reflection() {
    return record_type("App.LiveDraft.Room", [], LiveDraft_Room, () => [["Code", string_type], ["HostKey", string_type], ["Members", list_type(LiveDraft_Member_$reflection())], ["Started", bool_type], ["TurnIndex", int32_type], ["PoolId", string_type], ["TakenIds", list_type(string_type)], ["Seed", int32_type], ["TurnDeadline", float64_type]]);
}

export const LiveDraft_turnSeconds = 45;

export const LiveDraft_liveSlots = append(blueprintSlotIds(defaultBlueprint), benchSlots);

export const LiveDraft_roundsPerMember = length(LiveDraft_liveSlots);

export function LiveDraft_totalPicks(room) {
    return length(room.Members) * LiveDraft_roundsPerMember;
}

export function LiveDraft_draftDone(room) {
    if (room.Started) {
        return room.TurnIndex >= LiveDraft_totalPicks(room);
    }
    else {
        return false;
    }
}

/**
 * Ambiguity-free room codes (no 0/O, 1/I/L).
 */
export function LiveDraft_makeRoomCode() {
    return initialize(6, (_arg) => "ABCDEFGHJKMNPQRSTUVWXYZ23456789"[LiveDraft_rng.Next1("ABCDEFGHJKMNPQRSTUVWXYZ23456789".length)]).join('');
}

/**
 * Whose pick is it? Snake order: 1-2-3-4, then 4-3-2-1, repeat.
 */
export function LiveDraft_memberOnTurn(room) {
    if (!room.Started ? true : LiveDraft_draftDone(room)) {
        return undefined;
    }
    else {
        const count = length(room.Members) | 0;
        const indexInRound = (room.TurnIndex % count) | 0;
        return tryItem(((~~(room.TurnIndex / count) % 2) === 1) ? ((count - 1) - indexInRound) : indexInRound, room.Members);
    }
}

export function LiveDraft_rosterMap(m) {
    return ofList(choose((tupledArg) => map_2((p) => [tupledArg[0], p], FSharpMap__TryFind(playerById, tupledArg[1])), m.Roster), {
        Compare: comparePrimitives,
    });
}

/**
 * First slot this member could legally give the player — starter
 * match first, bench as fallback, mirroring solo auto-fill.
 */
export function LiveDraft_autoSlotFor(m, player) {
    return tryHead(eligibleSlotsFor(LiveDraft_liveSlots, player, LiveDraft_rosterMap(m)));
}

/**
 * Players in a pool the member could actually draft right now.
 */
export function LiveDraft_eligibleFor(room, m, pool) {
    return filter((p) => {
        if (!contains(p.Id, room.TakenIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        })) {
            return LiveDraft_autoSlotFor(m, p) != null;
        }
        else {
            return false;
        }
    }, pool.Options);
}

/**
 * A pool the NEXT on-turn member can genuinely draft from. Falls
 * back to the current pool when the draft is over.
 */
export function LiveDraft_freshPoolId(room) {
    const matchValue = LiveDraft_memberOnTurn(room);
    if (matchValue != null) {
        const m = matchValue;
        const matchValue_1 = filter((pool) => !isEmpty(LiveDraft_eligibleFor(room, m, pool)), historicalRegistry);
        if (isEmpty(matchValue_1)) {
            return room.PoolId;
        }
        else {
            const pools = matchValue_1;
            return item(LiveDraft_rng.Next1(length(pools)), pools).Id;
        }
    }
    else {
        return room.PoolId;
    }
}

/**
 * Referee rule: apply a pick if and only if it is that member's
 * turn, the player is unclaimed, and a legal slot exists. Advances
 * the turn and rolls the next wheel landing.
 */
export function LiveDraft_applyPick(room, memberKey, playerId) {
    let player;
    const matchValue = LiveDraft_memberOnTurn(room);
    let matchResult, m_1;
    if (matchValue != null) {
        if (matchValue.Key === memberKey) {
            matchResult = 0;
            m_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_1 = FSharpMap__TryFind(playerById, playerId);
            let matchResult_1, player_1;
            if (matchValue_1 != null) {
                if ((player = matchValue_1, !contains(playerId, room.TakenIds, {
                    Equals: (x, y) => (x === y),
                    GetHashCode: stringHash,
                }))) {
                    matchResult_1 = 0;
                    player_1 = matchValue_1;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const matchValue_2 = LiveDraft_autoSlotFor(m_1, player_1);
                    if (matchValue_2 == null) {
                        return undefined;
                    }
                    else {
                        const slot = matchValue_2;
                        const advanced = new LiveDraft_Room(room.Code, room.HostKey, map((x_1) => {
                            if (x_1.Key === m_1.Key) {
                                return new LiveDraft_Member(x_1.Key, x_1.Handle, append(x_1.Roster, singleton([slot, playerId])));
                            }
                            else {
                                return x_1;
                            }
                        }, room.Members), room.Started, room.TurnIndex + 1, room.PoolId, cons(playerId, room.TakenIds), room.Seed, room.TurnDeadline);
                        return new LiveDraft_Room(advanced.Code, advanced.HostKey, advanced.Members, advanced.Started, advanced.TurnIndex, LiveDraft_freshPoolId(advanced), advanced.TakenIds, advanced.Seed, LiveDraft_draftDone(advanced) ? 0 : ((Date.now()) + (LiveDraft_turnSeconds * 1000)));
                    }
                }
                default:
                    return undefined;
            }
        }
        default:
            return undefined;
    }
}

/**
 * Host's AFK skip: the best-rated legal pick for whoever is on turn.
 */
export function LiveDraft_bestAutoPick(room, pool) {
    return bind((m) => map_2((p_1) => p_1.Id, tryHead(sortByDescending((p) => p.Ovr, LiveDraft_eligibleFor(room, m, pool), {
        Compare: comparePrimitives,
    }))), LiveDraft_memberOnTurn(room));
}

/**
 * A room's shared season seed, rolled by the host at tip-off.
 */
export function LiveDraft_makeSeed() {
    return LiveDraft_rng.Next2(1, 2000000000);
}

function LiveDraft_lcgNext(state) {
    return ((state * 9301) + 49297) % 233280;
}

/**
 * One member's 82-game season from the shared seed. Every client
 * computes the same record — reported results can't be forged.
 */
export function LiveDraft_seededSeason(roomSeed, memberIndex, m) {
    const chance = Engine_calculateWinProbability(Engine_calculateTeamRatings(LiveDraft_rosterMap(m)), "Balanced");
    let state = (roomSeed + (memberIndex * 7919)) + 1;
    let wins = 0;
    for (let forLoopVar = 1; forLoopVar <= 82; forLoopVar++) {
        state = LiveDraft_lcgNext(state);
        if ((state / 233280) < chance) {
            wins = ((wins + 1) | 0);
        }
    }
    return [wins, 82 - wins];
}

/**
 * The final standings, computed identically on every client the
 * moment the last pick lands. No reporting phase, no waiting.
 */
export function LiveDraft_finalTable(room) {
    return sortByDescending((tupledArg) => tupledArg[1], mapIndexed((index, m) => {
        const patternInput = LiveDraft_seededSeason(room.Seed, index, m);
        return [m, patternInput[0], patternInput[1]];
    }, room.Members), {
        Compare: comparePrimitives,
    });
}

export function LiveDraft_encode(room) {
    return {
        code: room.Code,
        host: room.HostKey,
        members: toArray_1(map((m) => ({
            key: m.Key,
            handle: m.Handle,
            roster: toArray_1(map((tupledArg) => [tupledArg[0], tupledArg[1]], m.Roster)),
        }), room.Members)),
        started: room.Started,
        turn: room.TurnIndex,
        pool: room.PoolId,
        taken: toArray_1(room.TakenIds),
        seed: room.Seed,
        deadline: room.TurnDeadline,
    };
}

/**
 * Total: a malformed snapshot decodes to None rather than crashing
 * the room.
 */
export function LiveDraft_decode(o) {
    try {
        const memberArr = o.members;
        return new LiveDraft_Room(o.code, o.host, ofArray(map_3((m) => {
            const rosterArr = m.roster;
            return new LiveDraft_Member(m.key, m.handle, ofArray(map_3((pair) => [item_1(0, pair), item_1(1, pair)], rosterArr)));
        }, memberArr)), o.started, o.turn, o.pool, ofArray(o.taken), o.seed, o.deadline);
    }
    catch (matchValue) {
        return undefined;
    }
}

/**
 * Fold a finished season into the profile.
 * 82-0  -> extend the streak, raise the high-water mark, unlock
 * the Immortality Trophy (idempotent — never duplicated)
 * any L -> streak resets to 0; trophies already earned are kept
 * A One-Franchise run additionally grades the win total against the
 * locked franchise's real record book, and EVERY cabinet accolade
 * is judged here from the season's facts — each one has a live,
 * reachable condition; nothing in the cabinet is decorative.
 */
export function Profile_recordSeason(franchiseLock, facts, profile) {
    let franchise_2, franchise_3, franchiseKeys;
    const wins = facts.Wins | 0;
    const losses = facts.Losses | 0;
    const addTrophy = (trophy, trophies) => {
        if (contains(trophy, trophies, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        })) {
            return trophies;
        }
        else {
            return cons(trophy, trophies);
        }
    };
    let withStreak;
    if ((losses === 0) && (wins === 82)) {
        const streak = (profile.CurrentStreak + 1) | 0;
        withStreak = (new UserProfile(profile.IsSignedIn, profile.UserId, profile.Email, streak, max(profile.HighestStreak, streak), addTrophy(immortalityTrophy, profile.Trophies)));
    }
    else {
        withStreak = (new UserProfile(profile.IsSignedIn, profile.UserId, profile.Email, 0, profile.HighestStreak, profile.Trophies));
    }
    const withFranchise = (franchiseLock != null) ? ((wins > franchiseLock.BestWins) ? ((franchise_2 = franchiseLock, new UserProfile(withStreak.IsSignedIn, withStreak.UserId, withStreak.Email, withStreak.CurrentStreak, withStreak.HighestStreak, addTrophy(franchiseRecordBreakerTrophy, withStreak.Trophies)))) : ((wins < franchiseLock.WorstWins) ? ((franchise_3 = franchiseLock, new UserProfile(withStreak.IsSignedIn, withStreak.UserId, withStreak.Email, withStreak.CurrentStreak, withStreak.HighestStreak, addTrophy(franchiseWorstEverTrophy, withStreak.Trophies)))) : withStreak)) : withStreak;
    const players = map((tuple) => tuple[1], toList(facts.Roster));
    const starters = filter((tupledArg) => !contains(tupledArg[0], benchSlots, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    }), toList(facts.Roster));
    const starterPlayers = map((tuple_1) => tuple_1[1], starters);
    const poolIds = map(Engine_franchiseOfPlayer, players);
    const isChampion = (facts.Rank === 1) ? true : ((losses === 0) && (wins === 82));
    return fold((acc, tupledArg_2) => {
        if (tupledArg_2[1]) {
            return new UserProfile(acc.IsSignedIn, acc.UserId, acc.Email, acc.CurrentStreak, acc.HighestStreak, addTrophy(tupledArg_2[0], acc.Trophies));
        }
        else {
            return acc;
        }
    }, withFranchise, ofArray([["Championship Ring", isChampion], ["Cup Champions", facts.DecemberSwept], ["The Triple Crown", (facts.DecemberSwept && isChampion) && (wins >= 60)], ["73-9 Golden Standard", wins >= 74], ["Playoff Bound", wins >= 50], ["Modern Dynasty", isChampion && defaultArg(map_2(wonChampionship, tryHead(facts.PreviousRuns)), false)], ["The Hard Way", ((facts.Rank >= 1) && (facts.Rank <= 4)) && (facts.TeamOvr <= 82)], ["Triple-Digit Firepower", facts.TeamPpg >= 115], ["The \'04 Pistons Matrix", (facts.OppPpg > 0) && (facts.OppPpg < 105)], ["Defensive Lockdown", Engine_defensiveBadgeCount(facts.Roster) >= 3], ["The \'12 Bobcats Faint", wins < 12], ["The Dream Team Effect", !isEmpty(starterPlayers) && forAll((p) => (p.Ovr >= 95), starterPlayers)], ["Twin Towers Alliance", isChampion && (length(filter((p_1) => {
        if (p_1.Ovr >= 90) {
            if (p_1.Pos === "PF") {
                return true;
            }
            else {
                return p_1.Pos === "C";
            }
        }
        else {
            return false;
        }
    }, players)) >= 2)], ["Out of Position Matrix", length(filter((tupledArg_1) => (positionOfSlot(tupledArg_1[0]) !== tupledArg_1[1].Pos), starters)) >= 3], ["Franchise Lifers", !isEmpty(poolIds) && ((franchiseKeys = map((id) => map_2((f) => f.Key, franchiseOfPool(id)), poolIds), forAll((option_3) => (option_3 != null), franchiseKeys) && (length(List_distinct(franchiseKeys, {
        Equals: equals,
        GetHashCode: structuralHash,
    })) === 1)))], ["The Veteran Guild", (wins >= 50) && (length(filter((id_1) => {
        const year = poolSeasonYear(id_1) | 0;
        if (year > 0) {
            return year <= 1999;
        }
        else {
            return false;
        }
    }, poolIds)) >= 3)], ["Global Domination", !isEmpty(starterPlayers) && forAll((p_3) => (nationalityOf(p_3.Id) !== "USA"), starterPlayers)], ["Multi-Era Continuum", length(List_distinct(filter((decade) => (decade > 0), map((id_2) => ~~(poolSeasonYear(id_2) / 10), poolIds)), {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: numberHash,
    })) >= 5], ["All-Era Cult Heroes", length(filter((p_4) => (p_4.Ovr < 78), players)) >= 3], ["Wire-to-Wire Dominance", isChampion && facts.NeverBelowFiveHundred], ["Hardwood Homegrown", !isEmpty(starterPlayers) && (length(List_distinct(map(Engine_franchiseOfPlayer, starterPlayers), {
        Equals: (x_4, y_4) => (x_4 === y_4),
        GetHashCode: stringHash,
    })) === 1)], ["Draft Lottery Sweepstakes", facts.Rank >= 28], ["The Iron Man Unit", !facts.DeadlineTouchedStarters]]));
}

const Store_profileKey = "eightytwo-zero.profile";

const Store_runsKey = "eightytwo-zero.runs";

const Store_emailOptKey = "eightytwo-zero.email-opt";

export function Store_loadEmailOptChoice() {
    try {
        const matchValue = window.localStorage.getItem(Store_emailOptKey);
        let matchResult;
        if (matchValue === defaultOf()) {
            matchResult = 0;
        }
        else if (matchValue === "") {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return undefined;
            default:
                return matchValue;
        }
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function Store_saveEmailOptChoice(choice) {
    try {
        window.localStorage.setItem(Store_emailOptKey, choice);
    }
    catch (matchValue) {
    }
}

export function Store_saveProfile(profile) {
    try {
        let value_1;
        const value = {
            isSignedIn: profile.IsSignedIn,
            userId: defaultArg(profile.UserId, ""),
            email: defaultArg(profile.Email, ""),
            currentStreak: profile.CurrentStreak,
            highestStreak: profile.HighestStreak,
            trophies: toArray_1(profile.Trophies),
        };
        value_1 = (JSON.stringify(value));
        window.localStorage.setItem(Store_profileKey, value_1);
    }
    catch (matchValue) {
    }
}

export function Store_loadProfile() {
    try {
        const raw = window.localStorage.getItem(Store_profileKey);
        if (raw == null) {
            return signedOutProfile;
        }
        else {
            const o = JSON.parse(raw);
            const signedIn = o.isSignedIn;
            const userId = o.userId;
            const email = o.email;
            const current = o.currentStreak | 0;
            const highest = o.highestStreak | 0;
            const trophies = o.trophies;
            return new UserProfile(signedIn, (userId === "") ? undefined : userId, (email === "") ? undefined : email, current, highest, (trophies == null) ? empty_1() : ofArray(trophies));
        }
    }
    catch (matchValue) {
        return signedOutProfile;
    }
}

export function Store_saveRuns(runs) {
    try {
        let value_1;
        const value = toArray_1(map((r) => ({
            date: r.Date,
            team: r.TeamName,
            franchiseId: r.FranchiseId,
            ovr: r.Ovr,
            record: r.Record,
            wins: r.Wins,
            losses: r.Losses,
            rank: r.Rank,
            difficulty: r.Difficulty,
            ratingMode: r.RatingMode,
            blueprint: r.Blueprint,
            ppg: r.PointsPerGame,
            perfect: r.Complete82_0,
        }), runs));
        value_1 = (JSON.stringify(value));
        window.localStorage.setItem(Store_runsKey, value_1);
    }
    catch (matchValue) {
    }
}

function Store_parseRecord(record) {
    const matchValue = split(record, ["-"], undefined, 0);
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) {
        const w = item_1(0, matchValue);
        const l = item_1(1, matchValue);
        let matchValue_1;
        let outArg = 0;
        matchValue_1 = [tryParse(w, 511, false, 32, new FSharpRef(() => outArg, (v) => {
            outArg = (v | 0);
        })), outArg];
        let matchValue_2;
        let outArg_1 = 0;
        matchValue_2 = [tryParse(l, 511, false, 32, new FSharpRef(() => outArg_1, (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1];
        let matchResult;
        if (matchValue_1[0]) {
            if (matchValue_2[0]) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return [matchValue_1[1], matchValue_2[1]];
            default:
                return [0, 0];
        }
    }
    else {
        return [0, 0];
    }
}

export function Store_loadRuns() {
    try {
        const raw = window.localStorage.getItem(Store_runsKey);
        return (raw == null) ? empty_1() : ofArray(map_3((o) => {
            const date = o.date;
            const team = o.team;
            const ovr = o.ovr | 0;
            const record = o.record;
            const perfect = o.perfect;
            const patternInput = Store_parseRecord(record);
            return new HistoricRun(date, team, typeof o.franchiseId === 'string' ? o.franchiseId : "", ovr, record, ~~(typeof o.wins === 'number' ? o.wins : patternInput[0]), ~~(typeof o.losses === 'number' ? o.losses : patternInput[1]), ~~(typeof o.rank === 'number' ? o.rank : 0), typeof o.ppg === 'number' ? o.ppg : 0, typeof o.difficulty === 'string' ? o.difficulty : "", typeof o.ratingMode === 'string' ? o.ratingMode : "", typeof o.blueprint === 'string' ? o.blueprint : "", perfect);
        }, JSON.parse(raw)));
    }
    catch (matchValue) {
        return empty_1();
    }
}

const Store_dailyKey = "eightytwo-zero.daily";

export function Store_saveDaily(progress) {
    try {
        let value_1;
        const value = {
            date: progress.Date,
            attempts: progress.AttemptsUsed,
            best: progress.BestScore,
            streak: progress.Streak,
        };
        value_1 = (JSON.stringify(value));
        window.localStorage.setItem(Store_dailyKey, value_1);
    }
    catch (matchValue) {
    }
}

export function Store_loadDaily() {
    try {
        const raw = window.localStorage.getItem(Store_dailyKey);
        if (raw == null) {
            return undefined;
        }
        else {
            const o = JSON.parse(raw);
            return new DailyProgress(o.date, o.attempts, o.best, o.streak);
        }
    }
    catch (matchValue) {
        return undefined;
    }
}

/**
 * Today's progress with day-rollover applied: a new day resets the
 * attempt count, and the streak survives only when the last played
 * day was yesterday.
 */
export function Store_dailyProgressToday() {
    const today = now();
    const dateKey = toString(today, "yyyy-MM-dd");
    const matchValue = Store_loadDaily();
    if (matchValue == null) {
        return new DailyProgress(dateKey, 0, 0, 0);
    }
    else if (matchValue.Date === dateKey) {
        const p_1 = matchValue;
        return p_1;
    }
    else {
        const p_2 = matchValue;
        return new DailyProgress(dateKey, 0, 0, (p_2.Date === toString(addDays(today, -1), "yyyy-MM-dd")) ? p_2.Streak : 0);
    }
}

const Store_consentKey = "eightytwo-zero.cookie-consent";

/**
 * Record that the preferences card was seen. Essential-only is the
 * only possible state, so the value is just an acknowledgement date.
 */
export function Store_saveConsentAcknowledged() {
    try {
        window.localStorage.setItem(Store_consentKey, toString(now(), "yyyy-MM-dd"));
    }
    catch (matchValue) {
    }
}

const Store_draftKey = "eightytwo-zero.draft";

function Store_playerToObj(player) {
    return {
        id: player.Id,
        name: player.Name,
        pos: player.Pos,
        ovr: player.Ovr,
        badge: player.Badge,
        statLine: player.StatLine,
    };
}

function Store_playerOfObj(o) {
    return new Player(o.id, o.name, o.pos, o.ovr, o.badge, o.statLine);
}

/**
 * Snapshot everything a resumed draft needs. Meta-progression is NOT
 * saved here — the profile store already owns it.
 */
export function Store_saveDraft(state) {
    let matchValue;
    try {
        let value_2;
        const value_1 = {
            roster: toArray_1(map((tupledArg) => ({
                slot: tupledArg[0],
                player: Store_playerToObj(tupledArg[1]),
            }), toList(state.Roster))),
            difficulty: (matchValue = state.Config.Difficulty, (matchValue.tag === 1) ? "Normal" : ((matchValue.tag === 2) ? "Hard" : "Easy")),
            ratingMode: (state.Config.RatingMode.tag === 1) ? "Prime" : "Season",
            rerolls: state.RerollsAvailable,
            drawn: toArray_1(state.DrawnFranchiseIds),
            knowledge: state.IsKnowledgeMode,
            draftMode: state.DraftModeSetting,
            eraStart: state.StartEraIndex,
            eraEnd: state.EndEraIndex,
            system: state.SystemArchetype,
            coaches: state.HeadCoachesEnabled,
            playoffs: state.PlayoffsEnabled,
            deadline: state.TradeDeadlineEnabled,
            luck: state.SeasonLuck,
            franchiseKey: defaultArg(map_2((f) => f.Key, state.FranchiseLock), ""),
            blueprint: state.Blueprint.Name,
        };
        value_2 = (JSON.stringify(value_1));
        window.localStorage.setItem(Store_draftKey, value_2);
    }
    catch (matchValue_2) {
    }
}

export function Store_clearDraft() {
    try {
        window.localStorage.removeItem(Store_draftKey);
    }
    catch (matchValue) {
    }
}

/**
 * Cheap existence probe for the landing page button.
 */
export function Store_hasDraft() {
    try {
        return !((window.localStorage.getItem(Store_draftKey)) == null);
    }
    catch (matchValue) {
        return false;
    }
}

/**
 * Rebuild a resumable state from the snapshot; the caller decides
 * which phase to drop back into. None when nothing (valid) is saved.
 */
export function Store_loadDraft() {
    let Config, RerollsAvailable, DrawnFranchiseIds, IsKnowledgeMode, DraftModeSetting, StartEraIndex, EndEraIndex, SystemArchetype, HeadCoachesEnabled, PlayoffsEnabled, TradeDeadlineEnabled, SeasonLuck;
    try {
        const raw = window.localStorage.getItem(Store_draftKey);
        if (raw == null) {
            return undefined;
        }
        else {
            const o = JSON.parse(raw);
            const roster = ofArray_1(map_3((entry) => [entry.slot, Store_playerOfObj(entry.player)], o.roster), {
                Compare: comparePrimitives,
            });
            let difficulty;
            const matchValue = o.difficulty;
            difficulty = ((matchValue === "Easy") ? (new Difficulty(0, [])) : ((matchValue === "Hard") ? (new Difficulty(2, [])) : (new Difficulty(1, []))));
            const ratingMode = (o.ratingMode === "Prime") ? (new RatingMode(1, [])) : (new RatingMode(0, []));
            const drawn = o.drawn;
            const franchiseKey = o.franchiseKey;
            const blueprintName = o.blueprint;
            return (Config = (new DraftConfig(difficulty, ratingMode)), (RerollsAvailable = (o.rerolls | 0), (DrawnFranchiseIds = ofArray(drawn), (IsKnowledgeMode = o.knowledge, (DraftModeSetting = o.draftMode, (StartEraIndex = (clampSeasonIndex(o.eraStart) | 0), (EndEraIndex = (clampSeasonIndex(o.eraEnd) | 0), (SystemArchetype = o.system, (HeadCoachesEnabled = o.coaches, (PlayoffsEnabled = o.playoffs, (TradeDeadlineEnabled = o.deadline, (SeasonLuck = (typeof o.luck === 'number' ? o.luck : 0), new GameState(initialState.Phase, roster, SystemArchetype, Config, RerollsAvailable, DrawnFranchiseIds, tryFind((f) => (f.Key === franchiseKey), franchises), defaultArg(tryFind((b) => (b.Name === blueprintName), blueprints), defaultBlueprint), initialState.DailyRun, IsKnowledgeMode, DraftModeSetting, StartEraIndex, EndEraIndex, HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, PlayoffsEnabled, TradeDeadlineEnabled, SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, initialState.Profile, initialState.UserRuns)))))))))))));
        }
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export class Store_LiveTicket extends Record {
    constructor(Code, Key, Handle, IsHost, SnapshotJson) {
        super();
        this.Code = Code;
        this.Key = Key;
        this.Handle = Handle;
        this.IsHost = IsHost;
        this.SnapshotJson = SnapshotJson;
    }
}

export function Store_LiveTicket_$reflection() {
    return record_type("App.Store.LiveTicket", [], Store_LiveTicket, () => [["Code", string_type], ["Key", string_type], ["Handle", string_type], ["IsHost", bool_type], ["SnapshotJson", string_type]]);
}

const Store_liveTicketKey = "eightytwo-zero.liveroom";

export function Store_saveLiveTicket(ticket) {
    try {
        let value_1;
        const value = {
            code: ticket.Code,
            key: ticket.Key,
            handle: ticket.Handle,
            host: ticket.IsHost,
            snapshot: ticket.SnapshotJson,
        };
        value_1 = (JSON.stringify(value));
        window.sessionStorage.setItem(Store_liveTicketKey, value_1);
    }
    catch (matchValue) {
    }
}

export function Store_loadLiveTicket() {
    try {
        const raw = window.sessionStorage.getItem(Store_liveTicketKey);
        if (raw == null) {
            return undefined;
        }
        else {
            const o = JSON.parse(raw);
            return new Store_LiveTicket(o.code, o.key, o.handle, o.host, typeof o.snapshot === 'string' ? o.snapshot : "");
        }
    }
    catch (matchValue) {
        return undefined;
    }
}

export function Store_clearLiveTicket() {
    try {
        window.sessionStorage.removeItem(Store_liveTicketKey);
    }
    catch (matchValue) {
    }
}

/**
 * Host-only: refresh the stored snapshot with the latest room.
 */
export function Store_updateLiveSnapshot(encodedRoom) {
    const matchValue = Store_loadLiveTicket();
    if (matchValue == null) {
    }
    else {
        const ticket = matchValue;
        Store_saveLiveTicket(new Store_LiveTicket(ticket.Code, ticket.Key, ticket.Handle, ticket.IsHost, JSON.stringify(encodedRoom)));
    }
}

/**
 * Parse a stored snapshot back into the wire shape.
 */
export function Store_parseLiveSnapshot(json) {
    try {
        return (json === "") ? undefined : some(JSON.parse(json));
    }
    catch (matchValue) {
        return undefined;
    }
}

/**
 * Mock social sign-in. No network, no OAuth redirect — it mints a
 * deterministic local identity so the signed-in UI is exercisable.
 * NOT real authentication; see the module header.
 */
export function Store_signIn(provider, profile) {
    const key = provider.toLocaleLowerCase();
    return new UserProfile(true, key + "-local-user", key + ".player@bannerseason.local", profile.CurrentStreak, profile.HighestStreak, profile.Trophies);
}

/**
 * Streaks and trophies are local progress, so they deliberately
 * survive a sign-out; only the identity is cleared.
 */
export function Store_signOut(profile) {
    return new UserProfile(false, undefined, undefined, profile.CurrentStreak, profile.HighestStreak, profile.Trophies);
}

export class Backend_GlobalRun extends Record {
    constructor(Handle, TeamName, FranchiseId, Ovr, Wins, Losses, PointsPerGame, Difficulty, RatingMode, Blueprint, Perfect) {
        super();
        this.Handle = Handle;
        this.TeamName = TeamName;
        this.FranchiseId = FranchiseId;
        this.Ovr = (Ovr | 0);
        this.Wins = (Wins | 0);
        this.Losses = (Losses | 0);
        this.PointsPerGame = PointsPerGame;
        this.Difficulty = Difficulty;
        this.RatingMode = RatingMode;
        this.Blueprint = Blueprint;
        this.Perfect = Perfect;
    }
}

export function Backend_GlobalRun_$reflection() {
    return record_type("App.Backend.GlobalRun", [], Backend_GlobalRun, () => [["Handle", string_type], ["TeamName", string_type], ["FranchiseId", string_type], ["Ovr", int32_type], ["Wins", int32_type], ["Losses", int32_type], ["PointsPerGame", float64_type], ["Difficulty", string_type], ["RatingMode", string_type], ["Blueprint", string_type], ["Perfect", bool_type]]);
}

export class Backend_BoardState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BoardIdle", "BoardLoading", "BoardLoaded", "BoardFailed"];
    }
}

export function Backend_BoardState_$reflection() {
    return union_type("App.Backend.BoardState", [], Backend_BoardState, () => [[], [], [["Item", list_type(Backend_GlobalRun_$reflection())]], [["Item", string_type]]]);
}

export class Backend_SubmitStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SubmitIdle", "SubmitSending", "SubmitDone", "SubmitFailed"];
    }
}

export function Backend_SubmitStatus_$reflection() {
    return union_type("App.Backend.SubmitStatus", [], Backend_SubmitStatus, () => [[], [], [["Item", string_type]], [["Item", string_type]]]);
}

function Backend_errMessage(e) {
    const m = (e && e.message) ? String(e.message) : 'request failed';
    if (m.indexOf("Failed to fetch") >= 0) {
        return "The leaderboard server could not be reached — check your connection.";
    }
    else {
        return m;
    }
}

export const Backend_createClient = createClient;

const Backend_client = (() => {
    const matchValue = ofNullable((typeof (import.meta.env.VITE_SUPABASE_URL) === 'string' && (import.meta.env.VITE_SUPABASE_URL).length > 20 && (import.meta.env.VITE_SUPABASE_URL).indexOf('YOUR-') === -1) ? (import.meta.env.VITE_SUPABASE_URL) : null);
    const matchValue_1 = ofNullable((typeof (import.meta.env.VITE_SUPABASE_ANON_KEY) === 'string' && (import.meta.env.VITE_SUPABASE_ANON_KEY).length > 20 && (import.meta.env.VITE_SUPABASE_ANON_KEY).indexOf('YOUR-') === -1) ? (import.meta.env.VITE_SUPABASE_ANON_KEY) : null);
    let matchResult, key, url;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            key = matchValue_1;
            url = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            try {
                return some(Backend_createClient(url, key));
            }
            catch (matchValue_3) {
                return undefined;
            }
        default:
            return undefined;
    }
})();

export const Backend_isConfigured = Backend_client != null;

/**
 * Same 3-16 alphanumeric-or-underscore rule the database enforces,
 * checked client-side so the Submit button can gate on it.
 */
export function Backend_isValidHandle(h) {
    return isMatch(/^[A-Za-z0-9_]{3,16}$/gu, h);
}

const Backend_handleKey = "eightytwo-zero.handle";

export function Backend_savedHandle() {
    try {
        const matchValue = window.localStorage.getItem(Backend_handleKey);
        let matchResult;
        if (matchValue === defaultOf()) {
            matchResult = 0;
        }
        else if (matchValue === "") {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return undefined;
            default:
                return matchValue;
        }
    }
    catch (matchValue_1) {
        return undefined;
    }
}

function Backend_cacheHandle(h) {
    try {
        window.localStorage.setItem(Backend_handleKey, h);
    }
    catch (matchValue) {
    }
}

export function Backend_signInWithProvider(provider, onError) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const payload = {
            provider: provider.toLocaleLowerCase(),
            options: {
                redirectTo: window.location.origin,
                skipBrowserRedirect: true,
            },
        };
        const follow = (res) => {
            const err = res.error;
            const url = res.data.url;
            if (!(err == null)) {
                onError(Backend_errMessage(err));
            }
            else if (url == null) {
                onError("The sign-in redirect could not be prepared.");
            }
            else {
                (fetch(url, { redirect: 'manual' })).then(((probe) => {
                    if (probe.type === 'opaqueredirect' || probe.ok) {
                        window.location.href = url;
                    }
                    else {
                        onError(`${provider} sign-in isn't switched on for this project yet — see SUPABASE-SETUP.md §5.`);
                    }
                }), ((_arg) => {
                    window.location.href = url;
                }));
            }
        };
        const plainSignIn = () => {
            (c.auth.signInWithOAuth(payload)).then(follow, ((e) => {
                onError(Backend_errMessage(e));
            }));
        };
        (c.auth.getSession()).then(((sess) => {
            if (sess.data.session == null) {
                plainSignIn();
            }
            else {
                (c.auth.linkIdentity(payload)).then(((res_1) => {
                    if (res_1.error == null) {
                        follow(res_1);
                    }
                    else {
                        plainSignIn();
                    }
                }), ((_arg_1) => {
                    plainSignIn();
                }));
            }
        }), ((e_1) => {
            onError(Backend_errMessage(e_1));
        }));
    }
    else {
        onError("Sign-in isn\'t connected on this build.");
    }
}

/**
 * The real (non-anonymous) identity on the current session, if any.
 * Fires None for signed-out AND anonymous-leaderboard sessions, so
 * the profile UI never mistakes a wheel-spinning ghost for a user.
 */
export function Backend_fetchAuthIdentity(onIdentity) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        (c.auth.getSession()).then(((sess) => {
            const s = sess.data.session;
            if (s == null) {
                onIdentity(undefined);
            }
            else {
                const user = s.user;
                if (user.is_anonymous) {
                    onIdentity(undefined);
                }
                else {
                    const email = user.email;
                    onIdentity([user.id, (email == null) ? undefined : email]);
                }
            }
        }), ((_arg) => {
            onIdentity(undefined);
        }));
    }
    else {
        onIdentity(undefined);
    }
}

/**
 * End the Supabase session, then report back so the caller can
 * clear the local flag. The next leaderboard interaction mints a
 * fresh anonymous identity.
 */
export function Backend_signOutAuth(onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        (c.auth.signOut()).then(((_arg) => {
            onDone();
        }), ((_arg_1) => {
            onDone();
        }));
    }
    else {
        onDone();
    }
}

/**
 * Fire-and-forget cloud backup of the signed-in profile. A missing
 * table or an RLS refusal degrades to silence — the local copy
 * stays the source of truth (see SUPABASE-SETUP.md for the table).
 */
export function Backend_saveProfileCloud(profile) {
    let uid, c;
    const matchValue = profile.UserId;
    let matchResult, c_1, uid_1;
    if (Backend_client != null) {
        if (matchValue != null) {
            if ((uid = matchValue, (c = value_4241(Backend_client), profile.IsSignedIn))) {
                matchResult = 0;
                c_1 = value_4241(Backend_client);
                uid_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const payload = {
                id: uid_1,
                current_streak: profile.CurrentStreak,
                highest_streak: profile.HighestStreak,
                trophies: toArray_1(profile.Trophies),
            };
            ((c_1.from("player_profiles")).upsert(payload)).then(((_arg) => {
            }), ((_arg_1) => {
            }));
            break;
        }
        case 1: {
            break;
        }
    }
}

/**
 * Record the marketing opt-in on the signed-in profile row, making
 * the mailing list a real, queryable thing (email_opt_in column —
 * SUPABASE-SETUP.md §5). Signed-out sessions, a missing column, or
 * a not-yet-created row all degrade to silence; the local choice
 * still stops the card from nagging.
 */
export function Backend_setEmailOptInCloud(optIn) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        (c.auth.getSession()).then(((sess) => {
            const s = sess.data.session;
            if (!(s == null)) {
                const uid = s.user.id;
                (((c.from("player_profiles")).update({
                    email_opt_in: optIn,
                })).eq("id", uid)).then(((_arg) => {
                }), ((_arg_1) => {
                }));
            }
        }), ((_arg_2) => {
        }));
    }
}

/**
 * The cloud copy of a signed-in profile, or None when there is
 * none (first sign-in, missing table, network refusal).
 */
export function Backend_fetchProfileCloud(uid, onLoaded) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        ((((c.from("player_profiles")).select("current_streak,highest_streak,trophies")).eq("id", uid)).maybeSingle()).then(((res) => {
            const row = res.data;
            if (row == null) {
                onLoaded(undefined);
            }
            else {
                const trophies = row.trophies;
                onLoaded([row.current_streak, row.highest_streak, (trophies == null) ? empty_1() : ofArray(trophies)]);
            }
        }), ((_arg) => {
            onLoaded(undefined);
        }));
    }
    else {
        onLoaded(undefined);
    }
}

function Backend_ensureSession(c) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((c.auth.getSession()).then((_arg) => {
        const existing = _arg.data.session;
        return !(existing == null) ? (Promise.resolve(new FSharpResult$2(0, [existing.user.id]))) : ((c.auth.signInAnonymously()).then((_arg_1) => {
            const signed = _arg_1;
            const err = signed.error;
            return (err == null) ? (Promise.resolve(new FSharpResult$2(0, [signed.data.user.id]))) : (Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(err)])));
        }));
    }))));
}

function Backend_ensureProfile(c, uid, handle) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((((c.from("profiles")).select("handle")).eq("id", uid)).maybeSingle()).then((_arg) => {
        const existing = _arg;
        const readErr = existing.error;
        if (!(readErr == null)) {
            return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(readErr)]));
        }
        else {
            const mine = existing.data;
            return ((mine == null) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((c.from("profiles")).insert({
                id: uid,
                handle: handle,
            })).then((_arg_1) => (Promise.resolve(_arg_1.error)))))) : ((mine.handle.toLocaleLowerCase() === handle.toLocaleLowerCase()) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(defaultOf())))) : PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((((c.from("profiles")).update({
                handle: handle,
            })).eq("id", uid)).then((_arg_2) => (Promise.resolve(_arg_2.error)))))))).then((_arg_3) => {
                const writeErr = _arg_3;
                return (writeErr == null) ? (Promise.resolve(new FSharpResult$2(0, [undefined]))) : ((!!(writeErr && writeErr.code === '23505')) ? (Promise.resolve(new FSharpResult$2(1, ["That handle is already taken."]))) : (Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(writeErr)]))));
            });
        }
    }))));
}

/**
 * Post one archived season to the global board. Chains session ->
 * handle claim -> insert, reporting each failure in the player's
 * terms. onDone always fires exactly once, on the happy and every
 * sad path, so the UI can never wedge in "Posting…".
 */
export function Backend_submitRun(handle, run, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Backend_ensureSession(c).then((_arg) => {
            if (_arg.tag === 0) {
                const uid = _arg.fields[0];
                return Backend_ensureProfile(c, uid, handle).then((_arg_1) => {
                    if (_arg_1.tag === 0) {
                        const payload = {
                            user_id: uid,
                            team_name: run.TeamName,
                            franchise_id: run.FranchiseId,
                            ovr: run.Ovr,
                            wins: run.Wins,
                            losses: run.Losses,
                            rank: run.Rank,
                            ppg: run.PointsPerGame,
                            difficulty: run.Difficulty,
                            rating_mode: run.RatingMode,
                            blueprint: run.Blueprint,
                            perfect: run.Complete82_0,
                        };
                        return ((c.from("runs")).insert(payload)).then((_arg_2) => {
                            const err = _arg_2.error;
                            if (err == null) {
                                Backend_cacheHandle(handle);
                                return Promise.resolve(new Backend_SubmitStatus(2, [handle]));
                            }
                            else {
                                return Promise.resolve(new Backend_SubmitStatus(3, [Backend_errMessage(err)]));
                            }
                        });
                    }
                    else {
                        return Promise.resolve(new Backend_SubmitStatus(3, [_arg_1.fields[0]]));
                    }
                });
            }
            else {
                return Promise.resolve(new Backend_SubmitStatus(3, [_arg.fields[0]]));
            }
        }))));
        work.then(onDone, ((_arg_3) => {
            onDone(new Backend_SubmitStatus(3, ["Couldn\'t reach the leaderboard server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new Backend_SubmitStatus(3, ["The backend is not configured on this build."]));
    }
}

/**
 * Top-50 global runs, best-first, optionally restricted to one
 * franchise's pool ids. Reads are public under RLS — no session.
 */
export function Backend_fetchGlobal(poolIds, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const query = (c.from("runs")).select("team_name,franchise_id,ovr,wins,losses,ppg,difficulty,rating_mode,blueprint,perfect,profiles(handle)");
            let filtered;
            if (poolIds == null) {
                filtered = query;
            }
            else {
                const ids = poolIds;
                filtered = (query.filter("franchise_id", "in", (("(" + join(",", ids)) + ")")));
            }
            return (((filtered.order("wins", {
                ascending: false,
            })).order("ppg", {
                ascending: false,
            })).limit(50)).then((_arg) => {
                const res = _arg;
                const err = res.error;
                if (!(err == null)) {
                    return Promise.resolve(new Backend_BoardState(3, [Backend_errMessage(err)]));
                }
                else {
                    const mapped = ofArray(map_3((o) => {
                        const joined = o.profiles;
                        return new Backend_GlobalRun((joined == null) ? "anonymous" : joined.handle, o.team_name, o.franchise_id, o.ovr, o.wins, o.losses, o.ppg, o.difficulty, o.rating_mode, o.blueprint, o.perfect);
                    }, res.data));
                    return Promise.resolve(new Backend_BoardState(2, [mapped]));
                }
            });
        }));
        work.then(onDone, ((_arg_1) => {
            onDone(new Backend_BoardState(3, ["The leaderboard server could not be reached — check your connection."]));
        }));
    }
    else {
        onDone(new Backend_BoardState(3, ["The backend is not configured on this build."]));
    }
}

export class Backend_WaitlistStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["WaitlistIdle", "WaitlistSending", "WaitlistDone", "WaitlistFailed"];
    }
}

export function Backend_WaitlistStatus_$reflection() {
    return union_type("App.Backend.WaitlistStatus", [], Backend_WaitlistStatus, () => [[], [], [], [["Item", string_type]]]);
}

/**
 * Same shape the waitlist table's CHECK constraint enforces.
 */
export function Backend_isValidEmail(e) {
    return isMatch(/^[^@\s]+@[^@\s]+\.[^@\s]+$/gu, e);
}

/**
 * Add an email to the Discord waitlist. The table is write-only
 * from the client (no select policy), and no session is needed —
 * the anon role may insert. A duplicate signup counts as success:
 * that person IS on the list.
 */
export function Backend_joinDiscordWaitlist(email, wantsNews, wantsMod, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const payload = {
                email: email.trim().toLocaleLowerCase(),
                wants_news: wantsNews,
                wants_mod: wantsMod,
            };
            return ((c.from("discord_waitlist")).insert(payload)).then((_arg) => {
                const err = _arg.error;
                return (err == null) ? (Promise.resolve(new Backend_WaitlistStatus(2, []))) : ((!!(err && err.code === '23505')) ? (Promise.resolve(new Backend_WaitlistStatus(2, []))) : (Promise.resolve(new Backend_WaitlistStatus(3, [Backend_errMessage(err)]))));
            });
        }));
        work.then(onDone, ((_arg_1) => {
            onDone(new Backend_WaitlistStatus(3, ["Could not reach the signup server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new Backend_WaitlistStatus(3, ["The backend is not configured on this build."]));
    }
}

let Backend_presenceChannel = undefined;

/**
 * Join the presence channel once per session. onCount fires on
 * every roster change (joins, leaves, playing-flag flips).
 * Unconfigured builds simply never call onCount.
 */
export function Backend_startPresence(isPlaying, onCount) {
    const Backend_presenceChannel_1 = Backend_presenceChannel;
    let matchResult, c;
    if (Backend_client != null) {
        if (Backend_presenceChannel_1 == null) {
            matchResult = 1;
            c = value_4241(Backend_client);
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            break;
        }
        case 1: {
            try {
                const ch = c.channel("live-now");
                ch.on("presence", {
                    event: "sync",
                }, ((_arg) => {
                    onCount(Object.values(ch.presenceState()).filter(function(metas){ return metas.length > 0 && metas[metas.length - 1].playing === true; }).length);
                }));
                ch.subscribe((status) => {
                    if (status === "SUBSCRIBED") {
                        ch.track({
                            playing: isPlaying,
                        });
                    }
                });
                Backend_presenceChannel = some(ch);
            }
            catch (matchValue_1) {
            }
            break;
        }
    }
}

/**
 * Re-track with the new flag whenever the player's phase moves
 * between the menu pages and an actual run.
 */
export function Backend_setPresencePlaying(isPlaying) {
    if (Backend_presenceChannel == null) {
    }
    else {
        const ch = value_4241(Backend_presenceChannel);
        try {
            ch.track({
                playing: isPlaying,
            });
        }
        catch (matchValue) {
        }
    }
}

export class Backend_LeagueInfo extends Record {
    constructor(Id, Code, Name) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.Name = Name;
    }
}

export function Backend_LeagueInfo_$reflection() {
    return record_type("App.Backend.LeagueInfo", [], Backend_LeagueInfo, () => [["Id", string_type], ["Code", string_type], ["Name", string_type]]);
}

export class Backend_LeagueStanding extends Record {
    constructor(Handle, TeamName, Wins, Losses, Ovr, HasRun) {
        super();
        this.Handle = Handle;
        this.TeamName = TeamName;
        this.Wins = (Wins | 0);
        this.Losses = (Losses | 0);
        this.Ovr = (Ovr | 0);
        this.HasRun = HasRun;
    }
}

export function Backend_LeagueStanding_$reflection() {
    return record_type("App.Backend.LeagueStanding", [], Backend_LeagueStanding, () => [["Handle", string_type], ["TeamName", string_type], ["Wins", int32_type], ["Losses", int32_type], ["Ovr", int32_type], ["HasRun", bool_type]]);
}

function Backend_ensureMembership(c, uid, leagueId) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((c.from("league_members")).insert({
        league_id: leagueId,
        user_id: uid,
    })).then((_arg) => {
        const err = _arg.error;
        return (err == null) ? (Promise.resolve(new FSharpResult$2(0, [undefined]))) : ((!!(err && err.code === '23505')) ? (Promise.resolve(new FSharpResult$2(0, [undefined]))) : (Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(err)]))));
    }))));
}

/**
 * Create a league and join it as its first member. The join code
 * comes back from the database default.
 */
export function Backend_createLeague(name, handle, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Backend_ensureSession(c).then((_arg) => {
            if (_arg.tag === 0) {
                const uid = _arg.fields[0];
                return Backend_ensureProfile(c, uid, handle).then((_arg_1) => ((_arg_1.tag === 0) ? (((((c.from("leagues")).insert({
                    name: name,
                    creator: uid,
                })).select("id,code,name")).single()).then((_arg_2) => {
                    const created = _arg_2;
                    const err = created.error;
                    if (!(err == null)) {
                        return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(err)]));
                    }
                    else {
                        const row = created.data;
                        const info = new Backend_LeagueInfo(row.id, row.code, row.name);
                        return Backend_ensureMembership(c, uid, info.Id).then((_arg_3) => {
                            if (_arg_3.tag === 0) {
                                Backend_cacheHandle(handle);
                                return Promise.resolve(new FSharpResult$2(0, [info]));
                            }
                            else {
                                return Promise.resolve(new FSharpResult$2(1, [_arg_3.fields[0]]));
                            }
                        });
                    }
                })) : (Promise.resolve(new FSharpResult$2(1, [_arg_1.fields[0]])))));
            }
            else {
                return Promise.resolve(new FSharpResult$2(1, [_arg.fields[0]]));
            }
        }))));
        work.then(onDone, ((_arg_4) => {
            onDone(new FSharpResult$2(1, ["Could not reach the league server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new FSharpResult$2(1, ["The backend is not configured on this build."]));
    }
}

/**
 * Join an existing league by its share code.
 */
export function Backend_joinLeague(code, handle, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Backend_ensureSession(c).then((_arg) => {
            if (_arg.tag === 0) {
                const uid = _arg.fields[0];
                return Backend_ensureProfile(c, uid, handle).then((_arg_1) => ((_arg_1.tag === 0) ? (((((c.from("leagues")).select("id,code,name")).eq("code", code.trim().toLocaleUpperCase())).maybeSingle()).then((_arg_2) => {
                    const found = _arg_2;
                    const err = found.error;
                    if (!(err == null)) {
                        return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(err)]));
                    }
                    else {
                        const row = found.data;
                        if (row == null) {
                            return Promise.resolve(new FSharpResult$2(1, ["No league found with that code — check it with whoever sent it."]));
                        }
                        else {
                            const info = new Backend_LeagueInfo(row.id, row.code, row.name);
                            return Backend_ensureMembership(c, uid, info.Id).then((_arg_3) => {
                                if (_arg_3.tag === 0) {
                                    Backend_cacheHandle(handle);
                                    return Promise.resolve(new FSharpResult$2(0, [info]));
                                }
                                else {
                                    return Promise.resolve(new FSharpResult$2(1, [_arg_3.fields[0]]));
                                }
                            });
                        }
                    }
                })) : (Promise.resolve(new FSharpResult$2(1, [_arg_1.fields[0]])))));
            }
            else {
                return Promise.resolve(new FSharpResult$2(1, [_arg.fields[0]]));
            }
        }))));
        work.then(onDone, ((_arg_4) => {
            onDone(new FSharpResult$2(1, ["Could not reach the league server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new FSharpResult$2(1, ["The backend is not configured on this build."]));
    }
}

/**
 * Every league this browser's identity belongs to.
 */
export function Backend_fetchMyLeagues(onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Backend_ensureSession(c).then((_arg) => ((_arg.tag === 0) ? ((((c.from("league_members")).select("leagues(id,code,name)")).eq("user_id", _arg.fields[0])).then((_arg_1) => {
            const res = _arg_1;
            const err = res.error;
            if (!(err == null)) {
                return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(err)]));
            }
            else {
                const leagues = ofArray(choose_1((o) => {
                    const lg = o.leagues;
                    if (lg == null) {
                        return undefined;
                    }
                    else {
                        return new Backend_LeagueInfo(lg.id, lg.code, lg.name);
                    }
                }, res.data));
                return Promise.resolve(new FSharpResult$2(0, [leagues]));
            }
        })) : (Promise.resolve(new FSharpResult$2(1, [_arg.fields[0]]))))))));
        work.then(onDone, ((_arg_2) => {
            onDone(new FSharpResult$2(1, ["Could not reach the league server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new FSharpResult$2(1, ["The backend is not configured on this build."]));
    }
}

/**
 * The league table: every member, with their submitted season when
 * they have one. Members and runs are two public reads merged by
 * user id — no session needed.
 */
export function Backend_fetchLeagueStandings(leagueId, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((((c.from("league_members")).select("user_id,profiles(handle)")).eq("league_id", leagueId)).then((_arg) => {
            const members = _arg;
            const mErr = members.error;
            return !(mErr == null) ? (Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(mErr)]))) : ((((c.from("league_runs")).select("user_id,runs(team_name,wins,losses,ovr)")).eq("league_id", leagueId)).then((_arg_1) => {
                const entries = _arg_1;
                const eErr = entries.error;
                if (!(eErr == null)) {
                    return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(eErr)]));
                }
                else {
                    const runByUser = ofArray_1(choose_1((o) => {
                        const r = o.runs;
                        if (r == null) {
                            return undefined;
                        }
                        else {
                            return [o.user_id, r];
                        }
                    }, entries.data), {
                        Compare: comparePrimitives,
                    });
                    const standings = ofArray(sortByDescending_1((s) => [s.HasRun, s.Wins], map_3((o_1) => {
                        const profile = o_1.profiles;
                        const uid = o_1.user_id;
                        const handle = (profile == null) ? "anonymous" : profile.handle;
                        const matchValue = FSharpMap__TryFind(runByUser, uid);
                        if (matchValue == null) {
                            return new Backend_LeagueStanding(handle, "", 0, 0, 0, false);
                        }
                        else {
                            const r_1 = value_4241(matchValue);
                            return new Backend_LeagueStanding(handle, r_1.team_name, r_1.wins, r_1.losses, r_1.ovr, true);
                        }
                    }, members.data), {
                        Compare: compareArrays,
                    }));
                    return Promise.resolve(new FSharpResult$2(0, [standings]));
                }
            }));
        }))));
        work.then(onDone, ((_arg_2) => {
            onDone(new FSharpResult$2(1, ["Could not reach the league server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new FSharpResult$2(1, ["The backend is not configured on this build."]));
    }
}

/**
 * Post an archived season into a league: the run row goes to the
 * global runs table (same shape as submitRun) and the league entry
 * points at it. Resubmitting replaces the previous entry —
 * one season per member per league, reference-game style.
 */
export function Backend_submitRunToLeague(leagueId, run, onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Backend_ensureSession(c).then((_arg) => {
            if (_arg.tag === 0) {
                const uid = _arg.fields[0];
                const payload = {
                    user_id: uid,
                    team_name: run.TeamName,
                    franchise_id: run.FranchiseId,
                    ovr: run.Ovr,
                    wins: run.Wins,
                    losses: run.Losses,
                    rank: run.Rank,
                    ppg: run.PointsPerGame,
                    difficulty: run.Difficulty,
                    rating_mode: run.RatingMode,
                    blueprint: run.Blueprint,
                    perfect: run.Complete82_0,
                };
                return ((((c.from("runs")).insert(payload)).select("id")).single()).then((_arg_1) => {
                    const inserted = _arg_1;
                    const iErr = inserted.error;
                    if (!(iErr == null)) {
                        return Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(iErr)]));
                    }
                    else {
                        const runId = inserted.data.id;
                        return ((c.from("league_runs")).upsert({
                            league_id: leagueId,
                            user_id: uid,
                            run_id: runId,
                        }, {
                            onConflict: "league_id,user_id",
                        })).then((_arg_2) => {
                            const uErr = _arg_2.error;
                            return (uErr == null) ? (Promise.resolve(new FSharpResult$2(0, [undefined]))) : (Promise.resolve(new FSharpResult$2(1, [Backend_errMessage(uErr)])));
                        });
                    }
                });
            }
            else {
                return Promise.resolve(new FSharpResult$2(1, [_arg.fields[0]]));
            }
        }))));
        work.then(onDone, ((_arg_3) => {
            onDone(new FSharpResult$2(1, ["Could not reach the league server — check your connection and try again."]));
        }));
    }
    else {
        onDone(new FSharpResult$2(1, ["The backend is not configured on this build."]));
    }
}

/**
 * Fire-and-forget +1. The PostgREST builder is lazy, so it must
 * be settled to actually execute.
 */
export function Backend_bumpSeasonsSimulated() {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        try {
            (c.rpc("bump_seasons_simulated")).then(((_arg) => {
            }), ((_arg_1) => {
            }));
        }
        catch (matchValue) {
        }
    }
}

/**
 * Current all-time total; silently does nothing when the backend
 * (or the stats table) is missing, so the tile just keeps its
 * last value.
 */
export function Backend_fetchSeasonsSimulated(onDone) {
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        const work = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((((c.from("global_stats")).select("seasons_simulated")).single()).then((_arg) => {
            const res = _arg;
            const err = res.error;
            return (err == null) ? (Promise.resolve(Number(res.data.seasons_simulated))) : (Promise.resolve(-1));
        }))));
        work.then(((total) => {
            if (total >= 0) {
                onDone(total);
            }
        }), ((_arg_1) => {
        }));
    }
}

let Backend_draftChannel = undefined;

export function Backend_leaveDraftRoom() {
    const Backend_draftChannel_1 = Backend_draftChannel;
    let matchResult, c, ch;
    if (Backend_draftChannel_1 != null) {
        if (Backend_client != null) {
            matchResult = 0;
            c = value_4241(Backend_client);
            ch = value_4241(Backend_draftChannel_1);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            try {
                c.removeChannel(ch);
            }
            catch (matchValue_1) {
            }
            Backend_draftChannel = undefined;
            break;
        }
        case 1: {
            break;
        }
    }
}

/**
 * Join (or create — the channel exists the moment someone names
 * it) a room. onPeers fires with the connected browsers on every
 * join/leave; onAction carries guests' requests (the host consumes
 * them); onState carries the host's snapshots; onReady reports
 * whether the socket actually opened.
 */
export function Backend_joinDraftRoom(code, myKey, handle, onPeers, onAction, onState, onChat, onReady) {
    Backend_leaveDraftRoom();
    if (Backend_client != null) {
        const c = value_4241(Backend_client);
        try {
            const ch = c.channel(("draft-" + code), {
                config: {
                    broadcast: {
                        self: false,
                    },
                    presence: {
                        key: myKey,
                    },
                },
            });
            ch.on("presence", {
                event: "sync",
            }, ((_arg) => {
                onPeers(ofArray(Object.entries(ch.presenceState()).map(function(kv){ var metas = kv[1]; return [kv[0], metas.length ? String(metas[metas.length-1].handle || '') : '']; })));
            }));
            ch.on("broadcast", {
                event: "action",
            }, ((msg) => {
                onAction(msg.payload);
            }));
            ch.on("broadcast", {
                event: "state",
            }, ((msg_1) => {
                onState(msg_1.payload);
            }));
            ch.on("broadcast", {
                event: "chat",
            }, ((msg_2) => {
                onChat(msg_2.payload);
            }));
            ch.subscribe((status) => {
                if (status === "SUBSCRIBED") {
                    ch.track({
                        handle: handle,
                    });
                    onReady(true);
                }
            });
            Backend_draftChannel = some(ch);
        }
        catch (matchValue) {
            onReady(false);
        }
    }
    else {
        onReady(false);
    }
}

/**
 * Fire-and-forget broadcast on the current room channel.
 */
export function Backend_sendDraftEvent(event, payload) {
    if (Backend_draftChannel == null) {
    }
    else {
        const ch = value_4241(Backend_draftChannel);
        try {
            ch.send({
                type: "broadcast",
                event: event,
                payload: payload,
            });
        }
        catch (matchValue) {
        }
    }
}

export class Backend_DraftAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ActPick", "ActUnknown"];
    }
}

export function Backend_DraftAction_$reflection() {
    return union_type("App.Backend.DraftAction", [], Backend_DraftAction, () => [[["memberKey", string_type], ["playerId", string_type]], []]);
}

export function Backend_pickPayload(key, player) {
    return {
        kind: "pick",
        key: key,
        player: player,
    };
}

export function Backend_parseDraftAction(payload) {
    try {
        return (payload.kind === "pick") ? (new Backend_DraftAction(0, [payload.key, payload.player])) : (new Backend_DraftAction(1, []));
    }
    catch (matchValue_1) {
        return new Backend_DraftAction(1, []);
    }
}

export function Backend_chatPayload(handle, text) {
    return {
        handle: handle,
        text: text,
    };
}

/**
 * (handle, text), or None for anything malformed.
 */
export function Backend_parseChat(payload) {
    try {
        const handle = payload.handle;
        const text = payload.text;
        return (text === "") ? undefined : [handle, text];
    }
    catch (matchValue) {
        return undefined;
    }
}

/**
 * Render a 1200x630 dark share card and trigger a browser download.
 * The 2D context API is stringly-typed, so the dynamic interop stays
 * contained in this one function. Total: a failed render must never
 * take the results screen down with it.
 */
export function ShareCard_download(record, verdict, rosterLines, footerLine) {
    try {
        const canvas = document.createElement("canvas");
        canvas.width = 1200;
        canvas.height = 630;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#09090b";
        ctx.fillRect(0, 0, 1200, 630);
        ctx.fillStyle = "#f97316";
        ctx.fillRect(0, 0, 1200, 10);
        ctx.fillStyle = "#f97316";
        ctx.font = "900 46px Arial";
        ctx.fillText("BANNER SEASON", 60, 100);
        ctx.fillStyle = "#52525b";
        ctx.font = "700 22px Arial";
        ctx.fillText("THE ALL-TIME ROSTER DRAFT", 470, 100);
        ctx.fillStyle = "#ffffff";
        ctx.font = "900 96px Arial";
        ctx.fillText(record, 60, 225);
        ctx.fillStyle = "#a1a1aa";
        ctx.font = "700 30px Arial";
        ctx.fillText(verdict, 60, 280);
        ctx.font = "600 26px Arial";
        iterateIndexed((index, line) => {
            const column = ~~(index / 4) | 0;
            const row = (index % 4) | 0;
            ctx.fillStyle = "#d4d4d8";
            ctx.fillText(line, (60 + (column * 560)), (355 + (row * 46)));
        }, rosterLines);
        ctx.fillStyle = "#71717a";
        ctx.font = "600 22px Arial";
        ctx.fillText(footerLine, 60, 592);
        const url = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download = "banner-season.png";
        link.click();
    }
    catch (matchValue) {
    }
}

const Actions_rng = nonSeeded();

const Actions_teamWheel = toArray_1(historicalRegistry);

const Actions_coachWheel = toArray_1(headCoaches);

export const Actions_seasonTickMs = 400;

export const Actions_tradeDeadlineGame = 52;

export const Actions_spinDelayMs = 600;

export const Actions_reelSpinMs = 2500;

export const Actions_opponentPool = ["Atlanta Hawks", "Boston Celtics", "Brooklyn Nets", "Charlotte Hornets", "Chicago Bulls", "Cleveland Cavaliers", "Dallas Mavericks", "Denver Nuggets", "Detroit Pistons", "Golden State Warriors", "Houston Rockets", "Indiana Pacers", "LA Clippers", "Los Angeles Lakers", "Memphis Grizzlies", "Miami Heat", "Milwaukee Bucks", "Minnesota Timberwolves", "New Orleans Pelicans", "New York Knicks", "Oklahoma City Thunder", "Orlando Magic", "Philadelphia 76ers", "Phoenix Suns", "Portland Trail Blazers", "Sacramento Kings", "San Antonio Spurs", "Toronto Raptors", "Utah Jazz", "Washington Wizards"];

let Actions_currentRunId = 0;

let Actions_fastForwardTo = 0;

export let Actions_tickMultiplier = createAtom(1);

/**
 * Advance the pace 1x → 2x → 4x → back to 1x, returning the new value.
 */
export function Actions_cycleTickSpeed() {
    Actions_tickMultiplier((Actions_tickMultiplier() === 1) ? 2 : ((Actions_tickMultiplier() === 2) ? 4 : 1));
    return Actions_tickMultiplier() | 0;
}

/**
 * First unfilled slot in the run's draft order (blueprint starters,
 * then the bench).
 */
export function Actions_nextOpenSlot(slots, roster) {
    return tryFind((slot) => !FSharpMap__ContainsKey(roster, slot), slots);
}

/**
 * Lock in the setup chosen on SystemSelect and push the console
 * straight to the wheel. Reads the config out of state rather than
 * taking it as an argument, so the panels stay the single source of
 * truth right up to the moment the run starts.
 */
export function Actions_startGame(setState) {
    Actions_currentRunId = ((Actions_currentRunId + 1) | 0);
    Actions_fastForwardTo = 0;
    setState((st) => (new GameState(new ConsolePhase(2, []), initialState.Roster, st.SystemArchetype, (st.FranchiseLock == null) ? st.Config : (new DraftConfig(st.Config.Difficulty, new RatingMode(0, []))), rerollsFor(st.Config.Difficulty), empty_1(), st.FranchiseLock, st.Blueprint, initialState.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, undefined, false, undefined, false, empty({
        Compare: comparePrimitives,
    }), empty_1(), empty_1(), undefined, empty_1(), initialState.PlayoffRecords, initialState.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, (Actions_rng.NextDouble() - 0.5) * 0.12, initialState.Wins, initialState.Losses, initialState.GameLog, st.Profile, st.UserRuns)));
}

function Actions_availablePools(franchiseLock, eraRange_, eraRange__1, drawnIds, roster) {
    const eraRange = [eraRange_, eraRange__1];
    let pools;
    if (franchiseLock == null) {
        pools = poolsInSeasonRange(eraRange[0], eraRange[1]);
    }
    else {
        const franchise = franchiseLock;
        pools = filter((pool) => contains(pool.Id, franchise.PoolIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }), historicalRegistry);
    }
    const unseen = filter((team) => !contains(team.Id, drawnIds, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    }), pools);
    if (!isEmpty(unseen)) {
        return toArray_1(unseen);
    }
    else {
        const drafted = ofList_1(map((tupledArg) => tupledArg[1].Id, toList(roster)), {
            Compare: comparePrimitives,
        });
        const matchValue = filter((pool_1) => exists((p) => !FSharpSet__Contains(drafted, p.Id), pool_1.Options), pools);
        if (isEmpty(matchValue)) {
            return toArray_1(pools);
        }
        else {
            return toArray_1(matchValue);
        }
    }
}

/**
 * Open the squad sheet once the reels have stopped. Guarded on the
 * pool id, so only THIS spin's reels (or its fallback timer) may
 * advance the phase — never a stale timer from an abandoned spin.
 * Idempotent, because it is fired from BOTH the reel's animationend
 * event and a reelSpinMs timeout: hidden tabs throttle timers and
 * freeze animations, so whichever signal arrives first wins and the
 * other no-ops.
 */
export function Actions_landWheel(setState, pool) {
    setState((st) => {
        const matchValue = st.Phase;
        let matchResult, spinning_1;
        if (matchValue.tag === 3) {
            if (matchValue.fields[0].Id === pool.Id) {
                matchResult = 0;
                spinning_1 = matchValue.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new GameState(new ConsolePhase(4, [spinning_1]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns);
            default:
                return st;
        }
    });
}

/**
 * Spin the wheel: the landing is decided IMMEDIATELY and carried
 * into the WheelSpinning phase, so the view can render slot reels
 * that decelerate onto the true result — the reference game's
 * trick. After reelSpinMs the phase advances to DraftChoice and the
 * squad sheet opens.
 * 
 * The landing records the franchise as spent at spin time. Both
 * transitions are phase-guarded, so a spin that is no longer wanted
 * — a denied reroll, or a run restarted mid-reel — resolves to a
 * no-op instead of yanking the console back.
 */
export function Actions_spinWheel(setState, config, franchiseLock, targetPos, eraRange_, eraRange__1, drawnIds, roster) {
    const eraRange = [eraRange_, eraRange__1];
    const wheel = Actions_availablePools(franchiseLock, eraRange[0], eraRange[1], drawnIds, roster);
    let wheel_1;
    if (targetPos != null) {
        const pos = targetPos;
        const drafted = ofList_1(map((tupledArg) => tupledArg[1].Id, toList(roster)), {
            Compare: comparePrimitives,
        });
        const eligibleCount = (pool) => length(filter((p_1) => {
            if (!FSharpSet__Contains(drafted, p_1.Id)) {
                return contains(pos, playerPositions(p_1), {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: stringHash,
                });
            }
            else {
                return false;
            }
        }, pool.Options));
        const matchValue = wheel.filter((pool_1) => (eligibleCount(pool_1) >= 2));
        if (!equalsWith(equals, matchValue, defaultOf()) && (matchValue.length === 0)) {
            const matchValue_1 = wheel.filter((pool_2) => (eligibleCount(pool_2) >= 1));
            wheel_1 = ((!equalsWith(equals, matchValue_1, defaultOf()) && (matchValue_1.length === 0)) ? wheel : matchValue_1);
        }
        else {
            wheel_1 = matchValue;
        }
    }
    else {
        wheel_1 = wheel;
    }
    const landed = item_1(Actions_rng.Next1(wheel_1.length), wheel_1);
    const pool_3 = applyRatingMode(config.RatingMode, landed);
    setState((st) => ((st.Phase.tag === 2) ? (new GameState(new ConsolePhase(3, [pool_3]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, contains(landed.Id, st.DrawnFranchiseIds, {
        Equals: (x_4, y_4) => (x_4 === y_4),
        GetHashCode: stringHash,
    }) ? st.DrawnFranchiseIds : cons(landed.Id, st.DrawnFranchiseIds), st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : st));
    const runId = Actions_currentRunId | 0;
    setTimeout(() => {
        if (runId === Actions_currentRunId) {
            Actions_landWheel(setState, pool_3);
        }
    }, Actions_reelSpinMs);
}

/**
 * Spend one of the draft session's rerolls to escape a bad wheel
 * landing: decrement the token, drop the console back into the
 * SpinningWheel delay, and let the wheel resolve a fresh pool.
 * A no-op once the tokens are gone, so the count cannot go negative.
 * 
 * Note the rerolled-away franchise stays spent — that is what gives
 * a reroll its cost, but it also means each reroll consumes one of
 * the era's franchises.
 */
export function Actions_useReroll(setState, config, franchiseLock, targetPos, eraRange_, eraRange__1, drawnIds, roster) {
    const eraRange = [eraRange_, eraRange__1];
    setState((st) => ((st.RerollsAvailable > 0) ? (new GameState(new ConsolePhase(2, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable - 1, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : st));
    Actions_spinWheel(setState, config, franchiseLock, targetPos, eraRange[0], eraRange[1], drawnIds, roster);
}

/**
 * Inject the chosen player into the active slot. If an open slot
 * remains, return to the wheel for the next spin; once all 8 are
 * filled, hand the console to the live sim.
 * (Greying out already-rostered players is the view's job.)
 */
export function Actions_pickPlayer(setState, player, activeSlotId) {
    setState((st) => {
        const roster = FSharpMap__Add(st.Roster, activeSlotId, player);
        const matchValue = Actions_nextOpenSlot(append(blueprintSlotIds(st.Blueprint), benchSlots), roster);
        return (matchValue == null) ? (new GameState(new ConsolePhase(5, []), roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : (new GameState(new ConsolePhase(2, []), roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns));
    });
}

/**
 * Return to the landing page from anywhere.
 * 
 * Bumping the run id first is what makes this safe: a season loop
 * may still be ticking, and it checks the id on every game. Without
 * this it would keep accumulating results in the background and
 * eventually force the console to SeasonComplete underneath
 * whatever the user navigated to. The roster is left intact —
 * startGame resets it wholesale on the next run anyway.
 */
export function Actions_navigateToHome(setState) {
    Actions_currentRunId = ((Actions_currentRunId + 1) | 0);
    setState((st) => (new GameState(new ConsolePhase(0, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Spin the coaching carousel, then appoint whoever it lands on.
 * Mirrors the team wheel's suspense delay.
 * 
 * `onSettled` fires unconditionally once the spin resolves. The
 * caller's busy flag is cleared from there rather than from a state
 * change, because landing on the already-appointed coach would leave
 * a state-keyed effect dormant and strand the button on "Spinning".
 */
export function Actions_spinForCoach(setState, onSettled) {
    setTimeout(() => {
        const coach = item_1(Actions_rng.Next1(Actions_coachWheel.length), Actions_coachWheel);
        setState((st) => ((st.Phase.tag === 5) ? (new GameState(new ConsolePhase(6, [coach]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : st));
        onSettled();
    }, Actions_spinDelayMs);
}

/**
 * Accept the revealed coach and hand the console to the season.
 */
export function Actions_confirmCoach(setState, coach) {
    setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, coach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Work the phones: deal ONE of the three deadline event cards.
 * 
 * - The Blockbuster (40%): a contender bids for the roster's BEST
 * player. Cashing in swaps him — and the weakest other spot —
 * for two arrivals off the franchise wheel. The premium event,
 * modelled on how deadline day actually works: stars move to
 * contenders, sellers restock.
 * - The Buyout Market (35%): three blind veteran offers for the
 * weakest slot, ratings hidden until the pick commits.
 * - The Bargain Bin (25%): a scout swears he has found a gem —
 * one blind signing for the weakest spot, no choice at all.
 * 
 * The card itself is a gamble: the user chooses to enter the market
 * before knowing which event they get.
 */
export function Actions_enterTradeMarket(setState, roster) {
    const matchValue = toList(roster);
    if (isEmpty(matchValue)) {
        setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
    }
    else {
        const entries = matchValue;
        const eventRoll = Actions_rng.NextDouble();
        if (eventRoll < 0.4) {
            const patternInput = maxBy((tupledArg) => tupledArg[1].Ovr, entries, {
                Compare: comparePrimitives,
            });
            setState((st_1) => (new GameState(new ConsolePhase(17, [patternInput[0], patternInput[1]]), st_1.Roster, st_1.SystemArchetype, st_1.Config, st_1.RerollsAvailable, st_1.DrawnFranchiseIds, st_1.FranchiseLock, st_1.Blueprint, st_1.DailyRun, st_1.IsKnowledgeMode, st_1.DraftModeSetting, st_1.StartEraIndex, st_1.EndEraIndex, st_1.HeadCoachesEnabled, st_1.SelectedCoach, st_1.IsTradeResolved, st_1.TradeOutcome, st_1.IsInstantSkipActive, st_1.PlayerSeason, st_1.TradedInPlayerIds, st_1.DeadlineDeals, st_1.ProjectedWins, st_1.RivalStandings, st_1.PlayoffRecords, st_1.PlayoffOutcome, st_1.PlayoffsEnabled, st_1.TradeDeadlineEnabled, st_1.SeasonLuck, st_1.Wins, st_1.Losses, st_1.GameLog, st_1.Profile, st_1.UserRuns)));
        }
        else {
            const patternInput_1 = minBy((tupledArg_1) => tupledArg_1[1].Ovr, entries, {
                Compare: comparePrimitives,
            });
            const weakest = patternInput_1[1];
            const slot_1 = patternInput_1[0];
            const group = positionCategory(weakest.Pos);
            const rollTier = (tier, index) => {
                const candidates = filter((asset) => {
                    if (asset.Group === group) {
                        return asset.Tier === tier;
                    }
                    else {
                        return false;
                    }
                }, tradeAssets);
                const asset_1 = item(Actions_rng.Next1(length(candidates)), candidates);
                return new Player(`trade-${tier.toLocaleLowerCase()}-${index}`, asset_1.Name, weakest.Pos, Actions_rng.Next2(asset_1.MinOvr, asset_1.MaxOvr + 1), asset_1.Badge, asset_1.Franchise);
            };
            if (eventRoll < 0.75) {
                const offers = map((tuple_1) => tuple_1[1], sortBy((tuple) => tuple[0], map((offer) => [Actions_rng.Next0(), offer], ofArray([rollTier("Star", 0), rollTier("Bust", 1), rollTier("Shifter", 2)])), {
                    Compare: comparePrimitives,
                }));
                setState((st_2) => (new GameState(new ConsolePhase(14, [slot_1, weakest.Name, offers]), st_2.Roster, st_2.SystemArchetype, st_2.Config, st_2.RerollsAvailable, st_2.DrawnFranchiseIds, st_2.FranchiseLock, st_2.Blueprint, st_2.DailyRun, st_2.IsKnowledgeMode, st_2.DraftModeSetting, st_2.StartEraIndex, st_2.EndEraIndex, st_2.HeadCoachesEnabled, st_2.SelectedCoach, st_2.IsTradeResolved, st_2.TradeOutcome, st_2.IsInstantSkipActive, st_2.PlayerSeason, st_2.TradedInPlayerIds, st_2.DeadlineDeals, st_2.ProjectedWins, st_2.RivalStandings, st_2.PlayoffRecords, st_2.PlayoffOutcome, st_2.PlayoffsEnabled, st_2.TradeDeadlineEnabled, st_2.SeasonLuck, st_2.Wins, st_2.Losses, st_2.GameLog, st_2.Profile, st_2.UserRuns)));
            }
            else {
                const tier_1 = item(Actions_rng.Next1(3), ofArray(["Star", "Bust", "Shifter"]));
                setState((st_3) => (new GameState(new ConsolePhase(15, [slot_1, weakest.Name, rollTier(tier_1, 0)]), st_3.Roster, st_3.SystemArchetype, st_3.Config, st_3.RerollsAvailable, st_3.DrawnFranchiseIds, st_3.FranchiseLock, st_3.Blueprint, st_3.DailyRun, st_3.IsKnowledgeMode, st_3.DraftModeSetting, st_3.StartEraIndex, st_3.EndEraIndex, st_3.HeadCoachesEnabled, st_3.SelectedCoach, st_3.IsTradeResolved, st_3.TradeOutcome, st_3.IsInstantSkipActive, st_3.PlayerSeason, st_3.TradedInPlayerIds, st_3.DeadlineDeals, st_3.ProjectedWins, st_3.RivalStandings, st_3.PlayoffRecords, st_3.PlayoffOutcome, st_3.PlayoffsEnabled, st_3.TradeDeadlineEnabled, st_3.SeasonLuck, st_3.Wins, st_3.Losses, st_3.GameLog, st_3.Profile, st_3.UserRuns)));
            }
        }
    }
}

/**
 * Hang up on the contender: the star stays, the deadline passes.
 * Routes through the closure card rather than resuming silently.
 */
export function Actions_declineBlockbuster(setState, starName) {
    setState((st) => (new GameState(new ConsolePhase(8, ["The Blockbuster", `You hung up on the contender. ${starName} stays, the roster is unchanged, and the season goes again as it stands.`]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, `Kept ${starName} — the contender moved on. Roster unchanged.`, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Apply the finished blockbuster: swap every deal into the roster,
 * log it, and open the Done Deals reveal. Guarded on the phase still
 * being a blockbuster spin, and therefore idempotent — it is fired
 * from BOTH the last reel's animationend and a fallback timer, and
 * whichever lands second finds the phase already moved on.
 */
export function Actions_commitBlockbuster(setState, deals) {
    const message = `🚨 Deadline blockbuster: ${join("; ", map((tupledArg) => {
        const incoming = tupledArg[2];
        return `${tupledArg[1].Name} out, ${incoming.Name} (${incoming.Ovr} OVR) in at ${tupledArg[0]}`;
    }, deals))}.`;
    setState((st) => {
        if (st.Phase.tag === 18) {
            const note = new LogEntry(st.Wins + st.Losses, "", 0, 0, false, 0, "", message);
            return new GameState(new ConsolePhase(19, [deals]), fold((acc, tupledArg_1) => FSharpMap__Add(acc, tupledArg_1[0], tupledArg_1[2]), st.Roster, deals), st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, message, st.IsInstantSkipActive, st.PlayerSeason, map((tupledArg_2) => tupledArg_2[2].Id, deals), deals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, cons(note, st.GameLog), st.Profile, st.UserRuns);
        }
        else {
            return st;
        }
    });
}

/**
 * A signing's reel has stopped: move to the next signing, or commit
 * once every deal has had its spin. The stage transition is guarded
 * on the CURRENT stage, so the animationend and the fallback timer
 * can both call this without double-advancing.
 */
export function Actions_advanceBlockbuster(setState, stage, deals) {
    if (stage < length(deals)) {
        setState((st) => {
            const matchValue = st.Phase;
            let matchResult, current_1, pending_1;
            if (matchValue.tag === 18) {
                if (matchValue.fields[0] === stage) {
                    matchResult = 0;
                    current_1 = matchValue.fields[0];
                    pending_1 = matchValue.fields[1];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new GameState(new ConsolePhase(18, [stage + 1, pending_1]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns);
                default:
                    return st;
            }
        });
        const runId = Actions_currentRunId | 0;
        setTimeout(() => {
            if (runId === Actions_currentRunId) {
                Actions_advanceBlockbuster(setState, stage + 1, deals);
            }
        }, Actions_reelSpinMs);
    }
    else {
        Actions_commitBlockbuster(setState, deals);
    }
}

/**
 * Cash in on the blockbuster: the star is dealt, and two arrivals
 * come back off the franchise wheel — one to fill his slot, one to
 * upgrade (or downgrade — it is a gamble) the weakest other spot.
 * 
 * Each signing is drawn from a random era-legal pool that actually
 * holds an undrafted player at the needed position, then takes that
 * pool's best such player — the front office targets a fit, but the
 * wheel decides which squad picks up the phone. Randomness runs
 * OUTSIDE the state updater, matching enterTradeMarket, so React
 * re-invoking the updater cannot re-roll the deals.
 */
export function Actions_executeBlockbuster(setState, config, eraRange_, eraRange__1, roster, starSlot) {
    let matchValue_2, patternInput, weakest;
    const eraRange = [eraRange_, eraRange__1];
    const matchValue = FSharpMap__TryFind(roster, starSlot);
    if (matchValue != null) {
        const star = matchValue;
        const rosterIds = ofList_1(map((tupledArg) => tupledArg[1].Id, toList(roster)), {
            Compare: comparePrimitives,
        });
        const pickSigning = (pos, exclude) => {
            const candidates = choose((pool) => {
                const rated = applyRatingMode(config.RatingMode, pool);
                const matchValue_1 = filter((p_1) => {
                    if (p_1.Pos === pos) {
                        return !FSharpSet__Contains(exclude, p_1.Id);
                    }
                    else {
                        return false;
                    }
                }, rated.Options);
                if (isEmpty(matchValue_1)) {
                    return undefined;
                }
                else {
                    return [rated, maxBy((p_2) => p_2.Ovr, matchValue_1, {
                        Compare: comparePrimitives,
                    })];
                }
            }, poolsInSeasonRange(eraRange[0], eraRange[1]));
            if (isEmpty(candidates)) {
                return undefined;
            }
            else {
                const cs = candidates;
                return item(Actions_rng.Next1(length(cs)), cs);
            }
        };
        const firstSigning = pickSigning(star.Pos, rosterIds);
        const matchValue_3 = choose((x_3) => x_3, ofArray([map_2((tupledArg_1) => [starSlot, star, tupledArg_1[1]], firstSigning), (matchValue_2 = toList(FSharpMap__Remove(roster, starSlot)), isEmpty(matchValue_2) ? undefined : ((patternInput = minBy((tupledArg_2) => tupledArg_2[1].Ovr, matchValue_2, {
            Compare: comparePrimitives,
        }), (weakest = patternInput[1], map_2((tupledArg_3) => [patternInput[0], weakest, tupledArg_3[1]], pickSigning(weakest.Pos, (firstSigning == null) ? rosterIds : FSharpSet__Add(rosterIds, firstSigning[1].Id)))))))]));
        if (isEmpty(matchValue_3)) {
            setState((st_1) => (new GameState(new ConsolePhase(20, []), st_1.Roster, st_1.SystemArchetype, st_1.Config, st_1.RerollsAvailable, st_1.DrawnFranchiseIds, st_1.FranchiseLock, st_1.Blueprint, st_1.DailyRun, st_1.IsKnowledgeMode, st_1.DraftModeSetting, st_1.StartEraIndex, st_1.EndEraIndex, st_1.HeadCoachesEnabled, st_1.SelectedCoach, true, "The blockbuster collapsed — no deal could be built. Roster unchanged.", st_1.IsInstantSkipActive, st_1.PlayerSeason, st_1.TradedInPlayerIds, st_1.DeadlineDeals, st_1.ProjectedWins, st_1.RivalStandings, st_1.PlayoffRecords, st_1.PlayoffOutcome, st_1.PlayoffsEnabled, st_1.TradeDeadlineEnabled, st_1.SeasonLuck, st_1.Wins, st_1.Losses, st_1.GameLog, st_1.Profile, st_1.UserRuns)));
        }
        else {
            const deals = matchValue_3;
            setState((st_2) => ((st_2.Phase.tag === 17) ? (new GameState(new ConsolePhase(18, [1, deals]), st_2.Roster, st_2.SystemArchetype, st_2.Config, st_2.RerollsAvailable, st_2.DrawnFranchiseIds, st_2.FranchiseLock, st_2.Blueprint, st_2.DailyRun, st_2.IsKnowledgeMode, st_2.DraftModeSetting, st_2.StartEraIndex, st_2.EndEraIndex, st_2.HeadCoachesEnabled, st_2.SelectedCoach, st_2.IsTradeResolved, st_2.TradeOutcome, st_2.IsInstantSkipActive, st_2.PlayerSeason, st_2.TradedInPlayerIds, st_2.DeadlineDeals, st_2.ProjectedWins, st_2.RivalStandings, st_2.PlayoffRecords, st_2.PlayoffOutcome, st_2.PlayoffsEnabled, st_2.TradeDeadlineEnabled, st_2.SeasonLuck, st_2.Wins, st_2.Losses, st_2.GameLog, st_2.Profile, st_2.UserRuns)) : st_2));
            const runId = Actions_currentRunId | 0;
            setTimeout(() => {
                if (runId === Actions_currentRunId) {
                    Actions_advanceBlockbuster(setState, 1, deals);
                }
            }, Actions_reelSpinMs);
        }
    }
    else {
        setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
    }
}

/**
 * Commit a blind pick. The swap and its log note land immediately,
 * but IsTradeResolved is deliberately left alone: the deadline is
 * not settled until the reveal is acknowledged, and nothing can run
 * in the meantime because the phase is no longer LiveSim.
 * 
 * The outgoing player is read out of the roster here rather than
 * passed in, so the reveal payload and the roster write are sourced
 * from the same snapshot and cannot disagree.
 */
export function Actions_acceptTradeOffer(setState, slot, incoming) {
    setState((st) => {
        let matchValue_1, keywords_1;
        const matchValue = FSharpMap__TryFind(st.Roster, slot);
        if (matchValue != null) {
            const outgoing = matchValue;
            const message = `🤝 Trade Deadline Finalized: Swapped out ${outgoing.Name} for ${incoming.Name} (${incoming.Ovr} OVR).${(matchValue_1 = FSharpMap__TryFind(Engine_systemBadgeAffinity, st.SystemArchetype), (matchValue_1 != null) ? (exists((k) => (incoming.Badge.indexOf(k) >= 0), matchValue_1) ? ((keywords_1 = matchValue_1, ` ${st.SystemArchetype} synergy activated!`)) : "") : "")}`;
            const note = new LogEntry(st.Wins + st.Losses, "", 0, 0, false, 0, "", message);
            return new GameState(new ConsolePhase(16, [slot, outgoing, incoming, incoming.Ovr - outgoing.Ovr]), FSharpMap__Add(st.Roster, slot, incoming), st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, message, st.IsInstantSkipActive, st.PlayerSeason, singleton(incoming.Id), singleton([slot, outgoing, incoming]), st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, cons(note, st.GameLog), st.Profile, st.UserRuns);
        }
        else {
            return new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns);
        }
    });
}

/**
 * Acknowledge the reveal: settle the deadline and release the ticker.
 */
export function Actions_confirmTrade(setState) {
    setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Decline the deal and close the deadline with an acknowledgment
 * card. The caller supplies the card copy, because "stood pat on
 * deadline day" and "walked away from the bargain bin" are
 * different stories that end the same way.
 */
export function Actions_stickWithRoster(setState, headline, body) {
    setState((st) => (new GameState(new ConsolePhase(8, [headline, body]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, true, "Stood pat at the deadline — roster unchanged.", st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Acknowledge the closed deadline and release the ticker.
 */
export function Actions_continueAfterDeadline(setState) {
    setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Leave the lineup screen and hand the console to the season ticker.
 */
export function Actions_startSeason(setState) {
    setState((st) => (new GameState(new ConsolePhase(20, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the profile dashboard.
 * 
 * Deliberately does NOT abandon a running season: the header keeps
 * this entry point locked while the phase is LiveSim, so there is
 * never a live run to discard here. Silently binning someone's
 * season because they opened their profile would be worse than the
 * lock.
 */
export function Actions_navigateToProfile(setState) {
    setState((st) => (new GameState(new ConsolePhase(22, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Same idea for the explainer guide: a full-page route, so entering
 * it is a phase change rather than a panel toggle.
 */
export function Actions_navigateToDraftGuide(setState) {
    setState((st) => (new GameState(new ConsolePhase(23, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the all-time lineup builder guide.
 */
export function Actions_navigateToLineupBuilderGuide(setState) {
    setState((st) => (new GameState(new ConsolePhase(24, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the season simulator guide.
 */
export function Actions_navigateToSeasonSimulatorGuide(setState) {
    setState((st) => (new GameState(new ConsolePhase(25, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the greatest all-time roster showcase.
 */
export function Actions_navigateToGreatestLineupGuide(setState) {
    setState((st) => (new GameState(new ConsolePhase(26, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the how-to-play rules guide.
 */
export function Actions_navigateToHowToPlayGuide(setState) {
    setState((st) => (new GameState(new ConsolePhase(27, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the multiplayer hub.
 */
export function Actions_navigateToMultiplayerHub(setState) {
    setState((st) => (new GameState(new ConsolePhase(28, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Live Draft room creation terminal.
 */
export function Actions_navigateToLiveDraftSetup(setState) {
    setState((st) => (new GameState(new ConsolePhase(29, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Leagues hub.
 */
export function Actions_navigateToLeaguesSetup(setState) {
    setState((st) => (new GameState(new ConsolePhase(30, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the league rules configuration form.
 */
export function Actions_navigateToLeagueRulesConfig(setState) {
    setState((st) => (new GameState(new ConsolePhase(31, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the One-Franchise Roster challenge view.
 */
export function Actions_navigateToFranchiseMode(setState) {
    setState((st) => (new GameState(new ConsolePhase(32, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Daily Challenge menu.
 */
export function Actions_navigateToDailyChallenge(setState) {
    setState((st) => (new GameState(new ConsolePhase(33, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Era Challenge menu.
 */
export function Actions_navigateToEraChallenge(setState) {
    setState((st) => (new GameState(new ConsolePhase(34, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the leaderboard.
 */
export function Actions_navigateToLeaderboard(setState) {
    setState((st) => (new GameState(new ConsolePhase(35, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Our Story page.
 */
export function Actions_navigateToStory(setState) {
    setState((st) => (new GameState(new ConsolePhase(36, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Get the App page.
 */
export function Actions_navigateToGetApp(setState) {
    setState((st) => (new GameState(new ConsolePhase(37, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Partners page.
 */
export function Actions_navigateToPartners(setState) {
    setState((st) => (new GameState(new ConsolePhase(38, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Privacy & Cookies Policy.
 */
export function Actions_navigateToPrivacyPolicy(setState) {
    setState((st) => (new GameState(new ConsolePhase(39, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Discord waitlist page.
 */
export function Actions_navigateToDiscord(setState) {
    setState((st) => (new GameState(new ConsolePhase(41, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Route to the Terms of Use.
 */
export function Actions_navigateToTermsOfUse(setState) {
    setState((st) => (new GameState(new ConsolePhase(40, []), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Reset to a fresh run's system picker, keeping meta-progression.
 * The landing "Play Banner Season" button and the footer "Play" link share
 * this single entry point into the draft.
 */
export function Actions_beginRunSetup(setState) {
    setState((st) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Enter setup with a One-Franchise Roster lock: same fresh-run reset
 * as beginRunSetup, plus the lock and its forced season-accurate
 * ratings. The lock then rides through startGame into the draft.
 */
export function Actions_beginFranchiseSetup(setState, franchise) {
    setState((st) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, new DraftConfig(defaultDraftConfig.Difficulty, new RatingMode(0, [])), initialState.RerollsAvailable, initialState.DrawnFranchiseIds, franchise, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Enter setup with the wheel pre-locked to one era: the same
 * fresh-run reset as beginRunSetup, with the era slider already
 * narrowed to the chosen span. Every other rule stays the player's
 * to choose — an Era Challenge run IS a normal run whose wheel
 * simply cannot leave its decade, so it rides the existing
 * era-range machinery instead of a parallel mode.
 */
export function Actions_beginEraSetup(setState, fromYear, toYear) {
    setState((st) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, clampSeasonIndex(fromYear - 1947), clampSeasonIndex(toYear - 1947), initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Start today's Daily Challenge: spend an attempt, seed the star
 * into their natural slot, and open the wheel. A no-op once the
 * day's five attempts are gone. Always a fresh Balanced draft on
 * Normal — the daily is one shared ruleset for everyone.
 */
export function Actions_startDailyChallenge(setState) {
    const progress = Store_dailyProgressToday();
    if (progress.AttemptsUsed >= dailyAttemptsPerDay) {
    }
    else {
        Store_saveDaily(new DailyProgress(progress.Date, progress.AttemptsUsed + 1, progress.BestScore, (progress.AttemptsUsed === 0) ? (progress.Streak + 1) : progress.Streak));
        const pool = dailyFeaturedPool();
        const star = dailyStarOf(pool);
        Actions_currentRunId = ((Actions_currentRunId + 1) | 0);
        Actions_fastForwardTo = 0;
        setState((st) => (new GameState(new ConsolePhase(2, []), ofList(singleton([star.Pos, star]), {
            Compare: comparePrimitives,
        }), initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, new DailyRun(pool.Id, star), initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st.Profile, st.UserRuns)));
    }
}

/**
 * Resume the saved in-progress draft — the landing page's
 * "Continue Draft". Drops back to the wheel when slots remain, or
 * straight to the lineup screen when the eight are already in.
 * A no-op when nothing valid is saved.
 */
export function Actions_continueDraft(setState) {
    const matchValue = Store_loadDraft();
    if (matchValue != null) {
        const saved = matchValue;
        Actions_currentRunId = ((Actions_currentRunId + 1) | 0);
        Actions_fastForwardTo = 0;
        setState((st) => (new GameState((Actions_nextOpenSlot(append(blueprintSlotIds(saved.Blueprint), benchSlots), saved.Roster) != null) ? (new ConsolePhase(2, [])) : (new ConsolePhase(5, [])), saved.Roster, saved.SystemArchetype, saved.Config, saved.RerollsAvailable, saved.DrawnFranchiseIds, saved.FranchiseLock, saved.Blueprint, saved.DailyRun, saved.IsKnowledgeMode, saved.DraftModeSetting, saved.StartEraIndex, saved.EndEraIndex, saved.HeadCoachesEnabled, saved.SelectedCoach, saved.IsTradeResolved, saved.TradeOutcome, saved.IsInstantSkipActive, saved.PlayerSeason, saved.TradedInPlayerIds, saved.DeadlineDeals, saved.ProjectedWins, saved.RivalStandings, saved.PlayoffRecords, saved.PlayoffOutcome, saved.PlayoffsEnabled, saved.TradeDeadlineEnabled, saved.SeasonLuck, saved.Wins, saved.Losses, saved.GameLog, st.Profile, st.UserRuns)));
    }
}

function Actions_generateScores(won) {
    const winnerScore = Actions_rng.Next2(100, 126) | 0;
    const loserScore = (winnerScore - Actions_rng.Next2(4, 19)) | 0;
    if (won) {
        return [winnerScore, loserScore];
    }
    else {
        return [loserScore, winnerScore];
    }
}

function Actions_generateStandoutLine(roster, teamScore) {
    const matchValue = map((tuple) => tuple[1], toList(roster));
    if (isEmpty(matchValue)) {
        return "";
    }
    else {
        const players = matchValue;
        const ranked = sortByDescending((p) => p.Ovr, players, {
            Compare: comparePrimitives,
        });
        const scorer = item(Actions_rng.Next1(min(3, length(ranked))), ranked);
        const points = ~~round_3(teamScore * (0.18 + (Actions_rng.NextDouble() * 0.1))) | 0;
        const surname = (p_1) => last(split(p_1.Name, [" "], undefined, 0));
        let playmaker;
        const matchValue_1 = filter((p_2) => (p_2.Id !== scorer.Id), players);
        if (isEmpty(matchValue_1)) {
            playmaker = undefined;
        }
        else {
            const others = matchValue_1;
            playmaker = item(Actions_rng.Next1(length(others)), others);
        }
        if (playmaker == null) {
            return `${surname(scorer)} ${points} PTS`;
        }
        else {
            const mate = playmaker;
            return `${surname(scorer)} ${points} PTS, ${surname(mate)} ${Actions_rng.Next2(4, 13)} AST`;
        }
    }
}

function Actions_distributeBoxScore(roster, teamScore) {
    const players = map((tuple) => tuple[1], toList(roster));
    if (isEmpty(players)) {
        return empty_1();
    }
    else {
        const ratingTotal = sumBy((p) => p.Ovr, players, {
            GetZero: () => 0,
            Add: (x, y) => (x + y),
        });
        const assistWeight = (p_1) => {
            let matchValue;
            return p_1.Ovr * ((matchValue = p_1.Pos, (matchValue === "PG") ? 2.2 : ((matchValue === "SG") ? 1.4 : ((matchValue === "SF") ? 1 : 0.6))));
        };
        const stockWeight = (p_2) => {
            let matchValue_1;
            return p_2.Ovr * ((matchValue_1 = p_2.Pos, (matchValue_1 === "C") ? 1.8 : ((matchValue_1 === "PF") ? 1.4 : ((matchValue_1 === "SF") ? 1 : 0.8))));
        };
        const assistTotal = sumBy(assistWeight, players, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        });
        const stockTotal = sumBy(stockWeight, players, {
            GetZero: () => 0,
            Add: (x_2, y_2) => (x_2 + y_2),
        });
        const teamAssists = Actions_rng.Next2(20, 31);
        const teamStocks = Actions_rng.Next2(8, 16);
        return map((p_3) => [p_3.Id, [~~round_3((teamScore * (p_3.Ovr / ratingTotal)) * (0.85 + (Actions_rng.NextDouble() * 0.3))), ~~round_3((teamAssists * assistWeight(p_3)) / assistTotal), ~~round_3((teamStocks * stockWeight(p_3)) / stockTotal)]], players);
    }
}

function Actions_accumulateSeason(existing, lines) {
    return fold((acc, tupledArg) => {
        const playerId = tupledArg[0];
        const _arg = tupledArg[1];
        const prior = defaultArg(tryFind_1(playerId, acc), emptySeasonLine);
        return add(playerId, new SeasonLine(prior.Games + 1, prior.Points + _arg[0], prior.Assists + _arg[1], prior.Stocks + _arg[2]), acc);
    }, existing, lines);
}

/**
 * Jump the running season forward: every game up to `target`
 * resolves without waiting. A no-op once the season is past it.
 */
export function Actions_skipToGame(target) {
    Actions_fastForwardTo = (max(Actions_fastForwardTo, target) | 0);
}

/**
 * Collapse every remaining tick and run the season out.
 * 
 * The loop already gates its sleep on `fastForwardTo`, so pushing
 * that past the final game is the bypass — no second flag for the
 * loop to consult, and therefore no way for the two to disagree.
 * The state boolean exists so the view can retire the link.
 */
export function Actions_skipRestOfSeason(setState) {
    Actions_fastForwardTo = 82;
    setState((st) => (new GameState(st.Phase, st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, true, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

function Actions_awaitTabVisible() {
    if (!document.hidden) {
        return singleton_1.Return(undefined);
    }
    else {
        return fromContinuations((tupledArg) => {
            let handler = defaultOf();
            handler = ((_arg_2) => {
                if (!document.hidden) {
                    document.removeEventListener("visibilitychange", handler);
                    tupledArg[0]();
                }
            });
            document.addEventListener("visibilitychange", handler);
        });
    }
}

/**
 * Resolve the full 82-game season, one LogEntry every seasonTickMs.
 * Ratings are pulled from Engine once up front (the roster is
 * frozen during the sim): team OVR, then win probability under the
 * selected system — the +2% synergy only applies when drafted
 * badges actually back that system (rosterSynergyActive).
 * Kick this off from the component when Phase becomes LiveSim:
 * React.useEffect ((fun () ->
 * match state.Phase with
 * | LiveSim -> Actions.runSeason setState state.Roster state.SystemArchetype
 * | _ -> ()), [| box state.Phase |])
 * `resumeAt` is the first game this loop should play, so a season
 * interrupted by the trade deadline picks up exactly where it
 * stopped. Ratings are recomputed here, which is what makes a
 * post-trade roster take effect immediately.
 * 
 * `haltAtDeadline` is captured once: the resumed loop is started with
 * it false, so deadline day is not intercepted twice.
 */
export function Actions_runSeason(setState, roster, systemArchetype, coach, franchiseLock, seasonLuck, resumeAt, haltAtDeadline) {
    const runId = Actions_currentRunId | 0;
    const teamOvr = Engine_calculateTeamRatings(roster) | 0;
    const winChance = Engine_applySeasonLuck(seasonLuck, Engine_calculateWinProbabilityWithCoach(teamOvr, Engine_rosterSynergyActive(systemArchetype, roster) ? systemArchetype : "Balanced", coach));
    let runLabel;
    const players = map((tuple) => tuple[1], toList(roster));
    if (isEmpty(players)) {
        runLabel = "Empty Roster";
    }
    else if (franchiseLock == null) {
        runLabel = ((maxBy((p_1) => p_1.Ovr, players, {
            Compare: comparePrimitives,
        }).Name + " · ") + systemArchetype);
    }
    else {
        const franchise = franchiseLock;
        runLabel = ((maxBy((p) => p.Ovr, players, {
            Compare: comparePrimitives,
        }).Name + " · ") + franchise.Name);
    }
    const franchiseId = Engine_primaryFranchise(roster);
    if (resumeAt <= 1) {
        const projected = ~~round_3(winChance * 82) | 0;
        setState((st) => ((st.ProjectedWins == null) ? (new GameState(st.Phase, st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, projected, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : st));
    }
    const loop = (gameNumber) => singleton_1.Delay(() => {
        if (runId !== Actions_currentRunId) {
            return singleton_1.Return(undefined);
        }
        else if (gameNumber > 82) {
            let rivals;
            const nickname = map_2((pool) => franchiseNickname(pool.TeamName), FSharpMap__TryFind(poolById, franchiseId));
            let replacedIndex;
            const lockedIndex = bind((franchise_1) => tryFindIndex((team) => (team === franchise_1.Name), Actions_opponentPool), franchiseLock);
            if (lockedIndex == null) {
                if (nickname == null) {
                    replacedIndex = Actions_rng.Next1(Actions_opponentPool.length);
                }
                else {
                    const nick = nickname;
                    replacedIndex = defaultArg(tryFindIndex((team_1) => team_1.endsWith(nick), Actions_opponentPool), Actions_rng.Next1(Actions_opponentPool.length));
                }
            }
            else {
                replacedIndex = lockedIndex;
            }
            rivals = toList_1(delay(() => collect_1((i) => ((i !== replacedIndex) ? singleton_2([item_1(i, Actions_opponentPool), ~~((Actions_rng.Next2(11, 65) + Actions_rng.Next2(11, 65)) / 2)]) : empty_2()), rangeDouble(0, 1, Actions_opponentPool.length - 1))));
            setState((st_1) => {
                let decemberGames, matchValue_3, matchValue_4;
                const perfect = (st_1.Losses === 0) && (st_1.Wins === 82);
                const finalRank = (1 + length(filter((tupledArg) => (tupledArg[1] > st_1.Wins), rivals))) | 0;
                const seasonGames = filter((g) => (g.Note == null), st_1.GameLog);
                const facts = new SeasonFacts(st_1.Wins, st_1.Losses, finalRank, teamOvr, isEmpty(seasonGames) ? 0 : averageBy((g_1) => g_1.TeamScore, seasonGames, {
                    GetZero: () => 0,
                    Add: (x_3, y_2) => (x_3 + y_2),
                    DivideByInt: (x_2, i_1) => (x_2 / i_1),
                }), isEmpty(seasonGames) ? 0 : averageBy((g_2) => g_2.OppScore, seasonGames, {
                    GetZero: () => 0,
                    Add: (x_5, y_3) => (x_5 + y_3),
                    DivideByInt: (x_4, i_2) => (x_4 / i_2),
                }), (decemberGames = filter((g_3) => gameDateLabel(g_3.GameNumber).startsWith("Dec"), seasonGames), !isEmpty(decemberGames) && forAll((g_4) => g_4.Won, decemberGames)), fold((tupledArg_1, g_6) => {
                    const w = tupledArg_1[1] | 0;
                    const l = tupledArg_1[2] | 0;
                    const w$0027 = (g_6.Won ? (w + 1) : w) | 0;
                    const l$0027 = (g_6.Won ? l : (l + 1)) | 0;
                    return [tupledArg_1[0] && (w$0027 >= l$0027), w$0027, l$0027];
                }, [true, 0, 0], sortBy((g_5) => g_5.GameNumber, seasonGames, {
                    Compare: comparePrimitives,
                }))[0], exists((tupledArg_3) => !contains(tupledArg_3[0], benchSlots, {
                    Equals: (x_7, y_5) => (x_7 === y_5),
                    GetHashCode: stringHash,
                }), st_1.DeadlineDeals), st_1.Roster, st_1.UserRuns);
                const run = new HistoricRun(toString(now(), "yyyy-MM-dd"), runLabel, franchiseId, teamOvr, `${st_1.Wins}-${st_1.Losses}`, st_1.Wins, st_1.Losses, finalRank, (matchValue_3 = filter((g_7) => (g_7.Note == null), st_1.GameLog), isEmpty(matchValue_3) ? 0 : averageBy((g_8) => g_8.TeamScore, matchValue_3, {
                    GetZero: () => 0,
                    Add: (x_9, y_6) => (x_9 + y_6),
                    DivideByInt: (x_8, i_3) => (x_8 / i_3),
                })), (matchValue_4 = st_1.Config.Difficulty, (matchValue_4.tag === 1) ? "Normal" : ((matchValue_4.tag === 2) ? "Hard" : "Easy")), (st_1.Config.RatingMode.tag === 1) ? "Prime" : "Season", st_1.Blueprint.Name, perfect);
                return new GameState(new ConsolePhase(21, [st_1.Wins, st_1.Losses]), st_1.Roster, st_1.SystemArchetype, st_1.Config, st_1.RerollsAvailable, st_1.DrawnFranchiseIds, st_1.FranchiseLock, st_1.Blueprint, st_1.DailyRun, st_1.IsKnowledgeMode, st_1.DraftModeSetting, st_1.StartEraIndex, st_1.EndEraIndex, st_1.HeadCoachesEnabled, st_1.SelectedCoach, st_1.IsTradeResolved, st_1.TradeOutcome, st_1.IsInstantSkipActive, st_1.PlayerSeason, st_1.TradedInPlayerIds, st_1.DeadlineDeals, st_1.ProjectedWins, rivals, st_1.PlayoffRecords, st_1.PlayoffOutcome, st_1.PlayoffsEnabled, st_1.TradeDeadlineEnabled, st_1.SeasonLuck, st_1.Wins, st_1.Losses, st_1.GameLog, Profile_recordSeason(franchiseLock, facts, st_1.Profile), cons(run, st_1.UserRuns));
            });
            Backend_bumpSeasonsSimulated();
            return singleton_1.Zero();
        }
        else if (haltAtDeadline && (gameNumber === Actions_tradeDeadlineGame)) {
            setState((st_2) => ((st_2.Phase.tag === 20) ? (new GameState(new ConsolePhase(7, []), st_2.Roster, st_2.SystemArchetype, st_2.Config, st_2.RerollsAvailable, st_2.DrawnFranchiseIds, st_2.FranchiseLock, st_2.Blueprint, st_2.DailyRun, st_2.IsKnowledgeMode, st_2.DraftModeSetting, st_2.StartEraIndex, st_2.EndEraIndex, st_2.HeadCoachesEnabled, st_2.SelectedCoach, st_2.IsTradeResolved, st_2.TradeOutcome, st_2.IsInstantSkipActive, st_2.PlayerSeason, st_2.TradedInPlayerIds, st_2.DeadlineDeals, st_2.ProjectedWins, st_2.RivalStandings, st_2.PlayoffRecords, st_2.PlayoffOutcome, st_2.PlayoffsEnabled, st_2.TradeDeadlineEnabled, st_2.SeasonLuck, st_2.Wins, st_2.Losses, st_2.GameLog, st_2.Profile, st_2.UserRuns)) : st_2));
            return singleton_1.Return(undefined);
        }
        else {
            return singleton_1.Combine((gameNumber > Actions_fastForwardTo) ? singleton_1.Bind(sleep(~~(Actions_seasonTickMs / Actions_tickMultiplier())), () => singleton_1.Bind(Actions_awaitTabVisible(), () => singleton_1.Return(undefined))) : singleton_1.Zero(), singleton_1.Delay(() => {
                if (runId !== Actions_currentRunId) {
                    return singleton_1.Return(undefined);
                }
                else {
                    const won = Actions_rng.NextDouble() < winChance;
                    const patternInput = Actions_generateScores(won);
                    const teamScore = patternInput[0] | 0;
                    const entry = new LogEntry(gameNumber, item_1(Actions_rng.Next1(Actions_opponentPool.length), Actions_opponentPool), teamScore, patternInput[1], won, winChance, Actions_generateStandoutLine(roster, teamScore), undefined);
                    const boxScore = Actions_distributeBoxScore(roster, teamScore);
                    setState((st_3) => (new GameState(st_3.Phase, st_3.Roster, st_3.SystemArchetype, st_3.Config, st_3.RerollsAvailable, st_3.DrawnFranchiseIds, st_3.FranchiseLock, st_3.Blueprint, st_3.DailyRun, st_3.IsKnowledgeMode, st_3.DraftModeSetting, st_3.StartEraIndex, st_3.EndEraIndex, st_3.HeadCoachesEnabled, st_3.SelectedCoach, st_3.IsTradeResolved, st_3.TradeOutcome, st_3.IsInstantSkipActive, Actions_accumulateSeason(st_3.PlayerSeason, boxScore), st_3.TradedInPlayerIds, st_3.DeadlineDeals, st_3.ProjectedWins, st_3.RivalStandings, st_3.PlayoffRecords, st_3.PlayoffOutcome, st_3.PlayoffsEnabled, st_3.TradeDeadlineEnabled, st_3.SeasonLuck, st_3.Wins + (won ? 1 : 0), st_3.Losses + (won ? 0 : 1), cons(entry, st_3.GameLog), st_3.Profile, st_3.UserRuns)));
                    return singleton_1.ReturnFrom(loop(gameNumber + 1));
                }
            }));
        }
    });
    startImmediate(loop(resumeAt));
}

export const Actions_playoffYou = "Your Roster";

export function Actions_roundName(round) {
    switch (round) {
        case 1:
            return "First Round";
        case 2:
            return "Semifinals";
        default:
            return "The Finals";
    }
}

function Actions_playoffWinChance(teamOvr, system, coach, seasonLuck, oppWins82, homeCourt) {
    return min(0.93, max(0.07, (Engine_applySeasonLuck(seasonLuck, Engine_calculateWinProbabilityWithCoach(teamOvr, system, coach)) + ((41 - oppWins82) * 0.006)) + (homeCourt ? 0.035 : -0.035)));
}

/**
 * 2-2-1-1-1: the better seed hosts games 1, 2, 5 and 7. Public —
 * the live scoreboard derives its venue label from the same rule
 * the sim rolls with, so the two can never disagree.
 */
export function Actions_hostsGame(mySeed, oppSeed, game) {
    const betterSeedHosts = contains(game, ofArray([1, 2, 5, 7]), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    });
    if (mySeed < oppSeed) {
        return betterSeedHosts;
    }
    else {
        return !betterSeedHosts;
    }
}

function Actions_quarterTotals(finalScore) {
    const q1 = (~~(finalScore / 4) + Actions_rng.Next2(-4, 5)) | 0;
    const q2 = (~~(finalScore / 2) + Actions_rng.Next2(-4, 5)) | 0;
    const q3 = (~~((finalScore * 3) / 4) + Actions_rng.Next2(-4, 5)) | 0;
    return ofArray([max(2, q1), max(4, q2), max(6, q3), finalScore]);
}

function Actions_resolveElsewhere(_arg2_, _arg2__1, _arg2__2, _arg1_, _arg1__1, _arg1__2) {
    const _arg = [_arg2_, _arg2__1, _arg2__2];
    const _arg_1 = [_arg1_, _arg1__1, _arg1__2];
    const winsA = _arg[2] | 0;
    const seedA = _arg[0] | 0;
    const nameA = _arg[1];
    const winsB = _arg_1[2] | 0;
    const seedB = _arg_1[0] | 0;
    const nameB = _arg_1[1];
    const pA = min(0.85, max(0.15, 0.5 + ((winsA - winsB) * 0.01)));
    const patternInput = (Actions_rng.NextDouble() < pA) ? [[seedA, nameA, winsA], [seedB, nameB, winsB]] : [[seedB, nameB, winsB], [seedA, nameA, winsA]];
    const winner = patternInput[0];
    const loser = patternInput[1];
    const games = (4 + Actions_rng.Next1(4)) | 0;
    const ws = winner[0] | 0;
    const wn = winner[1];
    const ls = loser[0] | 0;
    const ln = loser[1];
    return [winner, (games === 4) ? (`(${ws}) ${wn} swept (${ls}) ${ln}.`) : (`(${ws}) ${wn} put away (${ls}) ${ln} in ${games}.`)];
}

function Actions_nextPairings(mySeed, survivors) {
    let pairs;
    const arr = toArray_1(sortBy((tupledArg) => tupledArg[0], cons([mySeed, Actions_playoffYou, 0], survivors), {
        Compare: comparePrimitives,
    }));
    pairs = toList_1(delay(() => map_1((i) => [item_1(i, arr), item_1((arr.length - 1) - i, arr)], rangeDouble(0, 1, ~~(arr.length / 2) - 1))));
    const myPair = find((tupledArg_1) => {
        if (tupledArg_1[0][1] === Actions_playoffYou) {
            return true;
        }
        else {
            return tupledArg_1[1][1] === Actions_playoffYou;
        }
    }, pairs);
    return [(myPair[0][1] === Actions_playoffYou) ? myPair[1] : myPair[0], filter((p) => !equalArrays(p, myPair), pairs)];
}

/**
 * Abandon the campaign (the header's Exit): kill the loop and drop
 * back to the results screen. No outcome is recorded — the gateway
 * stays open for another attempt, the one mercy this mode offers.
 */
export function Actions_exitPlayoffs(setState) {
    Actions_currentRunId = ((Actions_currentRunId + 1) | 0);
    setState((st) => (new GameState(new ConsolePhase(21, [st.Wins, st.Losses]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

/**
 * Close a finished campaign: back to the results screen, where the
 * PlayoffOutcome now renders the summary card in the gateway's place.
 */
export function Actions_closePlayoffs(setState) {
    setState((st) => (new GameState(new ConsolePhase(21, [st.Wins, st.Losses]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
}

function Actions_playSeries(setState, runId, teamOvr, system, coach, seasonLuck, roster, series, alive) {
    return singleton_1.Delay(() => {
        if (runId !== Actions_currentRunId) {
            return singleton_1.Return(undefined);
        }
        else {
            const game = ((series.MyWins + series.OppWins) + 1) | 0;
            const home = Actions_hostsGame(series.MySeed, series.OpponentSeed, game);
            const p = Actions_playoffWinChance(teamOvr, system, coach, seasonLuck, series.OpponentWins82, home);
            const won = Actions_rng.NextDouble() < p;
            const patternInput = Actions_generateScores(won);
            const teamScore = patternInput[0] | 0;
            const oppScore = patternInput[1] | 0;
            const mine = Actions_quarterTotals(teamScore);
            const theirs = Actions_quarterTotals(oppScore);
            return singleton_1.Combine(singleton_1.For(rangeDouble(1, 1, 4), (_arg) => {
                const q = _arg | 0;
                return singleton_1.Bind(sleep(~~(900 / Actions_tickMultiplier())), () => singleton_1.Bind(Actions_awaitTabVisible(), () => {
                    if (runId === Actions_currentRunId) {
                        const shown = map((tupledArg) => [tupledArg[0], tupledArg[1]], zip(truncate(q, mine), truncate(q, theirs)));
                        setState((st) => {
                            let s;
                            const matchValue = st.Phase;
                            let matchResult, a_2, s_1;
                            if (matchValue.tag === 10) {
                                if ((s = matchValue.fields[0], (s.Round === series.Round) && (length(s.Games) === length(series.Games)))) {
                                    matchResult = 0;
                                    a_2 = matchValue.fields[1];
                                    s_1 = matchValue.fields[0];
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0:
                                    return new GameState(new ConsolePhase(10, [s_1, a_2, shown]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns);
                                default:
                                    return st;
                            }
                        });
                        return singleton_1.Zero();
                    }
                    else {
                        return singleton_1.Zero();
                    }
                }));
            }), singleton_1.Delay(() => {
                if (runId !== Actions_currentRunId) {
                    return singleton_1.Return(undefined);
                }
                else {
                    const series$0027 = new PlayoffSeries(series.Round, series.Opponent, series.OpponentSeed, series.OpponentWins82, series.MySeed, series.MyWins + (won ? 1 : 0), series.OppWins + (won ? 0 : 1), cons(new PlayoffGameLog(game, teamScore, oppScore, won, Actions_generateStandoutLine(roster, teamScore), home), series.Games));
                    setState((st_1) => {
                        const matchValue_1 = st_1.Phase;
                        return (matchValue_1.tag === 10) ? (new GameState(new ConsolePhase(10, [series$0027, matchValue_1.fields[1], empty_1()]), st_1.Roster, st_1.SystemArchetype, st_1.Config, st_1.RerollsAvailable, st_1.DrawnFranchiseIds, st_1.FranchiseLock, st_1.Blueprint, st_1.DailyRun, st_1.IsKnowledgeMode, st_1.DraftModeSetting, st_1.StartEraIndex, st_1.EndEraIndex, st_1.HeadCoachesEnabled, st_1.SelectedCoach, st_1.IsTradeResolved, st_1.TradeOutcome, st_1.IsInstantSkipActive, st_1.PlayerSeason, st_1.TradedInPlayerIds, st_1.DeadlineDeals, st_1.ProjectedWins, st_1.RivalStandings, st_1.PlayoffRecords, st_1.PlayoffOutcome, st_1.PlayoffsEnabled, st_1.TradeDeadlineEnabled, st_1.SeasonLuck, st_1.Wins, st_1.Losses, st_1.GameLog, st_1.Profile, st_1.UserRuns)) : st_1;
                    });
                    return singleton_1.Bind(sleep(~~(1300 / Actions_tickMultiplier())), () => singleton_1.Bind(Actions_awaitTabVisible(), () => {
                        if (runId !== Actions_currentRunId) {
                            return singleton_1.Return(undefined);
                        }
                        else if (series$0027.MyWins >= 4) {
                            const record = [series$0027.Round, series$0027.Opponent, series$0027.MyWins, series$0027.OppWins];
                            if (series$0027.Round >= 3) {
                                setState((st_3) => {
                                    let bind$0040;
                                    const o = new PlayoffOutcome(true, 4, append(st_3.PlayoffRecords, singleton(record)));
                                    return new GameState(new ConsolePhase(12, [o]), st_3.Roster, st_3.SystemArchetype, st_3.Config, st_3.RerollsAvailable, st_3.DrawnFranchiseIds, st_3.FranchiseLock, st_3.Blueprint, st_3.DailyRun, st_3.IsKnowledgeMode, st_3.DraftModeSetting, st_3.StartEraIndex, st_3.EndEraIndex, st_3.HeadCoachesEnabled, st_3.SelectedCoach, st_3.IsTradeResolved, st_3.TradeOutcome, st_3.IsInstantSkipActive, st_3.PlayerSeason, st_3.TradedInPlayerIds, st_3.DeadlineDeals, st_3.ProjectedWins, st_3.RivalStandings, o.Records, o, st_3.PlayoffsEnabled, st_3.TradeDeadlineEnabled, st_3.SeasonLuck, st_3.Wins, st_3.Losses, st_3.GameLog, contains("The Playoff Gauntlet", st_3.Profile.Trophies, {
                                        Equals: (x, y) => (x === y),
                                        GetHashCode: stringHash,
                                    }) ? st_3.Profile : ((bind$0040 = st_3.Profile, new UserProfile(bind$0040.IsSignedIn, bind$0040.UserId, bind$0040.Email, bind$0040.CurrentStreak, bind$0040.HighestStreak, cons("The Playoff Gauntlet", st_3.Profile.Trophies)))), st_3.UserRuns);
                                });
                                return singleton_1.Zero();
                            }
                            else {
                                let resolutions;
                                const arr = toArray_1(sortBy((tupledArg_2) => tupledArg_2[0], alive, {
                                    Compare: comparePrimitives,
                                }));
                                resolutions = map((tupledArg_1) => {
                                    const a_4 = tupledArg_1[0];
                                    const b_1 = tupledArg_1[1];
                                    return Actions_resolveElsewhere(a_4[0], a_4[1], a_4[2], b_1[0], b_1[1], b_1[2]);
                                }, toList_1(delay(() => map_1((i) => [item_1(i, arr), item_1((arr.length - 1) - i, arr)], rangeDouble(0, 1, ~~(arr.length / 2) - 1)))));
                                const survivors = map((tuple) => tuple[0], resolutions);
                                const flavor = map((tuple_1) => tuple_1[1], resolutions);
                                const nextOpp = Actions_nextPairings(series.MySeed, survivors)[0];
                                const remaining = filter((t) => !equalArrays(t, nextOpp), survivors);
                                setState((st_4) => (new GameState(new ConsolePhase(11, [series$0027, remaining, flavor, nextOpp]), st_4.Roster, st_4.SystemArchetype, st_4.Config, st_4.RerollsAvailable, st_4.DrawnFranchiseIds, st_4.FranchiseLock, st_4.Blueprint, st_4.DailyRun, st_4.IsKnowledgeMode, st_4.DraftModeSetting, st_4.StartEraIndex, st_4.EndEraIndex, st_4.HeadCoachesEnabled, st_4.SelectedCoach, st_4.IsTradeResolved, st_4.TradeOutcome, st_4.IsInstantSkipActive, st_4.PlayerSeason, st_4.TradedInPlayerIds, st_4.DeadlineDeals, st_4.ProjectedWins, st_4.RivalStandings, append(st_4.PlayoffRecords, singleton(record)), st_4.PlayoffOutcome, st_4.PlayoffsEnabled, st_4.TradeDeadlineEnabled, st_4.SeasonLuck, st_4.Wins, st_4.Losses, st_4.GameLog, st_4.Profile, st_4.UserRuns)));
                                return singleton_1.Zero();
                            }
                        }
                        else if (series$0027.OppWins >= 4) {
                            setState((st_5) => {
                                const o_1 = new PlayoffOutcome(false, series$0027.Round, append(st_5.PlayoffRecords, singleton([series$0027.Round, series$0027.Opponent, series$0027.MyWins, series$0027.OppWins])));
                                return new GameState(new ConsolePhase(13, [series$0027, o_1]), st_5.Roster, st_5.SystemArchetype, st_5.Config, st_5.RerollsAvailable, st_5.DrawnFranchiseIds, st_5.FranchiseLock, st_5.Blueprint, st_5.DailyRun, st_5.IsKnowledgeMode, st_5.DraftModeSetting, st_5.StartEraIndex, st_5.EndEraIndex, st_5.HeadCoachesEnabled, st_5.SelectedCoach, st_5.IsTradeResolved, st_5.TradeOutcome, st_5.IsInstantSkipActive, st_5.PlayerSeason, st_5.TradedInPlayerIds, st_5.DeadlineDeals, st_5.ProjectedWins, st_5.RivalStandings, o_1.Records, o_1, st_5.PlayoffsEnabled, st_5.TradeDeadlineEnabled, st_5.SeasonLuck, st_5.Wins, st_5.Losses, st_5.GameLog, st_5.Profile, st_5.UserRuns);
                            });
                            return singleton_1.Zero();
                        }
                        else {
                            return singleton_1.ReturnFrom(Actions_playSeries(setState, runId, teamOvr, system, coach, seasonLuck, roster, series$0027, alive));
                        }
                    }));
                }
            }));
        }
    });
}

function Actions_startSeries(setState, roster, system, coach, seasonLuck, round, mySeed, _arg1_, _arg1__1, _arg1__2, alive) {
    const _arg = [_arg1_, _arg1__1, _arg1__2];
    const series = new PlayoffSeries(round, _arg[1], _arg[0], _arg[2], mySeed, 0, 0, empty_1());
    setState((st) => (new GameState(new ConsolePhase(10, [series, alive, empty_1()]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)));
    startImmediate(Actions_playSeries(setState, Actions_currentRunId, Engine_calculateTeamRatings(roster), system, coach, seasonLuck, roster, series, alive));
}

/**
 * The gateway: seed the top eight off the final table (the roster
 * plus the seven best rivals — ties break the roster's way, same
 * as finalRank) and open the Road screen.
 */
export function Actions_enterPlayoffs(setState) {
    setState((st) => {
        const field = mapIndexed((i, tupledArg) => [i + 1, tupledArg[0], tupledArg[1]], truncate(8, sortByDescending((tuple) => tuple[1], cons([Actions_playoffYou, st.Wins], st.RivalStandings), {
            Compare: comparePrimitives,
        })));
        const matchValue = tryFind((tupledArg_1) => (tupledArg_1[1] === Actions_playoffYou), field);
        return (matchValue != null) ? (new GameState(new ConsolePhase(9, [matchValue[0], field]), st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, empty_1(), undefined, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, st.Profile, st.UserRuns)) : st;
    });
}

/**
 * Tip off the First Round from the Road screen.
 */
export function Actions_tipOffFirstRound(setState, roster, system, coach, seasonLuck, mySeed, field) {
    const opponent = find((tupledArg) => (tupledArg[0] === (9 - mySeed)), field);
    Actions_startSeries(setState, roster, system, coach, seasonLuck, 1, mySeed, opponent[0], opponent[1], opponent[2], filter((tupledArg_1) => {
        if (tupledArg_1[1] !== Actions_playoffYou) {
            return tupledArg_1[0] !== (9 - mySeed);
        }
        else {
            return false;
        }
    }, field));
}

/**
 * Advance from a series-won card into the next round.
 */
export function Actions_continuePlayoffs(setState, roster, system, coach, seasonLuck, series, alive, next_, next__1, next__2) {
    const next = [next_, next__1, next__2];
    Actions_startSeries(setState, roster, system, coach, seasonLuck, series.Round + 1, series.MySeed, next[0], next[1], next[2], alive);
}

/**
 * `navigate` receives the clicked site-link label; the caller owns the
 * label-to-phase mapping so the footer itself stays state-free. Labels
 * with no destination yet resolve to a no-op there.
 */
export function pageFooter(navigate) {
    let elems_5, elems, elems_3, elems_4, value_61;
    return createElement("footer", createObj(ofArray([["className", "mt-10 border-t border-zinc-900 pt-8"], (elems_5 = [createElement("div", createObj(ofArray([["className", "flex flex-wrap justify-center gap-x-6 gap-y-2 text-zinc-400 text-xs font-medium mb-6"], (elems = toList_1(delay(() => map_1((label) => createElement("button", {
        key: label,
        className: "cursor-pointer transition-colors hover:text-orange-500",
        onClick: (_arg) => {
            navigate(label);
        },
        children: label,
    }), ["Home", "Play", "Multiplayer", "How to Play", "Greatest Lineup", "How It Works", "Draft Game", "Lineup Builder", "Season Simulator", "Leaderboard", "Story", "Get the App"]))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "flex flex-wrap justify-center gap-3 mb-6 text-zinc-400"], (elems_3 = toList_1(delay(() => collect_1((matchValue) => {
        let href, href_1, value_17, elems_1, href_2;
        const label_1 = matchValue[1];
        const glyph = matchValue[0];
        const matchValue_1 = matchValue[2];
        if (matchValue_1 != null) {
            return ((href = matchValue_1, href.startsWith("nav:"))) ? ((href_1 = matchValue_1, singleton_2(createElement("button", createObj(ofArray([["key", label_1], ["onClick", (_arg_1) => {
                navigate(substring(href_1, 4));
            }], (value_17 = "border border-zinc-800 bg-zinc-900/40 px-4 py-1.5 rounded-full text-xs font-semibold flex items-center gap-2 hover:border-zinc-700 transition-all cursor-pointer text-zinc-400", ["className", value_17]), (elems_1 = [createElement("span", {
                children: glyph,
            }), createElement("span", {
                children: label_1,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : ((href_2 = matchValue_1, singleton_2(createElement("a", createObj(toList_1(delay(() => append_1(singleton_2(["key", label_1]), delay(() => append_1(singleton_2(["href", href_2]), delay(() => append_1(!href_2.startsWith("mailto:") ? append_1(singleton_2(["target", "_blank"]), delay(() => singleton_2(["rel", "noopener noreferrer"]))) : empty_2(), delay(() => {
                let value_31;
                return append_1(singleton_2((value_31 = "border border-zinc-800 bg-zinc-900/40 px-4 py-1.5 rounded-full text-xs font-semibold flex items-center gap-2 hover:border-zinc-700 transition-all cursor-pointer no-underline text-zinc-400", ["className", value_31])), delay(() => {
                    let elems_2;
                    return singleton_2((elems_2 = [createElement("span", {
                        children: glyph,
                    }), createElement("span", {
                        children: label_1,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
                }));
            })))))))))))));
        }
        else {
            return empty_2();
        }
    }, [["✉", "Feedback & bugs", "mailto:rifaeyah@bannerseason.app?subject=Banner%20Season%20feedback"], ["💬", "Discord", "nav:Discord"], ["𝕏", "X (Twitter)", "https://x.com/BannerSznAPP"], ["📸", "Instagram", "https://www.instagram.com/bannerseasonapp/"], ["☕", "Buy us a coffee", "https://buymeacoffee.com/bannerseason"]]))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("span", {
        className: "text-zinc-600 text-center text-xs tracking-wide block mb-3",
        children: `© ${year_1(now())} bannerseason.app. All rights reserved.`,
    }), createElement("div", createObj(ofArray([["className", "flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-zinc-600 text-xs"], (elems_4 = toList_1(delay(() => collect_1((matchValue_2) => {
        const label_2 = matchValue_2[1];
        const i = matchValue_2[0] | 0;
        return append_1((i > 0) ? singleton_2(createElement("span", {
            key: `policy-sep-${i}`,
            className: "text-zinc-800",
            children: "|",
        })) : empty_2(), delay(() => singleton_2(createElement("button", {
            key: label_2,
            className: "transition-colors hover:text-orange-500 cursor-pointer",
            onClick: (_arg_2) => {
                navigate(label_2);
            },
            children: label_2,
        }))));
    }, indexed(ofArray(["Partners", "Privacy & Cookies Policy", "Terms of Use", "Cookie Preferences"]))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("p", createObj(ofArray([["className", "text-zinc-700 text-center text-[10px] leading-relaxed max-w-4xl mx-auto px-4 mt-4 font-normal"], (value_61 = "Banner Season is an independent fan-made basketball draft and season simulator. It is not affiliated with, endorsed by, sponsored by, licensed by, or otherwise associated with the National Basketball Association (NBA), any professional basketball club, competition, league, player association, governing body, organization, game publisher, or ratings provider. All club names, player names, ratings, statistics, and season data are used strictly for informational, descriptive, and editorial purposes only. No official logos, crests, player images, likenesses, or other official branding are used. All trademarks, trade names, and other intellectual property rights remain the property of their respective owners.", ["children", value_61])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export const totalPlayerSeasons = sumBy((pool) => length(pool.Options), historicalRegistry, {
    GetZero: () => 0,
    Add: (x, y) => (x + y),
});

export const registryEraRange = "1947–2024";

export const landingSeasonRange = "1947–2026";

export function LandingView(landingViewInputProps) {
    let elems_8, value_54, elems_4, value_56, value_65, elems_5, elems_6, elems_7, elems_13, elems_9, elems_10, value_118, elems_11, elems_12, elems_17, elems_16, elems_20, elems_19, elems_25, elems_21, value_189, elems_23, elems_22, elems_24, elems_26, value_230, value_234, elems_30, elems_29, elems_33, elems_32, elems_35;
    const seasonsTotal = landingViewInputProps.seasonsTotal;
    const liveNow = landingViewInputProps.liveNow;
    const setState = landingViewInputProps.setState;
    const patternInput = reactApi.useState(undefined);
    const startDraft = () => {
        Actions_beginRunSetup(setState);
    };
    const eyebrow = (text) => createElement("div", {
        className: "text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500",
        children: text,
    });
    const sectionTitle = (text_1) => createElement("h2", {
        className: "text-2xl font-black tracking-tight text-zinc-50",
        children: text_1,
    });
    const modeCard = (title, blurb, badge, available, onOpen) => {
        let elems_2, elems_1, elems;
        return createElement("div", createObj(ofArray([["key", title], ["className", "group flex items-start justify-between gap-4 rounded-xl border border-zinc-800 bg-zinc-900/40 p-4 transition-all " + ((available ? true : (onOpen != null)) ? "cursor-pointer hover:border-orange-500/40 hover:bg-zinc-900/60" : "opacity-70")], ["onClick", (_arg) => {
            if (onOpen == null) {
                if (available) {
                    startDraft();
                }
            }
            else {
                onOpen();
            }
        }], (elems_2 = [createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_1 = [createElement("div", createObj(ofArray([["className", "flex flex-wrap items-center gap-2"], (elems = toList_1(delay(() => append_1(singleton_2(createElement("span", {
            className: "text-sm font-bold text-zinc-100",
            children: title,
        })), delay(() => {
            let matchValue, value_21;
            return append_1((matchValue = badge, (matchValue == null) ? singleton_2(defaultOf_1()) : singleton_2(createElement("span", createObj(ofArray([(value_21 = "rounded-full border border-amber-500/20 bg-amber-500/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-amber-400", ["className", value_21]), ["children", matchValue]]))))), delay(() => {
                let value_25;
                return !available ? singleton_2(createElement("span", createObj(ofArray([(value_25 = "rounded-full border border-zinc-800 bg-zinc-900 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-zinc-500", ["className", value_25]), ["children", "Soon"]])))) : empty_2();
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("p", {
            className: "mt-1 text-xs leading-relaxed text-zinc-500",
            children: blurb,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("span", {
            className: "shrink-0 text-lg text-zinc-600 transition-colors group-hover:text-orange-400",
            children: "→",
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    };
    const statCell = (value_40, label) => {
        let elems_3;
        return createElement("div", createObj(ofArray([["key", label], ["className", "flex flex-col items-center gap-1"], (elems_3 = [createElement("div", {
            className: "text-xl font-black leading-none text-zinc-50",
            children: value_40,
        }), createElement("div", {
            className: "text-[10px] uppercase tracking-wider text-zinc-500 text-center",
            children: label,
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    };
    const hero = createElement("section", createObj(ofArray([["className", "w-full flex flex-col items-center gap-5 text-center relative pt-12 pb-14 px-4 z-10"], (elems_8 = [createElement("div", createObj(ofArray([(value_54 = "absolute inset-0 w-full max-w-xl left-1/2 -translate-x-1/2 border border-orange-500/20 rounded-2xl bg-gradient-to-b from-zinc-950 via-zinc-900/5 to-zinc-950 pointer-events-none select-none z-0", ["className", value_54]), (elems_4 = [createElement("div", createObj(singleton((value_56 = "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full border border-orange-500/10", ["className", value_56])))), createElement("div", {
        className: "absolute top-0 left-1/3 w-1/3 h-16 border border-orange-500/10 border-t-0",
    }), createElement("div", {
        className: "absolute bottom-0 left-1/3 w-1/3 h-16 border border-orange-500/10 border-b-0",
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([(value_65 = "relative z-10 inline-flex items-center gap-2 rounded-full border border-amber-500/20 bg-amber-500/10 px-3 py-1", ["className", value_65]), (elems_5 = [createElement("span", {
        className: "h-1.5 w-1.5 rounded-full bg-amber-400",
    }), createElement("span", {
        className: "text-[10px] font-bold uppercase tracking-[0.15em] text-amber-400",
        children: "Unofficial fan draft game",
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("h1", createObj(ofArray([["className", "relative z-10 text-5xl font-black tracking-tighter text-zinc-50 sm:text-6xl"], (elems_6 = [createElement("span", {
        children: "BANNER",
    }), createElement("span", {
        className: "text-orange-500",
        children: " SEASON",
    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("p", {
        className: "relative z-10 text-xl font-bold text-zinc-200",
        children: "Build an All-Time NBA Roster",
    }), createElement("p", {
        className: "relative z-10 mx-auto max-w-xl text-xs leading-relaxed text-zinc-500",
        children: `Draft your starting five and second unit player-by-player from ${totalFranchises} unique historical team pools spanning across decades of basketball history, then track their live position-weighted stats in a grueling 82-game campaign loop.`,
    }), createElement("div", createObj(ofArray([["className", "relative z-10 mt-1 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center"], (elems_7 = toList_1(delay(() => append_1(singleton_2(createElement("button", {
        className: "rounded-xl bg-orange-500 px-6 py-3 font-bold text-zinc-950 transition-colors hover:bg-orange-400",
        onClick: (_arg_1) => {
            startDraft();
        },
        children: "Play Banner Season →",
    })), delay(() => {
        let value_98;
        return append_1(singleton_2(createElement("button", createObj(ofArray([(value_98 = "rounded-xl border border-zinc-800 bg-zinc-900/40 px-6 py-3 font-bold text-zinc-300 transition-colors hover:border-zinc-700 hover:text-zinc-100", ["className", value_98]), ["onClick", (_arg_2) => {
            document.getElementById("how-to-play")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }], ["children", "How it works"]])))), delay(() => {
            let value_103;
            return Store_hasDraft() ? singleton_2(createElement("button", createObj(ofArray([(value_103 = "rounded-xl border border-orange-500/40 bg-orange-500/5 px-6 py-3 font-bold text-orange-400 transition-colors hover:bg-orange-500/10", ["className", value_103]), ["onClick", (_arg_3) => {
                Actions_continueDraft(setState);
            }], ["children", "Continue Draft"]])))) : empty_2();
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
    const modes = createElement("section", createObj(ofArray([["className", "flex flex-col gap-6"], (elems_13 = [createElement("div", createObj(ofArray([["className", "flex flex-col gap-3"], (elems_9 = [eyebrow("Play with mates"), modeCard("Multiplayer", "Same rules, your 5 vs theirs. Most wins take the title.", undefined, true, () => {
        Actions_navigateToMultiplayerHub(setState);
    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), createElement("div", createObj(ofArray([["className", "flex flex-col gap-3"], (elems_10 = [eyebrow("More ways to play"), modeCard("One-Franchise Roster", `Select one of ${length(franchises)} NBA franchises and build exclusively from that team's history.`, undefined, true, () => {
        Actions_navigateToFranchiseMode(setState);
    }), modeCard("Daily Challenge", "Today\'s puzzle: one go, fresh every day.", undefined, true, () => {
        Actions_navigateToDailyChallenge(setState);
    }), modeCard("Era Challenge", "Build a 90s or 2000s era roster and go 82-0 unbeaten.", "Limited time", true, () => {
        Actions_navigateToEraChallenge(setState);
    })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("button", createObj(ofArray([(value_118 = "flex w-full cursor-pointer items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-3 text-left transition-all hover:border-orange-500/40 hover:bg-zinc-900/60", ["className", value_118]), ["onClick", (_arg_4) => {
        Actions_navigateToGetApp(setState);
    }], (elems_11 = [createElement("span", {
        className: "text-xs font-semibold text-zinc-300",
        children: "Other ways to play Banner Season",
    }), createElement("span", {
        className: "shrink-0 text-zinc-600",
        children: "→",
    })], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-4 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-5"], (elems_12 = [statCell(int32ToString(totalFranchises), "NBA Franchises"), statCell(int32ToString(totalPlayerSeasons), "Player Seasons"), statCell(landingSeasonRange, "Seasons available")], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
    const howToPlaySteps = ofArray([["Spin, pick, place", `The wheel lands blind on one of ${totalFranchises} historic squads and offers three of its players. Pick one, then use the placement tray to slot them into a position they can actually play — PG, SG, SF, PF or C — or onto one of the three utility bench cards, B1, B2 and B3.`], ["The emergency reroll", `Normal difficulty grants exactly ${rerollsFor(new Difficulty(1, []))} Emergency Reroll token per draft session, to escape a spoiler landing like the '12 Bobcats or the '01 rebuild Bulls. Easy gives ${rerollsFor(new Difficulty(0, []))}; Hard gives ${rerollsFor(new Difficulty(2, []))} and hides every rating. A rerolled franchise is spent either way.`], ["The February deadline", "Switch on the deadline in Advanced and the season pauses on deadline day — 51 games played, February 6 on the sim calendar, right before the All-Star break. Work the phones and one of two events fires: a contender bids for your best player (cash in and two replacements come off the franchise wheel), or the blind buyout market offers three veterans for your weakest spot."], ["Real simulation math", `A tail-recursive loop resolves a game every ${Actions_seasonTickMs} milliseconds, writing a log entry each tick. Every night's box score is distributed live through a PlayerSeason tracker — scoring weighted to the stars, assists toward the guards, steals and blocks toward the bigs.`]]);
    const howToPlay = createElement("section", createObj(ofArray([["id", "how-to-play"], ["className", "flex scroll-mt-8 flex-col gap-5"], (elems_17 = [sectionTitle("How to Play"), createElement("div", createObj(ofArray([["className", "flex flex-col gap-4"], (elems_16 = toList_1(delay(() => collect_1((matchValue_1) => {
        let elems_15, value_144, elems_14;
        const title_1 = matchValue_1[1][0];
        return singleton_2(createElement("div", createObj(ofArray([["key", title_1], ["className", "flex items-start gap-4"], (elems_15 = [createElement("div", createObj(ofArray([(value_144 = "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-orange-500/10 text-sm font-black text-orange-400 ring-1 ring-orange-500/20", ["className", value_144]), ["children", int32ToString(matchValue_1[0] + 1)]]))), createElement("div", createObj(ofArray([["className", "min-w-0 pt-1"], (elems_14 = [createElement("div", {
            className: "text-sm font-bold text-zinc-100",
            children: title_1,
        }), createElement("p", {
            className: "mt-1 text-xs leading-relaxed text-zinc-500",
            children: matchValue_1[1][1],
        })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
    }, indexed(howToPlaySteps)))), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])));
    const popularChallenges = createElement("section", createObj(ofArray([["className", "flex flex-col gap-5"], (elems_20 = [sectionTitle("Popular Challenges"), createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-2 sm:grid-cols-2"], (elems_19 = toList_1(delay(() => map_1((challenge) => {
        let value_168, elems_18;
        return createElement("div", createObj(ofArray([["key", challenge], (value_168 = "flex cursor-default select-none items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-3 text-left", ["className", value_168]), (elems_18 = [createElement("span", {
            className: "text-xs font-semibold text-zinc-300",
            children: challenge,
        }), createElement("span", {
            className: "shrink-0 text-zinc-600",
            children: "→",
        })], ["children", reactApi.Children.toArray(Array.from(elems_18))])])));
    }, ["Go a full 82-game season unbeaten", "Chase a perfect 82-0", "Win the NBA Championship", "Build a modern-era team (2010 onwards)", "Draft an all-time roster from every era", "Win it on Hard Mode with ratings hidden"]))), ["children", reactApi.Children.toArray(Array.from(elems_19))])])))], ["children", reactApi.Children.toArray(Array.from(elems_20))])])));
    const socialProof = createElement("section", createObj(ofArray([["className", "flex flex-col gap-5 rounded-xl border border-zinc-800 bg-zinc-900/40 p-6"], (elems_25 = [createElement("div", createObj(singleton((elems_21 = [createElement("h2", {
        className: "text-lg font-black text-zinc-50",
        children: "Settle the group-chat argument",
    }), createElement("p", createObj(ofArray([["className", "mt-2 text-xs leading-relaxed text-zinc-500"], (value_189 = "Every group chat has the same argument on a loop: whose five actually goes unbeaten? Banner Season turns that argument into a run you can settle — spin, draft, simulate, and post the record. The bad beats travel further than the perfect seasons.", ["children", value_189])])))], ["children", reactApi.Children.toArray(Array.from(elems_21))])))), createElement("div", createObj(ofArray([["className", "flex flex-col items-center gap-2 py-4"], (elems_23 = [createElement("div", {
        className: "font-mono text-4xl font-black tracking-tight text-orange-400",
        children: seasonsTotal.toLocaleString('en-US'),
    }), createElement("div", {
        className: "text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500",
        children: (seasonsTotal === 1) ? "Season simulated · and counting" : "Seasons simulated · and counting",
    }), createElement("div", createObj(ofArray([["className", "mt-1 inline-flex items-center gap-2"], (elems_22 = toList_1(delay(() => ((liveNow > 0) ? append_1(singleton_2(createElement("span", {
        className: "h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400",
    })), delay(() => singleton_2(createElement("span", {
        className: "text-[10px] font-bold uppercase tracking-[0.15em] text-emerald-400",
        children: (liveNow === 1) ? "1 person drafting right now" : (`${liveNow} people drafting right now`),
    })))) : append_1(singleton_2(createElement("span", {
        className: "h-1.5 w-1.5 animate-pulse rounded-full bg-orange-400",
    })), delay(() => singleton_2(createElement("span", {
        className: "text-[10px] font-bold uppercase tracking-[0.15em] text-orange-400",
        children: "Every one real — add yours",
    }))))))), ["children", reactApi.Children.toArray(Array.from(elems_22))])])))], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-4 border-t border-zinc-800 pt-5"], (elems_24 = [statCell(int32ToString(totalPlayerSeasons), "Real player seasons"), statCell(int32ToString(totalFranchises), "Historic team pools"), statCell("1947", "Every season since")], ["children", reactApi.Children.toArray(Array.from(elems_24))])])))], ["children", reactApi.Children.toArray(Array.from(elems_25))])])));
    const explainer = createElement("section", createObj(ofArray([["className", "flex flex-col gap-4"], (elems_26 = [sectionTitle("What is Banner Season?"), createElement("p", {
        className: "text-sm leading-relaxed text-zinc-400",
        children: `Banner Season is a free basketball draft game built on ${totalPlayerSeasons} player-seasons drawn from ${totalFranchises} historic NBA squads, spanning ${landingSeasonRange}. That pool is not curated down to the greats: ${totalFranchises - totalSpoilerPools} genuine contenders sit alongside ${totalSpoilerPools} of the worst teams the league has ever iced, and narrowing the era filter never removes them. You do not manage a franchise or track live scores — you assemble one roster and find out how far it goes.`,
    }), createElement("p", createObj(ofArray([["className", "text-sm leading-relaxed text-zinc-400"], (value_230 = "The appeal is the era-mixing. The wheel does not care about chronology, so a single lineup can put 1996 Michael Jordan beside 2016 LeBron James and 2023 Nikola Jokić — the exact matchup that basketball arguments never resolve, played out instead of debated.", ["children", value_230])]))), createElement("p", createObj(ofArray([["className", "text-sm leading-relaxed text-zinc-400"], (value_234 = "Underneath, every roster resolves to a single team rating built from historical production and video-game-style badge profiles. That rating sets a per-game win probability, and the simulator plays out a full 82-game regular season one result at a time.", ["children", value_234])])))], ["children", reactApi.Children.toArray(Array.from(elems_26))])])));
    const faqSection = createElement("section", createObj(ofArray([["className", "flex flex-col gap-5"], (elems_30 = [sectionTitle("Frequently Asked Questions"), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_29 = toList_1(delay(() => collect_1((matchValue_2) => {
        let isOpen, elems_28;
        const question = matchValue_2[1][0];
        const i_1 = matchValue_2[0] | 0;
        return singleton_2((isOpen = equals(patternInput[0], i_1), createElement("div", createObj(ofArray([["key", question], ["className", "overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900/40"], (elems_28 = toList_1(delay(() => {
            let value_245, elems_27;
            return append_1(singleton_2(createElement("button", createObj(ofArray([(value_245 = "flex w-full items-center justify-between gap-4 px-4 py-3 text-left transition-colors hover:bg-zinc-900/60", ["className", value_245]), ["onClick", (_arg_5) => {
                patternInput[1](isOpen ? undefined : i_1);
            }], (elems_27 = [createElement("span", {
                className: "text-sm font-semibold " + (isOpen ? "text-orange-400" : "text-zinc-200"),
                children: question,
            }), createElement("span", {
                className: "shrink-0 text-lg leading-none transition-transform " + (isOpen ? "rotate-45 text-orange-400" : "text-zinc-600"),
                children: "+",
            })], ["children", reactApi.Children.toArray(Array.from(elems_27))])])))), delay(() => (isOpen ? singleton_2(createElement("p", {
                className: "border-t border-zinc-800 px-4 py-3 text-xs leading-relaxed text-zinc-400",
                children: matchValue_2[1][1],
            })) : empty_2())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_28))])])))));
    }, indexed(ofArray([["What is Banner Season?", "A free browser game where you draft eight players from historic NBA rosters and simulate a full 82-game season, chasing a perfect record."], ["How do you play Banner Season?", "Spin the wheel to land on a historic squad, draft one player from it, and repeat until your five starters and three bench spots are filled. Pick a system, then watch the season play out."], ["Which players and franchises are included?", `${totalFranchises} historic team pools covering ${landingSeasonRange} — championship sides alongside deliberately dreadful ones, because the wheel is not on your side.`], ["Is Banner Season free to play?", "Yes, and no account is needed. Signing in only backs up your run history and streaks so they survive across devices."], ["Is Banner Season a fantasy basketball game?", "No. It is not tied to live games, real-world scoring, or any current season. Every roster is drawn from completed historical seasons."], ["Is Banner Season affiliated with the NBA?", "No. It is an independent fan project with no affiliation, endorsement, or licence from the NBA, any club, or any game publisher."], ["Where do the player ratings come from?", "They are approximations mapped onto a 0-99 scale from each player\'s production in that specific season. They are this game\'s own numbers, not official ratings from any publisher."], ["Why is it called Banner Season?", "A banner season is the kind they hang in the rafters. Every run here chases one — a title-worthy record, a franchise best, or the perfect 82-0 no real team has ever pulled off (the 2015-16 Warriors got closest at 73-9)."]]))))), ["children", reactApi.Children.toArray(Array.from(elems_29))])])))], ["children", reactApi.Children.toArray(Array.from(elems_30))])])));
    const explore = createElement("section", createObj(ofArray([["className", "flex flex-col gap-5"], (elems_33 = [sectionTitle("Explore Banner Season"), createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-3 sm:grid-cols-2"], (elems_32 = toList_1(delay(() => collect_1((matchValue_3) => {
        let value_270, elems_31;
        const title_2 = matchValue_3[0];
        return singleton_2(createElement("div", createObj(ofArray([["key", title_2], (value_270 = "flex cursor-pointer flex-col gap-1 rounded-xl border border-zinc-800 bg-zinc-900/40 p-4 transition-all hover:border-orange-500/40 hover:bg-zinc-900/60", ["className", value_270]), ["onClick", (_arg_6) => {
            matchValue_3[2]();
        }], (elems_31 = [createElement("div", {
            className: "text-sm font-bold text-zinc-100",
            children: `${title_2} →`,
        }), createElement("p", {
            className: "text-xs leading-relaxed text-zinc-500",
            children: matchValue_3[1],
        })], ["children", reactApi.Children.toArray(Array.from(elems_31))])]))));
    }, [["Basketball draft game", "How the spin-and-draft format works.", () => {
        Actions_navigateToDraftGuide(setState);
    }], ["All-time Roster builder", "Combine legends and modern stars into one team.", () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }], ["Greatest all-time 5", "The starting lineup every group chat falls out over.", () => {
        Actions_navigateToGreatestLineupGuide(setState);
    }], ["Season simulator", "What happens when you play out all 82 games.", () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }], ["How to play Banner Season", "A step-by-step guide to your first run.", () => {
        Actions_navigateToHowToPlayGuide(setState);
    }]]))), ["children", reactApi.Children.toArray(Array.from(elems_32))])])))], ["children", reactApi.Children.toArray(Array.from(elems_33))])])));
    return createElement("div", createObj(ofArray([["className", "w-full min-h-screen bg-zinc-950 relative overflow-hidden flex flex-col justify-between pt-4 pb-8"], (elems_35 = [createElement("div", {
        className: "relative z-10 flex flex-col gap-16",
        children: reactApi.Children.toArray([hero, modes, howToPlay, popularChallenges, socialProof, explainer, faqSection, explore]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_35))])])));
}

export function ConfettiBurst() {
    let elems;
    const patternInput = useState(0);
    const setBurst = patternInput[1];
    const burst = patternInput[0] | 0;
    const wasInView = reactApi.useRef(true);
    const sentinel = reactApi.useRef(undefined);
    useEffectDisposableOnce(() => {
        const onVisibility = (_arg) => {
            if (!document.hidden) {
                setBurst((b) => (b + 1));
            }
        };
        document.addEventListener("visibilitychange", onVisibility);
        return createDisposable(() => {
            document.removeEventListener("visibilitychange", onVisibility);
        });
    });
    useEffectDisposableOnce(() => {
        const matchValue = sentinel.current;
        if (matchValue != null) {
            const el = matchValue;
            const observer = new IntersectionObserver(((entries) => {
                const inView = entries[0].isIntersecting;
                if (inView && !wasInView.current) {
                    setBurst((b_1) => (b_1 + 1));
                }
                wasInView.current = inView;
            }), { threshold: 0.1 });
            observer.observe(el);
            return createDisposable(() => {
                observer.disconnect();
            });
        }
        else {
            return createDisposable(() => {
            });
        }
    });
    const palette = ["#f97316", "#fbbf24", "#34d399", "#60a5fa", "#f472b6", "#e4e4e7"];
    return createElement("div", createObj(ofArray([["className", "pointer-events-none"], ["aria-hidden", true], (elems = toList_1(delay(() => append_1(singleton_2(createElement("span", {
        ref: sentinel,
        className: "block h-px w-px",
    })), delay(() => collect_1((i) => {
        const seed = (i + (burst * 101)) | 0;
        const h1 = (((seed * 631) + 89) % 997) | 0;
        const h2 = (((seed * 271) + 31) % 907) | 0;
        return singleton_2(createElement("span", {
            key: toText(interpolate("%d%P()-%d%P()", [burst, i])),
            className: "confetti-piece",
            style: {
                left: (h1 % 100) + "%",
                backgroundColor: item_1(seed % palette.length, palette),
                animationDuration: toText(interpolate("%d%P()ms", [2800 + (h2 * 3)])),
                animationDelay: toText(interpolate("%d%P()ms", [(h1 * 7) % 2600])),
            },
        }));
    }, rangeDouble(0, 1, 99)))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function AppView() {
    let copyOfStruct, elems_56, elems_55, value_696, elems_57, elems_59, elems_58, value_713, elems_64, elems_60, elems_62, elems_61, elems_63, elems_69, elems_70, elems_74, elems_79, elems_83, elems_89, elems_87, elems_88, value_1044, value_1048, elems_102, elems_107, value_1229, elems_106, value_1235, value_1240, elems_115, elems_113, elems_111, seed, wins, elems_112, elems_114, elems_118, elems_119, value_1369, elems_123, elems_122, elems_121, value_1406, value_1411, elems_127, elems_126, elems_125, elems_129, elems_128, value_1469, value_1471, value_1476, elems_131, elems_130, value_1503, elems_137, value_1512, elems_136, value_1518, elems_133, elems_132, elems_135, elems_134, value_1566, elems_139, elems_138, value_1593, value_1598, elems_144, elems_143, elems_142, elems_152, elems_151, elems_150, value_1716, w_2, l_2, finalRank, matchValue_43, leagueWinner, isChampion, patternInput_39, winPct, raw, panel, metricBox, earnedBadges, verdict, blockBadges, elems_17, recapHeadline, narrativeParagraphs, coachLine_1, matchValue_45, coach_3, coach_4, deadlineParagraph, matchValue_46, delta_1, outs, ins, net, matchValue_47, scorerLine, matchValue_48, player_12, line_3, player_13, projectionLine, matchValue_49, projected_3, projected_4, projected_5, extremesLine, matchValue_50, big, averageUnit, starterList, unitRatings, unitSummary, patternInput_40, patternInput_41, blockSystem, elems_22, blockTable, headCell, elems_30, elems_28, elems_24, elems_23, elems_27, elems_29, awardCard, benchLeader, _arg_24, biggestWin, _arg_27, highestScoring, recordCard, extremeCard, blockAwards, elems_37, value_433, elems_34, value_440, value_450, elems_35, elems_36, blockStandings, matchValue_56, rivals_1, table_4, replacedTeam, elems_40, blockLeaderboard, elems_41, value_509, submitting, archivedRun, blockActions, elems_44, blockFranchiseRecord, matchValue_61, franchise, patternInput_42, elems_45, blockSavedLine, blockEmailCard, value_605, elems_46, value_609, value_614, elems_48, value_1725, elements, path, elems_166, elems_172, elems_171, elems_168, elems_167, elems_170, value_1918, elems_179, elems_174, value_1922, elems_173, elems_178, elems_176, elems_175, elems_177, elems_182, elems_181, value_1984, elems_185, elems_187, elems_191, elems_189, value_2034, elems_188, elems_190, value_2059, value_2064, value_2069, elems_193, value_2073, value_2125, elems_197, elems_198, elems_199, value_2150, elems_201, elems_205, elems_213, elems_211, elems_207, elems_206, matchValue_97, daily_4, result_4, featuredName, tick_1, elems_209, value_2301, elems_217, elems_218, elems_219, elems_224, value_2370, elems_223, value_2378, value_2380, elems_230, elems_228, value_2429, elems_229, value_2439, elems_234, value_2469, elems_233, value_2484, elems_238, value_2531, elems_254, elems_273, elems_295, elems_300, value_3228, value_3238, elems_298, elems_299, value_3250, elems_315, value_3271, value_3285, elems_304, elems_303, elems_308, elems_307, elems_312, elems_309, elems_310, elems_311, elems_313, value_3391, elems_314, value_3413, elems_320, value_3443, value_3453, elems_318, elems_319, value_3466, value_3476, value_3486, elems_337, elems_342, elems_340, elems_341, value_3742, value_3747, elems_348, value_3799, elems_347, value_3808, value_3812, value_3817, elems_352, elems_357, elems_355, elems_356, value_3955, elems_358, elems_359, elems_364, elems_363, value_4004, elems_362, value_4009, value_4055, elems_372, elems_373, value_4090, value_4201, elems_382, value_4210, elems_383, value_4230, elems_385, matchValue_124;
    const patternInput = useState(initialState);
    const state = patternInput[0];
    const setState = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setActiveSlot = patternInput_1[1];
    const activeSlot = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setSpinning = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setPendingPlayer = patternInput_3[1];
    const pendingPlayer = patternInput_3[0];
    const patternInput_4 = reactApi.useState("Rating");
    const draftSort = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setMoveMode = patternInput_5[1];
    const moveMode = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setCoachSpinning = patternInput_6[1];
    const coachSpinning = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const shareCopied = patternInput_7[0];
    const setShareCopied = patternInput_7[1];
    const patternInput_8 = reactApi.useState(undefined);
    const setMovingFrom = patternInput_8[1];
    const movingFrom = patternInput_8[0];
    let patternInput_9;
    const initial_9 = equals(Store_loadEmailOptChoice(), "in");
    patternInput_9 = reactApi.useState(initial_9);
    let patternInput_10;
    const initial_10 = Store_loadEmailOptChoice();
    patternInput_10 = reactApi.useState(initial_10);
    const recordEmailChoice = (optedIn) => {
        const choice = optedIn ? "in" : "dismissed";
        patternInput_9[1](optedIn);
        patternInput_10[1](choice);
        Store_saveEmailOptChoice(choice);
        Backend_setEmailOptInCloud(optedIn);
    };
    let patternInput_11;
    const initial_11 = Actions_tickMultiplier() | 0;
    patternInput_11 = reactApi.useState(initial_11);
    const tickSpeed = patternInput_11[0] | 0;
    const setTickSpeed = patternInput_11[1];
    const patternInput_12 = reactApi.useState(false);
    const setCookiePrefsOpen = patternInput_12[1];
    let patternInput_13;
    const initial_13 = defaultArg(Backend_savedHandle(), "");
    patternInput_13 = reactApi.useState(initial_13);
    const submitHandle = patternInput_13[0];
    const patternInput_14 = reactApi.useState(new Backend_SubmitStatus(0, []));
    const submitStatus = patternInput_14[0];
    const setSubmitStatus = patternInput_14[1];
    const patternInput_15 = reactApi.useState("");
    const discordEmail = patternInput_15[0];
    const patternInput_16 = reactApi.useState(false);
    const discordNews = patternInput_16[0];
    const patternInput_17 = reactApi.useState(false);
    const discordMod = patternInput_17[0];
    const patternInput_18 = reactApi.useState(new Backend_WaitlistStatus(0, []));
    const setDiscordStatus = patternInput_18[1];
    const discordStatus = patternInput_18[0];
    const patternInput_19 = reactApi.useState(0);
    const liveNow = patternInput_19[0] | 0;
    let isMidRun;
    const matchValue = state.Phase;
    switch (matchValue.tag) {
        case 0:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 21: {
            isMidRun = false;
            break;
        }
        default:
            isMidRun = true;
    }
    useEffectOnce(() => {
        Backend_startPresence(false, patternInput_19[1]);
    });
    const dependencies = [isMidRun];
    reactApi.useEffect(() => {
        Backend_setPresencePlaying(isMidRun);
    }, dependencies);
    const patternInput_20 = reactApi.useState(0);
    const setSeasonsTotal = patternInput_20[1];
    useEffectOnce(() => {
        Backend_fetchSeasonsSimulated(setSeasonsTotal);
    });
    const isSeasonCompletePhase = state.Phase.tag === 21;
    const dependencies_2 = [isSeasonCompletePhase];
    reactApi.useEffect(() => {
        if (isSeasonCompletePhase) {
            Backend_fetchSeasonsSimulated(setSeasonsTotal);
        }
    }, dependencies_2);
    let patternInput_21;
    const initial_21 = defaultArg(Backend_savedHandle(), "");
    patternInput_21 = reactApi.useState(initial_21);
    const leagueHandle = patternInput_21[0];
    const patternInput_22 = reactApi.useState("");
    const setLeagueNameInput = patternInput_22[1];
    const leagueNameInput = patternInput_22[0];
    const patternInput_23 = reactApi.useState("");
    const setLeagueCodeInput = patternInput_23[1];
    const leagueCodeInput = patternInput_23[0];
    const patternInput_24 = reactApi.useState(empty_1());
    const setMyLeagues = patternInput_24[1];
    const myLeagues = patternInput_24[0];
    const patternInput_25 = reactApi.useState(undefined);
    const setActiveLeague = patternInput_25[1];
    const patternInput_26 = reactApi.useState(empty_1());
    const setLeagueRows = patternInput_26[1];
    const leagueRows = patternInput_26[0];
    const patternInput_27 = reactApi.useState(false);
    const setLeagueBusy = patternInput_27[1];
    const leagueBusy = patternInput_27[0];
    const patternInput_28 = reactApi.useState(undefined);
    const setLeagueMsg = patternInput_28[1];
    const leagueMsg = patternInput_28[0];
    const openLeague = (league) => {
        setActiveLeague(league);
        setLeagueRows(empty_1());
        setLeagueMsg(undefined);
        Backend_fetchLeagueStandings(league.Id, (result) => {
            if (result.tag === 1) {
                setLeagueMsg(new FSharpResult$2(1, [result.fields[0]]));
            }
            else {
                setLeagueRows(result.fields[0]);
            }
        });
    };
    const onLeaguesPage = equals(state.Phase, new ConsolePhase(30, []));
    const dependencies_4 = [onLeaguesPage];
    reactApi.useEffect(() => {
        if (onLeaguesPage && Backend_isConfigured) {
            Backend_fetchMyLeagues((result_1) => {
                if (result_1.tag === 1) {
                }
                else {
                    setMyLeagues(result_1.fields[0]);
                }
            });
        }
    }, dependencies_4);
    let liveKey;
    const initialValue = substring((copyOfStruct = newGuid(), copyOfStruct), 0, 8);
    liveKey = (reactApi.useRef(initialValue));
    const liveRoomRef = reactApi.useRef(undefined);
    const patternInput_29 = reactApi.useState(undefined);
    const liveIsHostRef = reactApi.useRef(false);
    const patternInput_30 = reactApi.useState(empty_1());
    const setLivePeers = patternInput_30[1];
    const livePeers = patternInput_30[0];
    const patternInput_31 = reactApi.useState(false);
    const setLiveConnected = patternInput_31[1];
    const liveConnected = patternInput_31[0];
    const patternInput_32 = reactApi.useState("");
    const setLiveActiveCode = patternInput_32[1];
    const liveActiveCode = patternInput_32[0];
    const patternInput_33 = reactApi.useState("");
    const liveCodeInput = patternInput_33[0];
    const patternInput_34 = reactApi.useState("");
    const setLiveErr = patternInput_34[1];
    const liveErr = patternInput_34[0];
    const patternInput_35 = useState(empty_1());
    const setLiveChat = patternInput_35[1];
    const liveChat = patternInput_35[0];
    const patternInput_36 = reactApi.useState("");
    const setLiveChatInput = patternInput_36[1];
    const liveChatInput = patternInput_36[0];
    const patternInput_37 = useState(0);
    const liveTick = patternInput_37[0] | 0;
    const setLiveRoom = (room) => {
        liveRoomRef.current = room;
        patternInput_29[1](room);
    };
    const hostApply = (next) => {
        setLiveRoom(next);
        const encoded = LiveDraft_encode(next);
        Backend_sendDraftEvent("state", encoded);
        Store_updateLiveSnapshot(encoded);
    };
    const enterDraftRoom = (code, asHost, handle, restored) => {
        liveIsHostRef.current = asHost;
        setLiveRoom(restored);
        setLivePeers(empty_1());
        setLiveChat((_arg) => empty_1());
        setLiveErr("");
        setLiveActiveCode(code);
        Store_saveLiveTicket(new Store_LiveTicket(code, liveKey.current, handle, asHost, ""));
        if (restored == null) {
        }
        else {
            Store_updateLiveSnapshot(LiveDraft_encode(restored));
        }
        Backend_joinDraftRoom(code, liveKey.current, handle, (peers) => {
            setLivePeers(peers);
            if (liveIsHostRef.current) {
                const matchValue_5 = liveRoomRef.current;
                if (matchValue_5 == null) {
                }
                else {
                    Backend_sendDraftEvent("state", LiveDraft_encode(matchValue_5));
                }
            }
        }, (payload) => {
            if (liveIsHostRef.current) {
                const matchValue_2 = liveRoomRef.current;
                if (matchValue_2 == null) {
                }
                else {
                    const room_1 = matchValue_2;
                    const matchValue_3 = Backend_parseDraftAction(payload);
                    if (matchValue_3.tag === 1) {
                    }
                    else {
                        const matchValue_4 = LiveDraft_applyPick(room_1, matchValue_3.fields[0], matchValue_3.fields[1]);
                        if (matchValue_4 == null) {
                        }
                        else {
                            hostApply(matchValue_4);
                        }
                    }
                }
            }
        }, (payload_1) => {
            const matchValue_6 = LiveDraft_decode(payload_1);
            if (matchValue_6 == null) {
            }
            else {
                setLiveRoom(matchValue_6);
            }
        }, (payload_2) => {
            const matchValue_7 = Backend_parseChat(payload_2);
            if (matchValue_7 == null) {
            }
            else {
                const who = matchValue_7[0];
                const text = matchValue_7[1];
                setLiveChat((history) => cons([who, text], truncate(29, history)));
            }
        }, (ok) => {
            setLiveConnected(ok);
            if (!ok) {
                setLiveErr("Could not open a live connection. Check your internet and try again.");
            }
        });
    };
    const resetLiveState = () => {
        Backend_leaveDraftRoom();
        liveIsHostRef.current = false;
        setLiveRoom(undefined);
        setLivePeers(empty_1());
        setLiveChat((_arg_1) => empty_1());
        setLiveConnected(false);
        setLiveActiveCode("");
        setLiveErr("");
    };
    const leaveLiveRoom = () => {
        Store_clearLiveTicket();
        resetLiveState();
    };
    const sendChat = () => {
        const text_1 = liveChatInput.trim();
        if (text_1 !== "") {
            let handle_1;
            const matchValue_8 = liveRoomRef.current;
            handle_1 = ((matchValue_8 == null) ? defaultArg(map_2((tuple) => tuple[1], tryFind((tupledArg) => (tupledArg[0] === liveKey.current), livePeers)), "Manager") : defaultArg(map_2((m_1) => m_1.Handle, tryFind((m) => (m.Key === liveKey.current), matchValue_8.Members)), "Manager"));
            Backend_sendDraftEvent("chat", Backend_chatPayload(handle_1, text_1));
            setLiveChat((history_1) => cons([handle_1, text_1], truncate(29, history_1)));
            setLiveChatInput("");
        }
    };
    const liveAutoPick = () => {
        const matchValue_11 = liveRoomRef.current;
        if (matchValue_11 == null) {
        }
        else {
            const room_7 = matchValue_11;
            const matchValue_12 = FSharpMap__TryFind(poolById, room_7.PoolId);
            const matchValue_13 = LiveDraft_memberOnTurn(room_7);
            let matchResult, onTurn, pool;
            if (matchValue_12 != null) {
                if (matchValue_13 != null) {
                    matchResult = 0;
                    onTurn = matchValue_13;
                    pool = matchValue_12;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const matchValue_15 = LiveDraft_bestAutoPick(room_7, pool);
                    if (matchValue_15 == null) {
                    }
                    else {
                        const matchValue_16 = LiveDraft_applyPick(room_7, onTurn.Key, matchValue_15);
                        if (matchValue_16 == null) {
                        }
                        else {
                            hostApply(matchValue_16);
                        }
                    }
                    break;
                }
                case 1: {
                    break;
                }
            }
        }
    };
    const onLiveDraftPage = equals(state.Phase, new ConsolePhase(29, []));
    useEffectWithDeps(() => {
        if (onLiveDraftPage) {
            const id = window.setInterval(() => {
                patternInput_37[1]((tick) => (tick + 1));
            }, 1000);
            return createDisposable(() => {
                window.clearInterval(id);
            });
        }
        else {
            return createDisposable(() => {
            });
        }
    }, [onLiveDraftPage]);
    const dependencies_7 = [liveTick];
    reactApi.useEffect(() => {
        let room_8;
        if (liveIsHostRef.current) {
            const matchValue_17 = liveRoomRef.current;
            let matchResult_1, room_9;
            if (matchValue_17 != null) {
                if ((room_8 = matchValue_17, ((room_8.Started && !LiveDraft_draftDone(room_8)) && (room_8.TurnDeadline > 0)) && ((Date.now()) > (room_8.TurnDeadline + 500)))) {
                    matchResult_1 = 0;
                    room_9 = matchValue_17;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    liveAutoPick();
                    break;
                }
                case 1: {
                    break;
                }
            }
        }
    }, dependencies_7);
    useEffectOnce(() => {
        const matchValue_18 = Store_loadLiveTicket();
        if (matchValue_18 == null) {
        }
        else {
            Actions_navigateToLiveDraftSetup(setState);
        }
    });
    const dependencies_9 = [onLiveDraftPage];
    reactApi.useEffect(() => {
        if ((onLiveDraftPage && !liveConnected) && Backend_isConfigured) {
            const matchValue_19 = Store_loadLiveTicket();
            if (matchValue_19 == null) {
            }
            else {
                const ticket = matchValue_19;
                liveKey.current = ticket.Key;
                enterDraftRoom(ticket.Code, ticket.IsHost, ticket.Handle, ticket.IsHost ? bind(LiveDraft_decode, Store_parseLiveSnapshot(ticket.SnapshotJson)) : undefined);
            }
        }
    }, dependencies_9);
    const dependencies_11 = [onLiveDraftPage];
    reactApi.useEffect(() => {
        if (!onLiveDraftPage && liveConnected) {
            resetLiveState();
        }
    }, dependencies_11);
    const dependencies_13 = [state.UserRuns];
    reactApi.useEffect(() => {
        setSubmitStatus(new Backend_SubmitStatus(0, []));
    }, dependencies_13);
    useEffectOnce(() => {
        const storedProfile = Store_loadProfile();
        const storedRuns = Store_loadRuns();
        setState((st) => (new GameState(st.Phase, st.Roster, st.SystemArchetype, st.Config, st.RerollsAvailable, st.DrawnFranchiseIds, st.FranchiseLock, st.Blueprint, st.DailyRun, st.IsKnowledgeMode, st.DraftModeSetting, st.StartEraIndex, st.EndEraIndex, st.HeadCoachesEnabled, st.SelectedCoach, st.IsTradeResolved, st.TradeOutcome, st.IsInstantSkipActive, st.PlayerSeason, st.TradedInPlayerIds, st.DeadlineDeals, st.ProjectedWins, st.RivalStandings, st.PlayoffRecords, st.PlayoffOutcome, st.PlayoffsEnabled, st.TradeDeadlineEnabled, st.SeasonLuck, st.Wins, st.Losses, st.GameLog, storedProfile, storedRuns)));
    });
    const saveArmed = reactApi.useRef(false);
    const dependencies_15 = [state.Profile, state.UserRuns];
    reactApi.useEffect(() => {
        if (saveArmed.current) {
            Store_saveProfile(state.Profile);
            Store_saveRuns(state.UserRuns);
            Backend_saveProfileCloud(state.Profile);
        }
        else {
            saveArmed.current = true;
        }
    }, dependencies_15);
    const patternInput_38 = reactApi.useState(undefined);
    const setAuthError = patternInput_38[1];
    useEffectOnce(() => {
        Backend_fetchAuthIdentity((identity) => {
            if (identity != null) {
                const uid = identity[0];
                const email = identity[1];
                setState((st_1) => {
                    let bind$0040;
                    return new GameState(st_1.Phase, st_1.Roster, st_1.SystemArchetype, st_1.Config, st_1.RerollsAvailable, st_1.DrawnFranchiseIds, st_1.FranchiseLock, st_1.Blueprint, st_1.DailyRun, st_1.IsKnowledgeMode, st_1.DraftModeSetting, st_1.StartEraIndex, st_1.EndEraIndex, st_1.HeadCoachesEnabled, st_1.SelectedCoach, st_1.IsTradeResolved, st_1.TradeOutcome, st_1.IsInstantSkipActive, st_1.PlayerSeason, st_1.TradedInPlayerIds, st_1.DeadlineDeals, st_1.ProjectedWins, st_1.RivalStandings, st_1.PlayoffRecords, st_1.PlayoffOutcome, st_1.PlayoffsEnabled, st_1.TradeDeadlineEnabled, st_1.SeasonLuck, st_1.Wins, st_1.Losses, st_1.GameLog, (bind$0040 = st_1.Profile, new UserProfile(true, uid, email, bind$0040.CurrentStreak, bind$0040.HighestStreak, bind$0040.Trophies)), st_1.UserRuns);
                });
                Backend_fetchProfileCloud(uid, (cloud) => {
                    if (cloud != null) {
                        const cloudTrophies = cloud[2];
                        const cloudHighest = cloud[1] | 0;
                        const cloudCurrent = cloud[0] | 0;
                        setState((st_2) => {
                            const local = st_2.Profile;
                            return new GameState(st_2.Phase, st_2.Roster, st_2.SystemArchetype, st_2.Config, st_2.RerollsAvailable, st_2.DrawnFranchiseIds, st_2.FranchiseLock, st_2.Blueprint, st_2.DailyRun, st_2.IsKnowledgeMode, st_2.DraftModeSetting, st_2.StartEraIndex, st_2.EndEraIndex, st_2.HeadCoachesEnabled, st_2.SelectedCoach, st_2.IsTradeResolved, st_2.TradeOutcome, st_2.IsInstantSkipActive, st_2.PlayerSeason, st_2.TradedInPlayerIds, st_2.DeadlineDeals, st_2.ProjectedWins, st_2.RivalStandings, st_2.PlayoffRecords, st_2.PlayoffOutcome, st_2.PlayoffsEnabled, st_2.TradeDeadlineEnabled, st_2.SeasonLuck, st_2.Wins, st_2.Losses, st_2.GameLog, new UserProfile(local.IsSignedIn, local.UserId, local.Email, max(local.CurrentStreak, cloudCurrent), max(local.HighestStreak, cloudHighest), append(local.Trophies, filter((t) => !contains(t, local.Trophies, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: stringHash,
                            }), cloudTrophies))), st_2.UserRuns);
                        });
                    }
                });
            }
        });
    });
    const dependencies_17 = [toString_1(state.Phase), state.Roster];
    reactApi.useEffect(() => {
        const matchValue_20 = state.Phase;
        switch (matchValue_20.tag) {
            case 2:
            case 3:
            case 4:
            case 5:
            case 6: {
                if (state.DailyRun == null) {
                    Store_saveDraft(state);
                }
                break;
            }
            case 20:
            case 21: {
                Store_clearDraft();
                break;
            }
            default:
                undefined;
        }
    }, dependencies_17);
    const dependencies_19 = [state.Phase];
    reactApi.useEffect(() => {
        const matchValue_21 = state.Phase;
        switch (matchValue_21.tag) {
            case 20: {
                Actions_runSeason(setState, state.Roster, state.SystemArchetype, state.SelectedCoach, state.FranchiseLock, state.SeasonLuck, (state.Wins + state.Losses) + 1, state.TradeDeadlineEnabled && !state.IsTradeResolved);
                break;
            }
            case 2: {
                setSpinning(false);
                break;
            }
            case 4: {
                setSpinning(false);
                setPendingPlayer(undefined);
                break;
            }
            case 0: {
                setActiveSlot(undefined);
                break;
            }
            default:
                undefined;
        }
    }, dependencies_19);
    const teamOvr = Engine_calculateTeamRatings(state.Roster) | 0;
    const hideRatings = state.IsKnowledgeMode;
    const squadFirst = state.DraftModeSetting === draftModeSquadFirst;
    const targetPosFilter = squadFirst ? undefined : map_2(positionOfSlot, filter_1((slot) => !contains(slot, benchSlots, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    }), activeSlot));
    const triggerSpin = () => {
        if (!patternInput_2[0] && (squadFirst ? true : (activeSlot != null))) {
            setSpinning(true);
            Actions_spinWheel(setState, state.Config, state.FranchiseLock, targetPosFilter, state.StartEraIndex, state.EndEraIndex, state.DrawnFranchiseIds, state.Roster);
        }
    };
    useEffect(() => {
        const onKeyDown = (ev) => {
            if (ev.key === " ") {
                const matchValue_22 = state.Phase;
                switch (matchValue_22.tag) {
                    case 2: {
                        ev.preventDefault();
                        triggerSpin();
                        break;
                    }
                    case 3: {
                        ev.preventDefault();
                        break;
                    }
                    default:
                        undefined;
                }
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return createDisposable(() => {
            document.removeEventListener("keydown", onKeyDown);
        });
    });
    const dependencies_21 = [toString_1(state.Phase)];
    reactApi.useEffect(() => {
        const matchValue_23 = state.Phase;
        switch (matchValue_23.tag) {
            case 0:
            case 1:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41: {
                window.scrollTo(0, 0);
                break;
            }
            default:
                undefined;
        }
    }, dependencies_21);
    let isDrafting;
    const matchValue_24 = state.Phase;
    switch (matchValue_24.tag) {
        case 2:
        case 3:
        case 4: {
            isDrafting = true;
            break;
        }
        default:
            isDrafting = false;
    }
    const runSlots = append(blueprintSlotIds(state.Blueprint), benchSlots);
    const targetSlot = defaultArg(orElse(activeSlot, Actions_nextOpenSlot(runSlots, state.Roster)), head(runSlots));
    const dailyScore = (daily, roster) => {
        const featuredFranchise = franchiseOfPool(daily.PoolId);
        const featuredDecade = ~~(poolSeasonYear(daily.PoolId) / 10) | 0;
        const others = filter((p) => (p.Id !== daily.Star.Id), map((tuple_1) => tuple_1[1], toList(roster)));
        const fitsFranchise = (p_1) => {
            const matchValue_25 = franchiseOfPool(Engine_franchiseOfPlayer(p_1));
            let matchResult_2, a, b;
            if (matchValue_25 != null) {
                if (featuredFranchise != null) {
                    matchResult_2 = 0;
                    a = matchValue_25;
                    b = featuredFranchise;
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0:
                    return a.Key === b.Key;
                default:
                    return false;
            }
        };
        const fitsPosition = (p_2) => (p_2.Pos === daily.Star.Pos);
        const fitsDecade = (p_3) => {
            const matchValue_27 = FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(p_3));
            if (matchValue_27 == null) {
                return false;
            }
            else {
                return ~~(poolSeasonYear(matchValue_27.Id) / 10) === featuredDecade;
            }
        };
        const Score = (1 + length(filter((p_4) => {
            if (fitsFranchise(p_4) ? true : fitsPosition(p_4)) {
                return true;
            }
            else {
                return fitsDecade(p_4);
            }
        }, others))) | 0;
        const HasFranchise = exists(fitsFranchise, others);
        const HasPosition = exists(fitsPosition, others);
        return {
            HasDecade: exists(fitsDecade, others),
            HasFranchise: HasFranchise,
            HasPosition: HasPosition,
            Score: Score,
        };
    };
    const dependencies_23 = [toString_1(state.Phase)];
    reactApi.useEffect(() => {
        const matchValue_29 = state.DailyRun;
        let matchResult_3;
        if (state.Phase.tag === 5) {
            if (matchValue_29 != null) {
                matchResult_3 = 0;
            }
            else {
                matchResult_3 = 1;
            }
        }
        else {
            matchResult_3 = 1;
        }
        switch (matchResult_3) {
            case 0: {
                const result_2 = dailyScore(matchValue_29, state.Roster);
                const progress = Store_dailyProgressToday();
                Store_saveDaily(new DailyProgress(progress.Date, progress.AttemptsUsed, max(progress.BestScore, result_2.Score), progress.Streak));
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_23);
    const placePending = (player, slot_2) => {
        setPendingPlayer(undefined);
        setActiveSlot(undefined);
        Actions_pickPlayer(setState, player, slot_2);
    };
    const tickerConsole = (footer) => {
        let elems_10;
        const currentGame = min((state.Wins + state.Losses) + 1, 82) | 0;
        let playstyleTag;
        const matchValue_36 = state.SelectedCoach;
        playstyleTag = ((matchValue_36 == null) ? state.SystemArchetype : (`${matchValue_36.Name} system`));
        let ppgAverage;
        const matchValue_37 = filter((g) => (g.Note == null), state.GameLog);
        ppgAverage = (isEmpty(matchValue_37) ? 0 : averageBy((g_1) => g_1.TeamScore, matchValue_37, {
            GetZero: () => 0,
            Add: (x_6, y_5) => (x_6 + y_5),
            DivideByInt: (x_5, i) => (x_5 / i),
        }));
        const statTile = (value_36, label, valueClasses) => {
            let elems_2;
            return createElement("div", createObj(ofArray([["key", label], ["className", "px-2"], (elems_2 = [createElement("div", {
                className: "text-lg font-black leading-none " + valueClasses,
                children: value_36,
            }), createElement("div", {
                className: "mt-1 text-[10px] font-bold uppercase tracking-widest text-zinc-500",
                children: label,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        };
        return createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_10 = toList_1(delay(() => {
            let value_93, elems_7, elems_6;
            return append_1(singleton_2(createElement("div", createObj(ofArray([(value_93 = "flex justify-between items-center w-full text-xs font-mono font-bold border-b border-zinc-900 pb-3 mb-4", ["className", value_93]), (elems_7 = [createElement("span", {
                className: "text-zinc-500 font-bold uppercase tracking-wider",
                children: `Game ${currentGame} / 82`,
            }), createElement("div", createObj(ofArray([["className", "flex items-center gap-4"], (elems_6 = toList_1(delay(() => append_1((((state.TradeDeadlineEnabled && (currentGame < Actions_tradeDeadlineGame)) && !state.IsTradeResolved) && equals(state.Phase, new ConsolePhase(20, []))) ? singleton_2(createElement("button", {
                className: "text-orange-400 hover:text-orange-300 font-bold cursor-pointer transition-colors",
                onClick: (_arg_4) => {
                    Actions_skipToGame(Actions_tradeDeadlineGame);
                },
                children: "⏭️ Skip to the Feb 6 deadline",
            })) : empty_2(), delay(() => {
                let value_106;
                return append_1(equals(state.Phase, new ConsolePhase(20, [])) ? singleton_2(createElement("button", createObj(ofArray([(value_106 = "text-zinc-500 hover:text-orange-500 text-xs font-mono font-bold tracking-wide transition-colors cursor-pointer select-none", ["className", value_106]), ["onClick", (_arg_5) => {
                    setTickSpeed(Actions_cycleTickSpeed());
                }], ["children", `⏩ ${tickSpeed}x`]])))) : empty_2(), delay(() => {
                    let value_111;
                    return (equals(state.Phase, new ConsolePhase(20, [])) && !state.IsInstantSkipActive) ? singleton_2(createElement("button", createObj(ofArray([(value_111 = "text-zinc-500 hover:text-orange-500 text-xs font-mono font-bold tracking-wide transition-colors cursor-pointer select-none", ["className", value_111]), ["onClick", (_arg_6) => {
                        Actions_skipRestOfSeason(setState);
                    }], ["children", "Skip all ➔"]])))) : empty_2();
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let matchValue_39, value_118;
                return append_1((matchValue_39 = state.TradeOutcome, (matchValue_39 == null) ? singleton_2(defaultOf_1()) : singleton_2(createElement("div", createObj(ofArray([(value_118 = "mb-3 rounded-xl border border-orange-500/40 bg-orange-500/5 px-4 py-2.5 text-[11px] font-mono text-orange-400", ["className", value_118]), ["children", matchValue_39]]))))), delay(() => {
                    let elems_8;
                    return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "h-80 overflow-y-auto pr-1"], (elems_8 = toList_1(delay(() => map_1((entry_1) => {
                        let elems_5, elems_4, elems_3, value_52;
                        const entry = entry_1;
                        const matchValue_38 = entry.Note;
                        return (matchValue_38 == null) ? createElement("div", createObj(ofArray([["key", entry.GameNumber], ["className", "w-full border p-4 rounded-xl flex flex-col gap-1 mb-2.5 animate-slideIn " + (entry.Won ? "bg-emerald-500/5 border-emerald-950/60" : "bg-red-500/5 border-red-950/60")], (elems_5 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3"], (elems_4 = [createElement("div", createObj(ofArray([["className", "flex min-w-0 items-center gap-2"], (elems_3 = [createElement("span", {
                            className: "shrink-0 font-mono text-[10px] font-black tracking-wider text-zinc-600",
                            children: `GM${entry.GameNumber}`,
                        }), createElement("span", {
                            className: "shrink-0 font-mono text-[9px] font-bold tracking-wide text-zinc-700",
                            children: gameDateLabel(entry.GameNumber),
                        }), createElement("span", {
                            className: "flex h-4 w-4 shrink-0 items-center justify-center rounded text-[9px] font-black " + (entry.Won ? "bg-emerald-500/20 text-emerald-400" : "bg-red-500/20 text-red-400"),
                            children: entry.Won ? "W" : "L",
                        }), createElement("span", {
                            className: "truncate text-xs font-semibold text-zinc-200",
                            children: entry.Opponent,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("span", {
                            className: "shrink-0 font-black text-sm " + (entry.Won ? "text-emerald-400" : "text-red-400"),
                            children: `${entry.TeamScore} - ${entry.OppScore}`,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", {
                            className: "text-[10px] text-zinc-500",
                            children: `${entry.StandoutLine} • ${playstyleTag}`,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))) : createElement("div", createObj(ofArray([["key", `note-${entry.GameNumber}`], (value_52 = "w-full bg-orange-500/5 border border-orange-950/60 p-4 rounded-xl mb-2.5 animate-slideIn text-[11px] font-mono leading-relaxed text-orange-400", ["className", value_52]), ["children", matchValue_38]])));
                    }, truncate(10, state.GameLog)))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let value_125, elems_9;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([(value_125 = "w-full bg-zinc-900/40 border border-zinc-900 rounded-2xl p-4 grid grid-cols-4 text-center divide-x divide-zinc-900 mb-6 mt-4", ["className", value_125]), (elems_9 = [statTile(int32ToString(state.Wins), "Wins", "text-white"), statTile(int32ToString(state.Losses), "Losses", "text-white"), statTile(hideRatings ? "??" : int32ToString(teamOvr), "Team OVR", "text-white"), statTile(toText(interpolate("%.1f%P()", [ppgAverage])), "PPG Avg", "text-orange-500")], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => singleton_2(footer)));
                    }));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
    };
    const buildShareSummary = (w, l) => {
        let matchValue_40;
        return `${(l === 0) ? "82-0 — PERFECT SEASON on bannerseason.app" : (`${w}-${l} on bannerseason.app`)}
Team OVR ${teamOvr} · ${state.SystemArchetype}${(matchValue_40 = state.SelectedCoach, (matchValue_40 == null) ? "" : (` · Coach ${matchValue_40.Name}`))}

${join("\n", choose((slot_6) => map_2((player_8) => (`${positionOfSlot(slot_6)}  ${player_8.Name} (${player_8.Ovr})`), FSharpMap__TryFind(state.Roster, slot_6)), runSlots))}`;
    };
    const longestWinStreak = fold((tupledArg_3, game) => {
        const best = tupledArg_3[0] | 0;
        if (game.Won) {
            const running = (tupledArg_3[1] + 1) | 0;
            return [max(best, running), running];
        }
        else {
            return [best, 0];
        }
    }, [0, 0], filter((g_2) => (g_2.Note == null), state.GameLog))[0] | 0;
    const seasonGames = filter((g_3) => (g_3.Note == null), state.GameLog);
    const pointsScored = sumBy((g_4) => g_4.TeamScore, seasonGames, {
        GetZero: () => 0,
        Add: (x_7, y_6) => (x_7 + y_6),
    }) | 0;
    const pointsAllowed = sumBy((g_5) => g_5.OppScore, seasonGames, {
        GetZero: () => 0,
        Add: (x_8, y_7) => (x_8 + y_7),
    }) | 0;
    const tradeTaken = !isEmpty(state.TradedInPlayerIds);
    const rankOrdinal = (rank) => {
        let matchValue_41, matchValue_42;
        return `${rank}${(matchValue_41 = ((rank % 100) | 0), (matchValue_41 === 11) ? "th" : ((matchValue_41 === 12) ? "th" : ((matchValue_41 === 13) ? "th" : ((matchValue_42 = ((rank % 10) | 0), (matchValue_42 === 1) ? "st" : ((matchValue_42 === 2) ? "nd" : ((matchValue_42 === 3) ? "rd" : "th")))))))}`;
    };
    const perGame = (total, games_1) => {
        if (games_1 === 0) {
            return 0;
        }
        else {
            return total / games_1;
        }
    };
    const rosterWithLines = choose((slot_7) => map_2((player_10) => [slot_7, player_10, defaultArg(tryFind_1(player_10.Id, state.PlayerSeason), emptySeasonLine)], FSharpMap__TryFind(state.Roster, slot_7)), runSlots);
    const awardLeader = (score) => {
        if (isEmpty(rosterWithLines)) {
            return undefined;
        }
        else {
            return maxBy(score, map((tupledArg_4) => [tupledArg_4[1], tupledArg_4[2]], rosterWithLines), {
                Compare: comparePrimitives,
            });
        }
    };
    const setupOption = (key_349, selected, title, subtext, onPick) => {
        let elems_50, elems_49;
        return createElement("button", createObj(ofArray([["key", key_349], ["className", "w-full rounded-xl border-2 p-3 text-left transition-colors " + (selected ? "border-orange-500 bg-zinc-900 ring-1 ring-orange-500/30" : "border-zinc-800 bg-zinc-900 hover:border-orange-500/40")], ["onClick", (_arg_46) => {
            onPick();
        }], (elems_50 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3"], (elems_49 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
            className: "text-sm font-bold " + (selected ? "text-orange-400" : "text-zinc-100"),
            children: title,
        })), delay(() => (selected ? singleton_2(createElement("span", {
            className: "shrink-0 text-xs font-black text-orange-500",
            children: "✓",
        })) : empty_2()))))), ["children", reactApi.Children.toArray(Array.from(elems_49))])]))), createElement("div", {
            className: "mt-1 text-[11px] leading-relaxed text-zinc-500",
            children: subtext,
        })], ["children", reactApi.Children.toArray(Array.from(elems_50))])])));
    };
    const togglePanel = (heading, accent_1, options) => {
        let elems_53, elems_52;
        return createElement("div", createObj(ofArray([["key", heading], (elems_53 = [createElement("span", {
            className: "text-zinc-500 text-xs font-black tracking-wider block mb-3",
            children: heading,
        }), createElement("div", createObj(ofArray([["className", "grid grid-cols-2 gap-2"], (elems_52 = toList_1(delay(() => collect_1((matchValue_62) => {
            let selected_1, title_1, elems_51;
            return singleton_2((selected_1 = matchValue_62[0], (title_1 = matchValue_62[1], createElement("button", createObj(ofArray([["key", title_1], ["className", "rounded-xl border p-3 text-left transition-all " + (selected_1 ? accent_1 : "border-zinc-800 bg-zinc-900/40 text-zinc-400 hover:border-zinc-700")], ["onClick", (_arg_47) => {
                matchValue_62[3]();
            }], (elems_51 = [createElement("div", {
                className: "text-sm " + (selected_1 ? "font-bold" : "font-semibold text-zinc-200"),
                children: title_1,
            }), createElement("div", {
                className: "mt-1 text-[11px] leading-relaxed text-zinc-500",
                children: matchValue_62[2],
            })], ["children", reactApi.Children.toArray(Array.from(elems_51))])]))))));
        }, options))), ["children", reactApi.Children.toArray(Array.from(elems_52))])])))], ["children", reactApi.Children.toArray(Array.from(elems_53))])])));
    };
    const showRatingsPanel = togglePanel("SHOW RATINGS", "border-orange-500 bg-orange-500/5 text-orange-400 font-bold", ofArray([[!state.IsKnowledgeMode, "On", "Player overalls visible", () => {
        setState((st_6) => (new GameState(st_6.Phase, st_6.Roster, st_6.SystemArchetype, st_6.Config, st_6.RerollsAvailable, st_6.DrawnFranchiseIds, st_6.FranchiseLock, st_6.Blueprint, st_6.DailyRun, false, st_6.DraftModeSetting, st_6.StartEraIndex, st_6.EndEraIndex, st_6.HeadCoachesEnabled, st_6.SelectedCoach, st_6.IsTradeResolved, st_6.TradeOutcome, st_6.IsInstantSkipActive, st_6.PlayerSeason, st_6.TradedInPlayerIds, st_6.DeadlineDeals, st_6.ProjectedWins, st_6.RivalStandings, st_6.PlayoffRecords, st_6.PlayoffOutcome, st_6.PlayoffsEnabled, st_6.TradeDeadlineEnabled, st_6.SeasonLuck, st_6.Wins, st_6.Losses, st_6.GameLog, st_6.Profile, st_6.UserRuns)));
    }], [state.IsKnowledgeMode, "Off", "Blind mode: trust your gut", () => {
        setState((st_7) => (new GameState(st_7.Phase, st_7.Roster, st_7.SystemArchetype, st_7.Config, st_7.RerollsAvailable, st_7.DrawnFranchiseIds, st_7.FranchiseLock, st_7.Blueprint, st_7.DailyRun, true, st_7.DraftModeSetting, st_7.StartEraIndex, st_7.EndEraIndex, st_7.HeadCoachesEnabled, st_7.SelectedCoach, st_7.IsTradeResolved, st_7.TradeOutcome, st_7.IsInstantSkipActive, st_7.PlayerSeason, st_7.TradedInPlayerIds, st_7.DeadlineDeals, st_7.ProjectedWins, st_7.RivalStandings, st_7.PlayoffRecords, st_7.PlayoffOutcome, st_7.PlayoffsEnabled, st_7.TradeDeadlineEnabled, st_7.SeasonLuck, st_7.Wins, st_7.Losses, st_7.GameLog, st_7.Profile, st_7.UserRuns)));
    }]]));
    const draftModePanel = togglePanel("DRAFT MODE", "border-orange-500 bg-orange-500/5 text-orange-400 font-bold", ofArray([[state.DraftModeSetting === draftModeSquadFirst, "Squad First", "Spin a franchise, pick any player, choose their position", () => {
        setState((st_8) => (new GameState(st_8.Phase, st_8.Roster, st_8.SystemArchetype, st_8.Config, st_8.RerollsAvailable, st_8.DrawnFranchiseIds, st_8.FranchiseLock, st_8.Blueprint, st_8.DailyRun, st_8.IsKnowledgeMode, draftModeSquadFirst, st_8.StartEraIndex, st_8.EndEraIndex, st_8.HeadCoachesEnabled, st_8.SelectedCoach, st_8.IsTradeResolved, st_8.TradeOutcome, st_8.IsInstantSkipActive, st_8.PlayerSeason, st_8.TradedInPlayerIds, st_8.DeadlineDeals, st_8.ProjectedWins, st_8.RivalStandings, st_8.PlayoffRecords, st_8.PlayoffOutcome, st_8.PlayoffsEnabled, st_8.TradeDeadlineEnabled, st_8.SeasonLuck, st_8.Wins, st_8.Losses, st_8.GameLog, st_8.Profile, st_8.UserRuns)));
    }], [state.DraftModeSetting === draftModePositionFirst, "Position First", "Pick a slot, then spin for a franchise to fill it", () => {
        setState((st_9) => (new GameState(st_9.Phase, st_9.Roster, st_9.SystemArchetype, st_9.Config, st_9.RerollsAvailable, st_9.DrawnFranchiseIds, st_9.FranchiseLock, st_9.Blueprint, st_9.DailyRun, st_9.IsKnowledgeMode, draftModePositionFirst, st_9.StartEraIndex, st_9.EndEraIndex, st_9.HeadCoachesEnabled, st_9.SelectedCoach, st_9.IsTradeResolved, st_9.TradeOutcome, st_9.IsInstantSkipActive, st_9.PlayerSeason, st_9.TradedInPlayerIds, st_9.DeadlineDeals, st_9.ProjectedWins, st_9.RivalStandings, st_9.PlayoffRecords, st_9.PlayoffOutcome, st_9.PlayoffsEnabled, st_9.TradeDeadlineEnabled, st_9.SeasonLuck, st_9.Wins, st_9.Losses, st_9.GameLog, st_9.Profile, st_9.UserRuns)));
    }]]));
    const setupPanel = (heading_1, body) => {
        let elems_54;
        return createElement("div", createObj(ofArray([["key", heading_1], ["className", "flex flex-col gap-2"], (elems_54 = [createElement("div", {
            className: "text-[10px] font-bold uppercase tracking-widest text-zinc-500",
            children: heading_1,
        }), body], ["children", reactApi.Children.toArray(Array.from(elems_54))])])));
    };
    const blueprintPanel = (state.FranchiseLock == null) ? setupPanel("Lineup Blueprint", createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_56 = toList_1(delay(() => map_1((blueprint) => setupOption(blueprint.Name, state.Blueprint.Name === blueprint.Name, `${blueprint.Name} · ${join("-", blueprint.Starters)}`, blueprint.Blurb, () => {
        setState((st_11) => (new GameState(st_11.Phase, st_11.Roster, st_11.SystemArchetype, st_11.Config, st_11.RerollsAvailable, st_11.DrawnFranchiseIds, st_11.FranchiseLock, blueprint, st_11.DailyRun, st_11.IsKnowledgeMode, st_11.DraftModeSetting, st_11.StartEraIndex, st_11.EndEraIndex, st_11.HeadCoachesEnabled, st_11.SelectedCoach, st_11.IsTradeResolved, st_11.TradeOutcome, st_11.IsInstantSkipActive, st_11.PlayerSeason, st_11.TradedInPlayerIds, st_11.DeadlineDeals, st_11.ProjectedWins, st_11.RivalStandings, st_11.PlayoffRecords, st_11.PlayoffOutcome, st_11.PlayoffsEnabled, st_11.TradeDeadlineEnabled, st_11.SeasonLuck, st_11.Wins, st_11.Losses, st_11.GameLog, st_11.Profile, st_11.UserRuns)));
    }), blueprints))), ["children", reactApi.Children.toArray(Array.from(elems_56))])])))) : setupPanel("Lineup Blueprint", createElement("div", createObj(ofArray([["className", "rounded-xl border border-orange-500/30 bg-orange-500/5 p-4 text-left"], (elems_55 = [createElement("span", {
        className: "text-orange-400 text-xs font-bold block mb-1",
        children: "Balanced · locked by One-Franchise Roster",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-[11px] leading-relaxed block"], (value_696 = "Franchise drafts run the textbook five — one of each position — so every squad in your team\'s history can fill it.", ["children", value_696])])))], ["children", reactApi.Children.toArray(Array.from(elems_55))])]))));
    const difficultyPanel = setupPanel("Difficulty", createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_57 = toList_1(delay(() => collect_1((matchValue_64) => {
        const title_3 = matchValue_64[1];
        const difficulty = matchValue_64[0];
        return singleton_2(setupOption(title_3, equals(state.Config.Difficulty, difficulty), title_3, matchValue_64[2], () => {
            setState((st_12) => (new GameState(st_12.Phase, st_12.Roster, st_12.SystemArchetype, new DraftConfig(difficulty, st_12.Config.RatingMode), st_12.RerollsAvailable, st_12.DrawnFranchiseIds, st_12.FranchiseLock, st_12.Blueprint, st_12.DailyRun, equals(difficulty, new Difficulty(2, [])) ? true : st_12.IsKnowledgeMode, st_12.DraftModeSetting, st_12.StartEraIndex, st_12.EndEraIndex, st_12.HeadCoachesEnabled, st_12.SelectedCoach, st_12.IsTradeResolved, st_12.TradeOutcome, st_12.IsInstantSkipActive, st_12.PlayerSeason, st_12.TradedInPlayerIds, st_12.DeadlineDeals, st_12.ProjectedWins, st_12.RivalStandings, st_12.PlayoffRecords, st_12.PlayoffOutcome, st_12.PlayoffsEnabled, st_12.TradeDeadlineEnabled, st_12.SeasonLuck, st_12.Wins, st_12.Losses, st_12.GameLog, st_12.Profile, st_12.UserRuns)));
        }));
    }, [[new Difficulty(0, []), "Easy", "3 Emergency Rerolls available per draft."], [new Difficulty(1, []), "Normal", "1 Emergency Reroll available per draft."], [new Difficulty(2, []), "Hard (Classic Mode)", "No escape rerolls allowed. 2K Overall Ratings (OVR) hidden completely from cards."]]))), ["children", reactApi.Children.toArray(Array.from(elems_57))])]))));
    const ratingPanel = (state.FranchiseLock == null) ? setupPanel("Player Rating Base", createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_59 = toList_1(delay(() => collect_1((matchValue_66) => {
        const title_4 = matchValue_66[1];
        const mode = matchValue_66[0];
        return singleton_2(setupOption(title_4, equals(state.Config.RatingMode, mode), title_4, matchValue_66[2], () => {
            setState((st_10) => (new GameState(st_10.Phase, st_10.Roster, st_10.SystemArchetype, ((cfg) => (new DraftConfig(cfg.Difficulty, mode)))(st_10.Config), st_10.RerollsAvailable, st_10.DrawnFranchiseIds, st_10.FranchiseLock, st_10.Blueprint, st_10.DailyRun, st_10.IsKnowledgeMode, st_10.DraftModeSetting, st_10.StartEraIndex, st_10.EndEraIndex, st_10.HeadCoachesEnabled, st_10.SelectedCoach, st_10.IsTradeResolved, st_10.TradeOutcome, st_10.IsInstantSkipActive, st_10.PlayerSeason, st_10.TradedInPlayerIds, st_10.DeadlineDeals, st_10.ProjectedWins, st_10.RivalStandings, st_10.PlayoffRecords, st_10.PlayoffOutcome, st_10.PlayoffsEnabled, st_10.TradeDeadlineEnabled, st_10.SeasonLuck, st_10.Wins, st_10.Losses, st_10.GameLog, st_10.Profile, st_10.UserRuns)));
        }));
    }, [[new RatingMode(0, []), "Season Mode", "Players are rated exactly as they performed during that specific historical year."], [new RatingMode(1, []), "Prime Mode", "Players are boosted to their absolute career-highest peak 2K overall rating regardless of year drawn."]]))), ["children", reactApi.Children.toArray(Array.from(elems_59))])])))) : setupPanel("Player Rating Base", createElement("div", createObj(ofArray([["className", "rounded-xl border border-orange-500/30 bg-orange-500/5 p-4 text-left"], (elems_58 = [createElement("span", {
        className: "text-orange-400 text-xs font-bold block mb-1",
        children: "Season Mode · locked by One-Franchise Roster",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-[11px] leading-relaxed block"], (value_713 = "Season-accurate ratings only: everyone is rated exactly as they played for this franchise. Prime boosts are disabled in this mode.", ["children", value_713])])))], ["children", reactApi.Children.toArray(Array.from(elems_58))])]))));
    let eraPanel;
    const startIndex = state.StartEraIndex | 0;
    const endIndex = state.EndEraIndex | 0;
    const seasonsSelected = ((endIndex - startIndex) + 1) | 0;
    const pctOf = (index) => ((index / lastSeasonIndex) * 100);
    const handleClasses = "pointer-events-none absolute left-0 top-1/2 h-1 w-full -translate-y-1/2 appearance-none bg-transparent [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:shadow [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:pointer-events-auto [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:cursor-pointer";
    const rangeHandle = (key_399, value_719, onMove) => createElement("input", {
        key: key_399,
        type: "range",
        min: 0,
        max: lastSeasonIndex,
        step: 1,
        value: value_719,
        className: handleClasses,
        onChange: (ev_2) => {
            let matchValue_67;
            let outArg = 0;
            matchValue_67 = [tryParse(ev_2.target.value, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg];
            if (matchValue_67[0]) {
                onMove(matchValue_67[1]);
            }
        },
    });
    eraPanel = setupPanel("ERA", createElement("div", createObj(ofArray([["className", "flex flex-col gap-3"], (elems_64 = [createElement("div", createObj(ofArray([["className", "flex flex-wrap gap-2"], (elems_60 = toList_1(delay(() => collect_1((matchValue_68) => {
        const presetStart = matchValue_68[1] | 0;
        const presetEnd = matchValue_68[2] | 0;
        const label_8 = matchValue_68[0];
        return singleton_2(createElement("button", {
            key: label_8,
            className: ((startIndex === presetStart) && (endIndex === presetEnd)) ? "border border-orange-500 text-orange-400 bg-orange-500/5 px-3 py-1.5 rounded-xl font-bold text-xs cursor-pointer shadow-sm" : "border border-zinc-900 bg-zinc-900/40 text-zinc-500 px-3 py-1.5 rounded-xl text-xs hover:border-zinc-800",
            onClick: (_arg_48) => {
                setState((st_15) => (new GameState(st_15.Phase, st_15.Roster, st_15.SystemArchetype, st_15.Config, st_15.RerollsAvailable, st_15.DrawnFranchiseIds, st_15.FranchiseLock, st_15.Blueprint, st_15.DailyRun, st_15.IsKnowledgeMode, st_15.DraftModeSetting, presetStart, presetEnd, st_15.HeadCoachesEnabled, st_15.SelectedCoach, st_15.IsTradeResolved, st_15.TradeOutcome, st_15.IsInstantSkipActive, st_15.PlayerSeason, st_15.TradedInPlayerIds, st_15.DeadlineDeals, st_15.ProjectedWins, st_15.RivalStandings, st_15.PlayoffRecords, st_15.PlayoffOutcome, st_15.PlayoffsEnabled, st_15.TradeDeadlineEnabled, st_15.SeasonLuck, st_15.Wins, st_15.Losses, st_15.GameLog, st_15.Profile, st_15.UserRuns)));
            },
            children: label_8,
        }));
    }, eraPresets))), ["children", reactApi.Children.toArray(Array.from(elems_60))])]))), createElement("div", createObj(ofArray([["className", "relative w-full py-2"], (elems_62 = [createElement("div", createObj(ofArray([["className", "h-1 bg-orange-500 rounded-full relative w-full"], (elems_61 = [createElement("div", {
        className: "absolute inset-y-0 left-0 rounded-full bg-zinc-800",
        style: {
            width: pctOf(startIndex) + "%",
        },
    }), createElement("div", {
        className: "absolute inset-y-0 right-0 rounded-full bg-zinc-800",
        style: {
            width: (100 - pctOf(endIndex)) + "%",
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_61))])]))), rangeHandle("era-start", startIndex, (raw_1) => {
        setState((st_13) => (new GameState(st_13.Phase, st_13.Roster, st_13.SystemArchetype, st_13.Config, st_13.RerollsAvailable, st_13.DrawnFranchiseIds, st_13.FranchiseLock, st_13.Blueprint, st_13.DailyRun, st_13.IsKnowledgeMode, st_13.DraftModeSetting, min(clampSeasonIndex(raw_1), st_13.EndEraIndex), st_13.EndEraIndex, st_13.HeadCoachesEnabled, st_13.SelectedCoach, st_13.IsTradeResolved, st_13.TradeOutcome, st_13.IsInstantSkipActive, st_13.PlayerSeason, st_13.TradedInPlayerIds, st_13.DeadlineDeals, st_13.ProjectedWins, st_13.RivalStandings, st_13.PlayoffRecords, st_13.PlayoffOutcome, st_13.PlayoffsEnabled, st_13.TradeDeadlineEnabled, st_13.SeasonLuck, st_13.Wins, st_13.Losses, st_13.GameLog, st_13.Profile, st_13.UserRuns)));
    }), rangeHandle("era-end", endIndex, (raw_2) => {
        setState((st_14) => (new GameState(st_14.Phase, st_14.Roster, st_14.SystemArchetype, st_14.Config, st_14.RerollsAvailable, st_14.DrawnFranchiseIds, st_14.FranchiseLock, st_14.Blueprint, st_14.DailyRun, st_14.IsKnowledgeMode, st_14.DraftModeSetting, st_14.StartEraIndex, max(clampSeasonIndex(raw_2), st_14.StartEraIndex), st_14.HeadCoachesEnabled, st_14.SelectedCoach, st_14.IsTradeResolved, st_14.TradeOutcome, st_14.IsInstantSkipActive, st_14.PlayerSeason, st_14.TradedInPlayerIds, st_14.DeadlineDeals, st_14.ProjectedWins, st_14.RivalStandings, st_14.PlayoffRecords, st_14.PlayoffOutcome, st_14.PlayoffsEnabled, st_14.TradeDeadlineEnabled, st_14.SeasonLuck, st_14.Wins, st_14.Losses, st_14.GameLog, st_14.Profile, st_14.UserRuns)));
    })], ["children", reactApi.Children.toArray(Array.from(elems_62))])]))), createElement("div", createObj(ofArray([["className", "flex justify-between items-center text-xs font-mono font-bold mt-2.5 w-full"], (elems_63 = [createElement("span", {
        className: "text-orange-500",
        children: item_1(startIndex, seasonTimeline),
    }), createElement("span", {
        className: "text-zinc-600 font-medium",
        children: `${seasonsSelected} of ${seasonTimeline.length} seasons`,
    }), createElement("span", {
        className: "text-orange-500",
        children: item_1(endIndex, seasonTimeline),
    })], ["children", reactApi.Children.toArray(Array.from(elems_63))])]))), createElement("p", {
        className: "text-[11px] leading-relaxed text-zinc-500",
        children: "Only historic teams in this range can be spun. Narrow it to draft from an era you know.",
    })], ["children", reactApi.Children.toArray(Array.from(elems_64))])]))));
    const advancedSwitch = (isOn, title_5, subtext_3, onValues, offValues, onToggle) => {
        let value_787, elems_68, elems_67, elems_65, elems_66;
        return createElement("button", createObj(ofArray([["key", title_5], (value_787 = "flex w-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 px-5 py-4 text-left transition-all hover:border-zinc-700", ["className", value_787]), ["onClick", (_arg_49) => {
            onToggle();
        }], (elems_68 = [createElement("div", createObj(ofArray([["className", "flex w-full items-center justify-between"], (elems_67 = [createElement("div", createObj(ofArray([["className", "min-w-0 pr-4"], (elems_65 = [createElement("div", {
            className: "text-sm font-bold text-zinc-100",
            children: title_5,
        }), createElement("p", {
            className: "mt-1 text-[11px] leading-relaxed text-zinc-500",
            children: subtext_3,
        })], ["children", reactApi.Children.toArray(Array.from(elems_65))])]))), createElement("span", createObj(ofArray([["className", "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-all " + (isOn ? "bg-orange-500 shadow-md shadow-orange-500/10" : "bg-zinc-800")], (elems_66 = [createElement("span", {
            className: "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-all " + (isOn ? "translate-x-5" : "translate-x-0.5"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_66))])])))], ["children", reactApi.Children.toArray(Array.from(elems_67))])]))), createElement("div", {
            className: "mt-2 p-2 bg-zinc-950/60 border border-zinc-900 rounded-lg text-[11px] font-mono leading-relaxed " + (isOn ? "text-orange-400" : "text-zinc-600"),
            children: isOn ? onValues : offValues,
        })], ["children", reactApi.Children.toArray(Array.from(elems_68))])])));
    };
    const advancedPanel = createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_69 = [createElement("h3", {
        className: "text-zinc-500 text-xs font-black tracking-wider uppercase mb-4 text-left block",
        children: "ADVANCED",
    }), advancedSwitch(state.HeadCoachesEnabled, "Head Coaches", "After the draft, appoint a historic coach for system boosts. Off = no coach.", "✓ Active Values: Phil Jackson (+3 Triangle Synergy), Pat Riley (+3 Grit & Grind Def), Steve Kerr (+3 Pace & Space Off)", "🔒 Default: No system adjustments or coaching staff traits active.", () => {
        setState((st_16) => (new GameState(st_16.Phase, st_16.Roster, st_16.SystemArchetype, st_16.Config, st_16.RerollsAvailable, st_16.DrawnFranchiseIds, st_16.FranchiseLock, st_16.Blueprint, st_16.DailyRun, st_16.IsKnowledgeMode, st_16.DraftModeSetting, st_16.StartEraIndex, st_16.EndEraIndex, !st_16.HeadCoachesEnabled, st_16.SelectedCoach, st_16.IsTradeResolved, st_16.TradeOutcome, st_16.IsInstantSkipActive, st_16.PlayerSeason, st_16.TradedInPlayerIds, st_16.DeadlineDeals, st_16.ProjectedWins, st_16.RivalStandings, st_16.PlayoffRecords, st_16.PlayoffOutcome, st_16.PlayoffsEnabled, st_16.TradeDeadlineEnabled, st_16.SeasonLuck, st_16.Wins, st_16.Losses, st_16.GameLog, st_16.Profile, st_16.UserRuns)));
    }), advancedSwitch(state.PlayoffsEnabled, "Postseason Playoffs", "Finish in the top eight and your lineup advances to the best-of-seven NBA Playoffs. Off = just the regular 82-game league.", "✓ Active Values: Top 8 seeds dance. Three best-of-seven rounds after game 82 — First Round, Semifinals, The Finals at The Banner Arena.", "🔒 Default: Standard 82-game campaign loop only. Highest final win record wins the season.", () => {
        setState((st_17) => (new GameState(st_17.Phase, st_17.Roster, st_17.SystemArchetype, st_17.Config, st_17.RerollsAvailable, st_17.DrawnFranchiseIds, st_17.FranchiseLock, st_17.Blueprint, st_17.DailyRun, st_17.IsKnowledgeMode, st_17.DraftModeSetting, st_17.StartEraIndex, st_17.EndEraIndex, st_17.HeadCoachesEnabled, st_17.SelectedCoach, st_17.IsTradeResolved, st_17.TradeOutcome, st_17.IsInstantSkipActive, st_17.PlayerSeason, st_17.TradedInPlayerIds, st_17.DeadlineDeals, st_17.ProjectedWins, st_17.RivalStandings, st_17.PlayoffRecords, st_17.PlayoffOutcome, !st_17.PlayoffsEnabled, st_17.TradeDeadlineEnabled, st_17.SeasonLuck, st_17.Wins, st_17.Losses, st_17.GameLog, st_17.Profile, st_17.UserRuns)));
    }), advancedSwitch(state.TradeDeadlineEnabled, "February Trade Deadline", "On deadline day — 51 games in, early February, All-Star break ahead — gamble on a front-office event. It can upgrade or derail your roster. No undo.", "✓ Active Values: Season pauses at 51 games played (Feb 6). Random event: a contender bids for your star (cash in for two wheel arrivals) or the blind buyout market opens for your weakest spot. No undo.", "🔒 Default: Roster remains fully frozen from Game 1 through Game 82.", () => {
        setState((st_18) => (new GameState(st_18.Phase, st_18.Roster, st_18.SystemArchetype, st_18.Config, st_18.RerollsAvailable, st_18.DrawnFranchiseIds, st_18.FranchiseLock, st_18.Blueprint, st_18.DailyRun, st_18.IsKnowledgeMode, st_18.DraftModeSetting, st_18.StartEraIndex, st_18.EndEraIndex, st_18.HeadCoachesEnabled, st_18.SelectedCoach, st_18.IsTradeResolved, st_18.TradeOutcome, st_18.IsInstantSkipActive, st_18.PlayerSeason, st_18.TradedInPlayerIds, st_18.DeadlineDeals, st_18.ProjectedWins, st_18.RivalStandings, st_18.PlayoffRecords, st_18.PlayoffOutcome, st_18.PlayoffsEnabled, !st_18.TradeDeadlineEnabled, st_18.SeasonLuck, st_18.Wins, st_18.Losses, st_18.GameLog, st_18.Profile, st_18.UserRuns)));
    })], ["children", reactApi.Children.toArray(Array.from(elems_69))])])));
    const systemPanel = setupPanel("System Archetype", createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_70 = toList_1(delay(() => collect_1((matchValue_69) => {
        const name_392 = matchValue_69[0];
        return singleton_2(setupOption(name_392, state.SystemArchetype === name_392, name_392, matchValue_69[1], () => {
            setState((st_19) => (new GameState(st_19.Phase, st_19.Roster, name_392, st_19.Config, st_19.RerollsAvailable, st_19.DrawnFranchiseIds, st_19.FranchiseLock, st_19.Blueprint, st_19.DailyRun, st_19.IsKnowledgeMode, st_19.DraftModeSetting, st_19.StartEraIndex, st_19.EndEraIndex, st_19.HeadCoachesEnabled, st_19.SelectedCoach, st_19.IsTradeResolved, st_19.TradeOutcome, st_19.IsInstantSkipActive, st_19.PlayerSeason, st_19.TradedInPlayerIds, st_19.DeadlineDeals, st_19.ProjectedWins, st_19.RivalStandings, st_19.PlayoffRecords, st_19.PlayoffOutcome, st_19.PlayoffsEnabled, st_19.TradeDeadlineEnabled, st_19.SeasonLuck, st_19.Wins, st_19.Losses, st_19.GameLog, st_19.Profile, st_19.UserRuns)));
        }));
    }, [["Pace & Space", "Live by the three — synergy with shooting badges."], ["Grit & Grind", "Defense wins rings — synergy with lockdown badges."], ["Showtime", "Run-and-gun playmaking — synergy with passing badges."], ["Lob City", "Vertical spacing — synergy with finishing badges."], ["Post Dynasty", "Bully ball — synergy with post-scoring badges."], ["Balanced", "No badge dependency and no +2% bonus. Safe, steady."]]))), ["children", reactApi.Children.toArray(Array.from(elems_70))])]))));
    let setupConsole;
    let draftablePlayers;
    const matchValue_70 = state.FranchiseLock;
    draftablePlayers = ((matchValue_70 == null) ? draftablePlayersInRange(state.StartEraIndex, state.EndEraIndex) : sumBy((id_1) => defaultArg(map_2((pool_3) => length(pool_3.Options), FSharpMap__TryFind(poolById, id_1)), 0), matchValue_70.PoolIds, {
        GetZero: () => 0,
        Add: (x_25, y_23) => (x_25 + y_23),
    }));
    setupConsole = createElement("div", createObj(ofArray([["className", "flex flex-col gap-5"], (elems_74 = toList_1(delay(() => {
        let elems_72;
        return append_1(singleton_2(createElement("div", createObj(singleton((elems_72 = [createElement("h2", {
            className: "text-2xl font-black",
            children: "Game Setup",
        }), createElement("p", {
            className: "mt-1 text-xs text-zinc-500",
            children: "Lock in your rules before the wheel starts. These stay fixed for the whole run.",
        })], ["children", reactApi.Children.toArray(Array.from(elems_72))]))))), delay(() => {
            let matchValue_71, franchise_2, poolNames, elems_71, value_843;
            return append_1((matchValue_71 = state.FranchiseLock, (matchValue_71 == null) ? singleton_2(defaultOf_1()) : singleton_2((franchise_2 = matchValue_71, (poolNames = join(" · ", choose((id_2) => map_2((p_10) => p_10.TeamName, FSharpMap__TryFind(poolById, id_2)), franchise_2.PoolIds)), createElement("div", createObj(ofArray([["className", "rounded-2xl border border-orange-500/40 bg-orange-950/30 p-4 flex flex-col gap-1.5 text-left"], (elems_71 = [createElement("span", {
                className: "text-orange-400 text-[10px] font-black tracking-widest uppercase",
                children: "● One-Franchise Roster",
            }), createElement("span", {
                className: "text-white text-lg font-black tracking-tight",
                children: franchise_2.Name,
            }), createElement("span", {
                className: "text-zinc-400 text-[11px] font-medium",
                children: `Draftable squads: ${poolNames} — every pick suited up for this franchise, and your team replaces it in the league.`,
            }), createElement("span", {
                className: "text-zinc-400 text-[11px] font-medium",
                children: `🏅 Best ever ${franchise_2.BestWins} wins (${franchise_2.BestSeason}) · 🪦 Worst ever ${franchise_2.WorstWins} wins (${franchise_2.WorstSeason}). Beat ${franchise_2.BestWins} to break the record — finish below ${franchise_2.WorstWins} for worst ever.`,
            }), createElement("button", createObj(ofArray([(value_843 = "text-zinc-500 hover:text-orange-400 text-[11px] font-semibold w-fit mt-1 transition-colors cursor-pointer", ["className", value_843]), ["onClick", (_arg_50) => {
                Actions_beginRunSetup(setState);
            }], ["children", "✕ Exit franchise mode — draft from every team instead"]])))], ["children", reactApi.Children.toArray(Array.from(elems_71))])]))))))), delay(() => append_1(singleton_2(blueprintPanel), delay(() => append_1(singleton_2(showRatingsPanel), delay(() => append_1(singleton_2(draftModePanel), delay(() => append_1(singleton_2(difficultyPanel), delay(() => append_1(singleton_2(ratingPanel), delay(() => {
                let elems_73;
                return append_1((state.FranchiseLock == null) ? singleton_2(eraPanel) : singleton_2(setupPanel("ERA", createElement("div", createObj(ofArray([["className", "rounded-xl border border-zinc-800 bg-zinc-950/60 p-4 text-left"], (elems_73 = [createElement("span", {
                    className: "text-zinc-400 text-[11px] leading-relaxed block",
                    children: "All eras — a franchise draft always spans the team\'s whole draftable history.",
                })], ["children", reactApi.Children.toArray(Array.from(elems_73))])]))))), delay(() => append_1(singleton_2(systemPanel), delay(() => append_1(singleton_2(advancedPanel), delay(() => {
                    let value_867;
                    return append_1((draftablePlayers < length(allSlots)) ? singleton_2(createElement("div", createObj(ofArray([(value_867 = "rounded-xl border border-zinc-800 bg-zinc-950/60 p-3 text-[11px] font-mono leading-relaxed text-zinc-500", ["className", value_867]), ["children", `⚠ ${item_1(state.StartEraIndex, seasonTimeline)}–${item_1(state.EndEraIndex, seasonTimeline)} holds only ${draftablePlayers} draftable players. A roster needs ${length(allSlots)}. Widen the range to start.`]])))) : empty_2(), delay(() => {
                        let matchValue_73;
                        return singleton_2(createElement("button", {
                            disabled: draftablePlayers < length(allSlots),
                            className: (draftablePlayers < length(allSlots)) ? "w-full bg-zinc-800 text-zinc-600 font-black uppercase text-sm tracking-wider py-4 rounded-xl font-sans cursor-not-allowed flex justify-center items-center" : "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-sm tracking-wider py-4 rounded-xl transition-all font-sans cursor-pointer shadow-lg shadow-orange-500/10 flex justify-center items-center",
                            onClick: (_arg_51) => {
                                setActiveSlot(undefined);
                                Actions_startGame(setState);
                            },
                            children: (matchValue_73 = state.FranchiseLock, (matchValue_73 == null) ? "Start Draft ➔" : (`Start ${matchValue_73.Name} Draft ➔`)),
                        }));
                    }));
                }))))));
            }))))))))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_74))])])));
    let console$;
    const matchValue_74 = state.Phase;
    let matchResult_4;
    switch (matchValue_74.tag) {
        case 1: {
            matchResult_4 = 1;
            break;
        }
        case 3: {
            matchResult_4 = 4;
            break;
        }
        case 4: {
            matchResult_4 = 5;
            break;
        }
        case 5: {
            matchResult_4 = 6;
            break;
        }
        case 6: {
            matchResult_4 = 7;
            break;
        }
        case 7: {
            matchResult_4 = 8;
            break;
        }
        case 14: {
            matchResult_4 = 9;
            break;
        }
        case 15: {
            matchResult_4 = 10;
            break;
        }
        case 8: {
            matchResult_4 = 11;
            break;
        }
        case 16: {
            matchResult_4 = 12;
            break;
        }
        case 17: {
            matchResult_4 = 13;
            break;
        }
        case 18: {
            matchResult_4 = 14;
            break;
        }
        case 19: {
            matchResult_4 = 15;
            break;
        }
        case 20: {
            matchResult_4 = 16;
            break;
        }
        case 21: {
            matchResult_4 = 17;
            break;
        }
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
            matchResult_4 = 18;
            break;
        }
        case 22: {
            matchResult_4 = 19;
            break;
        }
        case 23: {
            matchResult_4 = 20;
            break;
        }
        case 24: {
            matchResult_4 = 21;
            break;
        }
        case 25: {
            matchResult_4 = 22;
            break;
        }
        case 26: {
            matchResult_4 = 23;
            break;
        }
        case 27: {
            matchResult_4 = 24;
            break;
        }
        case 28: {
            matchResult_4 = 25;
            break;
        }
        case 29: {
            matchResult_4 = 26;
            break;
        }
        case 30: {
            matchResult_4 = 27;
            break;
        }
        case 31: {
            matchResult_4 = 28;
            break;
        }
        case 32: {
            matchResult_4 = 29;
            break;
        }
        case 33: {
            matchResult_4 = 30;
            break;
        }
        case 34: {
            matchResult_4 = 31;
            break;
        }
        case 35: {
            matchResult_4 = 32;
            break;
        }
        case 36: {
            matchResult_4 = 33;
            break;
        }
        case 37: {
            matchResult_4 = 34;
            break;
        }
        case 38: {
            matchResult_4 = 35;
            break;
        }
        case 39: {
            matchResult_4 = 36;
            break;
        }
        case 40: {
            matchResult_4 = 37;
            break;
        }
        case 41: {
            matchResult_4 = 38;
            break;
        }
        case 2: {
            if (!squadFirst && (activeSlot == null)) {
                matchResult_4 = 2;
            }
            else {
                matchResult_4 = 3;
            }
            break;
        }
        default:
            matchResult_4 = 0;
    }
    switch (matchResult_4) {
        case 0: {
            console$ = defaultOf_1();
            break;
        }
        case 1: {
            console$ = setupConsole;
            break;
        }
        case 2: {
            const openSlots = filter((s) => !FSharpMap__ContainsKey(state.Roster, s), runSlots);
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col py-2"], (elems_79 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-4 block text-center",
                children: "SELECT A POSITION TO FILL",
            })), delay(() => {
                let elems_77;
                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_77 = toList_1(delay(() => map_1((slot_15) => {
                    let value_881, elems_75, value_884;
                    const slot_13 = slot_15;
                    return createElement("button", createObj(ofArray([["key", slot_13], (value_881 = "w-full bg-zinc-900/20 border border-zinc-900 hover:border-orange-500/40 p-3.5 rounded-xl flex items-center gap-3 text-left cursor-pointer transition-all mb-2", ["className", value_881]), ["onClick", (_arg_52) => {
                        setActiveSlot(slot_13);
                    }], (elems_75 = [createElement("span", createObj(ofArray([(value_884 = "shrink-0 w-10 text-center rounded-md border border-orange-500/40 px-1.5 py-1 text-[10px] font-black tracking-widest text-orange-400", ["className", value_884]), ["children", positionOfSlot(slot_13)]]))), createElement("span", {
                        className: "text-sm font-bold text-zinc-100",
                        children: positionFullName(slot_13),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_75))])])));
                }, openSlots))), ["children", reactApi.Children.toArray(Array.from(elems_77))])])))), delay(() => append_1(!isEmpty_1(state.Roster) ? append_1(singleton_2(createElement("span", {
                    className: "text-zinc-600 text-[10px] tracking-widest font-black uppercase mt-6 mb-2 block",
                    children: "DRAFT HISTORY",
                })), delay(() => {
                    let elems_78;
                    return singleton_2(createElement("div", createObj(ofArray([["className", "rounded-xl border border-zinc-900 bg-zinc-950 overflow-hidden"], (elems_78 = toList_1(delay(() => collect_1((slot_16) => {
                        let slot_14, player_17, pool_4, elems_76, value_897;
                        const matchValue_75 = FSharpMap__TryFind(state.Roster, slot_16);
                        if (matchValue_75 == null) {
                            return empty_2();
                        }
                        else {
                            return singleton_2((slot_14 = slot_16, (player_17 = matchValue_75, (pool_4 = FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(player_17)), createElement("div", createObj(ofArray([["key", slot_14], ["className", "flex items-center gap-3 px-3 py-2 border-b border-zinc-900/60 last:border-b-0"], (elems_76 = [createElement("span", createObj(ofArray([(value_897 = "shrink-0 w-10 text-center rounded-md border border-zinc-800 px-1 py-0.5 text-[9px] font-black tracking-widest text-zinc-500", ["className", value_897]), ["children", contains(slot_14, benchSlots, {
                                Equals: (x_26, y_24) => (x_26 === y_24),
                                GetHashCode: stringHash,
                            }) ? "BNCH" : positionOfSlot(slot_14)]]))), createElement("span", {
                                className: "truncate text-xs font-semibold text-zinc-200",
                                children: player_17.Name,
                            }), createElement("span", {
                                className: "ml-auto shrink-0 text-[10px] text-zinc-600 font-medium",
                                children: defaultArg(map_2((t_1) => t_1.TeamName, pool_4), "—"),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_76))])])))))));
                        }
                    }, runSlots))), ["children", reactApi.Children.toArray(Array.from(elems_78))])]))));
                })) : empty_2(), delay(() => {
                    let value_927;
                    return singleton_2(createElement("button", createObj(ofArray([(value_927 = "border border-zinc-900 bg-zinc-950 hover:border-zinc-800 text-zinc-400 hover:text-white text-xs font-semibold py-2.5 px-6 rounded-xl transition-all cursor-pointer mx-auto block w-fit mt-8", ["className", value_927]), ["onClick", (_arg_53) => {
                        Actions_navigateToHome(setState);
                    }], ["children", "🔄 Restart run"]]))));
                }))));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_79))])])));
            break;
        }
        case 3: {
            const slotsLeft = (length(allSlots) - FSharpMap__get_Count(state.Roster)) | 0;
            const slotBox = (label_9, boxClasses) => {
                let elems_80;
                return createElement("div", createObj(ofArray([["key", label_9], ["className", "flex flex-col items-center gap-1.5"], (elems_80 = [createElement("span", {
                    className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase",
                    children: label_9,
                }), createElement("div", {
                    className: boxClasses,
                })], ["children", reactApi.Children.toArray(Array.from(elems_80))])])));
            };
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col items-center py-6 cursor-pointer"], ["onClick", (_arg_54) => {
                triggerSpin();
            }], (elems_83 = toList_1(delay(() => {
                let matchValue_76, slot_17, slot_18, value_947;
                return append_1((matchValue_76 = activeSlot, (matchValue_76 != null) ? (((slot_17 = matchValue_76, !squadFirst)) ? ((slot_18 = matchValue_76, append_1(singleton_2(createElement("button", createObj(ofArray([(value_947 = "text-zinc-500 hover:text-orange-400 text-xs font-semibold self-start mb-3 transition-colors cursor-pointer", ["className", value_947]), ["onClick", (ev_3) => {
                    ev_3.stopPropagation();
                    setActiveSlot(undefined);
                }], ["children", "← Back"]])))), delay(() => append_1(singleton_2(createElement("span", {
                    className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                    children: "FILLING POSITION",
                })), delay(() => singleton_2(createElement("div", {
                    className: "text-white text-xl font-black font-sans mb-12",
                    children: `${positionFullName(slot_18)} (${positionOfSlot(slot_18)})`,
                })))))))) : append_1(singleton_2(createElement("span", {
                    className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                    children: "SPIN FOR A FRANCHISE",
                })), delay(() => singleton_2(createElement("div", {
                    className: "text-white text-xl font-black font-sans mb-12",
                    children: (slotsLeft === 1) ? "1 position left to fill" : (`${slotsLeft} positions left to fill`),
                }))))) : append_1(singleton_2(createElement("span", {
                    className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                    children: "SPIN FOR A FRANCHISE",
                })), delay(() => singleton_2(createElement("div", {
                    className: "text-white text-xl font-black font-sans mb-12",
                    children: (slotsLeft === 1) ? "1 position left to fill" : (`${slotsLeft} positions left to fill`),
                }))))), delay(() => {
                    let elems_81;
                    return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-end justify-center gap-4 mb-10"], (elems_81 = [slotBox("FRANCHISE", "w-40 h-14 bg-zinc-950 border border-zinc-900 rounded-xl flex items-center justify-center"), createElement("span", {
                        className: "text-zinc-700 text-lg font-black pb-4",
                        children: "×",
                    }), slotBox("SEASON", "w-24 h-14 bg-zinc-950 border border-zinc-900 rounded-xl flex items-center justify-center")], ["children", reactApi.Children.toArray(Array.from(elems_81))])])))), delay(() => {
                        let elems_82, value_977;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full"], (elems_82 = [createElement("button", createObj(ofArray([(value_977 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 flex justify-center items-center gap-2", ["className", value_977]), ["onClick", (ev_4) => {
                            ev_4.stopPropagation();
                            triggerSpin();
                        }], ["children", "🎰 Spin the Wheel"]]))), createElement("span", {
                            className: "text-zinc-600 text-[10px] font-medium tracking-wide mt-3 text-center block select-none",
                            children: "or tap anywhere, or press Space",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_82))])])))), delay(() => append_1(singleton_2(createElement("hr", {
                            className: "w-full border-zinc-900 mt-8",
                        })), delay(() => {
                            let value_989;
                            return singleton_2(createElement("button", createObj(ofArray([(value_989 = "border border-zinc-900 bg-zinc-950 hover:border-zinc-800 text-zinc-400 hover:text-white text-xs font-semibold py-2.5 px-6 rounded-xl transition-all cursor-pointer mx-auto block w-fit mt-8", ["className", value_989]), ["onClick", (ev_5) => {
                                ev_5.stopPropagation();
                                Actions_navigateToHome(setState);
                            }], ["children", "🔄 Restart run"]]))));
                        }))));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_83))])])));
            break;
        }
        case 4: {
            const landing = matchValue_74.fields[0];
            const slotsLeft_1 = (length(allSlots) - FSharpMap__get_Count(state.Roster)) | 0;
            const reelItems = (finalLabel, decoys) => {
                let ds;
                return append(isEmpty(decoys) ? replicate(11, finalLabel) : ((ds = decoys, initialize_1(11, (i_5) => item(i_5 % length(ds), ds)))), singleton(finalLabel));
            };
            let decoyPools;
            const stillDrawable = filter((pool_5) => {
                if (pool_5.Id !== landing.Id) {
                    return !contains(pool_5.Id, state.DrawnFranchiseIds, {
                        Equals: (x_27, y_25) => (x_27 === y_25),
                        GetHashCode: stringHash,
                    });
                }
                else {
                    return false;
                }
            }, poolsInSeasonRange(state.StartEraIndex, state.EndEraIndex));
            decoyPools = sortBy((pool_7) => reelOrderKey(landing.Id, pool_7.Id), isEmpty(stillDrawable) ? filter((pool_6) => (pool_6.Id !== landing.Id), poolsInSeasonRange(state.StartEraIndex, state.EndEraIndex)) : stillDrawable, {
                Compare: comparePrimitives,
            });
            const franchiseReel = reelItems(fullFranchiseName(landing), map(fullFranchiseName, decoyPools));
            const seasonReel = reelItems(seasonLabelForPool(landing.Id), map((p_11) => seasonLabelForPool(p_11.Id), decoyPools));
            const reelColumn = (key_554, items, animClass, boxWidth, onDone) => {
                let elems_85;
                return createElement("div", createObj(ofArray([["key", key_554], ["className", boxWidth + " h-14 bg-zinc-950 border border-orange-500/60 rounded-xl overflow-hidden shadow-lg shadow-orange-500/10"], (elems_85 = [createElement("div", createObj(toList_1(delay(() => append_1(singleton_2(["className", "flex flex-col " + animClass]), delay(() => append_1(singleton_2(["style", {
                    "--reel-end": "calc(-11 * 3.5rem)",
                }]), delay(() => {
                    let matchValue_77, fire;
                    return append_1((matchValue_77 = onDone, (matchValue_77 == null) ? (empty_2()) : ((fire = matchValue_77, singleton_2(["onAnimationEnd", (_arg_55) => {
                        fire();
                    }])))), delay(() => {
                        let elems_84;
                        return singleton_2((elems_84 = toList_1(delay(() => collect_1((matchValue_78) => {
                            let value_1008;
                            const label_10 = matchValue_78[1];
                            return singleton_2(createElement("div", createObj(ofArray([["key", `${matchValue_78[0]}-${label_10}`], (value_1008 = "h-14 shrink-0 flex items-center justify-center px-2 text-center text-xs font-bold text-zinc-100 truncate", ["className", value_1008]), ["children", label_10]]))));
                        }, indexed(items)))), ["children", reactApi.Children.toArray(Array.from(elems_84))]));
                    }));
                }))))))))], ["children", reactApi.Children.toArray(Array.from(elems_85))])])));
            };
            const reelBox = (label_11, reel) => {
                let elems_86;
                return createElement("div", createObj(ofArray([["key", label_11], ["className", "flex flex-col items-center gap-1.5"], (elems_86 = [createElement("span", {
                    className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase",
                    children: label_11,
                }), reel], ["children", reactApi.Children.toArray(Array.from(elems_86))])])));
            };
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col items-center py-6"], (elems_89 = [createElement("span", {
                className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                children: "SPIN FOR A FRANCHISE",
            }), createElement("div", {
                className: "text-white text-xl font-black font-sans mb-12",
                children: (slotsLeft_1 === 1) ? "1 position left to fill" : (`${slotsLeft_1} positions left to fill`),
            }), createElement("div", createObj(ofArray([["className", "flex items-end justify-center gap-4 mb-10"], (elems_87 = [reelBox("FRANCHISE", reelColumn(`franchise-${landing.Id}`, franchiseReel, "animate-reelDrop", "w-40", undefined)), createElement("span", {
                className: "text-zinc-700 text-lg font-black pb-4",
                children: "×",
            }), reelBox("SEASON", reelColumn(`season-${landing.Id}`, seasonReel, "animate-reelDropSlow", "w-24", () => {
                Actions_landWheel(setState, landing);
            }))], ["children", reactApi.Children.toArray(Array.from(elems_87))])]))), createElement("div", createObj(ofArray([["className", "w-full"], (elems_88 = [createElement("button", createObj(ofArray([["disabled", true], (value_1044 = "w-full bg-zinc-900 text-zinc-500 font-black uppercase text-xs tracking-widest py-4 rounded-xl cursor-wait flex justify-center items-center gap-2", ["className", value_1044]), ["children", "🎰 Spinning…"]]))), createElement("span", createObj(ofArray([(value_1048 = "text-zinc-600 text-[10px] font-medium tracking-wide mt-3 text-center block select-none animate-pulse", ["className", value_1048]), ["children", "The wheel decides…"]])))], ["children", reactApi.Children.toArray(Array.from(elems_88))])])))], ["children", reactApi.Children.toArray(Array.from(elems_89))])])));
            break;
        }
        case 5: {
            const pool_9 = matchValue_74.fields[0];
            let sortedOptions;
            const effectiveSort = (hideRatings && (draftSort === "Rating")) ? "Surname A-Z" : draftSort;
            sortedOptions = ((effectiveSort === "Position") ? sortBy((p_12) => defaultArg(tryFindIndex_1((y_27) => (p_12.Pos === y_27), starterSlots), 99), pool_9.Options, {
                Compare: comparePrimitives,
            }) : ((effectiveSort === "Surname A-Z") ? sortBy((p_13) => last(split(p_13.Name, [" "], undefined, 0)).toLocaleLowerCase(), pool_9.Options, {
                Compare: comparePrimitives,
            }) : sortByDescending((p_14) => p_14.Ovr, pool_9.Options, {
                Compare: comparePrimitives,
            })));
            const positionTarget = squadFirst ? undefined : activeSlot;
            let visibleOptions;
            if (positionTarget != null) {
                const slot_19 = positionTarget;
                const undrafted = (p_15) => !exists_1((_arg_56, q) => (q.Id === p_15.Id), state.Roster);
                visibleOptions = (contains(slot_19, benchSlots, {
                    Equals: (x_33, y_31) => (x_33 === y_31),
                    GetHashCode: stringHash,
                }) ? filter(undrafted, sortedOptions) : filter((p_16) => {
                    if (undrafted(p_16)) {
                        return contains(positionOfSlot(slot_19), playerPositions(p_16), {
                            Equals: (x_34, y_32) => (x_34 === y_32),
                            GetHashCode: stringHash,
                        });
                    }
                    else {
                        return false;
                    }
                }, sortedOptions));
            }
            else {
                visibleOptions = sortedOptions;
            }
            const sortTab = (label_12) => createElement("button", {
                key: label_12,
                className: (draftSort === label_12) ? "border border-orange-500 text-orange-400 px-2.5 py-1 rounded-lg text-[10px] font-bold cursor-pointer" : "border border-zinc-900 text-zinc-500 px-2.5 py-1 rounded-lg text-[10px] hover:border-zinc-800 cursor-pointer",
                onClick: (_arg_57) => {
                    patternInput_4[1](label_12);
                },
                children: label_12,
            });
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col gap-3"], (elems_102 = toList_1(delay(() => {
                let elems_94;
                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-wrap items-center justify-between gap-2"], (elems_94 = toList_1(delay(() => {
                    let elems_93;
                    return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center gap-2"], (elems_93 = [createElement("span", {
                        className: "h-1.5 w-1.5 rounded-full bg-orange-500",
                    }), createElement("span", {
                        className: "text-sm font-black text-orange-400",
                        children: `🏀 ${fullFranchiseName(pool_9)} ${seasonLabelForPool(pool_9.Id)}`,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_93))])])))), delay(() => {
                        let value_1105;
                        return (state.RerollsAvailable > 0) ? singleton_2(createElement("button", createObj(ofArray([(value_1105 = "shrink-0 rounded-full border px-3 py-1 text-[11px] font-bold transition-all border-zinc-800 bg-zinc-900 text-zinc-400 hover:border-orange-500/40 cursor-pointer", ["className", value_1105]), ["onClick", (_arg_60) => {
                            setSpinning(true);
                            Actions_useReroll(setState, state.Config, state.FranchiseLock, targetPosFilter, state.StartEraIndex, state.EndEraIndex, state.DrawnFranchiseIds, state.Roster);
                        }], ["children", `Re-roll (${state.RerollsAvailable} left)`]])))) : empty_2();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_94))])])))), delay(() => {
                    let matchValue_79, slot_20, elems_95, value_1113, matchValue_80;
                    return append_1((matchValue_79 = positionTarget, (matchValue_79 == null) ? singleton_2(createElement("p", {
                        className: "text-[11px] leading-relaxed text-zinc-500",
                        children: "Pick any player, then choose which open position to slot them into.",
                    })) : ((slot_20 = matchValue_79, singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center gap-2"], (elems_95 = [createElement("span", createObj(ofArray([(value_1113 = "shrink-0 rounded-md border border-orange-500/40 px-2 py-1 text-[10px] font-black tracking-widest text-orange-400", ["className", value_1113]), ["children", contains(slot_20, benchSlots, {
                        Equals: (x_35, y_33) => (x_35 === y_33),
                        GetHashCode: stringHash,
                    }) ? "BNCH" : positionOfSlot(slot_20)]]))), createElement("span", {
                        className: "text-[11px] leading-relaxed text-zinc-500",
                        children: (matchValue_80 = (length(visibleOptions) | 0), (matchValue_80 === 1) ? "1 eligible player found" : (`${matchValue_80} eligible players found`)),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_95))])]))))))), delay(() => {
                        let elems_96;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex justify-end gap-2"], (elems_96 = toList_1(delay(() => append_1(!hideRatings ? singleton_2(sortTab("Rating")) : empty_2(), delay(() => append_1(singleton_2(sortTab("Position")), delay(() => singleton_2(sortTab("Surname A-Z")))))))), ["children", reactApi.Children.toArray(Array.from(elems_96))])])))), delay(() => {
                            let elems_97, value_1135;
                            return append_1((isEmpty(visibleOptions) && (positionTarget != null)) ? singleton_2(createElement("div", createObj(ofArray([["className", "rounded-xl border border-zinc-800 bg-zinc-950/60 p-4 text-center flex flex-col gap-3"], (elems_97 = [createElement("span", {
                                className: "text-zinc-400 text-[11px] leading-relaxed",
                                children: "This squad has nobody for that spot.",
                            }), createElement("button", createObj(ofArray([(value_1135 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3 rounded-xl transition-all cursor-pointer", ["className", value_1135]), ["onClick", (_arg_61) => {
                                setPendingPlayer(undefined);
                                setState((st_20) => (new GameState(new ConsolePhase(2, []), st_20.Roster, st_20.SystemArchetype, st_20.Config, st_20.RerollsAvailable, st_20.DrawnFranchiseIds, st_20.FranchiseLock, st_20.Blueprint, st_20.DailyRun, st_20.IsKnowledgeMode, st_20.DraftModeSetting, st_20.StartEraIndex, st_20.EndEraIndex, st_20.HeadCoachesEnabled, st_20.SelectedCoach, st_20.IsTradeResolved, st_20.TradeOutcome, st_20.IsInstantSkipActive, st_20.PlayerSeason, st_20.TradedInPlayerIds, st_20.DeadlineDeals, st_20.ProjectedWins, st_20.RivalStandings, st_20.PlayoffRecords, st_20.PlayoffOutcome, st_20.PlayoffsEnabled, st_20.TradeDeadlineEnabled, st_20.SeasonLuck, st_20.Wins, st_20.Losses, st_20.GameLog, st_20.Profile, st_20.UserRuns)));
                            }], ["children", "Spin again — free"]]))), createElement("button", {
                                className: "text-zinc-500 hover:text-orange-400 text-xs font-semibold transition-colors cursor-pointer",
                                onClick: (_arg_62) => {
                                    setPendingPlayer(undefined);
                                    setActiveSlot(undefined);
                                    setState((st_21) => (new GameState(new ConsolePhase(2, []), st_21.Roster, st_21.SystemArchetype, st_21.Config, st_21.RerollsAvailable, st_21.DrawnFranchiseIds, st_21.FranchiseLock, st_21.Blueprint, st_21.DailyRun, st_21.IsKnowledgeMode, st_21.DraftModeSetting, st_21.StartEraIndex, st_21.EndEraIndex, st_21.HeadCoachesEnabled, st_21.SelectedCoach, st_21.IsTradeResolved, st_21.TradeOutcome, st_21.IsInstantSkipActive, st_21.PlayerSeason, st_21.TradedInPlayerIds, st_21.DeadlineDeals, st_21.ProjectedWins, st_21.RivalStandings, st_21.PlayoffRecords, st_21.PlayoffOutcome, st_21.PlayoffsEnabled, st_21.TradeDeadlineEnabled, st_21.SeasonLuck, st_21.Wins, st_21.Losses, st_21.GameLog, st_21.Profile, st_21.UserRuns)));
                                },
                                children: "← Pick a different position",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_97))])])))) : empty_2(), delay(() => {
                                let elems_98;
                                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_98 = toList_1(delay(() => collect_1((p_18) => {
                                    let p_17, taken, held, openSlots_1, elems_92, elems_91, ovr_2, elems_90, value_1087;
                                    return append_1(singleton_2((p_17 = p_18, (taken = exists_1((_arg_58, q_1) => (q_1.Id === p_17.Id), state.Roster), (held = exists_2((q_2) => (q_2.Id === p_17.Id), toArray_2(pendingPlayer)), (openSlots_1 = eligibleSlotsFor(runSlots, p_17, state.Roster), createElement("button", createObj(ofArray([["key", p_17.Id], ["disabled", taken ? true : isEmpty(openSlots_1)], ["className", "w-full bg-zinc-900/40 border p-3.5 rounded-xl flex items-center justify-between transition-all mb-2 " + ((taken ? true : isEmpty(openSlots_1)) ? "border-zinc-800/80 opacity-40 cursor-not-allowed" : (held ? "border-orange-500 cursor-pointer" : "border-zinc-800/80 hover:border-orange-500/40 cursor-pointer"))], ["onClick", (_arg_59) => {
                                        setPendingPlayer(p_17);
                                    }], (elems_92 = [createElement("div", createObj(ofArray([["className", "flex min-w-0 items-center gap-3"], (elems_91 = [createElement("span", {
                                        className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-sm font-black " + ((ovr_2 = (p_17.Ovr | 0), hideRatings ? "bg-zinc-800 text-zinc-500" : ((ovr_2 >= 90) ? "bg-orange-600 text-white" : ((ovr_2 >= 80) ? "bg-blue-900 text-blue-200" : "bg-zinc-800 text-zinc-400")))),
                                        children: hideRatings ? "??" : int32ToString(p_17.Ovr),
                                    }), createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_90 = [createElement("div", {
                                        className: "truncate text-sm font-bold text-white",
                                        children: p_17.Name,
                                    }), createElement("div", {
                                        className: "truncate text-[11px] text-zinc-500",
                                        children: hideRatings ? nationalityOf(p_17.Id) : (`${nationalityOf(p_17.Id)} · ${p_17.StatLine}`),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_90))])])))], ["children", reactApi.Children.toArray(Array.from(elems_91))])]))), createElement("span", createObj(ofArray([(value_1087 = "shrink-0 rounded-md border border-zinc-800 px-2 py-1 text-[10px] font-black tracking-widest text-zinc-400", ["className", value_1087]), ["children", join("/", playerPositions(p_17))]])))], ["children", reactApi.Children.toArray(Array.from(elems_92))])])))))))), delay(() => {
                                        let value_1150, slot_21;
                                        let matchResult_5, held_2, slot_22;
                                        if (positionTarget != null) {
                                            if (pendingPlayer != null) {
                                                if ((slot_21 = positionTarget, pendingPlayer.Id === p_18.Id)) {
                                                    matchResult_5 = 0;
                                                    held_2 = pendingPlayer;
                                                    slot_22 = positionTarget;
                                                }
                                                else {
                                                    matchResult_5 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_5 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_5 = 1;
                                        }
                                        switch (matchResult_5) {
                                            case 0:
                                                return singleton_2(createElement("button", createObj(ofArray([["key", "draft-" + p_18.Id], (value_1150 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3 rounded-xl transition-all cursor-pointer -mt-1 mb-3", ["className", value_1150]), ["onClick", (_arg_63) => {
                                                    placePending(held_2, slot_22);
                                                }], ["children", `Draft ${held_2.Name} ➔`]]))));
                                            default: {
                                                return empty_2();
                                            }
                                        }
                                    }));
                                }, visibleOptions))), ["children", reactApi.Children.toArray(Array.from(elems_98))])])))), delay(() => {
                                    let elems_101, elems_99, elems_100, player_19;
                                    const matchValue_82 = pendingPlayer;
                                    let matchResult_6, player_20;
                                    if (matchValue_82 != null) {
                                        if ((player_19 = matchValue_82, positionTarget == null)) {
                                            matchResult_6 = 0;
                                            player_20 = matchValue_82;
                                        }
                                        else {
                                            matchResult_6 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_6 = 1;
                                    }
                                    switch (matchResult_6) {
                                        case 0:
                                            return singleton_2(createElement("div", createObj(ofArray([["className", "rounded-xl border border-orange-500/50 bg-orange-500/5 p-3"], (elems_101 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3"], (elems_99 = [createElement("span", {
                                                className: "text-xs font-bold text-orange-400",
                                                children: `Place ${player_20.Name} (${player_20.Pos})`,
                                            }), createElement("button", {
                                                className: "text-[11px] font-semibold text-zinc-500 transition-colors hover:text-zinc-300",
                                                onClick: (_arg_64) => {
                                                    setPendingPlayer(undefined);
                                                },
                                                children: "Cancel",
                                            })], ["children", reactApi.Children.toArray(Array.from(elems_99))])]))), createElement("div", {
                                                className: "mt-1 text-[11px] text-zinc-500",
                                                children: "Only positions they can play are open. Bench spots take anyone.",
                                            }), createElement("div", createObj(ofArray([["className", "mt-2 grid grid-cols-4 gap-2"], (elems_100 = toList_1(delay(() => map_1((slot_23) => {
                                                let value_1178;
                                                return createElement("button", createObj(ofArray([["key", slot_23], (value_1178 = "rounded-lg border border-orange-500/40 bg-zinc-900 py-2 text-xs font-bold text-orange-400 transition-colors hover:bg-orange-500/10", ["className", value_1178]), ["onClick", (_arg_65) => {
                                                    placePending(player_20, slot_23);
                                                }], ["children", positionOfSlot(slot_23)]])));
                                            }, eligibleSlotsFor(runSlots, player_20, state.Roster)))), ["children", reactApi.Children.toArray(Array.from(elems_100))])])))], ["children", reactApi.Children.toArray(Array.from(elems_101))])]))));
                                        default:
                                            return singleton_2(defaultOf_1());
                                    }
                                }));
                            }));
                        }));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_102))])])));
            break;
        }
        case 6: {
            const patternInput_43 = Engine_calculateSideRatings(state.Roster);
            const coachBox = createElement("div", createObj(ofArray([["className", "w-full border border-zinc-900 bg-zinc-900/20 p-6 rounded-2xl text-center mt-6"], (elems_107 = [createElement("span", {
                className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-2 block",
                children: "Optional",
            }), createElement("div", {
                className: "text-white text-lg font-black",
                children: "Add a Head Coach?",
            }), createElement("p", createObj(ofArray([["className", "mx-auto mt-2 max-w-md text-[11px] leading-relaxed text-zinc-500"], (value_1229 = "A legendary head coach changes the tactical style of your season, adding unique systemic attribute modifiers to your win probability formulas. Off = play under a standard balanced package.", ["children", value_1229])]))), createElement("div", createObj(ofArray([["className", "flex items-center gap-3 w-full mt-6"], (elems_106 = [createElement("button", createObj(ofArray([["disabled", coachSpinning], (value_1235 = "flex-1 bg-zinc-950 border border-orange-500/30 hover:border-orange-500 text-orange-400 font-bold text-xs py-3.5 rounded-xl cursor-pointer transition-all flex justify-center items-center gap-2", ["className", value_1235]), ["onClick", (_arg_66) => {
                setCoachSpinning(true);
                Actions_spinForCoach(setState, () => {
                    setCoachSpinning(false);
                });
            }], ["children", coachSpinning ? "Spinning…" : ((state.SelectedCoach != null) ? "📋 Spin again" : "📋 Spin for a Coach")]]))), createElement("button", createObj(ofArray([(value_1240 = "bg-zinc-900/60 border border-zinc-800 hover:border-zinc-700 text-zinc-400 font-bold text-xs py-3.5 px-6 rounded-xl cursor-pointer transition-all", ["className", value_1240]), ["onClick", (_arg_67) => {
                setState((st_22) => (new GameState(st_22.Phase, st_22.Roster, st_22.SystemArchetype, st_22.Config, st_22.RerollsAvailable, st_22.DrawnFranchiseIds, st_22.FranchiseLock, st_22.Blueprint, st_22.DailyRun, st_22.IsKnowledgeMode, st_22.DraftModeSetting, st_22.StartEraIndex, st_22.EndEraIndex, st_22.HeadCoachesEnabled, undefined, st_22.IsTradeResolved, st_22.TradeOutcome, st_22.IsInstantSkipActive, st_22.PlayerSeason, st_22.TradedInPlayerIds, st_22.DeadlineDeals, st_22.ProjectedWins, st_22.RivalStandings, st_22.PlayoffRecords, st_22.PlayoffOutcome, st_22.PlayoffsEnabled, st_22.TradeDeadlineEnabled, st_22.SeasonLuck, st_22.Wins, st_22.Losses, st_22.GameLog, st_22.Profile, st_22.UserRuns)));
                Actions_startSeason(setState);
            }], ["children", "No coach (classic)"]])))], ["children", reactApi.Children.toArray(Array.from(elems_106))])])))], ["children", reactApi.Children.toArray(Array.from(elems_107))])])));
            let oddsPanel;
            if (hideRatings) {
                oddsPanel = createElement("div", {
                    className: "mt-4 rounded-2xl border border-zinc-900 bg-zinc-900/20 p-4 text-center text-[11px] text-zinc-500",
                    children: "🔮 Blind mode: the pre-season projections are hidden with the ratings. Simulate and find out.",
                });
            }
            else {
                const winChance = Engine_applySeasonLuck(state.SeasonLuck, Engine_calculateWinProbability(teamOvr, Engine_rosterSynergyActive(state.SystemArchetype, state.Roster) ? state.SystemArchetype : "Balanced"));
                const dist = Engine_winDistribution(winChance);
                const atLeast = (threshold) => Engine_probAtLeast(dist, threshold);
                const expectedWins = ~~round_3(winChance * 82) | 0;
                const perfectOdds = item_1(82, dist);
                const oddsBar = (label_13, rawProbability, barClasses) => {
                    let elems_110, elems_108, elems_109;
                    const probability_1 = max(0, rawProbability);
                    const pctText = ((probability_1 > 0) && (probability_1 < 0.0001)) ? "<0.01%" : ((probability_1 < 0.01) ? toText(interpolate("%.2f%P()%%", [probability_1 * 100])) : toText(interpolate("%.1f%P()%%", [probability_1 * 100])));
                    return createElement("div", createObj(ofArray([["key", label_13], ["className", "flex flex-col gap-1"], (elems_110 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between text-[10px]"], (elems_108 = [createElement("span", {
                        className: "font-semibold text-zinc-400",
                        children: label_13,
                    }), createElement("span", {
                        className: "font-mono font-bold text-zinc-300",
                        children: pctText,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_108))])]))), createElement("div", createObj(ofArray([["className", "h-1.5 w-full overflow-hidden rounded-full bg-zinc-900"], (elems_109 = [createElement("div", {
                        className: "h-full rounded-full " + barClasses,
                        style: {
                            width: max(1, probability_1 * 100) + "%",
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_109))])])))], ["children", reactApi.Children.toArray(Array.from(elems_110))])])));
                };
                oddsPanel = createElement("div", createObj(ofArray([["className", "mt-4 rounded-2xl border border-zinc-900 bg-zinc-900/20 p-5"], (elems_115 = [createElement("div", {
                    className: "text-[10px] font-black uppercase tracking-widest text-zinc-500",
                    children: "Pre-season odds",
                }), createElement("div", createObj(ofArray([["className", "mt-2 flex items-end justify-between"], (elems_113 = [createElement("div", createObj(singleton((elems_111 = [createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-zinc-600",
                    children: "Projected finish",
                }), createElement("div", {
                    className: "text-2xl font-black text-white leading-none mt-0.5",
                    children: (seed = ((wins = (expectedWins | 0), (wins >= 62) ? "1st" : ((wins >= 56) ? "2nd" : ((wins >= 52) ? "3rd" : ((wins >= 48) ? "4th" : ((wins >= 45) ? "5th" : ((wins >= 42) ? "6th" : ((wins >= 39) ? "7th" : ((wins >= 36) ? "8th" : "Lottery"))))))))), (seed === "Lottery") ? "Lottery" : (`${seed} seed`)),
                })], ["children", reactApi.Children.toArray(Array.from(elems_111))])))), createElement("div", createObj(ofArray([["className", "text-right"], (elems_112 = [createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-zinc-600",
                    children: "Expected wins",
                }), createElement("div", {
                    className: "text-2xl font-black text-orange-500 leading-none mt-0.5",
                    children: int32ToString(expectedWins),
                })], ["children", reactApi.Children.toArray(Array.from(elems_112))])])))], ["children", reactApi.Children.toArray(Array.from(elems_113))])]))), createElement("div", createObj(ofArray([["className", "mt-4 flex flex-col gap-2.5"], (elems_114 = [oddsBar("Ring pace (50+ wins)", atLeast(championshipWinThreshold), "bg-orange-500"), oddsBar("60-win juggernaut", atLeast(60), "bg-emerald-500"), oddsBar("Playoffs (42+)", atLeast(42), "bg-blue-500"), oddsBar("Play-in or better (36+)", atLeast(36), "bg-violet-500"), oddsBar("Miss everything (lottery)", 1 - atLeast(36), "bg-red-500"), oddsBar("Perfect 82-0", perfectOdds, "bg-amber-400")], ["children", reactApi.Children.toArray(Array.from(elems_114))])]))), createElement("p", {
                    className: "mt-3 text-[10px] leading-relaxed text-zinc-600",
                    children: `What a ${teamOvr} OVR roster should produce over 82 games. Simulate to see if you beat it.`,
                })], ["children", reactApi.Children.toArray(Array.from(elems_115))])])));
            }
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_118 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                children: "🏆 Squad Complete",
            })), delay(() => append_1(singleton_2(createElement("div", {
                className: "text-white text-2xl font-black tracking-tight mb-1",
                children: "Your Lineup",
            })), delay(() => append_1(singleton_2(createElement("div", {
                className: "text-[11px] text-zinc-500 mb-4",
                children: hideRatings ? (`${state.SystemArchetype} • Ratings hidden`) : (`${state.SystemArchetype} • Overall ${teamOvr} • Off ${patternInput_43[0]} / Def ${patternInput_43[1]}`),
            })), delay(() => {
                let elems_116;
                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "overflow-hidden rounded-xl border border-zinc-900"], (elems_116 = toList_1(delay(() => collect_1((slot_25) => {
                    let slot_24, player_21, isBench, pool_10, seasonYear, elems_105, elems_103, elems_104;
                    const matchValue_83 = FSharpMap__TryFind(state.Roster, slot_25);
                    if (matchValue_83 == null) {
                        return empty_2();
                    }
                    else {
                        return singleton_2((slot_24 = slot_25, (player_21 = matchValue_83, (isBench = contains(slot_24, benchSlots, {
                            Equals: (x_36, y_34) => (x_36 === y_34),
                            GetHashCode: stringHash,
                        }), (pool_10 = FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(player_21)), (seasonYear = (defaultArg(map_2((t_2) => poolSeasonYear(t_2.Id), pool_10), 0) | 0), createElement("div", createObj(ofArray([["key", slot_24], ["className", "w-full bg-zinc-950 border-b border-zinc-900/60 py-3.5 px-4 flex items-center justify-between"], (elems_105 = [createElement("div", createObj(ofArray([["className", "flex min-w-0 items-center gap-3"], (elems_103 = [createElement("span", {
                            className: "shrink-0 w-12 text-center rounded-md border px-1.5 py-1 text-[10px] font-black tracking-widest " + (isBench ? "border-zinc-800 text-zinc-500" : "border-orange-500/40 text-orange-400"),
                            children: isBench ? "BNCH" : positionOfSlot(slot_24),
                        }), createElement("span", {
                            className: "truncate text-sm font-semibold text-white",
                            children: player_21.Name,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_103))])]))), createElement("div", createObj(ofArray([["className", "flex shrink-0 items-center gap-3"], (elems_104 = [createElement("span", {
                            className: "h-2 w-2 rounded-full " + eraDotClasses(seasonYear),
                        }), createElement("span", {
                            className: "text-[11px] text-zinc-500",
                            children: defaultArg(map_2((t_3) => t_3.TeamName, pool_10), "—"),
                        }), createElement("span", {
                            className: "w-8 text-right text-sm font-black text-white",
                            children: hideRatings ? "??" : int32ToString(player_21.Ovr),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_104))])])))], ["children", reactApi.Children.toArray(Array.from(elems_105))])])))))))));
                    }
                }, runSlots))), ["children", reactApi.Children.toArray(Array.from(elems_116))])])))), delay(() => {
                    let matchValue_84, result_3, progress_1, elems_117;
                    return append_1((matchValue_84 = state.DailyRun, (matchValue_84 == null) ? singleton_2(defaultOf_1()) : ((result_3 = dailyScore(matchValue_84, state.Roster), (progress_1 = Store_dailyProgressToday(), singleton_2(createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-orange-500/40 bg-orange-500/10 px-4 py-3 mt-4 text-left"], (elems_117 = [createElement("span", {
                        className: "text-orange-400 text-[10px] font-black tracking-widest uppercase block",
                        children: "Daily Challenge result",
                    }), createElement("span", {
                        className: "text-white text-sm font-black block",
                        children: `Challenge score ${result_3.Score}/8 · best today ${max(progress_1.BestScore, result_3.Score)}/8`,
                    }), createElement("span", {
                        className: "text-zinc-400 text-[11px] font-medium block",
                        children: `Attempt ${progress_1.AttemptsUsed}/${dailyAttemptsPerDay} · 🔥 streak ${progress_1.Streak}. Simulate the season for glory — the score is already banked.`,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_117))])])))))))), delay(() => append_1(singleton_2(oddsPanel), delay(() => {
                        let value_1345;
                        return state.HeadCoachesEnabled ? singleton_2(coachBox) : singleton_2(createElement("button", createObj(ofArray([(value_1345 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 mt-6", ["className", value_1345]), ["onClick", (_arg_68) => {
                            Actions_startSeason(setState);
                        }], ["children", "Start the season ➔"]]))));
                    }))));
                }));
            })))))))), ["children", reactApi.Children.toArray(Array.from(elems_118))])])));
            break;
        }
        case 7: {
            const coach_5 = matchValue_74.fields[0];
            console$ = createElement("div", createObj(ofArray([["className", "w-full border border-zinc-900 bg-zinc-900/20 p-8 rounded-2xl text-center shadow-xl"], (elems_119 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-3 block",
                children: "Your Head Coach",
            }), createElement("div", {
                className: "text-white text-3xl font-black font-sans tracking-tight mb-4",
                children: coach_5.Name,
            }), createElement("p", {
                className: "text-zinc-200 text-sm font-medium leading-relaxed max-w-md mx-auto mb-1",
                children: coach_5.Philosophy,
            }), createElement("div", {
                className: "text-zinc-500 text-[11px] font-mono tracking-wide font-medium",
                children: (coach_5.System === state.SystemArchetype) ? (`${coach_5.System} · +${~~(Engine_coachWinBonus * 100)}% per game — your squad runs it`) : (`${coach_5.System} · no bonus — your squad runs ${state.SystemArchetype}`),
            }), createElement("button", createObj(ofArray([(value_1369 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 flex justify-center items-center mt-6", ["className", value_1369]), ["onClick", (_arg_69) => {
                Actions_confirmCoach(setState, coach_5);
            }], ["children", `Continue with ${coach_5.Name} ➔`]])))], ["children", reactApi.Children.toArray(Array.from(elems_119))])])));
            break;
        }
        case 8: {
            const played_2 = (state.Wins + state.Losses) | 0;
            const winPct_1 = (played_2 === 0) ? 0 : (state.Wins / played_2);
            let pctText_1;
            const raw_4 = toText(interpolate("%.3f%P()", [winPct_1]));
            pctText_1 = (raw_4.startsWith("0") ? substring(raw_4, 1) : raw_4);
            const projectedWins = ((played_2 === 0) ? 0 : ~~round_3(winPct_1 * 82)) | 0;
            const recordBox = (label_14, value_1375) => {
                let elems_120;
                return createElement("div", createObj(ofArray([["key", label_14], ["className", "flex-1 rounded-xl border border-zinc-900 bg-zinc-950 px-3 py-3"], (elems_120 = [createElement("div", {
                    className: "text-[10px] font-black uppercase tracking-widest text-zinc-500",
                    children: label_14,
                }), createElement("div", {
                    className: "mt-1 text-xl font-black leading-none text-white",
                    children: value_1375,
                })], ["children", reactApi.Children.toArray(Array.from(elems_120))])])));
            };
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_123 = [createElement("div", createObj(ofArray([["className", "w-full border border-zinc-900 bg-zinc-900/20 p-6 rounded-2xl text-center mb-4"], (elems_122 = [createElement("span", {
                className: "text-zinc-500 text-[10px] tracking-widest font-black uppercase mb-1 block",
                children: "NBA Trade Deadline · February 6, 3 PM ET",
            }), createElement("div", {
                className: "text-white text-2xl font-black font-sans mb-4",
                children: "Deadline day",
            }), createElement("div", createObj(ofArray([["className", "flex gap-2 mb-4"], (elems_121 = [recordBox("Wins", int32ToString(state.Wins)), recordBox("Losses", int32ToString(state.Losses)), recordBox("Win Pct", pctText_1)], ["children", reactApi.Children.toArray(Array.from(elems_121))])]))), createElement("p", {
                className: "mx-auto mb-5 max-w-md text-[11px] leading-relaxed text-zinc-400",
                children: `${played_2} games played, ${82 - played_2} to go, the All-Star break just ahead. On this pace you finish with ${projectedWins} wins. Work the phones and gamble on a deadline move — a contender may call about your star, or the buyout market may open — or stand pat and ride this roster. There is no undo.`,
            }), createElement("button", createObj(ofArray([(value_1406 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer font-sans shadow-lg shadow-orange-500/10 mb-2.5 flex justify-center items-center", ["className", value_1406]), ["onClick", (_arg_70) => {
                Actions_enterTradeMarket(setState, state.Roster);
            }], ["children", "Work the phones"]]))), createElement("button", createObj(ofArray([(value_1411 = "w-full border border-zinc-900 bg-zinc-950 hover:border-zinc-800 text-zinc-400 hover:text-white text-xs font-semibold py-3 rounded-xl transition-all cursor-pointer flex justify-center items-center", ["className", value_1411]), ["onClick", (_arg_71) => {
                Actions_stickWithRoster(setState, "Deadline Day Passes", "Phones stayed in pockets. The roster you built is the roster you ride — and it goes again as it stands.");
            }], ["children", "Stand pat"]])))], ["children", reactApi.Children.toArray(Array.from(elems_122))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_123))])])));
            break;
        }
        case 9: {
            const weakestSlot = matchValue_74.fields[0];
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_127 = [createElement("div", createObj(ofArray([["className", "w-full border border-orange-950/40 bg-zinc-950 p-8 rounded-2xl text-center select-none mb-4"], (elems_126 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-2 block",
                children: "Deadline Day • Wheeler Dealer",
            }), createElement("div", {
                className: "text-white text-lg font-black font-sans",
                children: `Three punts for your weakest spot, ${weakestSlot} (${matchValue_74.fields[1]}).`,
            }), createElement("span", {
                className: "text-amber-500 text-xs font-bold font-sans tracking-wide block mt-1 mb-6",
                children: "No ratings shown — pick the one you trust.",
            }), createElement("div", createObj(singleton((elems_125 = toList_1(delay(() => map_1((offer_1) => {
                let value_1422, elems_124;
                const offer = offer_1;
                return createElement("button", createObj(ofArray([["key", offer.Id], (value_1422 = "w-full bg-zinc-900/20 border border-zinc-900 hover:border-orange-500/40 p-4 rounded-xl text-left cursor-pointer transition-all mb-3 block", ["className", value_1422]), ["onClick", (_arg_72) => {
                    Actions_acceptTradeOffer(setState, weakestSlot, offer);
                }], (elems_124 = [createElement("span", {
                    className: "text-zinc-100 text-sm font-bold font-sans block",
                    children: offer.Name,
                }), createElement("span", {
                    className: "text-zinc-500 text-xs font-medium tracking-wide mt-1 block",
                    children: offer.StatLine,
                })], ["children", reactApi.Children.toArray(Array.from(elems_124))])])));
            }, matchValue_74.fields[2]))), ["children", reactApi.Children.toArray(Array.from(elems_125))])))), createElement("span", {
                className: "text-zinc-600 text-[10px] tracking-wide mt-2 block font-mono",
                children: "Pick one.",
            })], ["children", reactApi.Children.toArray(Array.from(elems_126))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_127))])])));
            break;
        }
        case 10: {
            const weakestSlot_1 = matchValue_74.fields[0];
            const currentPlayerName_1 = matchValue_74.fields[1];
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_129 = [createElement("div", createObj(ofArray([["className", "w-full border border-orange-950/40 bg-zinc-950 p-8 rounded-2xl text-center select-none mb-4"], (elems_128 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-2 block",
                children: "Deadline Day • The Bargain Bin",
            }), createElement("div", {
                className: "text-white text-lg font-black font-sans",
                children: `A scout swears he has found a gem for ${positionOfSlot(weakestSlot_1)} (${currentPlayerName_1}).`,
            }), createElement("span", createObj(ofArray([["className", "text-amber-500 text-xs font-bold font-sans tracking-wide block mt-1 mb-6"], (value_1469 = "One blind signing, no questions asked. No name, no rating — the deal is done the moment you shake hands.", ["children", value_1469])]))), createElement("button", createObj(ofArray([(value_1471 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 mb-3", ["className", value_1471]), ["onClick", (_arg_73) => {
                Actions_acceptTradeOffer(setState, weakestSlot_1, matchValue_74.fields[2]);
            }], ["children", "Confirm the move"]]))), createElement("button", createObj(ofArray([(value_1476 = "w-full border border-zinc-800 bg-zinc-900/40 text-zinc-300 font-bold text-xs py-3.5 rounded-xl transition-all hover:border-zinc-700 cursor-pointer", ["className", value_1476]), ["onClick", (_arg_74) => {
                Actions_stickWithRoster(setState, "The Bargain Bin", `You walked away from the mystery man. ${currentPlayerName_1} keeps his spot, and the season goes again as it stands.`);
            }], ["children", `Pass — keep ${currentPlayerName_1}`]]))), createElement("span", {
                className: "text-zinc-600 text-[10px] tracking-wide mt-3 block font-mono",
                children: "No undo.",
            })], ["children", reactApi.Children.toArray(Array.from(elems_128))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_129))])])));
            break;
        }
        case 11: {
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_131 = [createElement("div", createObj(ofArray([["className", "border border-zinc-800 bg-zinc-950/95 rounded-2xl p-6 text-center mb-4"], (elems_130 = [createElement("span", {
                className: "text-orange-500 text-[10px] font-black tracking-[0.2em] uppercase block mb-2",
                children: "Deadline Day",
            }), createElement("div", {
                className: "text-white text-xl font-black mb-2",
                children: matchValue_74.fields[0],
            }), createElement("p", {
                className: "mx-auto mb-5 max-w-md text-[11px] leading-relaxed text-zinc-400",
                children: matchValue_74.fields[1],
            }), createElement("button", createObj(ofArray([(value_1503 = "w-full border border-emerald-500/40 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer", ["className", value_1503]), ["onClick", (_arg_75) => {
                Actions_continueAfterDeadline(setState);
            }], ["children", "Continue the season"]])))], ["children", reactApi.Children.toArray(Array.from(elems_130))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_131))])])));
            break;
        }
        case 12: {
            const ovrDiff = matchValue_74.fields[3] | 0;
            const outPlayer = matchValue_74.fields[1];
            const inPlayer = matchValue_74.fields[2];
            const isUpgrade = ovrDiff >= 0;
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_137 = [createElement("div", createObj(ofArray([(value_1512 = "w-full border border-orange-950/40 bg-zinc-950 p-6 rounded-2xl text-center select-none shadow-xl mb-4", ["className", value_1512]), (elems_136 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-4 block",
                children: `Done Deal • ${matchValue_74.fields[0]}`,
            }), createElement("div", createObj(ofArray([(value_1518 = "w-full bg-zinc-900/20 border border-zinc-900/80 p-4 rounded-xl flex items-center justify-between text-left mb-3", ["className", value_1518]), (elems_133 = [createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_132 = [createElement("span", {
                className: "text-zinc-500 text-[9px] font-black tracking-wider block mb-0.5",
                children: "OUT",
            }), createElement("span", {
                className: "truncate text-sm font-bold text-white block",
                children: outPlayer.Name,
            })], ["children", reactApi.Children.toArray(Array.from(elems_132))])]))), createElement("span", {
                className: "shrink-0 text-white text-2xl font-black font-sans",
                children: int32ToString(outPlayer.Ovr),
            })], ["children", reactApi.Children.toArray(Array.from(elems_133))])]))), createElement("span", {
                className: "text-orange-500 text-xs my-2 block font-mono",
                children: "↓",
            }), createElement("div", createObj(ofArray([["className", "w-full p-4 rounded-xl flex items-center justify-between text-left mb-4 border " + (isUpgrade ? "bg-emerald-950/10 border-emerald-900/80" : "bg-red-950/10 border-red-900/80")], (elems_135 = [createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_134 = [createElement("span", {
                className: "text-zinc-500 text-[9px] font-black tracking-wider block mb-0.5",
                children: "IN",
            }), createElement("span", {
                className: "truncate text-sm font-bold text-white block",
                children: inPlayer.Name,
            }), createElement("span", {
                className: "truncate text-zinc-500 text-xs font-medium tracking-wide block mt-0.5",
                children: inPlayer.StatLine,
            })], ["children", reactApi.Children.toArray(Array.from(elems_134))])]))), createElement("span", {
                className: "shrink-0 text-2xl font-black font-sans " + (isUpgrade ? "text-emerald-400" : "text-red-400"),
                children: int32ToString(inPlayer.Ovr),
            })], ["children", reactApi.Children.toArray(Array.from(elems_135))])]))), createElement("span", {
                className: "text-xs font-semibold font-sans tracking-wide block mb-6 animate-pulse " + (isUpgrade ? "text-emerald-400" : "text-red-400"),
                children: isUpgrade ? (`Up ${ovrDiff} rating points in that position.`) : (`Down ${Math.abs(ovrDiff)} rating points in that position.`),
            }), createElement("button", createObj(ofArray([(value_1566 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 flex justify-center items-center", ["className", value_1566]), ["onClick", (_arg_76) => {
                Actions_confirmTrade(setState);
            }], ["children", "Continue the season"]])))], ["children", reactApi.Children.toArray(Array.from(elems_136))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_137))])])));
            break;
        }
        case 13: {
            const starSlot = matchValue_74.fields[0];
            const star = matchValue_74.fields[1];
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_139 = [createElement("div", createObj(ofArray([["className", "w-full border border-orange-950/40 bg-zinc-950 p-8 rounded-2xl text-center select-none mb-4"], (elems_138 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-2 block",
                children: "Deadline Day • The Blockbuster",
            }), createElement("div", {
                className: "text-white text-lg font-black font-sans",
                children: "The call every GM dreads",
            }), createElement("p", {
                className: "mx-auto mt-3 mb-2 max-w-md text-[11px] leading-relaxed text-zinc-400",
                children: `A championship contender wants ${star.Name} (${starSlot}) and they are offering the moon. Cash in, and two deadline arrivals come back off the franchise wheel — one to replace him, one for your weakest spot. Or hang up and keep your star.`,
            }), createElement("span", {
                className: "text-amber-500 text-xs font-bold font-sans tracking-wide block mb-6",
                children: "The wheel decides who calls back. No undo.",
            }), createElement("button", createObj(ofArray([(value_1593 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer font-sans shadow-lg shadow-orange-500/10 mb-2.5 flex justify-center items-center", ["className", value_1593]), ["onClick", (_arg_77) => {
                Actions_executeBlockbuster(setState, state.Config, state.StartEraIndex, state.EndEraIndex, state.Roster, starSlot);
            }], ["children", "Cash in"]]))), createElement("button", createObj(ofArray([(value_1598 = "w-full border border-zinc-900 bg-zinc-950 hover:border-zinc-800 text-zinc-400 hover:text-white text-xs font-semibold py-3 rounded-xl transition-all cursor-pointer flex justify-center items-center", ["className", value_1598]), ["onClick", (_arg_78) => {
                Actions_declineBlockbuster(setState, star.Name);
            }], ["children", `Keep ${star.Name}`]])))], ["children", reactApi.Children.toArray(Array.from(elems_138))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_139))])])));
            break;
        }
        case 14: {
            const stage = matchValue_74.fields[0] | 0;
            const deals_4 = matchValue_74.fields[1];
            const incoming_2 = defaultArg(tryItem(stage - 1, deals_4), last_1(deals_4))[2];
            const incomingPool = FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(incoming_2));
            const finalFranchise = defaultArg(map_2(fullFranchiseName, incomingPool), incoming_2.Name);
            const finalSeason = defaultArg(map_2((pool_12) => seasonLabelForPool(pool_12.Id), incomingPool), "—");
            const reelItems_1 = (finalLabel_1, decoys_1) => {
                let ds_1;
                return append(isEmpty(decoys_1) ? replicate(11, finalLabel_1) : ((ds_1 = decoys_1, initialize_1(11, (i_7) => item(i_7 % length(ds_1), ds_1)))), singleton(finalLabel_1));
            };
            const decoyPools_1 = sortBy((pool_14) => reelOrderKey(`${incoming_2.Id}-${stage}`, pool_14.Id), filter((pool_13) => !equals(pool_13.Id, map_2((p_19) => p_19.Id, incomingPool)), poolsInSeasonRange(state.StartEraIndex, state.EndEraIndex)), {
                Compare: comparePrimitives,
            });
            const reelColumn_1 = (key_899, items_1, animClass_1, boxWidth_1, onDone_1) => {
                let elems_141;
                return createElement("div", createObj(ofArray([["key", key_899], ["className", boxWidth_1 + " h-14 bg-zinc-950 border border-orange-500/60 rounded-xl overflow-hidden shadow-lg shadow-orange-500/10"], (elems_141 = [createElement("div", createObj(toList_1(delay(() => append_1(singleton_2(["className", "flex flex-col " + animClass_1]), delay(() => append_1(singleton_2(["style", {
                    "--reel-end": "calc(-11 * 3.5rem)",
                }]), delay(() => {
                    let matchValue_85, fire_1;
                    return append_1((matchValue_85 = onDone_1, (matchValue_85 == null) ? (empty_2()) : ((fire_1 = matchValue_85, singleton_2(["onAnimationEnd", (_arg_79) => {
                        fire_1();
                    }])))), delay(() => {
                        let elems_140;
                        return singleton_2((elems_140 = toList_1(delay(() => collect_1((matchValue_86) => {
                            let value_1622;
                            const label_15 = matchValue_86[1];
                            return singleton_2(createElement("div", createObj(ofArray([["key", `${matchValue_86[0]}-${label_15}`], (value_1622 = "h-14 shrink-0 flex items-center justify-center px-2 text-center text-xs font-bold text-zinc-100 truncate", ["className", value_1622]), ["children", label_15]]))));
                        }, indexed(items_1)))), ["children", reactApi.Children.toArray(Array.from(elems_140))]));
                    }));
                }))))))))], ["children", reactApi.Children.toArray(Array.from(elems_141))])])));
            };
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_144 = [createElement("div", createObj(ofArray([["key", `signing-${stage}`], ["className", "w-full border border-orange-950/40 bg-zinc-950 p-8 rounded-2xl text-center select-none mb-4"], (elems_143 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-2 block",
                children: `Deadline Day • Signing ${stage} of ${length(deals_4)}`,
            }), createElement("div", {
                className: "text-white text-lg font-black font-sans mb-8",
                children: "Spinning for the arrival…",
            }), createElement("div", createObj(ofArray([["className", "flex items-end justify-center gap-4 mb-6"], (elems_142 = [reelColumn_1(`bb-franchise-${stage}`, reelItems_1(finalFranchise, map(fullFranchiseName, decoyPools_1)), "animate-reelDrop", "w-40", undefined), createElement("span", {
                className: "text-zinc-700 text-lg font-black pb-4",
                children: "×",
            }), reelColumn_1(`bb-season-${stage}`, reelItems_1(finalSeason, map((p_20) => seasonLabelForPool(p_20.Id), decoyPools_1)), "animate-reelDropSlow", "w-24", () => {
                Actions_advanceBlockbuster(setState, stage, deals_4);
            })], ["children", reactApi.Children.toArray(Array.from(elems_142))])]))), createElement("span", {
                className: "text-zinc-600 text-[10px] font-medium tracking-wide block select-none animate-pulse",
                children: "The wheel decides who calls back…",
            })], ["children", reactApi.Children.toArray(Array.from(elems_143))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_144))])])));
            break;
        }
        case 15: {
            const deals_5 = matchValue_74.fields[0];
            console$ = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_152 = [createElement("div", createObj(ofArray([["className", "w-full border border-orange-950/40 bg-zinc-950 p-6 rounded-2xl select-none shadow-xl mb-4"], (elems_151 = [createElement("span", {
                className: "text-orange-500 text-[10px] tracking-widest font-black uppercase mb-4 block text-center",
                children: `Done Deals • ${length(deals_5)} In`,
            }), createElement("div", createObj(singleton((elems_150 = toList_1(delay(() => map_1((deal) => {
                let elems_149, value_1664, elems_146, elems_145, elems_148, elems_147;
                const tupledArg_26 = deal;
                const slot_26 = tupledArg_26[0];
                const outgoing_2 = tupledArg_26[1];
                const incoming_3 = tupledArg_26[2];
                const diff = (incoming_3.Ovr - outgoing_2.Ovr) | 0;
                const isUpgrade_1 = diff >= 0;
                const originSquad = defaultArg(map_2((pool_16) => pool_16.TeamName, FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(incoming_3))), incoming_3.StatLine);
                return createElement("div", createObj(ofArray([["key", slot_26], ["className", "w-full mb-4"], (elems_149 = [createElement("span", {
                    className: "text-zinc-500 text-[9px] font-black tracking-widest uppercase block mb-2 text-left",
                    children: slot_26,
                }), createElement("div", createObj(ofArray([(value_1664 = "w-full bg-zinc-900/20 border border-zinc-900/80 p-3 rounded-xl flex items-center justify-between text-left mb-1.5", ["className", value_1664]), (elems_146 = [createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_145 = [createElement("span", {
                    className: "text-zinc-500 text-[9px] font-black tracking-wider block mb-0.5",
                    children: "OUT",
                }), createElement("span", {
                    className: "truncate text-sm font-bold text-white block",
                    children: outgoing_2.Name,
                })], ["children", reactApi.Children.toArray(Array.from(elems_145))])]))), createElement("span", {
                    className: "shrink-0 text-white text-xl font-black font-sans",
                    children: int32ToString(outgoing_2.Ovr),
                })], ["children", reactApi.Children.toArray(Array.from(elems_146))])]))), createElement("div", createObj(ofArray([["className", "w-full p-3 rounded-xl flex items-center justify-between text-left border " + (isUpgrade_1 ? "bg-emerald-950/10 border-emerald-900/80" : "bg-red-950/10 border-red-900/80")], (elems_148 = [createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_147 = [createElement("span", {
                    className: "text-zinc-500 text-[9px] font-black tracking-wider block mb-0.5",
                    children: "IN",
                }), createElement("span", {
                    className: "truncate text-sm font-bold text-white block",
                    children: incoming_3.Name,
                }), createElement("span", {
                    className: "truncate text-zinc-500 text-[11px] font-medium tracking-wide block mt-0.5",
                    children: originSquad,
                })], ["children", reactApi.Children.toArray(Array.from(elems_147))])]))), createElement("span", {
                    className: "shrink-0 text-xl font-black font-sans " + (isUpgrade_1 ? "text-emerald-400" : "text-red-400"),
                    children: int32ToString(incoming_3.Ovr),
                })], ["children", reactApi.Children.toArray(Array.from(elems_148))])]))), createElement("span", {
                    className: "text-[11px] font-semibold tracking-wide block mt-1.5 text-left " + (isUpgrade_1 ? "text-emerald-400" : "text-red-400"),
                    children: (diff === 0) ? "Even swap in that spot." : (isUpgrade_1 ? (`Up ${diff} rating points in that spot.`) : (`Down ${Math.abs(diff)} rating points in that spot.`)),
                })], ["children", reactApi.Children.toArray(Array.from(elems_149))])])));
            }, deals_5))), ["children", reactApi.Children.toArray(Array.from(elems_150))])))), createElement("button", createObj(ofArray([(value_1716 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer shadow-lg shadow-orange-500/10 flex justify-center items-center", ["className", value_1716]), ["onClick", (_arg_80) => {
                Actions_confirmTrade(setState);
            }], ["children", "Continue the season"]])))], ["children", reactApi.Children.toArray(Array.from(elems_151))])]))), tickerConsole(defaultOf_1())], ["children", reactApi.Children.toArray(Array.from(elems_152))])])));
            break;
        }
        case 16: {
            console$ = tickerConsole(defaultOf_1());
            break;
        }
        case 17: {
            console$ = tickerConsole((w_2 = (matchValue_74.fields[0] | 0), (l_2 = (matchValue_74.fields[1] | 0), (finalRank = (((matchValue_43 = state.RivalStandings, isEmpty(matchValue_43) ? ((w_2 >= championshipWinThreshold) ? 1 : 2) : (1 + length(filter((tupledArg_5) => (tupledArg_5[1] > w_2), matchValue_43))))) | 0), (leagueWinner = tryHead(sortByDescending((tuple_4) => tuple_4[1], state.RivalStandings, {
                Compare: comparePrimitives,
            })), (isChampion = (((l_2 === 0) && (w_2 === 82)) ? true : (finalRank === 1)), (patternInput_39 = Engine_calculateSideRatings(state.Roster), (winPct = ((raw = toText(interpolate("%.3f%P()", [w_2 / max(1, w_2 + l_2)])), raw.startsWith("0") ? substring(raw, 1) : raw)), (panel = ((extra, children) => createElement("div", {
                className: "w-full bg-zinc-900/30 border border-zinc-900 rounded-2xl " + extra,
                children: reactApi.Children.toArray(Array.from(children)),
            })), (metricBox = ((label_1, value_171, valueClasses_1) => {
                let elems_13;
                return createElement("div", createObj(ofArray([["key", label_1], ["className", "flex-1 rounded-xl border border-zinc-900 bg-zinc-950 px-3 py-3 text-center"], (elems_13 = [createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-zinc-500",
                    children: label_1,
                }), createElement("div", {
                    className: "mt-1 text-lg font-black leading-none " + valueClasses_1,
                    children: value_171,
                })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
            }), (earnedBadges = toList_1(delay(() => append_1(isChampion ? singleton_2("🏆 Champions") : empty_2(), delay(() => append_1(tradeTaken ? singleton_2("🤝 Deadline Day Hero") : empty_2(), delay(() => ((longestWinStreak >= 10) ? singleton_2(`🔥 Hot Streak (${longestWinStreak})`) : empty_2()))))))), (verdict = map_2((projected) => {
                const delta = (w_2 - projected) | 0;
                if (delta >= 8) {
                    return ["SHATTERED THE CEILING", "border-emerald-500/40 bg-emerald-500/10 text-emerald-400"];
                }
                else if (delta >= 4) {
                    return ["OVERDELIVERED", "border-emerald-500/40 bg-emerald-500/10 text-emerald-400"];
                }
                else if (delta >= -3) {
                    return ["AS ADVERTISED", "border-zinc-700 bg-zinc-900 text-zinc-300"];
                }
                else if (delta >= -7) {
                    return ["UNDERWHELMED", "border-amber-500/40 bg-amber-500/10 text-amber-400"];
                }
                else {
                    return ["FLATTERED TO DECEIVE", "border-red-500/40 bg-red-500/10 text-red-400"];
                }
            }, state.ProjectedWins), (blockBadges = createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_17 = toList_1(delay(() => {
                let elems_14;
                return append_1(!isEmpty(earnedBadges) ? singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-wrap justify-center gap-2"], (elems_14 = toList_1(delay(() => map_1((badge) => {
                    let value_199;
                    return createElement("span", createObj(ofArray([["key", badge], (value_199 = "rounded-full border border-orange-500/40 bg-orange-500/10 px-3 py-1 text-[11px] font-bold text-orange-400", ["className", value_199]), ["children", badge]])));
                }, earnedBadges))), ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty_2(), delay(() => {
                    let value_213;
                    return append_1(singleton_2(panel("p-6 text-center mt-3", ofArray([createElement("div", {
                        className: "text-white text-lg font-black",
                        children: "Beat your mates",
                    }), createElement("p", {
                        className: "mx-auto mt-1 mb-4 max-w-sm text-[11px] leading-relaxed text-zinc-500",
                        children: "Your lineup against theirs, same rules. Best team on the day wins.",
                    }), createElement("button", createObj(ofArray([["onClick", (_arg_12) => {
                        Actions_navigateToMultiplayerHub(setState);
                    }], (value_213 = "w-full bg-zinc-900 border border-zinc-800 text-white font-bold text-xs py-3.5 rounded-xl cursor-pointer transition-all hover:border-zinc-700", ["className", value_213]), ["children", "Play with mates ➔"]]))), createElement("div", {
                        className: "mt-2 text-[10px] text-zinc-600",
                        children: "Live Draft with a room code, or an async league.",
                    })]))), delay(() => {
                        let elems_15, ovr, ovr_1;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_15 = [metricBox("Finished", rankOrdinal(finalRank), "text-white"), metricBox("Projected", (ovr = (teamOvr | 0), (ovr >= 93) ? "1st" : ((ovr >= 90) ? "2nd" : ((ovr >= 87) ? "3rd" : ((ovr >= 84) ? "5th" : ((ovr >= 80) ? "7th" : "Lottery"))))), "text-zinc-400"), metricBox("Projected Wins", defaultArg(map_2(int32ToString, state.ProjectedWins), "—"), "text-zinc-400"), metricBox("Squad Class", (ovr_1 = (teamOvr | 0), (ovr_1 >= 93) ? "SUPERTEAM" : ((ovr_1 >= 88) ? "CONTENDERS" : ((ovr_1 >= 83) ? "PLAYOFF SIDE" : ((ovr_1 >= 78) ? "PARTY CRASHERS" : "REBUILDING")))), "text-orange-500 text-sm")], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))), delay(() => {
                            let elems_16;
                            const matchValue_44 = verdict;
                            return (matchValue_44 == null) ? singleton_2(defaultOf_1()) : singleton_2(createElement("div", createObj(ofArray([["className", "flex justify-center"], (elems_16 = [createElement("span", {
                                className: "rounded-full border px-4 py-1.5 text-[11px] font-black uppercase tracking-widest " + matchValue_44[1],
                                children: matchValue_44[0],
                            })], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
                        }));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_17))])]))), (recapHeadline = (((l_2 === 0) && (w_2 === 82)) ? "IMMORTALITY. 82 AND 0." : ((w_2 >= 74) ? "RECORD BREAKERS" : ((w_2 >= 60) ? "A JUGGERNAUT SEASON" : ((w_2 >= championshipWinThreshold) ? "BANNER SEASON" : ((w_2 >= 42) ? "GOOD, NOT GREAT" : ((w_2 >= 30) ? "THE TREADMILL OF MEDIOCRITY" : ((w_2 >= 12) ? "LOTTERY BOUND" : "HISTORIC FUTILITY"))))))), (narrativeParagraphs = ((coachLine_1 = ((matchValue_45 = state.SelectedCoach, (matchValue_45 == null) ? " No coach was appointed; the roster played it straight." : ((matchValue_45.System === state.SystemArchetype) ? ((coach_3 = matchValue_45, ` ${coach_3.Name} on the sideline was worth a real edge: their ${coach_3.System} system matched the way this squad was built.`)) : ((coach_4 = matchValue_45, ` ${coach_4.Name} never quite fit — they coach ${coach_4.System}, this squad ran ${state.SystemArchetype}.`))))), (deadlineParagraph = ((matchValue_46 = state.DeadlineDeals, !isEmpty(matchValue_46) ? (isEmpty(tail_1(matchValue_46)) ? ((delta_1 = ((head(matchValue_46)[2].Ovr - head(matchValue_46)[1].Ovr) | 0), (delta_1 > 0) ? (`The February gamble paid off: ${head(matchValue_46)[2].Name} arrived at the deadline, ${head(matchValue_46)[1].Name} made way, and the spot got ${delta_1} rating points stronger overnight.`) : ((delta_1 < 0) ? (`The February gamble stung: ${head(matchValue_46)[2].Name} came in for ${head(matchValue_46)[1].Name} and arrived ${op_UnaryNegation_Int32(delta_1)} rating points lighter. The buyout market keeps its receipts.`) : (`${head(matchValue_46)[2].Name} replaced ${head(matchValue_46)[1].Name} at the deadline — a like-for-like swap that changed the mood more than the maths.`)))) : ((length(matchValue_46) >= 2) ? ((outs = join(" and ", map((tupledArg_6) => tupledArg_6[1].Name, matchValue_46)), (ins = join(" and ", map((tupledArg_7) => tupledArg_7[2].Name, matchValue_46)), (net = (sumBy((tupledArg_8) => (tupledArg_8[2].Ovr - tupledArg_8[1].Ovr), matchValue_46, {
                GetZero: () => 0,
                Add: (x_11, y_10) => (x_11 + y_10),
            }) | 0), `Deadline day delivered the blockbuster: ${outs} moved on, and ${ins} walked in off the wheel — ${(net > 0) ? (`a net gain of ${net} rating points`) : ((net < 0) ? (`a net loss of ${op_UnaryNegation_Int32(net)} rating points`) : "a dead-even exchange")} across the roster.`)))) : ((matchValue_47 = state.TradeOutcome, (matchValue_47 == null) ? "" : matchValue_47)))) : ((length(matchValue_46) >= 2) ? ((outs = join(" and ", map((tupledArg_6) => tupledArg_6[1].Name, matchValue_46)), (ins = join(" and ", map((tupledArg_7) => tupledArg_7[2].Name, matchValue_46)), (net = (sumBy((tupledArg_8) => (tupledArg_8[2].Ovr - tupledArg_8[1].Ovr), matchValue_46, {
                GetZero: () => 0,
                Add: (x_11, y_10) => (x_11 + y_10),
            }) | 0), `Deadline day delivered the blockbuster: ${outs} moved on, and ${ins} walked in off the wheel — ${(net > 0) ? (`a net gain of ${net} rating points`) : ((net < 0) ? (`a net loss of ${op_UnaryNegation_Int32(net)} rating points`) : "a dead-even exchange")} across the roster.`)))) : ((matchValue_47 = state.TradeOutcome, (matchValue_47 == null) ? "" : matchValue_47))))), (scorerLine = ((matchValue_48 = awardLeader((tupledArg_9) => {
                const line_1 = tupledArg_9[1];
                return perGame(line_1.Points, line_1.Games);
            }), (matchValue_48 != null) ? (((player_12 = matchValue_48[0], matchValue_48[1].Games > 0)) ? ((line_3 = matchValue_48[1], (player_13 = matchValue_48[0], ` ${player_13.Name} carried the offense at ${toText(interpolate("%.1f%P()", [perGame(line_3.Points, line_3.Games)]))} a night.`))) : "") : "")), (projectionLine = ((matchValue_49 = state.ProjectedWins, (matchValue_49 == null) ? "" : (((w_2 - matchValue_49) >= 4) ? ((projected_3 = (matchValue_49 | 0), ` The pundits pencilled in ${projected_3} wins; this roster tore the projection up.`)) : (((matchValue_49 - w_2) >= 4) ? ((projected_4 = (matchValue_49 | 0), ` Projected for ${projected_4} wins, the season never lived up to the paper.`)) : ((projected_5 = (matchValue_49 | 0), ` Projected for ${projected_5} wins — this team was exactly what it looked like.`)))))), (extremesLine = ((matchValue_50 = filter((g_6) => g_6.Won, seasonGames), isEmpty(matchValue_50) ? "" : ((big = maxBy((g_7) => (g_7.TeamScore - g_7.OppScore), matchValue_50, {
                Compare: comparePrimitives,
            }), ` The high point: a ${big.TeamScore}-${big.OppScore} statement over the ${big.Opponent}.`)))), filter((para) => (para !== ""), ofArray([`A ${w_2}-${l_2} season scoring ${toText(interpolate("%.1f%P()", [perGame(pointsScored, w_2 + l_2)]))} a night and conceding ${toText(interpolate("%.1f%P()", [perGame(pointsAllowed, w_2 + l_2)]))}. The longest winning run reached ${longestWinStreak} games.${scorerLine}`, (extremesLine + coachLine_1).trim(), deadlineParagraph, projectionLine.trim()])))))))), (averageUnit = ((players) => {
                if (isEmpty(players)) {
                    return 0;
                }
                else {
                    return ~~round_3(averageBy((p_6) => p_6.Ovr, players, {
                        GetZero: () => 0,
                        Add: (x_14, y_12) => (x_14 + y_12),
                        DivideByInt: (x_13, i_3) => (x_13 / i_3),
                    })) | 0;
                }
            }), (starterList = map((tuple_5) => tuple_5[1], filter((tupledArg_10) => !contains(tupledArg_10[0], benchSlots, {
                Equals: (x_15, y_13) => (x_15 === y_13),
                GetHashCode: stringHash,
            }), toList(state.Roster))), (unitRatings = filter((tupledArg_11) => (tupledArg_11[1] > 0), ofArray([["backcourt", averageUnit(filter((p_7) => {
                if (p_7.Pos === "PG") {
                    return true;
                }
                else {
                    return p_7.Pos === "SG";
                }
            }, starterList))], ["frontcourt", averageUnit(filter((p_8) => {
                if ((p_8.Pos === "SF") ? true : (p_8.Pos === "PF")) {
                    return true;
                }
                else {
                    return p_8.Pos === "C";
                }
            }, starterList))], ["bench", averageUnit(choose((key_130) => FSharpMap__TryFind(state.Roster, key_130), benchSlots))], ["defense", patternInput_39[1]]])), (unitSummary = ((patternInput_40 = maxBy((tuple_6) => tuple_6[1], unitRatings, {
                Compare: comparePrimitives,
            }), (patternInput_41 = minBy((tuple_7) => tuple_7[1], unitRatings, {
                Compare: comparePrimitives,
            }), ((patternInput_40[1] - patternInput_41[1]) <= 2) ? "A balanced build — no obvious weak link anywhere." : (`Built around the ${patternInput_40[0]}; the ${patternInput_41[0]} was the weak link.`)))), (blockSystem = createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_22 = toList_1(delay(() => append_1(singleton_2(panel("px-5 py-3", ofArray([createElement("div", {
                className: "text-center text-[11px] font-mono font-bold tracking-wide text-zinc-400",
                children: join(" • ", map((tupledArg_12) => {
                    let value_167;
                    return `${tupledArg_12[0].toLocaleUpperCase()} ${(value_167 = (tupledArg_12[1] | 0), (value_167 >= 93) ? "Elite" : ((value_167 >= 88) ? "Very Good" : ((value_167 >= 83) ? "Strong" : ((value_167 >= 76) ? "Solid" : "Fragile"))))}`;
                }, unitRatings)),
            }), createElement("div", {
                className: "mt-1.5 text-center text-[11px] leading-relaxed text-zinc-500",
                children: unitSummary,
            })]))), delay(() => {
                let matchValue_51, elems_20, value_277, value_279, outcome_2, elems_19, elems_18;
                return append_1((matchValue_51 = state.PlayoffOutcome, (matchValue_51 == null) ? ((state.PlayoffsEnabled && (finalRank <= 8)) ? singleton_2(createElement("div", createObj(ofArray([["className", "w-full border border-amber-500/70 bg-amber-500/5 p-6 rounded-2xl text-center"], (elems_20 = [createElement("span", {
                    className: "text-amber-400 text-[10px] tracking-widest font-black uppercase block mb-2",
                    children: `A top-eight finish · ${rankOrdinal(finalRank)} seed`,
                }), createElement("div", {
                    className: "text-white text-lg font-black mb-1",
                    children: "The Dance Card Is Out",
                }), createElement("p", createObj(ofArray([["className", "mx-auto mb-4 max-w-sm text-[11px] leading-relaxed text-zinc-400"], (value_277 = "Three best-of-seven rounds between this roster and a ring. The regular season bought the ticket — the postseason is where the banner hangs.", ["children", value_277])]))), createElement("button", createObj(ofArray([(value_279 = "w-full bg-amber-500 hover:bg-amber-400 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl shadow-lg shadow-amber-500/20 transition-all cursor-pointer", ["className", value_279]), ["onClick", (_arg_21) => {
                    Actions_enterPlayoffs(setState);
                }], ["children", "Enter the Playoffs ➔"]])))], ["children", reactApi.Children.toArray(Array.from(elems_20))])])))) : empty_2()) : ((outcome_2 = matchValue_51, singleton_2(createElement("div", createObj(ofArray([["className", "w-full border p-6 rounded-2xl text-center " + (outcome_2.WonRing ? "border-amber-500/60 bg-amber-500/5" : "border-zinc-800 bg-zinc-900/30")], (elems_19 = [createElement("span", {
                    className: "text-amber-400 text-[10px] tracking-widest font-black uppercase block mb-2",
                    children: "The Postseason",
                }), createElement("div", {
                    className: "text-white text-lg font-black mb-2",
                    children: outcome_2.WonRing ? "🏆 Playoff Champions" : (`Out in the ${Actions_roundName(outcome_2.ExitRound)}`),
                }), createElement("div", createObj(ofArray([["className", "text-[11px] font-mono leading-relaxed text-zinc-400"], (elems_18 = toList_1(delay(() => collect_1((matchValue_52) => {
                    const round = matchValue_52[0] | 0;
                    const ow = matchValue_52[3] | 0;
                    const opp = matchValue_52[1];
                    const mw = matchValue_52[2] | 0;
                    return singleton_2(createElement("div", createObj(toList_1(delay(() => append_1(singleton_2(["key", `${round}-${opp}`]), delay(() => {
                        const verb = (mw > ow) ? "beat" : "lost to";
                        return singleton_2(["children", `${Actions_roundName(round)}: ${verb} ${opp} ${mw}-${ow}`]);
                    })))))));
                }, outcome_2.Records))), ["children", reactApi.Children.toArray(Array.from(elems_18))])])))], ["children", reactApi.Children.toArray(Array.from(elems_19))])]))))))), delay(() => {
                    let elems_21;
                    return singleton_2(panel("p-5", ofArray([createElement("div", {
                        className: "text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-1",
                        children: "Season recap",
                    }), createElement("div", {
                        className: "text-base font-black tracking-tight text-white mb-2",
                        children: recapHeadline,
                    }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_21 = toList_1(delay(() => map_1((paragraph) => createElement("p", {
                        key: paragraph,
                        className: "text-[11px] leading-relaxed text-zinc-400",
                        children: paragraph,
                    }), narrativeParagraphs))), ["children", reactApi.Children.toArray(Array.from(elems_21))])])))])));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_22))])]))), (blockTable = ((headCell = ((label_5, extra_2) => createElement("th", {
                key: label_5,
                className: "px-3 py-2 text-[9px] font-black uppercase tracking-widest text-zinc-500 " + extra_2,
                children: label_5,
            })), createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_30 = [panel("overflow-x-auto", singleton(createElement("table", createObj(ofArray([["className", "w-full min-w-[520px] text-left"], (elems_28 = [createElement("thead", createObj(ofArray([["className", "bg-zinc-900/60"], (elems_24 = [createElement("tr", createObj(singleton((elems_23 = [headCell("Player", ""), headCell("PPG", "text-right"), headCell("APG", "text-right"), headCell("STL/BLK", "text-right"), headCell("Club-Season", ""), headCell("OVR", "text-right")], ["children", reactApi.Children.toArray(Array.from(elems_23))]))))], ["children", reactApi.Children.toArray(Array.from(elems_24))])]))), createElement("tbody", createObj(ofArray([["className", "divide-y divide-zinc-900"], (elems_27 = toList_1(delay(() => collect_1((matchValue_53) => {
                let elems_26, elems_25;
                const player_14 = matchValue_53[1];
                const line_4 = matchValue_53[2];
                return singleton_2(createElement("tr", createObj(ofArray([["key", matchValue_53[0]], ["className", "text-xs"], (elems_26 = [createElement("td", createObj(ofArray([["className", "px-3 py-2"], (elems_25 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                    className: "font-semibold text-zinc-100",
                    children: player_14.Name,
                })), delay(() => {
                    let value_330;
                    return contains(player_14.Id, state.TradedInPlayerIds, {
                        Equals: (x_18, y_16) => (x_18 === y_16),
                        GetHashCode: stringHash,
                    }) ? singleton_2(createElement("span", createObj(ofArray([(value_330 = "ml-2 rounded border border-amber-500/50 bg-amber-500/10 px-1.5 py-0.5 text-[9px] font-black text-amber-400", ["className", value_330]), ["children", "🤝 IN"]])))) : empty_2();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_25))])]))), createElement("td", {
                    className: "px-3 py-2 text-right font-mono text-zinc-300",
                    children: toText(interpolate("%.1f%P()", [perGame(line_4.Points, line_4.Games)])),
                }), createElement("td", {
                    className: "px-3 py-2 text-right font-mono text-zinc-300",
                    children: toText(interpolate("%.1f%P()", [perGame(line_4.Assists, line_4.Games)])),
                }), createElement("td", {
                    className: "px-3 py-2 text-right font-mono text-zinc-400",
                    children: toText(interpolate("%.1f%P()", [perGame(line_4.Stocks, line_4.Games)])),
                }), createElement("td", {
                    className: "px-3 py-2 text-[11px] text-zinc-500",
                    children: defaultArg(map_2((pool_2) => pool_2.TeamName, FSharpMap__TryFind(poolById, Engine_franchiseOfPlayer(player_14))), player_14.StatLine),
                }), createElement("td", {
                    className: "px-3 py-2 text-right font-black text-white",
                    children: int32ToString(player_14.Ovr),
                })], ["children", reactApi.Children.toArray(Array.from(elems_26))])]))));
            }, rosterWithLines))), ["children", reactApi.Children.toArray(Array.from(elems_27))])])))], ["children", reactApi.Children.toArray(Array.from(elems_28))])]))))), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-2"], (elems_29 = [metricBox("Wins", int32ToString(w_2), "text-white"), metricBox("Losses", int32ToString(l_2), "text-white"), metricBox("Win Percentage", winPct, "text-orange-500"), metricBox("Points Scored", int32ToString(pointsScored), "text-white"), metricBox("Points Allowed", int32ToString(pointsAllowed), "text-white"), metricBox("PPG Differential", toText(interpolate("%+.1f%P()", [perGame(pointsScored, w_2 + l_2) - perGame(pointsAllowed, w_2 + l_2)])), "text-orange-500")], ["children", reactApi.Children.toArray(Array.from(elems_29))])])))], ["children", reactApi.Children.toArray(Array.from(elems_30))])]))))), (awardCard = ((tag, winner, stat) => {
                let elems_31;
                return createElement("div", createObj(ofArray([["key", tag], ["className", "flex-1 min-w-[150px] rounded-xl border border-zinc-900 bg-zinc-950 p-4"], (elems_31 = toList_1(delay(() => append_1(singleton_2(createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-orange-500",
                    children: tag,
                })), delay(() => {
                    const matchValue_54 = winner;
                    if (matchValue_54 == null) {
                        return singleton_2(createElement("div", {
                            className: "mt-2 text-sm text-zinc-600",
                            children: "—",
                        }));
                    }
                    else {
                        const player_15 = matchValue_54[0];
                        const line_5 = matchValue_54[1];
                        return append_1(singleton_2(createElement("div", {
                            className: "mt-2 text-sm font-bold text-white",
                            children: player_15.Name,
                        })), delay(() => singleton_2(createElement("div", {
                            className: "mt-0.5 font-mono text-[11px] text-zinc-500",
                            children: stat([player_15, line_5]),
                        }))));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_31))])])));
            }), (benchLeader = ((_arg_24 = filter((tupledArg_13) => contains(tupledArg_13[0], benchSlots, {
                Equals: (x_19, y_17) => (x_19 === y_17),
                GetHashCode: stringHash,
            }), rosterWithLines), isEmpty(_arg_24) ? undefined : maxBy((tupledArg_15) => {
                const line_7 = tupledArg_15[1];
                return perGame(line_7.Points, line_7.Games);
            }, map((tupledArg_14) => [tupledArg_14[1], tupledArg_14[2]], _arg_24), {
                Compare: comparePrimitives,
            }))), (biggestWin = ((_arg_27 = filter((g_8) => g_8.Won, seasonGames), isEmpty(_arg_27) ? undefined : maxBy((g_9) => (g_9.TeamScore - g_9.OppScore), _arg_27, {
                Compare: comparePrimitives,
            }))), (highestScoring = (isEmpty(seasonGames) ? undefined : maxBy((g_10) => (g_10.TeamScore + g_10.OppScore), seasonGames, {
                Compare: comparePrimitives,
            })), (recordCard = ((label_6, value_384, sub) => {
                let elems_32;
                return createElement("div", createObj(ofArray([["key", label_6], ["className", "rounded-xl border border-zinc-900 bg-zinc-950 p-4"], (elems_32 = [createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-zinc-500",
                    children: label_6,
                }), createElement("div", {
                    className: "mt-2 font-mono text-sm font-black text-white",
                    children: value_384,
                }), createElement("div", {
                    className: "mt-0.5 text-[11px] text-zinc-500",
                    children: sub,
                })], ["children", reactApi.Children.toArray(Array.from(elems_32))])])));
            }), (extremeCard = ((label_7, game_1) => {
                let elems_33;
                return createElement("div", createObj(ofArray([["key", label_7], ["className", "flex-1 rounded-xl border border-zinc-900 bg-zinc-950 p-4"], (elems_33 = toList_1(delay(() => append_1(singleton_2(createElement("div", {
                    className: "text-[9px] font-black uppercase tracking-widest text-zinc-500",
                    children: label_7,
                })), delay(() => {
                    const matchValue_55 = game_1;
                    if (matchValue_55 == null) {
                        return singleton_2(createElement("div", {
                            className: "mt-2 text-sm text-zinc-600",
                            children: "—",
                        }));
                    }
                    else {
                        const g_11 = matchValue_55;
                        return append_1(singleton_2(createElement("div", {
                            className: "mt-2 font-mono text-sm font-black text-white",
                            children: `${g_11.TeamScore} - ${g_11.OppScore}`,
                        })), delay(() => singleton_2(createElement("div", {
                            className: "mt-0.5 text-[11px] text-zinc-500",
                            children: `vs ${g_11.Opponent}`,
                        }))));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_33))])])));
            }), (blockAwards = createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_37 = [panel("p-5 text-center", ofArray([createElement("div", {
                className: "text-white text-sm font-black",
                children: "Don\'t lose this season",
            }), createElement("p", {
                className: "mx-auto mt-1 mb-4 max-w-sm text-[11px] leading-relaxed text-zinc-500",
                children: "Runs are saved to this browser only. Sign in to keep them across devices.",
            }), createElement("button", createObj(ofArray([(value_433 = "w-full rounded-xl bg-emerald-500 py-3 text-xs font-black uppercase tracking-widest text-black transition-all hover:bg-emerald-600 cursor-pointer", ["className", value_433]), ["onClick", (_arg_28) => {
                Actions_navigateToProfile(setState);
            }], ["children", "Sign in & keep my history"]]))), createElement("div", createObj(ofArray([["className", "mt-2 flex gap-2"], (elems_34 = [createElement("button", createObj(ofArray([(value_440 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-400 transition-all hover:border-zinc-700 cursor-pointer", ["className", value_440]), ["onClick", (_arg_29) => {
                Actions_navigateToProfile(setState);
            }], ["children", "Franchise history"]]))), createElement("a", createObj(ofArray([["href", "https://buymeacoffee.com/bannerseason"], ["target", "_blank"], ["rel", "noopener noreferrer"], (value_450 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-center text-[11px] font-semibold text-zinc-400 no-underline transition-all hover:border-orange-500/40 cursor-pointer", ["className", value_450]), ["children", "☕ Support the project"]])))], ["children", reactApi.Children.toArray(Array.from(elems_34))])])))])), createElement("div", createObj(ofArray([["className", "flex flex-wrap gap-2"], (elems_35 = [awardCard("🏀 League MVP", awardLeader((tupledArg_16) => {
                const line_8 = tupledArg_16[1];
                return perGame(line_8.Points, line_8.Games);
            }), (tupledArg_17) => {
                const line_9 = tupledArg_17[1];
                return toText(interpolate("%.1f%P() PPG", [perGame(line_9.Points, line_9.Games)]));
            }), awardCard("📋 Playmaker", awardLeader((tupledArg_18) => {
                const line_10 = tupledArg_18[1];
                return perGame(line_10.Assists, line_10.Games);
            }), (tupledArg_19) => {
                const line_11 = tupledArg_19[1];
                return toText(interpolate("%.1f%P() APG", [perGame(line_11.Assists, line_11.Games)]));
            }), awardCard("🛡️ Defensive Anchor", awardLeader((tupledArg_20) => {
                const line_12 = tupledArg_20[1];
                return perGame(line_12.Stocks, line_12.Games);
            }), (tupledArg_21) => {
                const line_13 = tupledArg_21[1];
                return toText(interpolate("%.1f%P() STL+BLK", [perGame(line_13.Stocks, line_13.Games)]));
            }), awardCard("🌟 Sixth Man", benchLeader, (tupledArg_22) => {
                const line_14 = tupledArg_22[1];
                return toText(interpolate("%.1f%P() PPG off the bench", [perGame(line_14.Points, line_14.Games)]));
            })], ["children", reactApi.Children.toArray(Array.from(elems_35))])]))), createElement("div", createObj(ofArray([["className", "grid grid-cols-2 gap-2"], (elems_36 = [recordCard("Longest win streak", int32ToString(longestWinStreak), "consecutive wins"), recordCard("Lockdowns", int32ToString(length(filter((g_12) => (g_12.OppScore < 100), seasonGames))), "opponents held under 100"), extremeCard("Biggest win", biggestWin), extremeCard("Highest-scoring game", highestScoring)], ["children", reactApi.Children.toArray(Array.from(elems_36))])])))], ["children", reactApi.Children.toArray(Array.from(elems_37))])]))), (blockStandings = ((matchValue_56 = state.RivalStandings, isEmpty(matchValue_56) ? defaultOf_1() : ((rivals_1 = matchValue_56, (table_4 = sortByDescending((tuple_8) => tuple_8[1], cons(["★ Your Roster", w_2], rivals_1), {
                Compare: comparePrimitives,
            }), (replacedTeam = tryFind_2((team) => forAll((tupledArg_23) => (tupledArg_23[0] !== team), rivals_1), Actions_opponentPool), panel("p-5", ofArray([createElement("div", {
                className: "text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-1",
                children: "Final league standings",
            }), createElement("p", {
                className: "mb-3 text-[10px] leading-relaxed text-zinc-600",
                children: (replacedTeam == null) ? "Simulated rival records." : (`Simulated rival records. Your roster replaced the ${replacedTeam} in the league.`),
            }), createElement("div", createObj(ofArray([["className", "max-h-64 overflow-y-auto rounded-xl border border-zinc-900"], (elems_40 = toList_1(delay(() => collect_1((matchValue_57) => {
                let isUser, elems_39, elems_38;
                const wins_3 = matchValue_57[1][1] | 0;
                const name_225 = matchValue_57[1][0];
                return singleton_2((isUser = (name_225 === "★ Your Roster"), createElement("div", createObj(ofArray([["key", name_225], ["className", "flex items-center justify-between gap-3 border-b border-zinc-900/60 px-3 py-2 text-xs " + (isUser ? "bg-orange-500/10" : "bg-zinc-950")], (elems_39 = [createElement("div", createObj(ofArray([["className", "flex min-w-0 items-center gap-3"], (elems_38 = [createElement("span", {
                    className: "w-6 shrink-0 text-right font-mono text-[10px] font-black text-zinc-600",
                    children: int32ToString(matchValue_57[0] + 1),
                }), createElement("span", {
                    className: "truncate font-semibold " + (isUser ? "text-orange-400" : "text-zinc-300"),
                    children: name_225,
                })], ["children", reactApi.Children.toArray(Array.from(elems_38))])]))), createElement("span", {
                    className: "shrink-0 font-mono font-bold " + (isUser ? "text-orange-400" : "text-zinc-400"),
                    children: `${wins_3}-${82 - wins_3}`,
                })], ["children", reactApi.Children.toArray(Array.from(elems_39))])])))));
            }, indexed(table_4)))), ["children", reactApi.Children.toArray(Array.from(elems_40))])])))])))))))), (blockLeaderboard = (!Backend_isConfigured ? panel("p-5", ofArray([createElement("div", {
                className: "text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-2",
                children: "Add this run to the leaderboard",
            }), createElement("p", {
                className: "mb-3 text-[11px] leading-relaxed text-zinc-500",
                children: "Pick a handle and compare your lineup strength against everyone else.",
            }), createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_41 = [createElement("input", createObj(ofArray([["type", "text"], ["disabled", true], ["placeholder", "Choose a handle"], (value_509 = "flex-1 cursor-not-allowed rounded-xl border border-zinc-800 bg-zinc-950 px-3 py-2.5 text-xs text-zinc-300 opacity-60 placeholder:text-zinc-600", ["className", value_509])]))), createElement("button", {
                key: "Submit",
                disabled: true,
                className: "cursor-not-allowed opacity-60 rounded-xl bg-emerald-500 px-6 text-xs font-black uppercase tracking-widest text-black",
                children: "Submit",
            })], ["children", reactApi.Children.toArray(Array.from(elems_41))])]))), createElement("div", {
                className: "mt-2 text-[10px] text-zinc-600",
                children: "There is no leaderboard service yet, so nothing is submitted.",
            })])) : ((submitting = equals(submitStatus, new Backend_SubmitStatus(1, [])), (archivedRun = tryHead(state.UserRuns), panel("p-5", toList_1(delay(() => append_1(singleton_2(createElement("div", {
                className: "text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-2",
                children: "Add this run to the global leaderboard",
            })), delay(() => {
                let matchValue_58, value_520, elems_43, elems_42, value_542, value_544;
                return append_1((matchValue_58 = submitStatus, (matchValue_58.tag === 2) ? singleton_2(createElement("div", createObj(ofArray([(value_520 = "rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-xs font-bold text-emerald-400", ["className", value_520]), ["children", `Posted as ${matchValue_58.fields[0]} — find it on the Leaderboard page's Global tab.`]])))) : singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_43 = [createElement("p", {
                    className: "mb-1 text-[11px] leading-relaxed text-zinc-500",
                    children: "Post this season under your handle and rank against every player in the world.",
                }), createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_42 = [createElement("input", createObj(ofArray([["type", "text"], ["value", submitHandle], ["onChange", (ev_1) => {
                    patternInput_13[1](ev_1.target.value);
                }], ["placeholder", "Choose a handle"], ["maxLength", 16], (value_542 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-950 px-3 py-2.5 text-xs text-zinc-300 placeholder:text-zinc-600 focus:border-orange-500/50 focus:outline-none", ["className", value_542])]))), createElement("button", createObj(ofArray([(value_544 = "rounded-xl bg-emerald-500 px-6 text-xs font-black uppercase tracking-widest text-black cursor-pointer transition-all hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-50", ["className", value_544]), ["disabled", (submitting ? true : (archivedRun == null)) ? true : !Backend_isValidHandle(submitHandle.trim())], ["onClick", (_arg_38) => {
                    let run;
                    let matchResult_7, run_1;
                    if (archivedRun != null) {
                        if ((run = archivedRun, !submitting)) {
                            matchResult_7 = 0;
                            run_1 = archivedRun;
                        }
                        else {
                            matchResult_7 = 1;
                        }
                    }
                    else {
                        matchResult_7 = 1;
                    }
                    switch (matchResult_7) {
                        case 0: {
                            setSubmitStatus(new Backend_SubmitStatus(1, []));
                            Backend_submitRun(submitHandle.trim(), run_1, setSubmitStatus);
                            break;
                        }
                        case 1: {
                            break;
                        }
                    }
                }], ["children", submitting ? "Posting…" : "Submit"]])))], ["children", reactApi.Children.toArray(Array.from(elems_42))])])))], ["children", reactApi.Children.toArray(Array.from(elems_43))])]))))), delay(() => {
                    const matchValue_59 = submitStatus;
                    return (matchValue_59.tag === 3) ? singleton_2(createElement("div", {
                        className: "mt-2 text-[10px] font-semibold text-red-400",
                        children: matchValue_59.fields[0],
                    })) : singleton_2(createElement("div", {
                        className: "mt-2 text-[10px] text-zinc-600",
                        children: "3–16 letters, numbers or underscores · posted seasons are public",
                    }));
                }));
            }))))))))), (blockActions = createElement("div", createObj(ofArray([["className", "w-full flex gap-3 pt-2"], (elems_44 = toList_1(delay(() => {
                let value_563;
                return append_1(singleton_2(createElement("button", createObj(ofArray([(value_563 = "flex-1 border border-zinc-800 bg-zinc-900/40 text-zinc-300 font-bold text-xs py-3.5 rounded-xl cursor-pointer hover:border-zinc-700 transition-all text-center", ["className", value_563]), ["onClick", (_arg_39) => {
                    navigator.clipboard ? navigator.clipboard.writeText(buildShareSummary(w_2, l_2)) : undefined;
                    setShareCopied(true);
                }], ["children", shareCopied ? "✓ Summary copied" : "📋 Copy run summary"]])))), delay(() => {
                    let value_568;
                    return append_1(singleton_2(createElement("button", createObj(ofArray([(value_568 = "flex-1 bg-zinc-900/40 border border-zinc-800 hover:border-orange-500/40 text-zinc-300 font-bold text-xs py-3.5 rounded-xl transition-all cursor-pointer text-center", ["className", value_568]), ["onClick", (_arg_40) => {
                        ShareCard_download(`${w_2}-${l_2}`, recapHeadline, choose((slot_11) => map_2((p_9) => (`${positionOfSlot(slot_11)}  ${p_9.Name} · ${p_9.Ovr}`), FSharpMap__TryFind(state.Roster, slot_11)), runSlots), `Team OVR ${teamOvr} · ${state.Blueprint.Name} · bannerseason.app`);
                    }], ["children", "📸 Share your season"]])))), delay(() => {
                        let matchValue_60, deals_3, value_573;
                        return append_1((matchValue_60 = state.DeadlineDeals, isEmpty(matchValue_60) ? singleton_2(defaultOf_1()) : ((deals_3 = matchValue_60, singleton_2(createElement("button", createObj(ofArray([(value_573 = "flex-1 bg-zinc-900/40 border border-zinc-800 hover:border-orange-500/40 text-zinc-300 font-bold text-xs py-3.5 rounded-xl transition-all cursor-pointer text-center", ["className", value_573]), ["onClick", (_arg_41) => {
                            const dealLines = collect((tupledArg_24) => {
                                const outgoing_1 = tupledArg_24[1];
                                const incoming_1 = tupledArg_24[2];
                                return ofArray([`OUT  ${outgoing_1.Name} · ${outgoing_1.Ovr}`, `IN   ${incoming_1.Name} · ${incoming_1.Ovr}  (${positionOfSlot(tupledArg_24[0])})`]);
                            }, deals_3);
                            const net_1 = sumBy((tupledArg_25) => (tupledArg_25[2].Ovr - tupledArg_25[1].Ovr), deals_3, {
                                GetZero: () => 0,
                                Add: (x_24, y_22) => (x_24 + y_22),
                            }) | 0;
                            ShareCard_download("DEADLINE DAY", (net_1 >= 0) ? (`Net +${net_1} rating points at the deadline`) : (`Net ${net_1} rating points at the deadline`), dealLines, `${w_2}-${l_2} season · bannerseason.app`);
                        }], ["children", "🤝 Share your deadline"]]))))))), delay(() => {
                            let value_578;
                            return singleton_2(createElement("button", createObj(ofArray([(value_578 = "flex-1 bg-emerald-500 hover:bg-emerald-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer text-center shadow-lg shadow-emerald-500/10", ["className", value_578]), ["onClick", (_arg_43) => {
                                setActiveSlot(undefined);
                                setShareCopied(false);
                                setState((st_5) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_5.Profile, st_5.UserRuns)));
                            }], ["children", "New Run ➔"]]))));
                        }));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_44))])]))), (blockFranchiseRecord = ((matchValue_61 = state.FranchiseLock, (matchValue_61 != null) ? ((franchise = matchValue_61, (patternInput_42 = ((w_2 > franchise.BestWins) ? [`🏅 FRANCHISE RECORD BROKEN — ${w_2} wins beats the real ${franchise.Name}' best of ${franchise.BestWins} (${franchise.BestSeason}). The trophy is yours.`, "border-amber-400/50 bg-amber-500/10 text-amber-300"] : ((w_2 < franchise.WorstWins) ? [`🪦 FRANCHISE WORST EVER — ${w_2} wins sinks below the real ${franchise.Name}' floor of ${franchise.WorstWins} (${franchise.WorstSeason}). You were warned.`, "border-red-500/50 bg-red-500/10 text-red-300"] : [`Inside franchise history: between the ${franchise.WorstWins}-win floor (${franchise.WorstSeason}) and the ${franchise.BestWins}-win record (${franchise.BestSeason}). Beat ${franchise.BestWins} to break it.`, "border-zinc-800 bg-zinc-900/40 text-zinc-400"])), createElement("div", createObj(ofArray([["className", "w-full rounded-2xl border p-4 text-left flex flex-col gap-1"], (elems_45 = [createElement("span", {
                className: "text-orange-400 text-[10px] font-black tracking-widest uppercase",
                children: `One-Franchise Roster · ${franchise.Name}`,
            }), createElement("div", {
                className: `rounded-xl border px-3 py-2.5 text-[11px] font-semibold leading-relaxed ${patternInput_42[1]}`,
                children: patternInput_42[0],
            })], ["children", reactApi.Children.toArray(Array.from(elems_45))])])))))) : defaultOf_1())), (blockSavedLine = createElement("div", {
                className: "text-[10px] font-medium tracking-wide text-zinc-600",
                children: state.Profile.IsSignedIn ? "✓ Saved — trophies and streaks backed up to your account." : "✓ Saved on this device — sign in to back up your trophies and streaks.",
            }), (blockEmailCard = ((!state.Profile.IsSignedIn ? true : (patternInput_10[0] != null)) ? defaultOf_1() : panel("p-5 text-center", ofArray([createElement("div", {
                className: "text-white text-sm font-black",
                children: "Hear about new modes first",
            }), createElement("p", createObj(ofArray([["className", "mx-auto mt-1 mb-4 max-w-sm text-[11px] leading-relaxed text-zinc-500"], (value_605 = "We\'ll email you when something new lands on Banner Season. Not often, and you can stop it whenever you like.", ["children", value_605])]))), createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_46 = [createElement("button", createObj(ofArray([(value_609 = "flex-1 bg-orange-500 hover:bg-orange-400 text-zinc-950 font-black uppercase text-[11px] tracking-widest py-2.5 rounded-xl transition-all cursor-pointer", ["className", value_609]), ["onClick", (_arg_44) => {
                recordEmailChoice(true);
            }], ["children", "Yes, email me"]]))), createElement("button", createObj(ofArray([(value_614 = "flex-1 border border-zinc-800 bg-zinc-900/40 text-zinc-400 font-bold text-[11px] py-2.5 rounded-xl transition-all hover:border-zinc-700 cursor-pointer", ["className", value_614]), ["onClick", (_arg_45) => {
                recordEmailChoice(false);
            }], ["children", "No thanks"]])))], ["children", reactApi.Children.toArray(Array.from(elems_46))])])))]))), createElement("div", createObj(ofArray([["className", "w-full flex flex-col items-center gap-6 overflow-y-auto pb-12 px-2"], (elems_48 = toList_1(delay(() => append_1(isChampion ? singleton_2(createElement(ConfettiBurst, null)) : empty_2(), delay(() => {
                let w_1, l_1, elems_11, value_131, value_147, value_151, value_156, elems_47, winnerWins, winnerName, winnerName_2, winnerWins_2, winnerWins_1, winnerName_1, winnerName_3, winnerWins_3, winnerName_4, winnerWins_4;
                return append_1(isChampion ? singleton_2((w_1 = (w_2 | 0), (l_1 = (l_2 | 0), createElement("div", createObj(ofArray([["className", "w-full border border-orange-950/40 bg-zinc-950 p-8 rounded-2xl text-center select-none shadow-xl"], (elems_11 = [createElement("div", createObj(ofArray([(value_131 = "text-orange-500 text-[11px] tracking-widest font-black uppercase mb-3 flex items-center justify-center gap-1.5 animate-bounce", ["className", value_131]), ["children", "🎉 NBA Champions 🎉"]]))), createElement("span", {
                    className: "text-5xl block my-4 filter drop-shadow-[0_0_15px_rgba(249,115,22,0.4)]",
                    children: "🏆",
                }), createElement("span", {
                    className: "text-white text-4xl font-black font-sans tracking-tight mb-2 uppercase text-center block",
                    children: "Champions",
                }), createElement("span", {
                    className: "text-zinc-400 text-xs font-semibold tracking-wide block mb-6 text-center",
                    children: `Top of the table at ${w_1}-${l_1}. The ring is yours.`,
                }), createElement("div", createObj(ofArray([(value_147 = "mx-auto w-fit bg-emerald-950/20 border border-emerald-900/60 text-emerald-400 text-[10px] font-mono font-bold tracking-wide py-1 px-4 rounded-full flex items-center gap-1.5 mb-8 select-none", ["className", value_147]), ["children", "● ✓ Simulated on this device — no server check"]]))), createElement("button", createObj(ofArray([(value_151 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer font-sans shadow-lg shadow-orange-500/10 mb-3 flex justify-center items-center gap-2", ["className", value_151]), ["onClick", (_arg_7) => {
                    navigator.clipboard ? navigator.clipboard.writeText(buildShareSummary(w_1, l_1)) : undefined;
                    setShareCopied(true);
                }], ["children", shareCopied ? "✓ Copied to clipboard" : "📸 Share the championship ring"]]))), createElement("button", createObj(ofArray([(value_156 = "w-full border border-zinc-900 bg-zinc-950 hover:border-zinc-800 text-zinc-400 hover:text-white text-xs font-semibold py-3 rounded-xl transition-all cursor-pointer flex justify-center items-center", ["className", value_156]), ["onClick", (_arg_8) => {
                    Actions_navigateToProfile(setState);
                }], ["children", "View full season history"]]))), createElement("button", {
                    className: "mt-4 text-[11px] font-semibold text-zinc-600 transition-colors hover:text-zinc-300",
                    onClick: (_arg_9) => {
                        setActiveSlot(undefined);
                        setState((st_4) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_4.Profile, st_4.UserRuns)));
                    },
                    children: "Draft a new team",
                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))))) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-center"], (elems_47 = [createElement("div", {
                    className: "text-2xl font-black text-zinc-100",
                    children: `Final Record: ${w_2}-${l_2}`,
                }), createElement("div", {
                    className: "mt-1 text-xs text-zinc-500",
                    children: (leagueWinner == null) ? "Top of the table takes the ring. Next time." : (((winnerWins = (leagueWinner[1] | 0), (winnerName = leagueWinner[0], finalRank === 2))) ? ((winnerName_2 = leagueWinner[0], (winnerWins_2 = (leagueWinner[1] | 0), `Finished 2nd — the ${winnerName_2} took the crown at ${winnerWins_2}-${82 - winnerWins_2}. So close.`))) : (((winnerWins_1 = (leagueWinner[1] | 0), (winnerName_1 = leagueWinner[0], finalRank <= 8))) ? ((winnerName_3 = leagueWinner[0], (winnerWins_3 = (leagueWinner[1] | 0), `Finished ${rankOrdinal(finalRank)}. A playoff team, not champions — the ${winnerName_3} ran it down at ${winnerWins_3} wins.`))) : ((winnerName_4 = leagueWinner[0], (winnerWins_4 = (leagueWinner[1] | 0), `Finished ${rankOrdinal(finalRank)}. Lottery territory — the ${winnerName_4} lapped the field at ${winnerWins_4} wins.`))))),
                })], ["children", reactApi.Children.toArray(Array.from(elems_47))])])))), delay(() => append_1(singleton_2(blockFranchiseRecord), delay(() => append_1(singleton_2(blockBadges), delay(() => append_1(singleton_2(blockSystem), delay(() => append_1(singleton_2(blockTable), delay(() => append_1(singleton_2(blockAwards), delay(() => append_1(singleton_2(blockStandings), delay(() => append_1(singleton_2(blockLeaderboard), delay(() => append_1(singleton_2(blockEmailCard), delay(() => append_1(singleton_2(blockSavedLine), delay(() => singleton_2(blockActions)))))))))))))))))))));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_48))])])))))))))))))))))))))))))))))))))))));
            break;
        }
        case 18: {
            console$ = defaultOf_1();
            break;
        }
        case 19: {
            console$ = defaultOf_1();
            break;
        }
        case 20: {
            console$ = defaultOf_1();
            break;
        }
        case 21: {
            console$ = defaultOf_1();
            break;
        }
        case 22: {
            console$ = defaultOf_1();
            break;
        }
        case 23: {
            console$ = defaultOf_1();
            break;
        }
        case 24: {
            console$ = defaultOf_1();
            break;
        }
        case 25: {
            console$ = defaultOf_1();
            break;
        }
        case 26: {
            console$ = defaultOf_1();
            break;
        }
        case 27: {
            console$ = defaultOf_1();
            break;
        }
        case 28: {
            console$ = defaultOf_1();
            break;
        }
        case 29: {
            console$ = defaultOf_1();
            break;
        }
        case 30: {
            console$ = defaultOf_1();
            break;
        }
        case 31: {
            console$ = defaultOf_1();
            break;
        }
        case 32: {
            console$ = defaultOf_1();
            break;
        }
        case 33: {
            console$ = defaultOf_1();
            break;
        }
        case 34: {
            console$ = defaultOf_1();
            break;
        }
        case 35: {
            console$ = defaultOf_1();
            break;
        }
        case 36: {
            console$ = defaultOf_1();
            break;
        }
        case 37: {
            console$ = defaultOf_1();
            break;
        }
        default:
            console$ = defaultOf_1();
    }
    const googleMark = createElement("span", createObj(ofArray([(value_1725 = "flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-[11px] font-black text-[#4285F4]", ["className", value_1725]), ["children", "G"]])));
    const appleMark = createElement("svg", createObj(ofArray([["className", "h-5 w-5 shrink-0 text-white"], ["viewBox", (((((0 + " ") + 0) + " ") + 24) + " ") + 24], ["fill", "currentColor"], (elements = ofArray([createElement("path", createObj(singleton((path = "M16.3 12.9c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3-1.6-1.3-.1-2.5.8-3.1.8-.6 0-1.6-.8-2.7-.8-1.4 0-2.7.8-3.4 2.1-1.5 2.5-.4 6.2 1 8.2.7 1 1.5 2.1 2.6 2.1 1 0 1.4-.7 2.7-.7 1.2 0 1.6.7 2.7.7 1.1 0 1.8-1 2.5-2 .8-1.1 1.1-2.2 1.1-2.3-.1 0-2.2-.9-2.2-3.3z", ["d", path])))), createElement("path", {
        d: "M14.4 6.3c.6-.7 1-1.7.9-2.7-.9 0-1.9.6-2.5 1.3-.5.6-1 1.6-.9 2.6 1 .1 2-.5 2.5-1.2z",
    })]), ["children", reactApi.Children.toArray(Array.from(elements))])])));
    const providerButton = (provider, mark) => {
        let value_1739, elems_154;
        return createElement("button", createObj(ofArray([["key", provider], (value_1739 = "flex w-full items-center gap-3 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3 text-left text-sm font-semibold text-zinc-200 transition-colors hover:border-orange-500/40", ["className", value_1739]), ["onClick", (_arg_81) => {
            setAuthError(undefined);
            Backend_signInWithProvider(provider, (arg) => {
                setAuthError(arg);
            });
        }], (elems_154 = [mark, createElement("span", {
            children: `Continue with ${provider}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_154))])])));
    };
    const statTile_1 = (label_16, value_1745) => {
        let elems_155;
        return createElement("div", createObj(ofArray([["key", label_16], ["className", "rounded-2xl border border-zinc-800 bg-zinc-900 px-4 py-3"], (elems_155 = [createElement("div", {
            className: "truncate text-[10px] font-bold uppercase tracking-widest text-zinc-500",
            title: label_16,
            children: label_16,
        }), createElement("div", {
            className: "mt-1 truncate text-2xl font-black leading-none text-orange-500",
            children: value_1745,
        })], ["children", reactApi.Children.toArray(Array.from(elems_155))])])));
    };
    const profileSection = (anchorId, heading_2, subtitle, body_2) => {
        let elems_157, elems_156;
        return createElement("section", createObj(ofArray([["key", heading_2], ["id", anchorId], ["className", "flex flex-col gap-4 rounded-2xl border border-zinc-900 bg-zinc-900/40 p-5 md:p-6"], (elems_157 = [createElement("div", createObj(singleton((elems_156 = [createElement("div", {
            className: "text-xs font-bold tracking-widest text-zinc-500",
            children: heading_2,
        }), createElement("div", {
            className: "mt-1 text-xs text-zinc-600",
            children: subtitle,
        })], ["children", reactApi.Children.toArray(Array.from(elems_156))])))), body_2], ["children", reactApi.Children.toArray(Array.from(elems_157))])])));
    };
    const isAccoladeEarned = (accolade) => contains(accolade.Id, state.Profile.Trophies, {
        Equals: (x_38, y_36) => (x_38 === y_36),
        GetHashCode: stringHash,
    });
    const earnedAccoladeCount = length(filter(isAccoladeEarned, accolades)) | 0;
    const franchiseRings = franchiseRingsWon(state.UserRuns);
    const secretAccoladesRemaining = undiscoveredFranchiseAccolades(state.UserRuns) | 0;
    const trophyRoom = createElement("div", createObj(ofArray([["className", "flex flex-col gap-4"], (elems_166 = toList_1(delay(() => {
        let value_1800, elems_160, value_1814, elems_161;
        return append_1((earnedAccoladeCount === 0) ? singleton_2(createElement("div", createObj(ofArray([(value_1800 = "flex flex-col items-center gap-3 rounded-xl border border-dashed border-zinc-800 px-4 py-8 text-center", ["className", value_1800]), (elems_160 = [createElement("div", {
            className: "text-3xl leading-none",
            children: "🏆",
        }), createElement("div", {
            className: "text-base font-black text-zinc-200",
            children: "Your Trophy Room\'s waiting",
        }), createElement("p", {
            className: "max-w-md text-xs leading-relaxed text-zinc-500",
            children: "Win a championship or go undefeated to start filling it. Every accolade below is yours to chase.",
        }), createElement("button", createObj(ofArray([(value_1814 = "mt-1 rounded-xl bg-orange-500 px-5 py-2.5 text-sm font-bold text-zinc-950 transition-colors hover:bg-orange-400", ["className", value_1814]), ["onClick", (_arg_82) => {
            setActiveSlot(undefined);
            setState((st_23) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_23.Profile, st_23.UserRuns)));
        }], ["children", "Start a new run"]])))], ["children", reactApi.Children.toArray(Array.from(elems_160))])])))) : singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center justify-between rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3"], (elems_161 = [createElement("span", {
            className: "text-xs font-bold text-amber-300",
            children: `👑 ${earnedAccoladeCount} of ${length(accolades)} accolades unlocked`,
        }), createElement("span", {
            className: "text-[11px] text-amber-500/70",
            children: "Keep chasing the rest.",
        })], ["children", reactApi.Children.toArray(Array.from(elems_161))])])))), delay(() => {
            let elems_162;
            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-3 md:grid-cols-2"], (elems_162 = toList_1(delay(() => map_1((a_1) => {
                let elems_159, elems_158;
                const accolade_1 = a_1;
                const earned = isAccoladeEarned(accolade_1);
                return createElement("div", createObj(ofArray([["key", accolade_1.Id], ["className", "bg-zinc-900/60 border border-zinc-800/80 p-4 rounded-xl flex items-start gap-4 hover:border-zinc-700 transition-all" + (earned ? " border-amber-500/40" : " opacity-70")], (elems_159 = [createElement("span", {
                    className: "shrink-0 text-2xl leading-none",
                    children: earned ? "👑" : "🔒",
                }), createElement("div", createObj(ofArray([["className", "flex min-w-0 flex-col gap-1"], (elems_158 = [createElement("div", {
                    className: "text-sm font-bold " + (earned ? "text-amber-300" : "text-zinc-300"),
                    children: accolade_1.Title,
                }), createElement("div", {
                    className: "text-[11px] leading-relaxed text-zinc-500",
                    children: accolade_1.Description,
                })], ["children", reactApi.Children.toArray(Array.from(elems_158))])])))], ["children", reactApi.Children.toArray(Array.from(elems_159))])])));
            }, accolades))), ["children", reactApi.Children.toArray(Array.from(elems_162))])])))), delay(() => {
                let elems_164, elems_163;
                return append_1(!isEmpty_2(franchiseRings) ? singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_164 = [createElement("div", {
                    className: "text-[10px] font-bold uppercase tracking-widest text-zinc-500",
                    children: `Franchise rings (${count_5(franchiseRings)}/${totalFranchises})`,
                }), createElement("div", createObj(ofArray([["className", "flex flex-wrap gap-2"], (elems_163 = toList_1(delay(() => collect_1((pool_17) => {
                    let value_1844;
                    return FSharpSet__Contains(franchiseRings, pool_17.Id) ? singleton_2(createElement("span", createObj(ofArray([["key", pool_17.Id], (value_1844 = "rounded-lg border border-amber-500/40 bg-amber-500/10 px-2.5 py-1 text-[11px] font-bold text-amber-300", ["className", value_1844]), ["children", `👑 ${pool_17.TeamName}`]])))) : empty_2();
                }, historicalRegistry))), ["children", reactApi.Children.toArray(Array.from(elems_163))])])))], ["children", reactApi.Children.toArray(Array.from(elems_164))])])))) : empty_2(), delay(() => {
                    let value_1850, elems_165;
                    return singleton_2(createElement("div", createObj(ofArray([(value_1850 = "text-zinc-500 text-xs font-mono tracking-wide mt-6 flex items-center justify-center gap-1.5 opacity-80", ["className", value_1850]), (elems_165 = toList_1(delay(() => ((secretAccoladesRemaining === 0) ? append_1(singleton_2(createElement("span", {
                        children: "👑",
                    })), delay(() => singleton_2(createElement("span", {
                        className: "text-amber-300",
                        children: `All ${totalFranchises} franchise accolades discovered! You are an NBA Legend.`,
                    })))) : append_1(singleton_2(createElement("span", {
                        children: `+${secretAccoladesRemaining} secret franchise accolades to discover`,
                    })), delay(() => singleton_2(createElement("span", {
                        children: "👑",
                    }))))))), ["children", reactApi.Children.toArray(Array.from(elems_165))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_166))])])));
    const runHistory = isEmpty(state.UserRuns) ? createElement("div", {
        className: "rounded-xl border border-dashed border-zinc-800 px-4 py-8 text-center text-sm text-zinc-600",
        children: "No completed seasons yet. Finish a run to fill this table.",
    }) : createElement("div", createObj(ofArray([["className", "overflow-x-auto rounded-xl border border-zinc-800"], (elems_172 = [createElement("table", createObj(ofArray([["className", "w-full min-w-[520px] text-left"], (elems_171 = [createElement("thead", createObj(ofArray([["className", "bg-zinc-900/70"], (elems_168 = [createElement("tr", createObj(ofArray([["className", "text-[10px] font-bold tracking-widest text-zinc-500"], (elems_167 = [createElement("th", {
        className: "px-4 py-3",
        children: "DATE",
    }), createElement("th", {
        className: "px-4 py-3",
        children: "ROSTER",
    }), createElement("th", {
        className: "px-4 py-3",
        children: "OVR",
    }), createElement("th", {
        className: "px-4 py-3 text-right",
        children: "RECORD",
    })], ["children", reactApi.Children.toArray(Array.from(elems_167))])])))], ["children", reactApi.Children.toArray(Array.from(elems_168))])]))), createElement("tbody", createObj(ofArray([["className", "divide-y divide-zinc-900"], (elems_170 = toList_1(delay(() => collect_1((matchValue_87) => {
        let elems_169;
        const r = matchValue_87[1];
        return singleton_2(createElement("tr", createObj(ofArray([["key", `${r.Date}-${matchValue_87[0]}`], (elems_169 = [createElement("td", {
            className: "px-4 py-3 font-mono text-xs text-zinc-500",
            children: r.Date,
        }), createElement("td", {
            className: "px-4 py-3 text-sm font-semibold text-zinc-300",
            children: r.TeamName,
        }), createElement("td", {
            className: "px-4 py-3 text-sm font-black text-orange-500",
            children: int32ToString(r.Ovr),
        }), createElement("td", {
            className: "px-4 py-3 text-right font-mono text-sm font-bold " + (r.Complete82_0 ? "text-amber-400" : "text-zinc-400"),
            children: r.Complete82_0 ? (`${r.Record} 🏆`) : r.Record,
        })], ["children", reactApi.Children.toArray(Array.from(elems_169))])]))));
    }, indexed(state.UserRuns)))), ["children", reactApi.Children.toArray(Array.from(elems_170))])])))], ["children", reactApi.Children.toArray(Array.from(elems_171))])])))], ["children", reactApi.Children.toArray(Array.from(elems_172))])])));
    const identityBanner = createElement("div", createObj(ofArray([(value_1918 = "flex flex-col gap-4 rounded-2xl border border-zinc-900 bg-zinc-900/40 p-5 md:flex-row md:items-center md:justify-between md:p-6", ["className", value_1918]), (elems_179 = [createElement("div", createObj(ofArray([["className", "flex min-w-0 items-center gap-4"], (elems_174 = [createElement("span", createObj(ofArray([(value_1922 = "flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-orange-500 text-xl font-black text-zinc-950", ["className", value_1922]), ["children", defaultArg(map_2((e_1) => substring(e_1, 0, 1).toLocaleUpperCase(), state.Profile.Email), "?")]]))), createElement("div", createObj(ofArray([["className", "min-w-0"], (elems_173 = [createElement("div", {
        className: "truncate text-xl font-black text-zinc-100",
        children: defaultArg(state.Profile.Email, "Not signed in"),
    }), createElement("div", {
        className: "truncate text-[11px] text-zinc-600",
        children: defaultArg(state.Profile.UserId, "Playing locally — progress is saved to this browser only."),
    })], ["children", reactApi.Children.toArray(Array.from(elems_173))])])))], ["children", reactApi.Children.toArray(Array.from(elems_174))])]))), createElement("div", createObj(ofArray([["className", "flex shrink-0 items-center gap-3"], (elems_178 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-3 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-2.5"], (elems_176 = [createElement("span", {
        className: "text-lg leading-none",
        children: "🔥",
    }), createElement("div", createObj(singleton((elems_175 = [createElement("div", {
        className: "text-[10px] font-bold tracking-widest text-zinc-500",
        children: "ACTIVE STREAK",
    }), createElement("div", {
        className: "text-lg font-black leading-none text-orange-500",
        children: int32ToString(state.Profile.CurrentStreak),
    })], ["children", reactApi.Children.toArray(Array.from(elems_175))]))))], ["children", reactApi.Children.toArray(Array.from(elems_176))])]))), createElement("div", createObj(ofArray([["className", "rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-2.5"], (elems_177 = [createElement("div", {
        className: "text-[10px] font-bold tracking-widest text-zinc-500",
        children: "BEST STREAK",
    }), createElement("div", {
        className: "text-lg font-black leading-none text-orange-500",
        children: int32ToString(state.Profile.HighestStreak),
    })], ["children", reactApi.Children.toArray(Array.from(elems_177))])])))], ["children", reactApi.Children.toArray(Array.from(elems_178))])])))], ["children", reactApi.Children.toArray(Array.from(elems_179))])])));
    let authSection;
    const cardHeading = (title_6, subtitle_1) => {
        let elems_180;
        return createElement("div", createObj(singleton((elems_180 = [createElement("h2", {
            className: "text-lg font-black text-zinc-100",
            children: title_6,
        }), createElement("p", {
            className: "mt-1 max-w-2xl text-xs leading-relaxed text-zinc-500",
            children: subtitle_1,
        })], ["children", reactApi.Children.toArray(Array.from(elems_180))]))));
    };
    authSection = (state.Profile.IsSignedIn ? createElement("div", createObj(ofArray([["className", "flex flex-col gap-4 rounded-2xl border border-zinc-900 bg-zinc-900/40 p-5 md:p-6"], (elems_182 = [cardHeading("Your franchise history is backed up", "Streaks, trophies and run history are local progress and deliberately survive a sign-out — only the identity is cleared."), createElement("div", createObj(ofArray([["className", "flex"], (elems_181 = [createElement("button", createObj(ofArray([(value_1984 = "rounded-xl border border-zinc-800 bg-zinc-900 px-5 py-2.5 text-xs font-bold tracking-wider text-zinc-400 transition-colors hover:border-red-500/40 hover:text-red-400", ["className", value_1984]), ["onClick", (_arg_83) => {
        Backend_signOutAuth(() => {
            setState((st_24) => (new GameState(st_24.Phase, st_24.Roster, st_24.SystemArchetype, st_24.Config, st_24.RerollsAvailable, st_24.DrawnFranchiseIds, st_24.FranchiseLock, st_24.Blueprint, st_24.DailyRun, st_24.IsKnowledgeMode, st_24.DraftModeSetting, st_24.StartEraIndex, st_24.EndEraIndex, st_24.HeadCoachesEnabled, st_24.SelectedCoach, st_24.IsTradeResolved, st_24.TradeOutcome, st_24.IsInstantSkipActive, st_24.PlayerSeason, st_24.TradedInPlayerIds, st_24.DeadlineDeals, st_24.ProjectedWins, st_24.RivalStandings, st_24.PlayoffRecords, st_24.PlayoffOutcome, st_24.PlayoffsEnabled, st_24.TradeDeadlineEnabled, st_24.SeasonLuck, st_24.Wins, st_24.Losses, st_24.GameLog, Store_signOut(st_24.Profile), st_24.UserRuns)));
        });
    }], ["children", "Sign Out"]])))], ["children", reactApi.Children.toArray(Array.from(elems_181))])])))], ["children", reactApi.Children.toArray(Array.from(elems_182))])]))) : createElement("div", createObj(ofArray([["className", "flex flex-col gap-4 rounded-2xl border border-zinc-900 bg-zinc-900/40 p-5 md:p-6"], (elems_185 = toList_1(delay(() => append_1(singleton_2(cardHeading("Save your franchise history", "You can keep playing without an account; your history is saved on this device. Sign in to back it up and sync it across devices.")), delay(() => {
        let elems_183;
        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-3 sm:grid-cols-2"], (elems_183 = [providerButton("Google", googleMark), providerButton("Apple", appleMark)], ["children", reactApi.Children.toArray(Array.from(elems_183))])])))), delay(() => {
            let matchValue_88;
            return append_1((matchValue_88 = patternInput_38[0], (matchValue_88 != null) ? singleton_2(createElement("div", {
                className: "rounded-xl border border-red-500/40 bg-red-500/10 px-4 py-2.5 text-xs leading-relaxed text-red-400",
                children: matchValue_88,
            })) : singleton_2(defaultOf_1())), delay(() => {
                let elems_184;
                return singleton_2(createElement("label", createObj(ofArray([["className", "flex cursor-pointer items-start gap-3 text-xs leading-relaxed text-zinc-500"], (elems_184 = [createElement("input", {
                    type: "checkbox",
                    className: "mt-0.5 h-4 w-4 shrink-0 accent-orange-500",
                    checked: patternInput_9[0],
                    onChange: (ev_6) => {
                        recordEmailChoice(ev_6.target.checked);
                    },
                }), createElement("span", {
                    children: "Email me occasional Banner Season updates and news. Unsubscribe anytime.",
                })], ["children", reactApi.Children.toArray(Array.from(elems_184))])]))));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_185))])]))));
    const navLinkPanel = (icon, label_17, blurb_1, onOpen) => {
        let value_2015, elems_186;
        return createElement("button", createObj(ofArray([["key", label_17], (value_2015 = "flex flex-col gap-1 rounded-2xl border border-zinc-900 bg-zinc-900/40 p-4 text-left transition-colors hover:border-orange-500/40 cursor-pointer md:p-5", ["className", value_2015]), ["onClick", (_arg_84) => {
            onOpen();
        }], (elems_186 = [createElement("div", {
            className: "text-sm font-bold text-zinc-100",
            children: `${icon} ${label_17}`,
        }), createElement("div", {
            className: "text-[11px] leading-relaxed text-zinc-500",
            children: blurb_1,
        })], ["children", reactApi.Children.toArray(Array.from(elems_186))])])));
    };
    const navLinks = createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-3 md:grid-cols-3"], (elems_187 = [navLinkPanel("📋", "Your Roster & Depth Chart", "The starting five and bench you drafted off the wheel.", () => {
        document.getElementById("run-history")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }), navLinkPanel("🏀", "Your Associations & Custom Leagues", "Franchise modes and custom league rules you\'ve saved.", () => {
        Actions_navigateToLeaguesSetup(setState);
    }), navLinkPanel("📊", "Your Season Archive", "Box scores and standings from every season you\'ve simulated.", () => {
        document.getElementById("run-history")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })], ["children", reactApi.Children.toArray(Array.from(elems_187))])])));
    let profilePage;
    const seasons = length(state.UserRuns) | 0;
    let bestRecord;
    const matchValue_89 = state.UserRuns;
    bestRecord = (isEmpty(matchValue_89) ? "—" : maxBy((r_1) => r_1.Wins, matchValue_89, {
        Compare: comparePrimitives,
    }).Record);
    let closestToPerfect;
    const matchValue_90 = state.UserRuns;
    closestToPerfect = (isEmpty(matchValue_90) ? "—" : minBy((r_2) => r_2.Losses, matchValue_90, {
        Compare: comparePrimitives,
    }).Record);
    let winPercentage;
    const totalWins = sumBy((r_3) => r_3.Wins, state.UserRuns, {
        GetZero: () => 0,
        Add: (x_41, y_39) => (x_41 + y_39),
    }) | 0;
    const totalGames = sumBy((r_4) => (r_4.Wins + r_4.Losses), state.UserRuns, {
        GetZero: () => 0,
        Add: (x_42, y_40) => (x_42 + y_40),
    }) | 0;
    winPercentage = ((totalGames === 0) ? "—" : toText(interpolate("%.1f%P()%%", [(100 * totalWins) / totalGames])));
    let highestPpg;
    const best_1 = fold((acc, r_5) => max(acc, r_5.PointsPerGame), 0, state.UserRuns);
    highestPpg = ((best_1 <= 0) ? "—" : toText(interpolate("%.1f%P() PPG", [best_1])));
    let topRatedLineup;
    const matchValue_91 = state.UserRuns;
    topRatedLineup = (isEmpty(matchValue_91) ? "—" : (`${maxBy((r_6) => r_6.Ovr, matchValue_91, {
        Compare: comparePrimitives,
    }).Ovr} OVR`));
    profilePage = createElement("div", createObj(ofArray([["className", "flex flex-col gap-6"], (elems_191 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-4"], (elems_189 = [createElement("button", createObj(ofArray([(value_2034 = "rounded-xl border border-zinc-800 bg-zinc-900 px-4 py-2 text-sm font-bold text-zinc-400 transition-colors hover:border-orange-500/40 hover:text-orange-400", ["className", value_2034]), ["onClick", (_arg_85) => {
        setState((st_25) => (new GameState(new ConsolePhase(0, []), st_25.Roster, st_25.SystemArchetype, st_25.Config, st_25.RerollsAvailable, st_25.DrawnFranchiseIds, st_25.FranchiseLock, st_25.Blueprint, st_25.DailyRun, st_25.IsKnowledgeMode, st_25.DraftModeSetting, st_25.StartEraIndex, st_25.EndEraIndex, st_25.HeadCoachesEnabled, st_25.SelectedCoach, st_25.IsTradeResolved, st_25.TradeOutcome, st_25.IsInstantSkipActive, st_25.PlayerSeason, st_25.TradedInPlayerIds, st_25.DeadlineDeals, st_25.ProjectedWins, st_25.RivalStandings, st_25.PlayoffRecords, st_25.PlayoffOutcome, st_25.PlayoffsEnabled, st_25.TradeDeadlineEnabled, st_25.SeasonLuck, st_25.Wins, st_25.Losses, st_25.GameLog, st_25.Profile, st_25.UserRuns)));
    }], ["children", "← Back to Simulator"]]))), createElement("div", createObj(ofArray([["className", "text-xl font-black tracking-tight"], (elems_188 = [createElement("span", {
        className: "text-orange-500",
        children: "BANNER",
    }), createElement("span", {
        children: " SEASON",
    }), createElement("span", {
        className: "ml-2 text-sm font-medium text-zinc-500",
        children: "Profile",
    })], ["children", reactApi.Children.toArray(Array.from(elems_188))])])))], ["children", reactApi.Children.toArray(Array.from(elems_189))])]))), identityBanner, navLinks, createElement("div", createObj(ofArray([["className", "grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6"], (elems_190 = [statTile_1("Seasons Simulated", int32ToString(seasons)), statTile_1("Best Record", bestRecord), statTile_1("Closest to 82-0", closestToPerfect), statTile_1("Win Percentage", winPercentage), statTile_1("Highest PPG", highestPpg), statTile_1("Top-Rated Lineup", topRatedLineup)], ["children", reactApi.Children.toArray(Array.from(elems_190))])]))), profileSection("trophy-room", "TROPHY ROOM", `${earnedAccoladeCount} of ${length(accolades)} accolades unlocked.`, trophyRoom), profileSection("run-history", `RUN HISTORY (${seasons})`, "Every archived season, newest first.", runHistory), authSection], ["children", reactApi.Children.toArray(Array.from(elems_191))])])));
    let headerBar;
    const profileAction = (state.Phase.tag === 20) ? createElement("button", createObj(ofArray([["disabled", true], (value_2059 = "flex cursor-not-allowed items-center gap-1.5 rounded-xl border border-zinc-900 bg-zinc-900/40 px-4 py-1.5 text-xs font-semibold text-zinc-600 transition-all", ["className", value_2059]), ["children", "🔒 Simulating Season..."]]))) : createElement("button", createObj(ofArray([(value_2064 = "flex cursor-pointer items-center gap-1.5 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-1.5 text-xs font-semibold text-zinc-300 transition-all hover:border-orange-500/40 hover:text-white", ["className", value_2064]), ["onClick", (_arg_86) => {
        Actions_navigateToProfile(setState);
    }], ["children", state.Profile.IsSignedIn ? defaultArg(map_2((email_1) => ("🏀 " + item_1(0, split(email_1, ["@"], undefined, 0))), state.Profile.Email), "🏀 User Profile") : "👤 Sign In"]])));
    headerBar = createElement("header", createObj(ofArray([(value_2069 = "sticky top-0 z-50 flex w-full items-center justify-between border-b border-zinc-900 bg-zinc-950/80 px-6 py-3 backdrop-blur-md", ["className", value_2069]), (elems_193 = [createElement("div", {
        className: "flex-1",
    }), createElement("button", createObj(ofArray([(value_2073 = "flex cursor-pointer items-center gap-1.5 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-1.5 text-xs font-semibold text-zinc-300 transition-all hover:border-zinc-700 hover:text-white", ["className", value_2073]), ["onClick", (_arg_87) => {
        Actions_navigateToHome(setState);
    }], ["children", "🏠 Home"]]))), createElement("div", {
        className: "flex flex-1 justify-end",
        children: reactApi.Children.toArray([profileAction]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_193))])])));
    const starterCourtPositions = zip(blueprintSlotIds(state.Blueprint), ofArray(["top-[12%] left-1/2 -translate-x-1/2", "top-[32%] left-[12%]", "top-[32%] right-[12%]", "top-[55%] left-1/2 -translate-x-1/2", "bottom-[18%] left-1/2 -translate-x-1/2"]));
    const slotIsTarget = (slot_27) => {
        let fromSlot, isDailyStar, matchValue_32, player_3, player_4, others_1;
        if (movingFrom == null) {
            if (pendingPlayer == null) {
                return false;
            }
            else {
                const player_23 = pendingPlayer;
                if (!FSharpMap__ContainsKey(state.Roster, slot_27)) {
                    return contains(slot_27, eligibleSlotsFor(runSlots, player_23, state.Roster), {
                        Equals: (x_45, y_43) => (x_45 === y_43),
                        GetHashCode: stringHash,
                    });
                }
                else {
                    return false;
                }
            }
        }
        else {
            return contains(slot_27, (fromSlot = movingFrom, (isDailyStar = ((player_1) => {
                const matchValue_31 = state.DailyRun;
                if (matchValue_31 == null) {
                    return false;
                }
                else {
                    return matchValue_31.Star.Id === player_1.Id;
                }
            }), (matchValue_32 = FSharpMap__TryFind(state.Roster, fromSlot), (matchValue_32 == null) ? empty_1() : (isDailyStar(matchValue_32) ? ((player_3 = matchValue_32, empty_1())) : ((player_4 = matchValue_32, (others_1 = FSharpMap__Remove(state.Roster, fromSlot), append(filter((slot_3) => (slot_3 !== fromSlot), eligibleSlotsFor(runSlots, player_4, others_1)), map((tuple_2) => tuple_2[0], filter((tupledArg_2) => {
                const slot_4 = tupledArg_2[0];
                const occupant = tupledArg_2[1];
                const cleared = FSharpMap__Remove(others_1, slot_4);
                if (!isDailyStar(occupant) && contains(slot_4, eligibleSlotsFor(runSlots, player_4, cleared), {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: stringHash,
                })) {
                    return contains(fromSlot, eligibleSlotsFor(runSlots, occupant, cleared), {
                        Equals: (x_3, y_3) => (x_3 === y_3),
                        GetHashCode: stringHash,
                    });
                }
                else {
                    return false;
                }
            }, toList(others_1))))))))))), {
                Equals: (x_44, y_42) => (x_44 === y_42),
                GetHashCode: stringHash,
            });
        }
    };
    const anythingInHand = (movingFrom != null) ? true : (pendingPlayer != null);
    const handleSlotClick = (slot_28) => {
        let player_24, source_10;
        if (movingFrom == null) {
            if (pendingPlayer == null) {
                if (moveMode && FSharpMap__ContainsKey(state.Roster, slot_28)) {
                    setMovingFrom(slot_28);
                }
                else if (isDrafting && !squadFirst) {
                    setActiveSlot(slot_28);
                }
            }
            else if ((player_24 = pendingPlayer, slotIsTarget(slot_28))) {
                const player_25 = pendingPlayer;
                placePending(player_25, slot_28);
            }
        }
        else if ((source_10 = movingFrom, slotIsTarget(slot_28))) {
            const source_11 = movingFrom;
            const fromSlot_1 = source_11;
            const toSlot = slot_28;
            setMovingFrom(undefined);
            setMoveMode(false);
            setState((st_3) => {
                const matchValue_33 = FSharpMap__TryFind(st_3.Roster, fromSlot_1);
                if (matchValue_33 == null) {
                    return st_3;
                }
                else {
                    const mover = matchValue_33;
                    const matchValue_34 = FSharpMap__TryFind(st_3.Roster, toSlot);
                    if (matchValue_34 == null) {
                        return new GameState(st_3.Phase, FSharpMap__Add(FSharpMap__Remove(st_3.Roster, fromSlot_1), toSlot, mover), st_3.SystemArchetype, st_3.Config, st_3.RerollsAvailable, st_3.DrawnFranchiseIds, st_3.FranchiseLock, st_3.Blueprint, st_3.DailyRun, st_3.IsKnowledgeMode, st_3.DraftModeSetting, st_3.StartEraIndex, st_3.EndEraIndex, st_3.HeadCoachesEnabled, st_3.SelectedCoach, st_3.IsTradeResolved, st_3.TradeOutcome, st_3.IsInstantSkipActive, st_3.PlayerSeason, st_3.TradedInPlayerIds, st_3.DeadlineDeals, st_3.ProjectedWins, st_3.RivalStandings, st_3.PlayoffRecords, st_3.PlayoffOutcome, st_3.PlayoffsEnabled, st_3.TradeDeadlineEnabled, st_3.SeasonLuck, st_3.Wins, st_3.Losses, st_3.GameLog, st_3.Profile, st_3.UserRuns);
                    }
                    else {
                        const occupant_1 = matchValue_34;
                        return new GameState(st_3.Phase, FSharpMap__Add(FSharpMap__Add(st_3.Roster, toSlot, mover), fromSlot_1, occupant_1), st_3.SystemArchetype, st_3.Config, st_3.RerollsAvailable, st_3.DrawnFranchiseIds, st_3.FranchiseLock, st_3.Blueprint, st_3.DailyRun, st_3.IsKnowledgeMode, st_3.DraftModeSetting, st_3.StartEraIndex, st_3.EndEraIndex, st_3.HeadCoachesEnabled, st_3.SelectedCoach, st_3.IsTradeResolved, st_3.TradeOutcome, st_3.IsInstantSkipActive, st_3.PlayerSeason, st_3.TradedInPlayerIds, st_3.DeadlineDeals, st_3.ProjectedWins, st_3.RivalStandings, st_3.PlayoffRecords, st_3.PlayoffOutcome, st_3.PlayoffsEnabled, st_3.TradeDeadlineEnabled, st_3.SeasonLuck, st_3.Wins, st_3.Losses, st_3.GameLog, st_3.Profile, st_3.UserRuns);
                    }
                }
            });
        }
    };
    const courtCard = createElement("div", createObj(ofArray([(value_2125 = "w-full aspect-[4/5] bg-zinc-950/90 border border-zinc-900 rounded-2xl p-6 relative flex flex-col justify-between overflow-hidden shadow-inner mb-4 select-none", ["className", value_2125]), (elems_197 = toList_1(delay(() => {
        let value_2127, elems_196, value_2129;
        return append_1(singleton_2(createElement("div", createObj(ofArray([(value_2127 = "absolute inset-4 border border-zinc-900/60 rounded-xl bg-gradient-to-b from-zinc-950 via-zinc-900/10 to-zinc-950 pointer-events-none", ["className", value_2127]), (elems_196 = [createElement("div", createObj(singleton((value_2129 = "absolute left-1/2 top-0 h-20 w-20 -translate-x-1/2 -translate-y-1/2 rounded-full border border-zinc-900/40", ["className", value_2129])))), createElement("div", {
            className: "w-1/3 h-1/3 border border-zinc-900/40 absolute bottom-0 left-1/3 border-b-0",
        })], ["children", reactApi.Children.toArray(Array.from(elems_196))])])))), delay(() => collect_1((matchValue_94) => {
            let slot_29, positionClasses, occupant_3, isTarget, isSource, blocked, stateClasses, player_26, elems_194;
            return singleton_2((slot_29 = matchValue_94[0], (positionClasses = matchValue_94[1], (occupant_3 = FSharpMap__TryFind(state.Roster, slot_29), (isTarget = slotIsTarget(slot_29), (isSource = equals(movingFrom, slot_29), (blocked = ((anythingInHand && !isTarget) && !isSource), (stateClasses = (blocked ? " opacity-30 cursor-not-allowed" : (isTarget ? " border-orange-500 scale-110" : (isSource ? " ring-2 ring-white" : ""))), (occupant_3 != null) ? ((player_26 = occupant_3, createElement("button", createObj(ofArray([["key", slot_29], ["disabled", blocked], ["className", ("absolute flex flex-col items-center transition-all cursor-pointer " + positionClasses) + stateClasses], ["onClick", (ev_8) => {
                ev_8.stopPropagation();
                handleSlotClick(slot_29);
            }], (elems_194 = [createElement("span", {
                className: "w-14 h-14 rounded-full flex items-center justify-center text-sm font-black shadow-lg shadow-black/60 " + positionBadgeClasses(player_26.Pos),
                children: hideRatings ? "??" : int32ToString(player_26.Ovr),
            }), createElement("span", {
                className: "text-[10px] font-bold text-white text-center mt-1 block tracking-tight",
                children: last(split(player_26.Name, [" "], undefined, 0)),
            })], ["children", reactApi.Children.toArray(Array.from(elems_194))])]))))) : createElement("button", {
                key: slot_29,
                disabled: blocked,
                className: ("w-14 h-14 absolute rounded-full border border-dashed border-zinc-800 bg-zinc-950/80 hover:border-orange-500/30 transition-colors text-[10px] tracking-wider text-zinc-600 font-mono font-black flex flex-col items-center justify-center cursor-pointer shadow-lg shadow-black/60 " + positionClasses) + stateClasses,
                onClick: (ev_7) => {
                    ev_7.stopPropagation();
                    handleSlotClick(slot_29);
                },
                children: positionOfSlot(slot_29),
            })))))))));
        }, starterCourtPositions)));
    })), ["children", reactApi.Children.toArray(Array.from(elems_197))])])));
    const benchRow = createElement("div", createObj(ofArray([["className", "w-full grid grid-cols-3 gap-2 px-1"], (elems_198 = toList_1(delay(() => map_1((slot_32) => {
        let elems_195;
        const slot_30 = slot_32;
        const occupant_4 = FSharpMap__TryFind(state.Roster, slot_30);
        const isTarget_1 = slotIsTarget(slot_30);
        const isSource_1 = equals(movingFrom, slot_30);
        const blocked_1 = (anythingInHand && !isTarget_1) && !isSource_1;
        return createElement("button", createObj(ofArray([["key", slot_30], ["disabled", blocked_1], ["className", "h-12 bg-zinc-950/40 border border-dashed rounded-xl flex items-center justify-center gap-1.5 text-[10px] font-mono font-black tracking-wider select-none transition-all " + (blocked_1 ? "border-zinc-900/80 text-zinc-700 opacity-40 cursor-not-allowed" : (isTarget_1 ? "border-orange-500 text-orange-400 cursor-pointer" : (isSource_1 ? "border-white text-white cursor-pointer" : ((occupant_4 != null) ? "border-zinc-800 text-zinc-300 cursor-pointer" : "border-zinc-900/80 text-zinc-600 hover:border-orange-500/20 cursor-pointer"))))], ["onClick", (ev_9) => {
            ev_9.stopPropagation();
            handleSlotClick(slot_30);
        }], (elems_195 = toList_1(delay(() => {
            if (occupant_4 == null) {
                return singleton_2(createElement("span", {
                    children: slot_30,
                }));
            }
            else {
                const player_27 = occupant_4;
                return append_1(singleton_2(createElement("span", {
                    className: "truncate",
                    children: last(split(player_27.Name, [" "], undefined, 0)),
                })), delay(() => singleton_2(createElement("span", {
                    className: "shrink-0 text-zinc-500",
                    children: hideRatings ? "??" : int32ToString(player_27.Ovr),
                }))));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_195))])])));
    }, benchSlots))), ["children", reactApi.Children.toArray(Array.from(elems_198))])])));
    let moveButton;
    const rosterEmpty = isEmpty_1(state.Roster);
    moveButton = createElement("div", createObj(singleton((elems_199 = toList_1(delay(() => append_1(singleton_2(createElement("button", {
        disabled: rosterEmpty ? true : (pendingPlayer != null),
        className: "w-full bg-zinc-900/40 border text-zinc-300 font-bold text-xs py-3 rounded-xl transition-all flex justify-center items-center gap-2 mt-4 " + ((rosterEmpty ? true : (pendingPlayer != null)) ? "border-zinc-900 opacity-40 cursor-not-allowed" : (moveMode ? "border-orange-500 text-orange-400 cursor-pointer" : "border-zinc-800 hover:border-orange-500/40 cursor-pointer")),
        onClick: (_arg_88) => {
            if (moveMode) {
                setMovingFrom(undefined);
                setMoveMode(false);
            }
            else {
                setMoveMode(true);
            }
        },
        children: moveMode ? "✕ Cancel move" : "🔄 Move a player",
    })), delay(() => (moveMode ? singleton_2(createElement("div", {
        className: "mt-2 text-[11px] leading-relaxed text-zinc-500",
        children: (movingFrom == null) ? "Pick a player on the court or bench to move." : (`Moving from ${movingFrom}. Pick a highlighted destination.`),
    })) : empty_2()))))), ["children", reactApi.Children.toArray(Array.from(elems_199))]))));
    const legendRow = createElement("div", createObj(ofArray([(value_2150 = "flex justify-center items-center gap-x-4 gap-y-1 flex-wrap text-[10px] font-medium text-zinc-500 tracking-wide mt-3 select-none w-full", ["className", value_2150]), (elems_201 = toList_1(delay(() => collect_1((matchValue_95) => {
        let elems_200;
        const label_19 = matchValue_95[1];
        return singleton_2(createElement("span", createObj(ofArray([["key", label_19], ["className", "flex items-center gap-1.5"], (elems_200 = [createElement("span", {
            className: "h-2 w-2 rounded-full " + matchValue_95[0],
        }), createElement("span", {
            children: label_19,
        })], ["children", reactApi.Children.toArray(Array.from(elems_200))])]))));
    }, [["bg-orange-500", "Guards"], ["bg-blue-500", "Forwards"], ["bg-amber-700", "Big Men"], ["bg-zinc-800", "Can\'t play there"]]))), ["children", reactApi.Children.toArray(Array.from(elems_201))])])));
    let ratingsPanel;
    const patternInput_45 = Engine_calculateSideRatings(state.Roster);
    const unitBar = (positions) => {
        const players_1 = map((tuple_9) => tuple_9[1], filter((tupledArg_27) => {
            if (!contains(tupledArg_27[0], benchSlots, {
                Equals: (x_46, y_44) => (x_46 === y_44),
                GetHashCode: stringHash,
            })) {
                return contains(tupledArg_27[1].Pos, positions, {
                    Equals: (x_47, y_45) => (x_47 === y_45),
                    GetHashCode: stringHash,
                });
            }
            else {
                return false;
            }
        }, toList(state.Roster)));
        if (isEmpty(players_1)) {
            return 0;
        }
        else {
            return ~~round_3(averageBy((p_21) => p_21.Ovr, players_1, {
                GetZero: () => 0,
                Add: (x_49, y_46) => (x_49 + y_46),
                DivideByInt: (x_48, i_10) => (x_48 / i_10),
            })) | 0;
        }
    };
    const backcourt = unitBar(ofArray(["PG", "SG"])) | 0;
    const frontcourt = unitBar(ofArray(["SF", "PF", "C"])) | 0;
    const bar = (icon_1, label_20, score_1) => {
        let elems_204, elems_202, elems_203;
        return createElement("div", createObj(ofArray([["key", label_20], ["className", "mb-3 last:mb-0"], (elems_204 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between text-[11px] font-bold"], (elems_202 = [createElement("span", {
            className: "text-zinc-400",
            children: `${icon_1} ${label_20}`,
        }), createElement("span", {
            className: "font-mono text-orange-400",
            children: hideRatings ? "??" : int32ToString(score_1),
        })], ["children", reactApi.Children.toArray(Array.from(elems_202))])]))), createElement("div", createObj(ofArray([["className", "mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-zinc-800"], (elems_203 = [createElement("div", {
            className: "h-full rounded-full bg-orange-500 transition-all",
            style: {
                width: (hideRatings ? 0 : ~~((score_1 * 100) / 99)) + "%",
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_203))])])))], ["children", reactApi.Children.toArray(Array.from(elems_204))])])));
    };
    ratingsPanel = createElement("div", createObj(ofArray([["className", "w-full bg-zinc-900/40 border border-zinc-900 rounded-2xl p-5 font-sans"], (elems_205 = [createElement("div", {
        className: "text-zinc-500 text-[10px] font-black tracking-widest uppercase",
        children: "Overall",
    }), createElement("div", {
        className: "text-white text-3xl font-black mt-1 mb-4",
        children: hideRatings ? "??" : int32ToString(teamOvr),
    }), bar("⚡", "Offense", patternInput_45[0]), bar("🛡️", "Defense", patternInput_45[1]), bar("🎯", "Backcourt", backcourt), bar("🏔️", "Frontcourt", frontcourt)], ["children", reactApi.Children.toArray(Array.from(elems_205))])])));
    const simulatorGrid = createElement("div", createObj(ofArray([["className", "grid grid-cols-1 gap-6 lg:grid-cols-2"], (elems_213 = [createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_211 = [createElement("div", createObj(ofArray([["className", "flex items-end justify-between mb-3 px-1"], (elems_207 = [createElement("div", createObj(singleton((elems_206 = [createElement("span", {
        className: "text-zinc-600 text-[9px] font-black tracking-widest uppercase block",
        children: "Blueprint",
    }), createElement("span", {
        className: "text-white text-sm font-black tracking-tight",
        children: state.Blueprint.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems_206))])))), createElement("span", {
        className: "text-zinc-600 text-[10px] font-medium",
        children: (state.Phase.tag === 1) ? "Pick a shape in Game Setup" : "Locked · restart to change",
    })], ["children", reactApi.Children.toArray(Array.from(elems_207))])]))), (matchValue_97 = state.DailyRun, (matchValue_97 != null) ? ((daily_4 = matchValue_97, (result_4 = dailyScore(daily_4, state.Roster), (featuredName = defaultArg(map_2(fullFranchiseName, FSharpMap__TryFind(poolById, daily_4.PoolId)), daily_4.PoolId), (tick_1 = ((met, label_21) => {
        let elems_208;
        return createElement("div", createObj(ofArray([["key", label_21], ["className", "flex items-center gap-2"], (elems_208 = [createElement("span", {
            className: met ? "text-emerald-400" : "text-zinc-700",
            children: met ? "🟢" : "○",
        }), createElement("span", {
            className: "text-[11px] font-medium " + (met ? "text-zinc-300" : "text-zinc-500"),
            children: label_21,
        })], ["children", reactApi.Children.toArray(Array.from(elems_208))])])));
    }), createElement("div", createObj(ofArray([["className", "w-full rounded-2xl border border-orange-500/30 bg-orange-950/20 p-4 mb-4 flex flex-col gap-2"], (elems_209 = [createElement("span", {
        className: "text-orange-400 text-[10px] font-black tracking-widest uppercase",
        children: "● Daily Challenge · Required",
    }), createElement("span", {
        className: "text-zinc-300 text-[11px] font-bold",
        children: `⭐ ${daily_4.Star.Name} starts — locked in`,
    }), tick_1(result_4.HasFranchise, `1 other ${featuredName} pick`), tick_1(result_4.HasPosition, `1 other player at ${daily_4.Star.Pos}`), tick_1(result_4.HasDecade, "1 other pick from the same decade"), createElement("span", {
        className: "text-orange-400 text-xs font-black font-mono mt-1",
        children: `Challenge score: ${result_4.Score}/8`,
    })], ["children", reactApi.Children.toArray(Array.from(elems_209))])])))))))) : defaultOf_1()), courtCard, benchRow, moveButton, legendRow, createElement("div", {
        className: "mt-4",
        children: reactApi.Children.toArray([ratingsPanel]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_211))])]))), createElement("div", {
        className: "rounded-2xl border border-zinc-900 bg-zinc-900/40 p-5",
        children: reactApi.Children.toArray([console$]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_213))])])));
    const guideBreadcrumb = (label_22) => {
        let value_2256, elems_214;
        return createElement("div", createObj(ofArray([(value_2256 = "flex items-center gap-1.5 text-zinc-600 text-xs font-medium mb-8 cursor-pointer select-none font-sans", ["className", value_2256]), (elems_214 = [createElement("span", {
            className: "transition-colors hover:text-zinc-300",
            onClick: (_arg_89) => {
                Actions_navigateToHome(setState);
            },
            children: "Home",
        }), createElement("span", {
            children: "/",
        }), createElement("span", {
            className: "text-white",
            children: label_22,
        })], ["children", reactApi.Children.toArray(Array.from(elems_214))])])));
    };
    const guideHeading = (text_2) => createElement("h2", {
        className: "text-white text-lg font-black font-sans tracking-tight mt-8 mb-3 block",
        children: text_2,
    });
    const guideBody = (text_3) => createElement("p", {
        className: "text-zinc-400 text-sm leading-relaxed mb-4 max-w-2xl",
        children: text_3,
    });
    const relatedCard = (label_23, isActive_1, navigate) => {
        let value_2282, value_2297, value_2288;
        if (isActive_1) {
            return createElement("button", createObj(ofArray([["key", label_23], ["disabled", true], (value_2282 = "border border-orange-500 bg-orange-500/5 text-orange-400 px-4 py-2.5 rounded-xl text-xs transition-all font-black font-sans cursor-default flex-1 text-center", ["className", value_2282]), ["children", label_23]])));
        }
        else if (navigate == null) {
            return createElement("button", createObj(ofArray([["key", label_23], ["disabled", true], (value_2297 = "border border-zinc-900 bg-zinc-900/40 text-zinc-400 px-4 py-2.5 rounded-xl text-xs hover:border-zinc-800 transition-all font-semibold font-sans cursor-not-allowed opacity-60 flex-1 text-center", ["className", value_2297]), ["children", label_23]])));
        }
        else {
            const go = navigate;
            return createElement("button", createObj(ofArray([["key", label_23], (value_2288 = "border border-zinc-900 bg-zinc-900/40 text-zinc-400 px-4 py-2.5 rounded-xl text-xs hover:border-zinc-800 hover:text-zinc-200 transition-all font-semibold font-sans cursor-pointer flex-1 text-center", ["className", value_2288]), ["onClick", (_arg_90) => {
                go();
            }], ["children", label_23]])));
        }
    };
    const guidePlayButton = createElement("button", createObj(ofArray([(value_2301 = "w-fit bg-orange-500 hover:bg-orange-600 text-black font-black font-sans text-xs px-6 py-3 rounded-xl cursor-pointer transition-all shadow-md shadow-orange-500/10 mt-6 block mb-12", ["className", value_2301]), ["onClick", (_arg_91) => {
        setActiveSlot(undefined);
        setState((st_26) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_26.Profile, st_26.UserRuns)));
    }], ["children", "Play Banner Season ➔"]])));
    const guideRelatedRow = (cards) => {
        let elems_216;
        return createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_216 = [createElement("hr", {
            className: "border-zinc-900 mb-6",
        }), createElement("div", {
            className: "flex flex-col gap-3 sm:flex-row",
            children: reactApi.Children.toArray(Array.from(cards)),
        })], ["children", reactApi.Children.toArray(Array.from(elems_216))])])));
    };
    const draftGameGuidePage = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_217 = [guideBreadcrumb("Basketball draft game"), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-6",
        children: "Basketball Draft Game",
    }), guideBody("Banner Season is a free basketball draft game with one twist: you do not pick from a pre-set list, you build your roster one franchise pool at a time. Spin the wheel to land on an iconic historical franchise from a single season, take one player out of that squad, and drop them into your rotation. Spin again, draft again, and keep going until all eight roster spots are filled."), guideHeading("How the draft works"), guideBody(`Every spin is a real franchise and season, pulled from ${totalPlayerSeasons} player seasons going back to ${seasonEndYear(0)}. So the squad you walk away with is shaped by where the wheel lands, the positional gaps you still need to fill, and the tactical calls you make with the clock ticking. There is no perfect route, and no two drafts ever play out the same. Part squad builder, part puzzle, part settling the argument your group chat has been having for years.`), guideHeading("From draft to result"), guideBody("Once your 8-man lineup is done you hand it to the season simulator and play out all 82 games to see how far it gets. Win the league, survive a February trade deadline event, or chase the one everyone talks about: a spotless 82 wins from 82. New to it? Have a read of how to play, or see what happens when you treat Banner Season as an all-time lineup builder."), guidePlayButton, guideRelatedRow(ofArray([relatedCard("Basketball draft game", true, () => {
        Actions_navigateToDraftGuide(setState);
    }), relatedCard("All-time lineup builder", false, () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }), relatedCard("Season simulator", false, () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }), relatedCard("Greatest all-time roster", false, () => {
        Actions_navigateToGreatestLineupGuide(setState);
    }), relatedCard("How to play", false, () => {
        Actions_navigateToHowToPlayGuide(setState);
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_217))])])));
    const lineupBuilderGuidePage = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_218 = [guideBreadcrumb("All-time lineup builder"), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-6",
        children: "All-Time Lineup Builder",
    }), guideBody(`Banner Season is an all-time lineup builder that lets you put one team together from the entire history of the NBA. With ${totalPlayerSeasons} historical player seasons covering every campaign from ${seasonEndYear(0)} to today, you can line up a 90s perimeter icon right next to a modern global superstar, or pick an 8-man rotation made entirely from one single era. The eight roster spots are yours.`), guideHeading("Every era on one hardwood court"), guideBody("Because every player is tied to a real historical franchise and season, your team turns into a proper cross-era what-if scenario: a 1996 Chicago Bulls star running the floor alongside last year\'s championship leader, or a cult-hero role specialist sitting on the bench next to an all-time MVP asset. It is the dream-team debate fans have always had in their group chats—only now you can actually draft it and put it to the test."), guideHeading("Then see if it holds up"), guideBody("Picking your rotation is the easy bit. Run it through the season simulator and find out whether your squad can win the league, survive a high-stakes trade deadline twist, or finish on a flawless, historic 82-0. Want a steer on who actually makes the cut? Check out our take on the greatest all-time roster. First time here? Start with how to play, or read up on the basketball draft game format that feeds it."), guidePlayButton, guideRelatedRow(ofArray([relatedCard("All-time lineup builder", true, () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }), relatedCard("Greatest all-time roster", false, () => {
        Actions_navigateToGreatestLineupGuide(setState);
    }), relatedCard("Basketball draft game", false, () => {
        Actions_navigateToDraftGuide(setState);
    }), relatedCard("Season simulator", false, () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }), relatedCard("How to play", false, () => {
        Actions_navigateToHowToPlayGuide(setState);
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_218))])])));
    const seasonSimulatorGuidePage = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_219 = [guideBreadcrumb("Season simulator"), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-6",
        children: "Season Simulator",
    }), guideBody("The Banner Season simulator is where your drafted squad gets put to work. Once your 8-man roster is built, it plays out a full 82-game campaign loop and hands you back the results, your team statistics, and where you finished, all in a few seconds."), guideHeading("What the simulation reflects"), guideBody("Stronger, better-balanced squads win more often, so how you draft really does count. But nothing is handed to you. Like a real NBA season, every game carries its own swing, and a cold night on the road can cost you. That tension is the whole challenge, and the reason a perfect 82 wins from 82 is so hard to pull off."), guideHeading("Chase the perfect record"), guideBody("Aim for the title, a postseason playoff run, or the one everyone wants: a clean 82-0. Want a stronger team to throw at it first? Use Banner Season as an all-time lineup builder, get the basics from how to play, or read more about the basketball draft game format that feeds the simulator."), guidePlayButton, guideRelatedRow(ofArray([relatedCard("Season simulator", true, () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }), relatedCard("Basketball draft game", false, () => {
        Actions_navigateToDraftGuide(setState);
    }), relatedCard("All-time lineup builder", false, () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }), relatedCard("Greatest all-time roster", false, () => {
        Actions_navigateToGreatestLineupGuide(setState);
    }), relatedCard("How to play", false, () => {
        Actions_navigateToHowToPlayGuide(setState);
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_219))])])));
    const nomineeBlock = (slot_34, positionName, tagline, description_2, nominees) => {
        let elems_222, elems_220, elems_221;
        return createElement("div", createObj(ofArray([["key", slot_34], ["className", "w-full bg-zinc-900/10 border border-zinc-900/60 p-6 rounded-2xl mb-6 font-sans"], (elems_222 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-4 mb-3"], (elems_220 = [createElement("span", {
            className: "text-white text-md font-black tracking-tight",
            children: positionName,
        }), createElement("span", {
            className: "text-orange-500 text-[10px] tracking-widest font-black uppercase font-mono",
            children: tagline,
        })], ["children", reactApi.Children.toArray(Array.from(elems_220))])]))), createElement("p", {
            className: "text-zinc-400 text-sm leading-relaxed",
            children: description_2,
        }), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-2 mt-4"], (elems_221 = toList_1(delay(() => map_1((nominee) => {
            let value_2358;
            return createElement("div", createObj(ofArray([["key", nominee], (value_2358 = "border border-orange-500/40 text-orange-400 bg-orange-500/5 font-bold px-3 py-2.5 rounded-xl text-xs font-sans text-center select-none", ["className", value_2358]), ["children", nominee]])));
        }, nominees))), ["children", reactApi.Children.toArray(Array.from(elems_221))])])))], ["children", reactApi.Children.toArray(Array.from(elems_222))])])));
    };
    const greatestLineupGuidePage = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_224 = [guideBreadcrumb("Greatest all-time roster"), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-6",
        children: "Greatest All-Time Roster",
    }), nomineeBlock("PG", "Point Guard (PG)", "Floor generals & dimers", "Every elite squad needs a floor general who dictates the tempo, tracks overlapping defensive rotations, and threads the needle with absolute precision. You want the maestro who elevates everyone around him.", ofArray(["Magic Johnson", "Stephen Curry", "John Stockton"])), nomineeBlock("SG", "Shooting Guard (SG)", "Scoring aces & perimeter locks", "Your primary perimeter threat. They need an unguardable mid-range iso package, an elite catch-and-shoot stroke, and enough point-of-attack defensive clamps to erase the opposition\'s best weapon.", ofArray(["Michael Jordan", "Kobe Bryant", "Dwyane Wade"])), nomineeBlock("SF", "Small Forward (SF)", "Do-it-all wings & two-way stars", "The absolute multi-tool of the modern court. You need a versatile forward who can clear defensive boards, spearhead the fast break, score from deep range, and guard positions 1 through 4.", ofArray(["LeBron James", "Larry Bird", "Kawhi Leonard"])), nomineeBlock("PF", "Power Forward (PF)", "Post power & decorated champions", "The post-anchor who commands the mid-range blocks, hits unguardable face-up fadeaways, sets bruising high-screens, and locks down interior glass positioning.", ofArray(["Tim Duncan", "Dirk Nowitzki", "Kevin Garnett"])), nomineeBlock("C", "Center (C)", "Rim protectors & paint beasts", "The final line of interior defense. They must block shots into the third row, enforce a hard no-fly zone in the paint, vacuum up every rebound, and score efficiently at the rim.", ofArray(["Kareem Abdul-Jabbar", "Shaquille O\'Neal", "Hakeem Olajuwon"])), guideHeading("No, we are not telling you the answer"), guideBody("We could stamp an official \'greatest of all time\' badge on a single roster and be done with it. But you would tell us we are wrong, and you would be right. An all-time list isn\'t a consensus; it\'s a pile of group-chat arguments stacked on top of each other. Does a modern floor-spacing guard walk into the side ahead of a 90s icon who carried defensive rings? That\'s what our simulator tests. Split a franchise, draft your roster, and run the full 82 games to see if it clears the standard. Settle the debate."), createElement("div", createObj(ofArray([(value_2370 = "w-full bg-zinc-900/10 border border-zinc-900/60 p-8 rounded-2xl flex flex-col items-center text-center font-sans mt-6 mb-12", ["className", value_2370]), (elems_223 = [createElement("span", {
        className: "text-white text-lg font-black tracking-tight mb-2",
        children: "Enough talk. Pick it, play it, settle it.",
    }), createElement("p", createObj(ofArray([["className", "text-zinc-400 text-sm leading-relaxed mb-6 max-w-md"], (value_2378 = "Build your all-time roster, simulate all 82 games, and send the final link straight to your group chat.", ["children", value_2378])]))), createElement("button", createObj(ofArray([(value_2380 = "w-fit bg-orange-500 hover:bg-orange-600 text-black font-black font-sans text-xs px-6 py-3 rounded-xl cursor-pointer transition-all shadow-md shadow-orange-500/10", ["className", value_2380]), ["onClick", (_arg_92) => {
        setActiveSlot(undefined);
        setState((st_27) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_27.Profile, st_27.UserRuns)));
    }], ["children", "Play Banner Season ➔"]])))], ["children", reactApi.Children.toArray(Array.from(elems_223))])]))), guideRelatedRow(ofArray([relatedCard("Greatest all-time roster", true, () => {
        Actions_navigateToGreatestLineupGuide(setState);
    }), relatedCard("Basketball draft game", false, () => {
        Actions_navigateToDraftGuide(setState);
    }), relatedCard("All-time lineup builder", false, () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }), relatedCard("Season simulator", false, () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }), relatedCard("How to play", false, () => {
        Actions_navigateToHowToPlayGuide(setState);
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_224))])])));
    const stepCard = (number, title_7, body_3) => {
        let value_2389, elems_226, value_2391, elems_225;
        return createElement("div", createObj(ofArray([["key", title_7], (value_2389 = "w-full bg-zinc-900/10 border border-zinc-900/60 p-5 rounded-2xl mb-3 flex items-start gap-4 font-sans", ["className", value_2389]), (elems_226 = [createElement("div", createObj(ofArray([(value_2391 = "flex h-8 w-8 shrink-0 items-center justify-center rounded-xl border border-orange-500/30 bg-orange-500/10 text-xs font-black text-orange-400", ["className", value_2391]), ["children", int32ToString(number)]]))), createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_225 = [createElement("span", {
            className: "text-white text-sm font-black tracking-tight mb-1.5",
            children: title_7,
        }), createElement("p", {
            className: "text-zinc-400 text-sm leading-relaxed",
            children: body_3,
        })], ["children", reactApi.Children.toArray(Array.from(elems_225))])])))], ["children", reactApi.Children.toArray(Array.from(elems_226))])])));
    };
    const strategyCard = (title_8, body_4) => {
        let elems_227;
        return createElement("div", createObj(ofArray([["key", title_8], ["className", "bg-zinc-900/10 border border-zinc-900/60 p-5 rounded-2xl font-sans"], (elems_227 = [createElement("span", {
            className: "text-orange-400 text-sm font-black tracking-tight mb-2 block",
            children: title_8,
        }), createElement("p", {
            className: "text-zinc-400 text-sm leading-relaxed",
            children: body_4,
        })], ["children", reactApi.Children.toArray(Array.from(elems_227))])])));
    };
    const howToPlayGuidePage = createElement("div", createObj(ofArray([["className", "flex flex-col"], (elems_230 = [guideBreadcrumb("How to play"), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-4",
        children: "How to Play Banner Season",
    }), guideBody("Banner Season is the game we built for the argument you could never finish: who really makes your all-time roster, and could that team go a whole season winning all 82 matches? You draft an iconic historical line up one player at a time, then run a full 82-game campaign loop. It takes about five minutes. Here is how a run goes, from your first spin to chasing the perfect record."), guideHeading("The game in six steps"), stepCard(1, "Spin the wheel", `Each turn, spin the wheel to land on a single historic team pool from basketball history spanning from ${seasonEndYear(0)} to today. The wheel never lands on the same franchise twice in one draft session, and it only ever draws from the era range you set in Game Setup.`), stepCard(2, "Draft a player", "From the team pool you landed on, draw one player into your roster. Every player is a real person from that historical season, with a rating and badges tied to how they performed that year. The same name can appear on more than one squad — LeBron sits in four different pools — so a legend you passed on may well come round again."), stepCard(3, "Choose their position", "Your squad follows a strict position-eligibility checking matrix. Use the inline placement dropdown tray to drop a player into their natural eligible starting position (PG, SG, SF, PF, C) or onto one of your 3 utility bench spots (B1, B2, B3)."), stepCard(4, "Complete your roster", "Keep spinning and drafting until all 8 roster positions are completely filled. The skill is in the balancing acts—take a legendary talent out of position, or track an elite role specialist to maintain proper archetype synergy ratings."), stepCard(5, "Simulate the season", "When your roster is complete, simulate a full 82-game season campaign in real time. The engine plays out every fixture from one team rating — your five starters weighted at 85%, your three bench players at 15% — plus a synergy bonus when your badges back the system you picked, and another when your head coach runs that same system."), stepCard(6, "Chase 82-0", "The goal is a perfect season: 82 wins, 0 losses, 0 draws. Almost nobody manages it, which is exactly why people keep coming back. Reset your statistics, check the profile trophies room, and try a stronger build next time."), guideHeading("How scoring works"), guideBody("The simulation weights the chemistry, depth, and structural balance of your active 8-man rotation across an advanced live processing log ticker. A more rounded squad gives you a real edge. There is luck in it, too, though. Just like the real NBA, a cold night on the road or a quiet shooting quarter can stall the best team, and a bad run can hit any roster. The draft is the part you control. Whether it all clicks across 82 games is where the tension lives."), createElement("div", createObj(ofArray([["className", "grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 mb-8"], (elems_228 = [strategyCard("Balance beats stars", "Your team rating is your five starters averaged at 85% plus your three bench players at 15%, so a weak link in the starting five costs you far more than a weak bench. The offence and defence bars on the court view show which way your badges tilt each side of the ball."), strategyCard("Draft the slot, not the badge", "The biggest error is piling up scoring guards and leaving your paint empty. Starting slots are strictly position-locked — only a genuine centre can fill C — so a run of guards leaves you with nowhere to put them but the three bench spots, and no way to complete the roster."), strategyCard("Know when to gamble", `Sometimes the wheel keeps landing on difficult spoiler/futility teams. Normal difficulty gives you ${rerollsFor(new Difficulty(1, []))} Emergency Reroll token to escape a low-tier trap squad — Easy gives ${rerollsFor(new Difficulty(0, []))}, Hard gives ${rerollsFor(new Difficulty(2, []))} — and once it is spent you must draft whoever you pull.`), strategyCard("Every era is in play", "A 90s perimeter lockdown icon can share the floor with a modern global MVP. You are blending multiple generations of basketball history, so do not let old-school versus new-school biases derail your build.")], ["children", reactApi.Children.toArray(Array.from(elems_228))])]))), guideHeading("Ways to play"), guideBody("The classic solo run is only the start. One-Franchise Roster locks the wheel to a single team\'s history and grades you against its real record book. The Daily Challenge and the Era Challenge rotate fresh constraints, and Multiplayer will settle whose roster is really best — live drafts and async leagues are on the way."), createElement("div", createObj(ofArray([(value_2429 = "w-full bg-zinc-900/10 border border-zinc-900/60 p-8 rounded-2xl flex flex-col items-center text-center font-sans mb-12", ["className", value_2429]), (elems_229 = [createElement("span", {
        className: "text-white text-lg font-black tracking-tight mb-2",
        children: "Ready to build your lineup?",
    }), createElement("p", {
        className: "text-zinc-400 text-sm leading-relaxed mb-6 max-w-md",
        children: "Spin the wheel, draft your rotation, and see if your roster can clear the ultimate 82-0 challenge.",
    }), createElement("button", createObj(ofArray([(value_2439 = "w-fit bg-orange-500 hover:bg-orange-600 text-black font-black font-sans text-xs px-6 py-3 rounded-xl cursor-pointer transition-all shadow-md shadow-orange-500/10", ["className", value_2439]), ["onClick", (_arg_93) => {
        setActiveSlot(undefined);
        setState((st_28) => (new GameState(new ConsolePhase(1, []), initialState.Roster, initialState.SystemArchetype, initialState.Config, initialState.RerollsAvailable, initialState.DrawnFranchiseIds, initialState.FranchiseLock, initialState.Blueprint, initialState.DailyRun, initialState.IsKnowledgeMode, initialState.DraftModeSetting, initialState.StartEraIndex, initialState.EndEraIndex, initialState.HeadCoachesEnabled, initialState.SelectedCoach, initialState.IsTradeResolved, initialState.TradeOutcome, initialState.IsInstantSkipActive, initialState.PlayerSeason, initialState.TradedInPlayerIds, initialState.DeadlineDeals, initialState.ProjectedWins, initialState.RivalStandings, initialState.PlayoffRecords, initialState.PlayoffOutcome, initialState.PlayoffsEnabled, initialState.TradeDeadlineEnabled, initialState.SeasonLuck, initialState.Wins, initialState.Losses, initialState.GameLog, st_28.Profile, st_28.UserRuns)));
    }], ["children", "Play Banner Season ➔"]])))], ["children", reactApi.Children.toArray(Array.from(elems_229))])]))), guideRelatedRow(ofArray([relatedCard("How to play", true, () => {
        Actions_navigateToHowToPlayGuide(setState);
    }), relatedCard("Basketball draft game", false, () => {
        Actions_navigateToDraftGuide(setState);
    }), relatedCard("All-time lineup builder", false, () => {
        Actions_navigateToLineupBuilderGuide(setState);
    }), relatedCard("Season simulator", false, () => {
        Actions_navigateToSeasonSimulatorGuide(setState);
    }), relatedCard("Greatest all-time roster", false, () => {
        Actions_navigateToGreatestLineupGuide(setState);
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_230))])])));
    const multiplayerModeCard = (heading_3, tag_1, tagClass, blurb_2, onClick) => createElement("div", createObj(toList_1(delay(() => append_1(singleton_2(["key", heading_3]), delay(() => append_1(singleton_2(["className", (onClick == null) ? "w-full bg-zinc-900/10 border border-zinc-900/60 p-6 rounded-2xl text-left relative opacity-60 cursor-not-allowed select-none" : "w-full bg-zinc-900/10 border border-zinc-900/60 p-6 rounded-2xl text-left relative select-none cursor-pointer hover:border-orange-500/40 transition-all"]), delay(() => {
        let matchValue_99, handler_73;
        return append_1((matchValue_99 = onClick, (matchValue_99 == null) ? (empty_2()) : ((handler_73 = matchValue_99, singleton_2(["onClick", (_arg_94) => {
            handler_73();
        }])))), delay(() => {
            let elems_232, elems_231;
            return singleton_2((elems_232 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3"], (elems_231 = [createElement("span", {
                className: "text-white text-lg font-black tracking-tight",
                children: heading_3,
            }), createElement("span", {
                className: tagClass,
                children: tag_1,
            })], ["children", reactApi.Children.toArray(Array.from(elems_231))])]))), createElement("span", {
                className: "text-zinc-400 text-xs leading-relaxed mt-2.5 max-w-md block font-medium",
                children: blurb_2,
            })], ["children", reactApi.Children.toArray(Array.from(elems_232))]));
        }));
    }))))))));
    const multiplayerHubPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col items-center text-center pt-8 pb-6 px-4 font-sans"], (elems_234 = [createElement("div", createObj(ofArray([(value_2469 = "bg-emerald-950/40 border border-emerald-900/60 text-emerald-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-6 flex items-center gap-1.5 w-fit select-none animate-pulse", ["className", value_2469]), ["children", "● Banner Season with mates"]]))), createElement("h1", {
        className: "text-white text-4xl font-black font-sans tracking-tight mb-2",
        children: "Multiplayer",
    }), createElement("p", {
        className: "text-zinc-500 text-sm font-medium tracking-wide",
        children: "Two ways to settle who builds the better team.",
    }), createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-4 mt-8"], (elems_233 = [multiplayerModeCard("Leagues", "🟢 Live", "bg-emerald-950/40 border border-emerald-900/40 text-emerald-400 text-[9px] font-mono font-black tracking-wider uppercase px-2 py-0.5 rounded-md shrink-0", "You and your mates each build a team and play a season whenever you want. No need to be online together, and the best team tops the league standings.", () => {
        Actions_navigateToLeaguesSetup(setState);
    }), multiplayerModeCard("Live Draft", "🔴 Live now", "bg-red-950/40 border border-red-900/40 text-red-400 text-[9px] font-mono font-black tracking-wider uppercase px-2 py-0.5 rounded-md shrink-0", "Draft in real time with up to 4 players. One wheel, snake order, everyone online at once.", () => {
        Actions_navigateToLiveDraftSetup(setState);
    })], ["children", reactApi.Children.toArray(Array.from(elems_233))])]))), createElement("button", createObj(ofArray([(value_2484 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-3 transition-colors cursor-pointer select-none font-sans mt-6 block mx-auto w-fit", ["className", value_2484]), ["onClick", (_arg_95) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Back to solo play"]])))], ["children", reactApi.Children.toArray(Array.from(elems_234))])])));
    let liveDraftSetupPage;
    const patternInput_46 = reactApi.useState(false);
    const setShowJoinCodeForm = patternInput_46[1];
    const patternInput_47 = reactApi.useState("");
    const userName = patternInput_47[0];
    const patternInput_48 = reactApi.useState(false);
    const setShowError = patternInput_48[1];
    const requireUserName = (proceed) => {
        if (isNullOrWhiteSpace(userName)) {
            setShowError(true);
        }
        else {
            setShowError(false);
            proceed();
        }
    };
    const chatPanel = createElement("div", createObj(ofArray([["className", "w-full rounded-2xl border border-zinc-800 bg-zinc-900/30 p-3 text-left"], (elems_238 = toList_1(delay(() => append_1(singleton_2(createElement("div", {
        className: "mb-2 text-[9px] font-black uppercase tracking-widest text-zinc-600",
        children: "Room chat",
    })), delay(() => {
        let elems_236;
        return append_1(!isEmpty(liveChat) ? singleton_2(createElement("div", createObj(ofArray([["className", "mb-2 flex max-h-32 flex-col-reverse gap-1 overflow-y-auto"], (elems_236 = toList_1(delay(() => collect_1((matchValue_100) => {
            let elems_235;
            return singleton_2(createElement("div", createObj(ofArray([["key", `chat-${matchValue_100[0]}`], ["className", "text-[11px] leading-relaxed text-zinc-400"], (elems_235 = [createElement("span", {
                className: "font-bold text-zinc-200",
                children: matchValue_100[1][0] + ": ",
            }), createElement("span", {
                children: matchValue_100[1][1],
            })], ["children", reactApi.Children.toArray(Array.from(elems_235))])]))));
        }, indexed(liveChat)))), ["children", reactApi.Children.toArray(Array.from(elems_236))])])))) : empty_2(), delay(() => {
            let elems_237, value_2522, value_2524;
            return singleton_2(createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_237 = [createElement("input", createObj(ofArray([["value", liveChatInput], ["maxLength", 140], ["onChange", (ev_10) => {
                setLiveChatInput(ev_10.target.value);
            }], ["onKeyUp", (ev_11) => {
                PropHelpers_createOnKey(key_enter, (_arg_96) => {
                    sendChat();
                }, ev_11);
            }], ["placeholder", "Talk your trash…"], (value_2522 = "flex-1 rounded-lg border border-zinc-800 bg-zinc-950 px-3 py-2 text-xs text-zinc-200 placeholder:text-zinc-700 focus:border-orange-500/50 focus:outline-none", ["className", value_2522])]))), createElement("button", createObj(ofArray([(value_2524 = "rounded-lg border border-zinc-700 bg-zinc-900 px-4 text-[10px] font-black uppercase text-zinc-300 hover:border-orange-500/40 transition-all cursor-pointer", ["className", value_2524]), ["onClick", (_arg_97) => {
                sendChat();
            }], ["children", "Send"]])))], ["children", reactApi.Children.toArray(Array.from(elems_237))])]))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_238))])])));
    liveDraftSetupPage = createElement("div", createObj(ofArray([(value_2531 = "w-full max-w-md mx-auto flex flex-col items-center text-center pt-10 pb-12 px-6 font-sans select-none", ["className", value_2531]), (elems_254 = toList_1(delay(() => {
        let value_2533;
        return append_1(singleton_2(createElement("div", createObj(ofArray([(value_2533 = "bg-emerald-950/40 border border-emerald-900/60 text-emerald-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-3 flex items-center gap-1.5 w-fit select-none", ["className", value_2533]), ["children", "● Multiplayer · Beta"]])))), delay(() => append_1(singleton_2(createElement("span", {
            className: "text-emerald-400 font-mono text-[11px] font-bold tracking-wide mb-6 block",
            children: (liveNow > 0) ? (`${liveNow} drafting right now`) : "Free · no login needed",
        })), delay(() => append_1(singleton_2(createElement("h1", {
            className: "text-white text-4xl font-black font-sans tracking-tight mb-2",
            children: "Play a Friend",
        })), delay(() => append_1(singleton_2(createElement("span", {
            className: "text-zinc-500 text-sm font-medium leading-relaxed max-w-sm block mb-8",
            children: "Build your own 8-man roster, simulate your seasons, and see who built the better team.",
        })), delay(() => append_1(!liveConnected ? append_1(singleton_2(createElement("span", {
            className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-2 text-left w-full pl-1",
            children: "Your name",
        })), delay(() => {
            let value_2553;
            return singleton_2(createElement("input", createObj(ofArray([(value_2553 = "w-full bg-zinc-900/40 border border-zinc-800 focus:border-orange-500/60 rounded-xl px-4 py-3.5 text-white placeholder-zinc-700 text-sm font-medium tracking-wide outline-none mb-4 transition-colors", ["className", value_2553]), ["placeholder", "e.g. Aiden"], ["value", userName], ["onChange", (ev_12) => {
                patternInput_47[1](ev_12.target.value);
            }]]))));
        })) : empty_2(), delay(() => {
            let value_2560, value_2562;
            return append_1(patternInput_48[0] ? singleton_2(createElement("div", createObj(ofArray([(value_2560 = "w-full bg-red-950/30 border border-red-900/60 text-red-400 text-xs font-semibold py-2.5 px-4 rounded-xl text-left mt-2 mb-2 animate-shake", ["className", value_2560]), (value_2562 = "⚠️ Validation Error: You must enter a username handle before initializing or joining a multiplayer session room.", ["children", value_2562])])))) : empty_2(), delay(() => {
                let value_2564;
                return append_1((liveErr !== "") ? singleton_2(createElement("div", createObj(ofArray([(value_2564 = "w-full bg-red-950/30 border border-red-900/60 text-red-400 text-xs font-semibold py-2.5 px-4 rounded-xl text-left mb-3", ["className", value_2564]), ["children", liveErr]])))) : empty_2(), delay(() => {
                    let elems_239, matchValue_101, room_10, room_12, table_8, elems_243, elems_242, elems_241, value_2604, room_13, onTurn_1, myTurn, me, hostGone, elems_249, elems_252, value_2752;
                    return append_1(!Backend_isConfigured ? singleton_2(createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-dashed border-zinc-800 px-6 py-8 text-center"], (elems_239 = [createElement("span", {
                        className: "block text-sm font-bold text-zinc-300 mb-1",
                        children: "Live rooms aren\'t connected on this build",
                    }), createElement("span", {
                        className: "block text-xs leading-relaxed text-zinc-600",
                        children: "This copy of the game has no realtime server behind it.",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_239))])])))) : (liveConnected ? ((matchValue_101 = patternInput_29[0], (matchValue_101 != null) ? (((room_10 = matchValue_101, room_10.Started && LiveDraft_draftDone(room_10))) ? ((room_12 = matchValue_101, (table_8 = LiveDraft_finalTable(room_12), singleton_2(createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_243 = [createElement("div", createObj(ofArray([["className", "rounded-2xl border border-zinc-800 bg-zinc-900/30 p-5 text-left"], (elems_242 = [createElement("span", {
                        className: "text-[10px] font-black uppercase tracking-widest text-zinc-500 block mb-3",
                        children: "Final table",
                    }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_241 = toList_1(delay(() => collect_1((matchValue_102) => {
                        let elems_240;
                        const m_4 = matchValue_102[1][0];
                        return singleton_2(createElement("div", createObj(ofArray([["key", m_4.Key], ["className", "flex items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3"], (elems_240 = [createElement("span", {
                            className: "truncate text-sm font-bold text-zinc-100",
                            children: (((matchValue_102[0] === 0) ? "🏆 " : "") + m_4.Handle) + ((m_4.Key === liveKey.current) ? " (you)" : ""),
                        }), createElement("span", {
                            className: "shrink-0 font-mono text-sm font-black text-zinc-200",
                            children: `${matchValue_102[1][1]}-${matchValue_102[1][2]}`,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_240))])]))));
                    }, indexed(table_8)))), ["children", reactApi.Children.toArray(Array.from(elems_241))])])))], ["children", reactApi.Children.toArray(Array.from(elems_242))])]))), chatPanel, createElement("button", createObj(ofArray([(value_2604 = "w-full rounded-xl border border-zinc-800 bg-zinc-900/40 py-3 text-xs font-bold text-zinc-300 transition-all hover:border-zinc-700 cursor-pointer", ["className", value_2604]), ["onClick", (_arg_98) => {
                        leaveLiveRoom();
                    }], ["children", "Leave room"]])))], ["children", reactApi.Children.toArray(Array.from(elems_243))])]))))))) : (matchValue_101.Started ? ((room_13 = matchValue_101, (onTurn_1 = LiveDraft_memberOnTurn(room_13), (myTurn = exists_2((m_5) => (m_5.Key === liveKey.current), toArray_2(onTurn_1)), (me = tryFind((m_6) => (m_6.Key === liveKey.current), room_13.Members), (hostGone = !exists((tupledArg_28) => (tupledArg_28[0] === room_13.HostKey), livePeers), singleton_2(createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3 text-left"], (elems_249 = toList_1(delay(() => append_1((hostGone && !liveIsHostRef.current) ? singleton_2(createElement("div", {
                        className: "rounded-xl border border-red-900/60 bg-red-950/30 px-4 py-2.5 text-xs font-semibold text-red-400",
                        children: "The host\'s connection dropped — this room is over.",
                    })) : empty_2(), delay(() => {
                        let pickNo, total_1, clock, d_2, m_7;
                        return append_1(singleton_2(createElement("div", {
                            className: "rounded-xl border px-4 py-3 text-center text-xs font-black uppercase tracking-widest " + (myTurn ? "border-emerald-500/60 bg-emerald-500/10 text-emerald-400 animate-pulse" : "border-zinc-800 bg-zinc-900/40 text-zinc-400"),
                            children: (pickNo = ((room_13.TurnIndex + 1) | 0), (total_1 = (LiveDraft_totalPicks(room_13) | 0), (clock = ((room_13.TurnDeadline > 0) ? toText(interpolate(" · ⏱ 0:%02d%P()", [~~((d_2 = max(0, (room_13.TurnDeadline - (Date.now())) / 1000), Math.floor(d_2)))])) : ""), (onTurn_1 == null) ? "Drafting…" : (myTurn ? (`Pick ${pickNo}/${total_1} — YOUR pick${clock}`) : ((m_7 = onTurn_1, `Pick ${pickNo}/${total_1} — ${m_7.Handle} is on the clock${clock}`)))))),
                        })), delay(() => {
                            let matchValue_103, pool_19, elems_246, elems_245;
                            return append_1((matchValue_103 = FSharpMap__TryFind(poolById, room_13.PoolId), (matchValue_103 != null) ? ((pool_19 = matchValue_103, singleton_2(createElement("div", createObj(ofArray([["className", "rounded-2xl border border-zinc-800 bg-zinc-900/30 p-4"], (elems_246 = [createElement("div", {
                                className: "mb-2 text-[10px] font-black uppercase tracking-widest text-orange-400",
                                children: `The wheel landed on · ${pool_19.TeamName}`,
                            }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-1.5"], (elems_245 = toList_1(delay(() => map_1((p_22) => {
                                let elems_244;
                                const taken_1 = contains(p_22.Id, room_13.TakenIds, {
                                    Equals: (x_50, y_47) => (x_50 === y_47),
                                    GetHashCode: stringHash,
                                });
                                const eligible = bind((m_8) => LiveDraft_autoSlotFor(m_8, p_22), me) != null;
                                return createElement("button", createObj(ofArray([["key", p_22.Id], ["disabled", (!myTurn ? true : taken_1) ? true : !eligible], ["className", "flex w-full items-center justify-between gap-3 rounded-xl border px-3 py-2.5 text-left transition-all " + (taken_1 ? "border-zinc-900 bg-zinc-950 opacity-40 cursor-not-allowed line-through" : ((myTurn && eligible) ? "border-zinc-800 bg-zinc-950 hover:border-emerald-500/60 cursor-pointer" : "border-zinc-900 bg-zinc-950 opacity-60 cursor-not-allowed"))], ["onClick", (_arg_100) => {
                                    const playerId_1 = p_22.Id;
                                    const matchValue_9 = liveRoomRef.current;
                                    if (matchValue_9 == null) {
                                    }
                                    else {
                                        const room_6 = matchValue_9;
                                        if (liveIsHostRef.current) {
                                            const matchValue_10 = LiveDraft_applyPick(room_6, liveKey.current, playerId_1);
                                            if (matchValue_10 == null) {
                                            }
                                            else {
                                                hostApply(matchValue_10);
                                            }
                                        }
                                        else {
                                            Backend_sendDraftEvent("action", Backend_pickPayload(liveKey.current, playerId_1));
                                        }
                                    }
                                }], (elems_244 = [createElement("span", {
                                    className: "truncate text-xs font-bold text-zinc-100",
                                    children: `${p_22.Name} · ${p_22.Pos}`,
                                }), createElement("span", {
                                    className: "shrink-0 font-mono text-xs font-black text-orange-400",
                                    children: int32ToString(p_22.Ovr),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_244))])])));
                            }, sortByDescending((p_23) => p_23.Ovr, pool_19.Options, {
                                Compare: comparePrimitives,
                            })))), ["children", reactApi.Children.toArray(Array.from(elems_245))])])))], ["children", reactApi.Children.toArray(Array.from(elems_246))])])))))) : singleton_2(defaultOf_1())), delay(() => {
                                let elems_248;
                                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-col gap-1.5"], (elems_248 = toList_1(delay(() => map_1((m_9) => {
                                    let elems_247;
                                    return createElement("div", createObj(ofArray([["key", m_9.Key], ["className", "flex items-center justify-between gap-3 rounded-xl border px-3 py-2 text-xs " + (exists_2((t_4) => (t_4.Key === m_9.Key), toArray_2(onTurn_1)) ? "border-emerald-500/40 bg-emerald-500/5" : "border-zinc-900 bg-zinc-950")], (elems_247 = [createElement("span", {
                                        className: "truncate font-bold text-zinc-200",
                                        children: (m_9.Handle + ((m_9.Key === liveKey.current) ? " (you)" : "")) + ((m_9.Key === room_13.HostKey) ? " · host" : ""),
                                    }), createElement("span", {
                                        className: "shrink-0 font-mono font-black text-zinc-500",
                                        children: `${length(m_9.Roster)}/${LiveDraft_roundsPerMember}`,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_247))])])));
                                }, room_13.Members))), ["children", reactApi.Children.toArray(Array.from(elems_248))])])))), delay(() => {
                                    let matchValue_104, my_1;
                                    return append_1((matchValue_104 = me, (matchValue_104 != null) ? (!isEmpty(matchValue_104.Roster) ? ((my_1 = matchValue_104, singleton_2(createElement("div", {
                                        className: "rounded-xl border border-zinc-900 bg-zinc-950 px-3 py-2 text-[10px] leading-relaxed text-zinc-500",
                                        children: "Your roster: " + join(" · ", map((tupledArg_29) => (`${tupledArg_29[0]} ${defaultArg(map_2((p_24) => last(split(p_24.Name, [" "], undefined, 0)), FSharpMap__TryFind(playerById, tupledArg_29[1])), "?")}`), my_1.Roster)),
                                    })))) : singleton_2(defaultOf_1())) : singleton_2(defaultOf_1())), delay(() => append_1(singleton_2(chatPanel), delay(() => {
                                        let value_2668;
                                        return append_1((liveIsHostRef.current && !myTurn) ? singleton_2(createElement("button", createObj(ofArray([(value_2668 = "w-full rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-400 transition-all hover:border-zinc-700 cursor-pointer", ["className", value_2668]), ["onClick", (_arg_101) => {
                                            liveAutoPick();
                                        }], ["children", (onTurn_1 == null) ? "⏭ Auto-pick" : (`⏭ Auto-pick for ${onTurn_1.Handle} (AFK skip)`)]])))) : empty_2(), delay(() => {
                                            let value_2673;
                                            return singleton_2(createElement("button", createObj(ofArray([(value_2673 = "w-full rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-500 transition-all hover:border-red-900/60 hover:text-red-400 cursor-pointer", ["className", value_2673]), ["onClick", (_arg_102) => {
                                                leaveLiveRoom();
                                            }], ["children", "Leave room"]]))));
                                        }));
                                    }))));
                                }));
                            }));
                        }));
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_249))])])))))))))) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_252 = toList_1(delay(() => {
                        let elems_250;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "rounded-2xl border border-orange-500/40 bg-orange-500/5 px-6 py-5 text-center"], (elems_250 = [createElement("span", {
                            className: "block text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-1",
                            children: "Room code",
                        }), createElement("span", {
                            className: "block font-mono text-3xl font-black tracking-[0.3em] text-orange-400",
                            children: liveActiveCode,
                        }), createElement("button", {
                            className: "mt-2 text-[11px] font-semibold text-zinc-500 transition-colors hover:text-orange-400 cursor-pointer",
                            onClick: (_arg_103) => {
                                navigator.clipboard ? navigator.clipboard.writeText(`Live draft, right now — go to bannerseason.app, open Multiplayer → Live Draft, and join with code ${liveActiveCode}`) : undefined;
                            },
                            children: "📋 Copy the invite",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_250))])])))), delay(() => {
                            let elems_251;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-wrap justify-center gap-2"], (elems_251 = toList_1(delay(() => collect_1((matchValue_105) => {
                                const key_1514 = matchValue_105[0];
                                const handle_4 = matchValue_105[1];
                                return singleton_2(createElement("span", {
                                    key: key_1514,
                                    className: "rounded-full border border-zinc-800 bg-zinc-900/60 px-3 py-1.5 text-xs font-bold text-zinc-200",
                                    children: ((handle_4 === "") ? "Manager" : handle_4) + ((key_1514 === liveKey.current) ? " (you)" : ""),
                                }));
                            }, livePeers))), ["children", reactApi.Children.toArray(Array.from(elems_251))])])))), delay(() => {
                                let value_2708, count_2, value_2713;
                                return append_1(liveIsHostRef.current ? singleton_2(createElement("button", createObj(ofArray([["disabled", (length(livePeers) < 2) ? true : (length(livePeers) > 4)], (value_2708 = "w-full bg-emerald-500 hover:bg-emerald-600 text-black font-black text-sm py-4 rounded-xl transition-all cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", ["className", value_2708]), ["onClick", (_arg_104) => {
                                    const members = map((tupledArg_1) => {
                                        const handle_2 = tupledArg_1[1];
                                        return new LiveDraft_Member(tupledArg_1[0], (handle_2 === "") ? "Manager" : handle_2, empty_1());
                                    }, truncate(4, livePeers));
                                    const ordered = append(filter((m_2) => (m_2.Key === liveKey.current), members), filter((m_3) => (m_3.Key !== liveKey.current), members));
                                    const seedRoom = new LiveDraft_Room(liveActiveCode, liveKey.current, ordered, true, 0, "", empty_1(), LiveDraft_makeSeed(), (Date.now()) + (LiveDraft_turnSeconds * 1000));
                                    hostApply(new LiveDraft_Room(seedRoom.Code, seedRoom.HostKey, seedRoom.Members, seedRoom.Started, seedRoom.TurnIndex, LiveDraft_freshPoolId(seedRoom), seedRoom.TakenIds, seedRoom.Seed, seedRoom.TurnDeadline));
                                }], ["children", (count_2 = (length(livePeers) | 0), (count_2 < 2) ? (`Waiting for managers… (${count_2}/2 minimum)`) : (`Tip it off — ${count_2} managers ➔`))]])))) : singleton_2(createElement("div", createObj(ofArray([(value_2713 = "rounded-xl border border-zinc-800 bg-zinc-900/40 py-3.5 text-center text-xs font-semibold text-zinc-400 animate-pulse", ["className", value_2713]), ["children", "Waiting for the host to tip it off…"]])))), delay(() => append_1(singleton_2(chatPanel), delay(() => {
                                    let value_2717;
                                    return singleton_2(createElement("button", createObj(ofArray([(value_2717 = "w-full rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-500 transition-all hover:border-red-900/60 hover:text-red-400 cursor-pointer", ["className", value_2717]), ["onClick", (_arg_105) => {
                                        leaveLiveRoom();
                                    }], ["children", "Leave room"]]))));
                                }))));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_252))])])))))) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3"], (elems_252 = toList_1(delay(() => {
                        let elems_250;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "rounded-2xl border border-orange-500/40 bg-orange-500/5 px-6 py-5 text-center"], (elems_250 = [createElement("span", {
                            className: "block text-[10px] font-black uppercase tracking-widest text-zinc-500 mb-1",
                            children: "Room code",
                        }), createElement("span", {
                            className: "block font-mono text-3xl font-black tracking-[0.3em] text-orange-400",
                            children: liveActiveCode,
                        }), createElement("button", {
                            className: "mt-2 text-[11px] font-semibold text-zinc-500 transition-colors hover:text-orange-400 cursor-pointer",
                            onClick: (_arg_103) => {
                                navigator.clipboard ? navigator.clipboard.writeText(`Live draft, right now — go to bannerseason.app, open Multiplayer → Live Draft, and join with code ${liveActiveCode}`) : undefined;
                            },
                            children: "📋 Copy the invite",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_250))])])))), delay(() => {
                            let elems_251;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex flex-wrap justify-center gap-2"], (elems_251 = toList_1(delay(() => collect_1((matchValue_105) => {
                                const key_1514 = matchValue_105[0];
                                const handle_4 = matchValue_105[1];
                                return singleton_2(createElement("span", {
                                    key: key_1514,
                                    className: "rounded-full border border-zinc-800 bg-zinc-900/60 px-3 py-1.5 text-xs font-bold text-zinc-200",
                                    children: ((handle_4 === "") ? "Manager" : handle_4) + ((key_1514 === liveKey.current) ? " (you)" : ""),
                                }));
                            }, livePeers))), ["children", reactApi.Children.toArray(Array.from(elems_251))])])))), delay(() => {
                                let value_2708, count_2, value_2713;
                                return append_1(liveIsHostRef.current ? singleton_2(createElement("button", createObj(ofArray([["disabled", (length(livePeers) < 2) ? true : (length(livePeers) > 4)], (value_2708 = "w-full bg-emerald-500 hover:bg-emerald-600 text-black font-black text-sm py-4 rounded-xl transition-all cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", ["className", value_2708]), ["onClick", (_arg_104) => {
                                    const members = map((tupledArg_1) => {
                                        const handle_2 = tupledArg_1[1];
                                        return new LiveDraft_Member(tupledArg_1[0], (handle_2 === "") ? "Manager" : handle_2, empty_1());
                                    }, truncate(4, livePeers));
                                    const ordered = append(filter((m_2) => (m_2.Key === liveKey.current), members), filter((m_3) => (m_3.Key !== liveKey.current), members));
                                    const seedRoom = new LiveDraft_Room(liveActiveCode, liveKey.current, ordered, true, 0, "", empty_1(), LiveDraft_makeSeed(), (Date.now()) + (LiveDraft_turnSeconds * 1000));
                                    hostApply(new LiveDraft_Room(seedRoom.Code, seedRoom.HostKey, seedRoom.Members, seedRoom.Started, seedRoom.TurnIndex, LiveDraft_freshPoolId(seedRoom), seedRoom.TakenIds, seedRoom.Seed, seedRoom.TurnDeadline));
                                }], ["children", (count_2 = (length(livePeers) | 0), (count_2 < 2) ? (`Waiting for managers… (${count_2}/2 minimum)`) : (`Tip it off — ${count_2} managers ➔`))]])))) : singleton_2(createElement("div", createObj(ofArray([(value_2713 = "rounded-xl border border-zinc-800 bg-zinc-900/40 py-3.5 text-center text-xs font-semibold text-zinc-400 animate-pulse", ["className", value_2713]), ["children", "Waiting for the host to tip it off…"]])))), delay(() => append_1(singleton_2(chatPanel), delay(() => {
                                    let value_2717;
                                    return singleton_2(createElement("button", createObj(ofArray([(value_2717 = "w-full rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-500 transition-all hover:border-red-900/60 hover:text-red-400 cursor-pointer", ["className", value_2717]), ["onClick", (_arg_105) => {
                                        leaveLiveRoom();
                                    }], ["children", "Leave room"]]))));
                                }))));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_252))])])))))) : (patternInput_46[0] ? append_1(singleton_2(createElement("span", {
                        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-2 text-left w-full pl-1",
                        children: "Room code",
                    })), delay(() => {
                        let value_2727;
                        return append_1(singleton_2(createElement("input", createObj(ofArray([(value_2727 = "w-full bg-zinc-900/40 border border-zinc-800 focus:border-orange-500/60 rounded-xl p-4 text-center font-mono tracking-[0.25em] font-black text-xl text-white placeholder:text-zinc-700 outline-none mb-6 uppercase", ["className", value_2727]), ["placeholder", "ABC123"], ["maxLength", 6], ["value", liveCodeInput], ["onChange", (ev_13) => {
                            const value_2735 = ev_13.target.value;
                            patternInput_33[1](value_2735.toLocaleUpperCase());
                        }]])))), delay(() => {
                            let elems_253, value_2739, value_2746;
                            return singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center gap-3 w-full"], (elems_253 = [createElement("button", createObj(ofArray([(value_2739 = "bg-zinc-900 border border-zinc-800 hover:border-zinc-700 text-zinc-300 font-bold text-xs py-4 px-6 rounded-xl transition-all cursor-pointer", ["className", value_2739]), ["onClick", (_arg_106) => {
                                setShowJoinCodeForm(false);
                            }], ["children", "← Back"]]))), createElement("button", createObj(ofArray([["disabled", liveCodeInput.trim().length !== 6], (value_2746 = "flex-1 bg-emerald-500 hover:bg-emerald-600 text-black font-black font-sans text-xs py-4 rounded-xl transition-all cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 relative flex justify-center items-center gap-1.5 shadow-lg shadow-emerald-500/5", ["className", value_2746]), ["onClick", (_arg_107) => {
                                requireUserName(() => {
                                    enterDraftRoom(liveCodeInput.trim().toLocaleUpperCase(), false, userName.trim(), undefined);
                                });
                            }], ["children", "Join Room ➔"]])))], ["children", reactApi.Children.toArray(Array.from(elems_253))])]))));
                        }));
                    })) : append_1(singleton_2(createElement("button", createObj(ofArray([(value_2752 = "w-full bg-emerald-500 hover:bg-emerald-600 text-black font-black font-sans text-sm py-4 rounded-xl transition-all cursor-pointer relative flex justify-center items-center gap-2 mb-3 shadow-lg shadow-emerald-500/5", ["className", value_2752]), ["onClick", (_arg_108) => {
                        requireUserName(() => {
                            enterDraftRoom(LiveDraft_makeRoomCode(), true, userName.trim(), undefined);
                        });
                    }], ["children", "🔴 New live game"]])))), delay(() => append_1(singleton_2(createElement("span", {
                        className: "text-zinc-600 text-[10px] font-medium tracking-wide block mb-4",
                        children: "2–4 managers, one wheel, snake order. Winner takes the bragging rights.",
                    })), delay(() => {
                        let value_2761;
                        return singleton_2(createElement("button", createObj(ofArray([(value_2761 = "w-full border border-zinc-800 bg-zinc-900/20 hover:border-zinc-700 text-zinc-300 font-bold text-xs py-4 rounded-xl flex justify-center items-center mb-8 cursor-pointer hover:border-orange-500/40 transition-all", ["className", value_2761]), ["onClick", (_arg_109) => {
                            requireUserName(() => {
                                setShowJoinCodeForm(true);
                            });
                        }], ["children", "Join with a code"]]))));
                    })))))), delay(() => {
                        let value_2766;
                        return singleton_2(createElement("button", createObj(ofArray([(value_2766 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_2766]), ["onClick", (_arg_110) => {
                            Actions_navigateToHome(setState);
                        }], ["children", "Or play solo →"]]))));
                    }));
                }));
            }));
        }))))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_254))])])));
    let leaguesSetupPage;
    const leagueStepCard = (icon_2, heading_4, blurb_3) => {
        let value_2774, elems_256, elems_255;
        return createElement("div", createObj(ofArray([["key", heading_4], (value_2774 = "w-full bg-zinc-900/10 border border-zinc-900/60 p-5 rounded-2xl mb-3 flex items-start gap-4 font-sans text-left", ["className", value_2774]), (elems_256 = [createElement("span", {
            className: "text-xl shrink-0 select-none",
            children: icon_2,
        }), createElement("div", createObj(singleton((elems_255 = [createElement("span", {
            className: "text-white text-xs font-black tracking-tight mb-0.5 block",
            children: heading_4,
        }), createElement("span", {
            className: "text-zinc-400 text-[11px] leading-relaxed font-medium block",
            children: blurb_3,
        })], ["children", reactApi.Children.toArray(Array.from(elems_255))]))))], ["children", reactApi.Children.toArray(Array.from(elems_256))])])));
    };
    leaguesSetupPage = createElement("div", createObj(ofArray([["className", "w-full max-w-md mx-auto flex flex-col items-center text-center pt-8 pb-12 px-6 font-sans"], (elems_273 = toList_1(delay(() => {
        let value_2792;
        return append_1(singleton_2(createElement("div", createObj(ofArray([(value_2792 = "bg-emerald-950/40 border border-emerald-900/60 text-emerald-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-6 flex items-center gap-1.5 w-fit select-none animate-pulse", ["className", value_2792]), ["children", "● Banner Season WITH MATES"]])))), delay(() => append_1(singleton_2(createElement("h1", {
            className: "text-white text-4xl font-black tracking-tight mb-2",
            children: "Leagues",
        })), delay(() => {
            let value_2802;
            return append_1(singleton_2(createElement("span", createObj(ofArray([["className", "text-zinc-500 text-sm font-medium leading-relaxed mb-6 block"], (value_2802 = "You and your mates each build a basketball roster and play a season. Whose team does best? Every submitted season lands on the league table.", ["children", value_2802])])))), delay(() => {
                let matchValue_106, elems_265, elems_272, league_1, elems_264;
                return append_1((matchValue_106 = patternInput_25[0], (matchValue_106 == null) ? (!Backend_isConfigured ? singleton_2(createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-dashed border-zinc-800 px-6 py-8 text-center mb-4"], (elems_265 = [createElement("span", {
                    className: "block text-sm font-bold text-zinc-300 mb-1",
                    children: "Leagues aren\'t connected on this build",
                }), createElement("span", {
                    className: "block text-xs leading-relaxed text-zinc-600",
                    children: "This copy of the game has no league server behind it.",
                })], ["children", reactApi.Children.toArray(Array.from(elems_265))])])))) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-left flex flex-col gap-4 mb-2"], (elems_272 = toList_1(delay(() => {
                    let elems_266, value_2927;
                    return append_1(singleton_2(createElement("div", createObj(singleton((elems_266 = [createElement("span", {
                        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-2",
                        children: "Your handle",
                    }), createElement("input", createObj(ofArray([["type", "text"], ["value", leagueHandle], ["maxLength", 16], ["onChange", (ev_14) => {
                        patternInput_21[1](ev_14.target.value);
                    }], ["placeholder", "3–16 letters, numbers, underscores"], (value_2927 = "w-full rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3 text-sm text-zinc-200 placeholder:text-zinc-700 focus:border-orange-500/50 focus:outline-none", ["className", value_2927])])))], ["children", reactApi.Children.toArray(Array.from(elems_266))]))))), delay(() => {
                        let elems_267, value_2942, value_2944;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_267 = [createElement("input", createObj(ofArray([["type", "text"], ["value", leagueNameInput], ["maxLength", 32], ["onChange", (ev_15) => {
                            setLeagueNameInput(ev_15.target.value);
                        }], ["placeholder", "New league name"], (value_2942 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3 text-sm text-zinc-200 placeholder:text-zinc-700 focus:border-orange-500/50 focus:outline-none", ["className", value_2942])]))), createElement("button", createObj(ofArray([(value_2944 = "rounded-xl bg-emerald-500 px-5 text-xs font-black uppercase tracking-wider text-black transition-all hover:bg-emerald-600 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", ["className", value_2944]), ["disabled", (leagueBusy ? true : (leagueNameInput.trim().length < 3)) ? true : !Backend_isValidHandle(leagueHandle.trim())], ["onClick", (_arg_115) => {
                            if (!leagueBusy) {
                                setLeagueBusy(true);
                                setLeagueMsg(undefined);
                                Backend_createLeague(leagueNameInput.trim(), leagueHandle.trim(), (result_6) => {
                                    setLeagueBusy(false);
                                    if (result_6.tag === 1) {
                                        setLeagueMsg(new FSharpResult$2(1, [result_6.fields[0]]));
                                    }
                                    else {
                                        const league_2 = result_6.fields[0];
                                        setLeagueNameInput("");
                                        setMyLeagues(cons(league_2, myLeagues));
                                        openLeague(league_2);
                                    }
                                });
                            }
                        }], ["children", leagueBusy ? "…" : "Create"]])))], ["children", reactApi.Children.toArray(Array.from(elems_267))])])))), delay(() => {
                            let elems_268, value_2964, value_2966;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex gap-2"], (elems_268 = [createElement("input", createObj(ofArray([["type", "text"], ["value", leagueCodeInput], ["maxLength", 6], ["onChange", (ev_16) => {
                                setLeagueCodeInput(ev_16.target.value);
                            }], ["placeholder", "Or enter a 6-letter code"], (value_2964 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3 font-mono text-sm uppercase tracking-[0.2em] text-zinc-200 placeholder:font-sans placeholder:normal-case placeholder:tracking-normal placeholder:text-zinc-700 focus:border-orange-500/50 focus:outline-none", ["className", value_2964])]))), createElement("button", createObj(ofArray([(value_2966 = "rounded-xl border border-zinc-700 bg-zinc-900 px-5 text-xs font-black uppercase tracking-wider text-zinc-200 transition-all hover:border-orange-500/40 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", ["className", value_2966]), ["disabled", (leagueBusy ? true : (leagueCodeInput.trim().length !== 6)) ? true : !Backend_isValidHandle(leagueHandle.trim())], ["onClick", (_arg_116) => {
                                if (!leagueBusy) {
                                    setLeagueBusy(true);
                                    setLeagueMsg(undefined);
                                    Backend_joinLeague(leagueCodeInput.trim(), leagueHandle.trim(), (result_7) => {
                                        setLeagueBusy(false);
                                        if (result_7.tag === 1) {
                                            setLeagueMsg(new FSharpResult$2(1, [result_7.fields[0]]));
                                        }
                                        else {
                                            const league_3 = result_7.fields[0];
                                            setLeagueCodeInput("");
                                            if (!exists((l_4) => (l_4.Id === league_3.Id), myLeagues)) {
                                                setMyLeagues(cons(league_3, myLeagues));
                                            }
                                            openLeague(league_3);
                                        }
                                    });
                                }
                            }], ["children", leagueBusy ? "…" : "Join"]])))], ["children", reactApi.Children.toArray(Array.from(elems_268))])])))), delay(() => {
                                let matchValue_110, copyOfStruct_2;
                                return append_1((matchValue_110 = leagueMsg, (matchValue_110 != null) ? ((copyOfStruct_2 = matchValue_110, (copyOfStruct_2.tag === 1) ? singleton_2(createElement("div", {
                                    className: "text-[11px] font-semibold text-red-400",
                                    children: copyOfStruct_2.fields[0],
                                })) : singleton_2(defaultOf_1()))) : singleton_2(defaultOf_1())), delay(() => {
                                    let elems_271, elems_270;
                                    return !isEmpty(myLeagues) ? singleton_2(createElement("div", createObj(singleton((elems_271 = [createElement("span", {
                                        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-2",
                                        children: "Your leagues",
                                    }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_270 = toList_1(delay(() => map_1((league_4) => {
                                        let value_2986, elems_269;
                                        return createElement("button", createObj(ofArray([["key", league_4.Id], (value_2986 = "flex w-full items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-3 text-left transition-all hover:border-orange-500/40 cursor-pointer", ["className", value_2986]), ["onClick", (_arg_117) => {
                                            openLeague(league_4);
                                        }], (elems_269 = [createElement("span", {
                                            className: "truncate text-xs font-bold text-zinc-100",
                                            children: league_4.Name,
                                        }), createElement("span", {
                                            className: "shrink-0 font-mono text-[10px] font-black tracking-[0.15em] text-zinc-500",
                                            children: league_4.Code,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_269))])])));
                                    }, myLeagues))), ["children", reactApi.Children.toArray(Array.from(elems_270))])])))], ["children", reactApi.Children.toArray(Array.from(elems_271))]))))) : empty_2();
                                }));
                            }));
                        }));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_272))])]))))) : ((league_1 = matchValue_106, singleton_2(createElement("div", createObj(ofArray([["className", "w-full rounded-2xl border border-zinc-800 bg-zinc-900/30 p-5 text-left mb-4"], (elems_264 = toList_1(delay(() => {
                    let elems_257, value_2812;
                    return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3 mb-1"], (elems_257 = [createElement("span", {
                        className: "truncate text-lg font-black text-white",
                        children: league_1.Name,
                    }), createElement("span", createObj(ofArray([(value_2812 = "shrink-0 rounded-lg border border-orange-500/40 bg-orange-500/10 px-3 py-1 font-mono text-sm font-black tracking-[0.2em] text-orange-400", ["className", value_2812]), ["children", league_1.Code]])))], ["children", reactApi.Children.toArray(Array.from(elems_257))])])))), delay(() => append_1(singleton_2(createElement("button", {
                        className: "mb-4 text-[11px] font-semibold text-zinc-500 transition-colors hover:text-orange-400 cursor-pointer",
                        onClick: (_arg_111) => {
                            navigator.clipboard ? navigator.clipboard.writeText(`Join my Banner Season league "${league_1.Name}": go to bannerseason.app, open Multiplayer → Leagues, and enter code ${league_1.Code}`) : undefined;
                            setLeagueMsg(new FSharpResult$2(0, ["Invite copied — send it to your mates."]));
                        },
                        children: "📋 Copy the invite",
                    })), delay(() => {
                        let elems_262;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "overflow-hidden rounded-xl border border-zinc-900"], (elems_262 = toList_1(delay(() => {
                            let value_2824, elems_258;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([(value_2824 = "flex items-center gap-3 bg-zinc-900/70 px-3 py-2 text-[9px] font-black tracking-widest text-zinc-500", ["className", value_2824]), (elems_258 = [createElement("span", {
                                className: "w-5 shrink-0 text-center",
                                children: "#",
                            }), createElement("span", {
                                className: "flex-1",
                                children: "MANAGER",
                            }), createElement("span", {
                                className: "shrink-0",
                                children: "RECORD",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_258))])])))), delay(() => {
                                let elems_261;
                                return isEmpty(leagueRows) ? singleton_2(createElement("div", {
                                    className: "px-3 py-4 text-center text-[11px] text-zinc-600",
                                    children: "Loading the table…",
                                })) : singleton_2(createElement("div", createObj(ofArray([["className", "divide-y divide-zinc-900/60"], (elems_261 = toList_1(delay(() => collect_1((matchValue_107) => {
                                    let elems_260, elems_259;
                                    const row = matchValue_107[1];
                                    const index_4 = matchValue_107[0] | 0;
                                    return singleton_2(createElement("div", createObj(ofArray([["key", `${row.Handle}-${index_4}`], ["className", "flex items-center gap-3 px-3 py-2.5"], (elems_260 = [createElement("span", {
                                        className: "w-5 shrink-0 text-center font-mono text-[10px] font-black text-zinc-600",
                                        children: int32ToString(index_4 + 1),
                                    }), createElement("div", createObj(ofArray([["className", "min-w-0 flex-1"], (elems_259 = [createElement("div", {
                                        className: "truncate text-xs font-bold text-zinc-100",
                                        children: row.Handle,
                                    }), createElement("div", {
                                        className: "truncate text-[10px] text-zinc-600",
                                        children: row.HasRun ? (`${row.TeamName} · ${row.Ovr} rated`) : "No season submitted yet",
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_259))])]))), createElement("span", {
                                        className: "shrink-0 font-mono text-xs font-black " + (row.HasRun ? "text-zinc-200" : "text-zinc-700"),
                                        children: row.HasRun ? (`${row.Wins}-${row.Losses}`) : "—",
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_260))])]))));
                                }, indexed(leagueRows)))), ["children", reactApi.Children.toArray(Array.from(elems_261))])]))));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_262))])])))), delay(() => {
                            let value_2871;
                            return append_1(singleton_2(createElement("button", createObj(ofArray([(value_2871 = "mt-4 w-full rounded-xl bg-orange-500 py-3 text-xs font-black uppercase tracking-widest text-zinc-950 transition-all hover:bg-orange-400 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", ["className", value_2871]), ["disabled", leagueBusy ? true : isEmpty(state.UserRuns)], ["onClick", (_arg_112) => {
                                const matchValue_108 = state.UserRuns;
                                let matchResult_8, latest_1;
                                if (!isEmpty(matchValue_108)) {
                                    if (!leagueBusy) {
                                        matchResult_8 = 0;
                                        latest_1 = head(matchValue_108);
                                    }
                                    else {
                                        matchResult_8 = 1;
                                    }
                                }
                                else {
                                    matchResult_8 = 1;
                                }
                                switch (matchResult_8) {
                                    case 0: {
                                        setLeagueBusy(true);
                                        setLeagueMsg(undefined);
                                        Backend_submitRunToLeague(league_1.Id, latest_1, (result_5) => {
                                            setLeagueBusy(false);
                                            if (result_5.tag === 1) {
                                                setLeagueMsg(new FSharpResult$2(1, [result_5.fields[0]]));
                                            }
                                            else {
                                                setLeagueMsg(new FSharpResult$2(0, [`Submitted your latest season (${latest_1.Record}).`]));
                                                openLeague(league_1);
                                            }
                                        });
                                        break;
                                    }
                                    case 1: {
                                        break;
                                    }
                                }
                            }], ["children", leagueBusy ? "Submitting…" : (isEmpty(state.UserRuns) ? "Finish a season to submit one" : "Submit my latest season")]])))), delay(() => {
                                let matchValue_109, copyOfStruct_1;
                                return append_1((matchValue_109 = leagueMsg, (matchValue_109 == null) ? singleton_2(defaultOf_1()) : ((copyOfStruct_1 = matchValue_109, (copyOfStruct_1.tag === 1) ? singleton_2(createElement("div", {
                                    className: "mt-2 text-[11px] font-semibold text-red-400",
                                    children: copyOfStruct_1.fields[0],
                                })) : singleton_2(createElement("div", {
                                    className: "mt-2 text-[11px] font-semibold text-emerald-400",
                                    children: copyOfStruct_1.fields[0],
                                }))))), delay(() => {
                                    let elems_263, value_2888, value_2893;
                                    return singleton_2(createElement("div", createObj(ofArray([["className", "mt-3 flex gap-2"], (elems_263 = [createElement("button", createObj(ofArray([(value_2888 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-400 transition-all hover:border-zinc-700 cursor-pointer", ["className", value_2888]), ["onClick", (_arg_113) => {
                                        openLeague(league_1);
                                    }], ["children", "🔄 Refresh table"]]))), createElement("button", createObj(ofArray([(value_2893 = "flex-1 rounded-xl border border-zinc-800 bg-zinc-900/40 py-2.5 text-[11px] font-semibold text-zinc-400 transition-all hover:border-zinc-700 cursor-pointer", ["className", value_2893]), ["onClick", (_arg_114) => {
                                        setActiveLeague(undefined);
                                        setLeagueMsg(undefined);
                                    }], ["children", "← All leagues"]])))], ["children", reactApi.Children.toArray(Array.from(elems_263))])]))));
                                }));
                            }));
                        }));
                    }))));
                })), ["children", reactApi.Children.toArray(Array.from(elems_264))])]))))))), delay(() => append_1(singleton_2(leagueStepCard("⚙️", "1. You set the rules", "Pick the settings once: eras, difficulty, all of it. Everyone in your league plays the exact same rules, so it\'s a fair fight.")), delay(() => append_1(singleton_2(leagueStepCard("🔮", "2. Everyone builds a team", "You and each mate build your own team of 8 basketball players. Pick legends from any franchise, any era.")), delay(() => append_1(singleton_2(leagueStepCard("🏆", "3. Best team wins", "The game plays a full season for each team. Best win-loss record tops the league standings. Share the link and see who comes out on top.")), delay(() => {
                    let value_3001;
                    return singleton_2(createElement("button", createObj(ofArray([(value_3001 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3001]), ["onClick", (_arg_118) => {
                        Actions_navigateToHome(setState);
                    }], ["children", "← Home"]]))));
                }))))))));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_273))])])));
    let leagueRulesConfigPage;
    const patternInput_49 = reactApi.useState(false);
    const setIsOngoing = patternInput_49[1];
    const isOngoing = patternInput_49[0];
    const groupLabel = (label_24) => createElement("span", {
        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-2 text-left",
        children: label_24,
    });
    const choiceGroupSub = (label_27, gridCols, options_1) => {
        let elems_276, elems_275;
        return createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_276 = [groupLabel(label_27), createElement("div", createObj(ofArray([["className", "grid gap-2 " + gridCols], (elems_275 = map((tupledArg_30) => {
            let elems_274;
            const active_3 = tupledArg_30[2];
            const label_26 = tupledArg_30[0];
            const sub_1 = tupledArg_30[1];
            return createElement("div", createObj(ofArray([["key", label_26], ["className", active_3 ? "bg-orange-500/10 border border-orange-500/60 py-3 px-3 rounded-xl text-center" : "bg-zinc-900/20 border border-zinc-800 py-3 px-3 rounded-xl text-center"], (elems_274 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                className: active_3 ? "text-orange-400 text-xs font-black block" : "text-zinc-400 text-xs font-bold block",
                children: label_26,
            })), delay(() => ((sub_1 !== "") ? singleton_2(createElement("span", {
                className: "text-zinc-600 text-[9px] font-medium block mt-0.5",
                children: sub_1,
            })) : empty_2()))))), ["children", reactApi.Children.toArray(Array.from(elems_274))])])));
        }, options_1), ["children", reactApi.Children.toArray(Array.from(elems_275))])])))], ["children", reactApi.Children.toArray(Array.from(elems_276))])])));
    };
    const groupNote = (body_5) => createElement("span", {
        className: "text-zinc-600 text-[10px] font-medium leading-relaxed block mt-2 text-left",
        children: body_5,
    });
    const leagueKindBox = (active_5, label_28, sub_3, select) => {
        let elems_277;
        return createElement("div", createObj(ofArray([["key", label_28], ["className", (active_5 ? "bg-orange-500/10 border border-orange-500/60" : "bg-zinc-900/20 border border-zinc-800 hover:border-zinc-700") + " py-3 px-3 rounded-xl text-center cursor-pointer transition-all"], ["onClick", (_arg_119) => {
            select();
        }], (elems_277 = [createElement("span", {
            className: active_5 ? "text-orange-400 text-xs font-black block" : "text-zinc-400 text-xs font-bold block",
            children: label_28,
        }), createElement("span", {
            className: "text-zinc-600 text-[9px] font-medium block mt-0.5",
            children: sub_3,
        })], ["children", reactApi.Children.toArray(Array.from(elems_277))])])));
    };
    const presetChip = (active_6, name_1507) => createElement("div", {
        key: name_1507,
        className: active_6 ? "bg-orange-500/5 border border-orange-500/40 text-orange-400 text-[10px] font-bold py-1.5 px-3 rounded-lg" : "bg-zinc-900/20 border border-zinc-800 text-zinc-400 text-[10px] font-bold py-1.5 px-3 rounded-lg",
        children: name_1507,
    });
    const pacingCard = (active_7, label_29, sub_4) => {
        let elems_278;
        return createElement("div", createObj(ofArray([["key", label_29], ["className", active_7 ? "bg-orange-500/10 border border-orange-500/60 p-4 rounded-xl text-left" : "bg-zinc-900/20 border border-zinc-800 p-4 rounded-xl text-left"], (elems_278 = [createElement("span", {
            className: active_7 ? "text-orange-400 text-xs font-black block mb-0.5" : "text-zinc-300 text-xs font-black block mb-0.5",
            children: label_29,
        }), createElement("span", {
            className: "text-zinc-500 text-[10px] font-medium leading-relaxed block",
            children: sub_4,
        })], ["children", reactApi.Children.toArray(Array.from(elems_278))])])));
    };
    const stepLine = (n_1, body_6) => {
        let elems_281;
        return createElement("div", createObj(ofArray([["key", int32ToString(n_1)], ["className", "flex items-start gap-2.5"], (elems_281 = [createElement("span", {
            className: "text-orange-500 font-mono text-[11px] font-black shrink-0",
            children: int32ToString(n_1) + ".",
        }), createElement("span", {
            className: "text-zinc-400 text-[11px] leading-relaxed font-medium",
            children: body_6,
        })], ["children", reactApi.Children.toArray(Array.from(elems_281))])])));
    };
    const textField = (label_31, placeholder) => {
        let elems_282, value_3094;
        return createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_282 = [groupLabel(label_31), createElement("input", createObj(ofArray([(value_3094 = "w-full bg-zinc-900/40 border border-zinc-800 focus:border-orange-500/60 rounded-xl px-4 py-3.5 text-white placeholder-zinc-700 text-sm font-medium tracking-wide outline-none transition-colors", ["className", value_3094]), ["placeholder", placeholder]])))], ["children", reactApi.Children.toArray(Array.from(elems_282))])])));
    };
    leagueRulesConfigPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col gap-6 pt-8 pb-12 px-4 font-sans select-none"], (elems_295 = toList_1(delay(() => {
        let value_3101;
        return append_1(singleton_2(createElement("div", createObj(ofArray([(value_3101 = "bg-emerald-950/40 border border-emerald-900/60 text-emerald-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full flex items-center gap-1.5 w-fit select-none mx-auto", ["className", value_3101]), ["children", "● LEAGUE"]])))), delay(() => {
            let elems_283;
            return append_1(singleton_2(createElement("div", createObj(singleton((elems_283 = [createElement("h1", {
                className: "text-white text-3xl font-black text-center mb-1",
                children: "Set the rules",
            }), createElement("span", {
                className: "text-zinc-500 text-xs text-center leading-relaxed max-w-md mx-auto block mb-6",
                children: "Everyone plays these settings. Only the team differs. You pick your lineup style when you play.",
            })], ["children", reactApi.Children.toArray(Array.from(elems_283))]))))), delay(() => {
                let elems_285, elems_284;
                return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_285 = [groupLabel("What kind of league?"), createElement("div", createObj(ofArray([["className", "grid gap-2 grid-cols-2"], (elems_284 = [leagueKindBox(!isOngoing, "One-off", "One table. A deadline. Most wins tops it.", () => {
                    setIsOngoing(false);
                }), leagueKindBox(isOngoing, "Ongoing", "A new challenge every day. Table updates itself.", () => {
                    setIsOngoing(true);
                })], ["children", reactApi.Children.toArray(Array.from(elems_284))])])))], ["children", reactApi.Children.toArray(Array.from(elems_285))])])))), delay(() => {
                    let value_3120, value_3122, elems_289, elems_288;
                    return append_1(isOngoing ? append_1(singleton_2(createElement("div", createObj(ofArray([(value_3120 = "w-full bg-zinc-900/30 border border-zinc-900/60 p-4 rounded-xl text-left text-xs text-zinc-400 font-medium leading-relaxed mb-4", ["className", value_3120]), (value_3122 = "Create a league, everyone submits a team each day, and the standings table updates automatically. It keeps running until you end it.", ["children", value_3122])])))), delay(() => {
                        let elems_287, elems_286;
                        return singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_287 = [groupLabel("How often does a new challenge drop?"), createElement("div", createObj(ofArray([["className", "grid gap-2 grid-cols-2"], (elems_286 = [pacingCard(true, "Daily", "A new standard challenge day."), pacingCard(false, "Weekly", "For teams who play slowly.")], ["children", reactApi.Children.toArray(Array.from(elems_286))])])))], ["children", reactApi.Children.toArray(Array.from(elems_287))])]))));
                    })) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full bg-zinc-900/40 border border-zinc-800 rounded-2xl p-5 text-left"], (elems_289 = [groupLabel("How your league works"), createElement("div", createObj(ofArray([["className", "flex flex-col gap-1.5"], (elems_288 = [stepLine(1, "Set the rules below"), stepLine(2, "Play your own team first"), stepLine(3, "Share the link with your mates"), stepLine(4, "They play the exact same rules"), stepLine(5, "Best win record by the deadline wins")], ["children", reactApi.Children.toArray(Array.from(elems_288))])])))], ["children", reactApi.Children.toArray(Array.from(elems_289))])])))), delay(() => append_1(singleton_2(textField("Your name", "e.g. Aiden")), delay(() => {
                        let elems_292, elems_290, elems_291;
                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_292 = [textField("League name", "e.g. Pace & Space"), createElement("div", createObj(ofArray([["className", "flex flex-wrap gap-2 mt-3"], (elems_290 = (isOngoing ? ofArray([presetChip(true, "The Triangle Offense"), presetChip(false, "Run & Gun"), presetChip(false, "ISO Ball")]) : ofArray([presetChip(true, "Row 2"), presetChip(true, "Pace & Space"), presetChip(true, "Grit & Grind")])), ["children", reactApi.Children.toArray(Array.from(elems_290))])]))), createElement("label", createObj(ofArray([["className", "flex items-center gap-2 mt-3 w-fit"], (elems_291 = [createElement("input", {
                            type: "checkbox",
                            className: "h-3.5 w-3.5 accent-orange-500",
                        }), createElement("span", {
                            className: "text-zinc-500 text-[11px] font-medium",
                            children: "Shuffle names",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_291))])])))], ["children", reactApi.Children.toArray(Array.from(elems_292))])])))), delay(() => {
                            let elems_280, elems_279;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full text-left"], (elems_280 = [groupLabel("Who\'s it for?"), createElement("div", createObj(ofArray([["className", "grid gap-2 grid-cols-2"], (elems_279 = map((tupledArg_31) => {
                                const label_25 = tupledArg_31[0];
                                return createElement("div", {
                                    key: label_25,
                                    className: tupledArg_31[1] ? "bg-orange-500/10 border border-orange-500/60 text-orange-400 text-xs font-black py-3 px-3 rounded-xl text-center" : "bg-zinc-900/20 border border-zinc-800 text-zinc-400 text-xs font-bold py-3 px-3 rounded-xl text-center",
                                    children: label_25,
                                });
                            }, ofArray([["Mates", true], ["Work", false], ["Family", false], ["The Squad", false], ["Uni", false], ["The Group Chat", false], ["Neighbours", false], ["The Pub", false]])), ["children", reactApi.Children.toArray(Array.from(elems_279))])])))], ["children", reactApi.Children.toArray(Array.from(elems_280))])])))), delay(() => append_1(singleton_2(choiceGroupSub("Player ratings", "grid-cols-2", ofArray([["Season", "their rating that year", true], ["Prime", "their best-ever rating", false]]))), delay(() => append_1(singleton_2(choiceGroupSub("Difficulty", "grid-cols-3", ofArray([["Easy", `${rerollsFor(new Difficulty(0, []))} re-rolls`, false], ["Normal", `${rerollsFor(new Difficulty(1, []))} re-roll`, true], ["Hard", "no re-rolls", false]]))), delay(() => append_1(singleton_2(choiceGroupSub("Show ratings", "grid-cols-2", ofArray([["On", "player overalls visible", true], ["Off", "blind mode, trust your gut", false]]))), delay(() => append_1(singleton_2(choiceGroupSub("Eras", "grid-cols-2", ofArray([["All eras", "every season", true], ["2000s onwards", "2000–2026", false], ["2010s onwards", "2010–2026", false], ["Modern", "2016–2026", false]]))), delay(() => append_1(singleton_2(choiceGroupSub("Max players", "grid-cols-2", ofArray([["Just us (2)", "", false], ["Up to 10", "", false], ["Up to 50", "", false], ["No limit", "go viral", true]]))), delay(() => {
                                let value_3153;
                                return append_1(isOngoing ? singleton_2(createElement("div", createObj(ofArray([(value_3153 = "w-full bg-zinc-900/20 border border-zinc-900/60 hover:border-zinc-800 p-4 rounded-xl flex items-center justify-between text-zinc-500 font-bold text-xs cursor-pointer select-none transition-all", ["className", value_3153]), ["children", "▶ HOW THE STANDINGS TABLE WORKS"]])))) : empty_2(), delay(() => {
                                    let elems_293;
                                    return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full"], (elems_293 = [choiceGroupSub("Who can join?", "grid-cols-2", ofArray([["Signed-in only", "one entry each, no dupes", false], ["Anyone", "no account needed", true]])), groupNote("Recommended: everyone signs in, so each mate keeps one entry across all their devices.")], ["children", reactApi.Children.toArray(Array.from(elems_293))])])))), delay(() => {
                                        let elems_294;
                                        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "w-full"], (elems_294 = [choiceGroupSub("Scoring", "grid-cols-2", ofArray([["Latest run counts", "replays replace your score", true], ["Best run counts", "your highest score stands", false]])), groupNote("Riskier: every replay replaces your score, win or lose. Hold your nerve. Locked once the league is created.")], ["children", reactApi.Children.toArray(Array.from(elems_294))])])))), delay(() => append_1(!isOngoing ? singleton_2(choiceGroupSub("Open for", "grid-cols-2", ofArray([["15 minutes", "lightning", false], ["30 minutes", "blitz", false], ["1 hour", "quick", false], ["3 hours", "tonight", false], ["6 hours", "this evening", false], ["12 hours", "by tomorrow", false], ["24 hours", "a day", false], ["3 days", "a weekend", true], ["1 week", "no rush", false], ["No deadline", "stays open", false]]))) : empty_2(), delay(() => {
                                            let value_3165;
                                            return append_1(singleton_2(createElement("button", createObj(ofArray([["disabled", true], (value_3165 = "w-full bg-emerald-500 hover:bg-emerald-600 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-not-allowed opacity-90 block text-center shadow-lg shadow-emerald-500/5", ["className", value_3165]), ["children", "Create league & play"]])))), delay(() => {
                                                let value_3171;
                                                return append_1(singleton_2(createElement("span", createObj(ofArray([["className", "text-zinc-600 text-[10px] font-medium tracking-wide block text-center -mt-2"], (value_3171 = "Custom rules are still being wired to the league server — quick leagues (name + join code) are live today.", ["children", value_3171])])))), delay(() => {
                                                    let value_3173;
                                                    return append_1(singleton_2(createElement("button", createObj(ofArray([(value_3173 = "w-full border border-zinc-800 bg-zinc-900/40 text-zinc-300 font-bold text-xs py-3 rounded-xl transition-all cursor-pointer hover:border-zinc-700 block text-center", ["className", value_3173]), ["onClick", (_arg_120) => {
                                                        Actions_navigateToLeaguesSetup(setState);
                                                    }], ["children", "Create a quick league instead ➔"]])))), delay(() => {
                                                        let value_3178;
                                                        return singleton_2(createElement("button", createObj(ofArray([(value_3178 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3178]), ["onClick", (_arg_121) => {
                                                            Actions_navigateToLeaguesSetup(setState);
                                                        }], ["children", "← Leagues"]]))));
                                                    }));
                                                }));
                                            }));
                                        }))));
                                    }));
                                }));
                            }))))))))))));
                        }));
                    }))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_295))])])));
    let franchiseModePage;
    const infoLine = (body_7) => createElement("span", {
        key: body_7,
        className: "text-zinc-400 text-[11px] leading-relaxed font-medium block text-left",
        children: body_7,
    });
    const infoHeading = (heading_5) => createElement("span", {
        key: heading_5,
        className: "text-orange-400 text-[10px] font-black tracking-widest uppercase block text-left mt-3 first:mt-0",
        children: heading_5,
    });
    franchiseModePage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col items-center text-center pt-8 pb-12 px-4 font-sans"], (elems_300 = [createElement("div", createObj(ofArray([(value_3228 = "bg-orange-950/40 border border-orange-900/60 text-orange-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-6 flex items-center gap-1.5 w-fit select-none", ["className", value_3228]), ["children", "● ONE-FRANCHISE ROSTER"]]))), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-2",
        children: "One franchise. Eight legends.",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-sm font-medium leading-relaxed max-w-md block mb-6"], (value_3238 = "Pick a single NBA franchise and build your whole eight-man rotation from that team\'s history alone. No borrowing a rival\'s superstar — your dynasty, your colours, your problem.", ["children", value_3238])]))), createElement("div", createObj(ofArray([["className", "w-full rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5 mb-6 flex flex-col gap-1.5"], (elems_298 = [infoHeading("How it works"), infoLine("Choose a franchise and you can only draft players who actually suited up for it. You get one real player per slot, in a rotation that franchise can genuinely ice. Build your eight, then simulate a full 82-game season and chase the perfect record: 82 played, 82 won. Everyone is rated by the season they actually played for the team, so Prime (career-best ratings) isn\'t available in this mode."), infoHeading("Trophies to chase"), infoLine("🏆 82-0 Immortality: win every game of the season."), infoLine("🏅 Franchise Record Breaker: out-win your franchise\'s real best-ever season."), infoLine("🪦 Franchise Worst Ever: finish below your franchise\'s real worst-ever season (for the brave)."), infoLine("All the standard Banner Season trophies are still up for grabs too."), infoHeading("Good to know"), infoLine("🎡 The wheel still spins — it just only lands on your franchise\'s draftable squads. Rerolls and both draft modes work as normal."), infoLine("📊 Your team replaces your franchise in the final league standings."), infoLine("🤝 Not available in multiplayer yet: One-Franchise Roster is a solo mode for now.")], ["children", reactApi.Children.toArray(Array.from(elems_298))])]))), createElement("span", {
        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-3 text-left w-full pl-1",
        children: `Pick your franchise (${length(franchises)})`,
    }), createElement("div", createObj(ofArray([["className", "w-full grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8"], (elems_299 = map((franchise_5) => {
        let poolId, prefix, elems_297, elems_296;
        const pools = choose((key_1789) => FSharpMap__TryFind(poolById, key_1789), franchise_5.PoolIds);
        const star_1 = maxBy((p_25) => p_25.Ovr, collect((pool_20) => pool_20.Options, pools), {
            Compare: comparePrimitives,
        });
        const poolNames_1 = join(" · ", map((p_26) => p_26.TeamName, pools));
        return createElement("button", createObj(ofArray([["key", franchise_5.Key], ["className", "bg-gradient-to-br border p-4 rounded-2xl text-left transition-all hover:brightness-110 hover:scale-[1.02] flex flex-col gap-1 cursor-pointer " + ((poolId = defaultArg(tryHead(franchise_5.PoolIds), ""), (prefix = ((poolId.length >= 3) ? substring(poolId, 0, 3) : poolId), (prefix === "BOS") ? "from-green-700 to-green-950 border-green-500/40" : ((prefix === "NJN") ? "from-slate-600 to-slate-900 border-slate-400/40" : ((prefix === "NYK") ? "from-blue-700 to-orange-800 border-blue-500/40" : ((prefix === "PHI") ? "from-blue-700 to-red-900 border-blue-500/40" : ((prefix === "TOR") ? "from-red-700 to-red-950 border-red-500/40" : ((prefix === "CHI") ? "from-red-600 to-red-950 border-red-500/40" : ((prefix === "CLE") ? "from-rose-800 to-amber-950 border-rose-500/40" : ((prefix === "DET") ? "from-blue-700 to-red-800 border-blue-500/40" : ((prefix === "IND") ? "from-blue-800 to-yellow-800 border-yellow-500/40" : ((prefix === "MIL") ? "from-emerald-800 to-emerald-950 border-emerald-500/40" : ((prefix === "ATL") ? "from-red-600 to-yellow-900 border-red-500/40" : ((prefix === "CHA") ? "from-teal-600 to-purple-950 border-teal-400/40" : ((prefix === "MIA") ? "from-red-700 to-zinc-950 border-red-500/40" : ((prefix === "ORL") ? "from-blue-600 to-blue-950 border-blue-400/40" : ((prefix === "WSB") ? "from-red-700 to-blue-950 border-red-500/40" : ((prefix === "DEN") ? "from-sky-600 to-yellow-800 border-sky-400/40" : ((prefix === "MIN") ? "from-blue-900 to-emerald-900 border-emerald-500/40" : ((prefix === "SEA") ? "from-emerald-700 to-yellow-900 border-emerald-500/40" : ((prefix === "POR") ? "from-red-600 to-zinc-950 border-red-500/40" : ((prefix === "UTA") ? "from-purple-800 to-sky-950 border-purple-400/40" : ((prefix === "GSW") ? "from-blue-600 to-yellow-700 border-blue-400/40" : ((prefix === "LAL") ? "from-violet-700 to-amber-600 border-violet-400/40" : ((prefix === "LAC") ? "from-red-600 to-blue-900 border-red-500/40" : ((prefix === "PHX") ? "from-orange-600 to-purple-950 border-orange-400/40" : ((prefix === "SAC") ? "from-purple-700 to-zinc-900 border-purple-400/40" : ((prefix === "DAL") ? "from-blue-600 to-blue-950 border-blue-400/40" : ((prefix === "HOU") ? "from-red-600 to-red-950 border-red-500/40" : ((prefix === "MEM") ? "from-sky-800 to-slate-950 border-sky-500/40" : ((prefix === "NOH") ? "from-teal-700 to-yellow-900 border-teal-400/40" : ((prefix === "SAS") ? "from-zinc-500 to-zinc-900 border-zinc-400/40" : ((prefix === "PRO") ? "from-amber-700 to-zinc-950 border-amber-500/40" : ((prefix === "SDR") ? "from-emerald-600 to-emerald-950 border-emerald-400/40" : ((prefix === "OKC") ? "from-sky-600 to-orange-800 border-sky-400/40" : "from-zinc-800 to-zinc-950 border-zinc-700/60")))))))))))))))))))))))))))))))))))], ["onClick", (_arg_122) => {
            Actions_beginFranchiseSetup(setState, franchise_5);
        }], (elems_297 = [createElement("span", {
            className: "text-white/60 text-[9px] font-black tracking-widest uppercase",
            children: poolNames_1,
        }), createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-2"], (elems_296 = [createElement("span", {
            className: "text-white text-sm font-black tracking-tight",
            children: franchise_5.Name,
        }), createElement("span", {
            className: "text-white/50 shrink-0",
            children: "→",
        })], ["children", reactApi.Children.toArray(Array.from(elems_296))])]))), createElement("span", {
            className: "text-white/70 text-[10px] font-medium",
            children: `⭐ ${star_1.Name} · ${star_1.Ovr} OVR`,
        }), createElement("span", {
            className: "text-white/50 text-[9px] font-semibold",
            children: `🏅 Best ${franchise_5.BestWins}W · 🪦 Worst ${franchise_5.WorstWins}W`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_297))])])));
    }, franchises), ["children", reactApi.Children.toArray(Array.from(elems_299))])]))), createElement("button", createObj(ofArray([(value_3250 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3250]), ["onClick", (_arg_123) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Home"]])))], ["children", reactApi.Children.toArray(Array.from(elems_300))])])));
    let dailyChallengePage;
    const today = now();
    const dailyProgress = Store_dailyProgressToday();
    const poolCount = length(historicalRegistry) | 0;
    const featured = item(dayOfYear(today) % poolCount, historicalRegistry);
    const yesterday = item(((dayOfYear(today) + poolCount) - 1) % poolCount, historicalRegistry);
    const featuredStar = maxBy((p_27) => p_27.Ovr, featured.Options, {
        Compare: comparePrimitives,
    });
    const untilReset = op_Subtraction(addDays(date_1(today), 1), today);
    const ruleRow = (glyph, rule) => {
        let elems_301;
        return createElement("div", createObj(ofArray([["key", rule], ["className", "w-full bg-zinc-900/10 border border-zinc-900/60 p-4 rounded-xl flex items-center gap-3 text-left"], (elems_301 = [createElement("span", {
            className: "text-base shrink-0 select-none",
            children: glyph,
        }), createElement("span", {
            className: "text-zinc-400 text-[11px] leading-relaxed font-medium",
            children: rule,
        })], ["children", reactApi.Children.toArray(Array.from(elems_301))])])));
    };
    dailyChallengePage = createElement("div", createObj(ofArray([["className", "w-full max-w-md mx-auto flex flex-col items-center text-center pt-8 pb-12 px-4 font-sans"], (elems_315 = [createElement("div", createObj(ofArray([(value_3271 = "bg-orange-950/40 border border-orange-900/60 text-orange-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-6 flex items-center gap-1.5 w-fit select-none animate-pulse", ["className", value_3271]), ["children", `● DAILY CHALLENGE · DAY ${dayOfYear(today)}`]]))), createElement("span", {
        className: "text-zinc-500 font-mono text-[11px] font-bold tracking-wide block -mt-3 mb-4",
        children: toText(interpolate("⏳ Refreshes in %P()h %02d%P()m · new franchise at midnight", [hours(untilReset), minutes(untilReset)])),
    }), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-2",
        children: "Today\'s puzzle",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-sm font-medium leading-relaxed max-w-sm block mb-6"], (value_3285 = "One franchise, one go, fresh every midnight. Everyone in the world gets the same squad today — build the best rotation you can from it.", ["children", value_3285])]))), createElement("div", createObj(ofArray([["className", "w-full bg-zinc-900/40 border border-orange-500/30 rounded-2xl p-5 text-left mb-6"], (elems_304 = [createElement("span", {
        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mb-1",
        children: "Today\'s franchise",
    }), createElement("span", {
        className: "text-white text-2xl font-black tracking-tight block mb-3",
        children: `${featured.City} ${featured.TeamName}`,
    }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-1.5"], (elems_303 = map((player_29) => {
        let elems_302;
        return createElement("div", createObj(ofArray([["key", player_29.Id], ["className", "flex items-center justify-between gap-3"], (elems_302 = [createElement("span", {
            className: "text-zinc-300 text-xs font-semibold",
            children: `${player_29.Name} · ${player_29.Pos}`,
        }), createElement("span", {
            className: "text-orange-500 text-xs font-black font-mono",
            children: int32ToString(player_29.Ovr),
        })], ["children", reactApi.Children.toArray(Array.from(elems_302))])])));
    }, featured.Options), ["children", reactApi.Children.toArray(Array.from(elems_303))])])))], ["children", reactApi.Children.toArray(Array.from(elems_304))])]))), createElement("div", createObj(ofArray([["className", "w-full bg-zinc-900/40 border border-zinc-800 rounded-2xl p-5 text-left mb-3"], (elems_308 = [createElement("span", {
        className: "text-orange-400 text-[10px] font-black tracking-widest uppercase block mb-2",
        children: "Required",
    }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_307 = toList_1(delay(() => {
        let elems_305;
        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center gap-2.5"], (elems_305 = [createElement("span", {
            className: "text-base shrink-0 select-none",
            children: "⭐",
        }), createElement("span", {
            className: "text-zinc-200 text-[11px] leading-relaxed font-bold",
            children: `${featuredStar.Name} starts in your lineup`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_305))])])))), delay(() => map_1((requirement) => {
            let elems_306;
            return createElement("div", createObj(ofArray([["key", requirement], ["className", "flex items-center gap-2.5"], (elems_306 = [createElement("span", {
                className: "text-zinc-700 shrink-0 select-none",
                children: "○",
            }), createElement("span", {
                className: "text-zinc-400 text-[11px] leading-relaxed font-medium",
                children: requirement,
            })], ["children", reactApi.Children.toArray(Array.from(elems_306))])])));
        }, [`0/1 · 1 other ${featured.City} ${featured.TeamName} pick`, `0/1 · 1 other player at ${featuredStar.Pos}`, "0/1 · 1 other pick from the same decade"])));
    })), ["children", reactApi.Children.toArray(Array.from(elems_307))])]))), createElement("span", {
        className: "text-zinc-600 text-[10px] font-medium leading-relaxed block mt-3",
        children: "Bonus: more players who fit the brief improve your challenge score.",
    })], ["children", reactApi.Children.toArray(Array.from(elems_308))])]))), createElement("div", createObj(ofArray([["className", "w-full grid grid-cols-3 gap-2 mb-6"], (elems_312 = [createElement("div", createObj(ofArray([["className", "bg-zinc-900/20 border border-zinc-800 py-3 px-3 rounded-xl text-center"], (elems_309 = [createElement("span", {
        className: "text-zinc-600 text-[9px] font-black tracking-widest uppercase block",
        children: "Attempts left",
    }), createElement("span", {
        className: "text-white text-sm font-black font-mono block",
        children: `${dailyAttemptsPerDay - dailyProgress.AttemptsUsed}/${dailyAttemptsPerDay}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems_309))])]))), createElement("div", createObj(ofArray([["className", "bg-zinc-900/20 border border-zinc-800 py-3 px-3 rounded-xl text-center"], (elems_310 = [createElement("span", {
        className: "text-zinc-600 text-[9px] font-black tracking-widest uppercase block",
        children: "Best today",
    }), createElement("span", {
        className: "text-white text-sm font-black font-mono block",
        children: (dailyProgress.AttemptsUsed > 0) ? (`${dailyProgress.BestScore}/8`) : "—",
    })], ["children", reactApi.Children.toArray(Array.from(elems_310))])]))), createElement("div", createObj(ofArray([["className", "bg-zinc-900/20 border border-zinc-800 py-3 px-3 rounded-xl text-center"], (elems_311 = [createElement("span", {
        className: "text-zinc-600 text-[9px] font-black tracking-widest uppercase block",
        children: "Streak",
    }), createElement("span", {
        className: "text-white text-sm font-black font-mono block",
        children: `🔥 ${dailyProgress.Streak}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems_311))])])))], ["children", reactApi.Children.toArray(Array.from(elems_312))])]))), createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-2 mb-3"], (elems_313 = [ruleRow("🎯", "Five attempts per day. No second chances after that until midnight."), ruleRow("🌍", "Same featured franchise for every player on Earth."), ruleRow("🔥", "Win streaks carry over — miss a day and the streak resets.")], ["children", reactApi.Children.toArray(Array.from(elems_313))])]))), createElement("div", createObj(ofArray([(value_3391 = "w-full bg-zinc-900/10 border border-zinc-900/60 py-2.5 px-4 rounded-xl flex items-center justify-between gap-3 mb-6", ["className", value_3391]), (elems_314 = [createElement("span", {
        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase shrink-0",
        children: "Yesterday",
    }), createElement("span", {
        className: "text-zinc-400 text-[11px] font-semibold truncate",
        children: `${yesterday.City} ${yesterday.TeamName}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems_314))])]))), createElement("button", {
        disabled: dailyProgress.AttemptsUsed >= dailyAttemptsPerDay,
        className: (dailyProgress.AttemptsUsed >= dailyAttemptsPerDay) ? "w-full bg-zinc-800 text-zinc-600 font-black font-sans text-xs py-4 rounded-xl cursor-not-allowed flex justify-center items-center gap-2" : "w-full bg-emerald-500 hover:bg-emerald-600 text-black font-black font-sans text-xs py-4 rounded-xl transition-all cursor-pointer flex justify-center items-center gap-2 shadow-lg shadow-emerald-500/5",
        onClick: (_arg_124) => {
            setActiveSlot(undefined);
            Actions_startDailyChallenge(setState);
        },
        children: (dailyProgress.AttemptsUsed >= dailyAttemptsPerDay) ? "No attempts left — new puzzle at midnight" : "Play today\'s challenge ➔",
    }), createElement("span", {
        className: "text-zinc-600 text-[10px] font-medium tracking-wide mt-3 mb-6 block select-none",
        children: "Scores are saved on this device; the shared world board arrives with accounts.",
    }), createElement("button", createObj(ofArray([(value_3413 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3413]), ["onClick", (_arg_125) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Home"]])))], ["children", reactApi.Children.toArray(Array.from(elems_315))])])));
    let eraChallengePage;
    const poolsBetween = (fromYear, toYear) => length(filter((pool_22) => {
        let value_3419;
        let year;
        let matchValue_111;
        let outArg_1 = 0;
        matchValue_111 = [tryParse((value_3419 = toArray(truncate_1(2, filter_2(isDigit, pool_22.TeamName.split("")))), value_3419.join('')), 511, false, 32, new FSharpRef(() => outArg_1, (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1];
        year = (matchValue_111[0] ? ((matchValue_111[1] >= 47) ? (1900 + matchValue_111[1]) : (2000 + matchValue_111[1])) : 0);
        if (year >= fromYear) {
            return year <= toYear;
        }
        else {
            return false;
        }
    }, historicalRegistry));
    const eraCard = (title_9, span, fromYear_1, toYear_1, count_4, blurb_4) => {
        let value_3423, elems_317, elems_316, value_3431;
        return createElement("button", createObj(ofArray([["key", title_9], ["onClick", (_arg_126) => {
            Actions_beginEraSetup(setState, fromYear_1, toYear_1);
        }], (value_3423 = "w-full bg-zinc-900/10 border border-zinc-900/60 hover:border-orange-500/40 p-5 rounded-2xl text-left transition-all cursor-pointer", ["className", value_3423]), (elems_317 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3 mb-1"], (elems_316 = [createElement("span", {
            className: "text-white text-sm font-black tracking-tight",
            children: `${title_9} · ${span}`,
        }), createElement("span", createObj(ofArray([(value_3431 = "bg-orange-950/40 border border-orange-900/40 text-orange-400 text-[9px] font-mono font-black tracking-wider uppercase px-2 py-0.5 rounded-md shrink-0", ["className", value_3431]), ["children", `${count_4} squads`]])))], ["children", reactApi.Children.toArray(Array.from(elems_316))])]))), createElement("span", {
            className: "text-zinc-400 text-[11px] leading-relaxed font-medium block",
            children: blurb_4,
        })], ["children", reactApi.Children.toArray(Array.from(elems_317))])])));
    };
    eraChallengePage = createElement("div", createObj(ofArray([["className", "w-full max-w-md mx-auto flex flex-col items-center text-center pt-8 pb-12 px-4 font-sans"], (elems_320 = [createElement("div", createObj(ofArray([(value_3443 = "bg-amber-950/40 border border-amber-900/60 text-amber-400 text-[10px] font-mono font-black tracking-widest uppercase py-1 px-4 rounded-full mb-6 flex items-center gap-1.5 w-fit select-none animate-pulse", ["className", value_3443]), ["children", "● ERA CHALLENGE · LIMITED TIME"]]))), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-2",
        children: "Pick your decade",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-sm font-medium leading-relaxed max-w-sm block mb-6"], (value_3453 = "Lock the wheel to a single basketball era and go 82-0 with only its legends. Short-shorts hand-checkers or pace-and-space snipers — no mixing generations.", ["children", value_3453])]))), createElement("div", createObj(ofArray([["className", "w-full flex flex-col gap-3 mb-6"], (elems_318 = [eraCard("The Pioneers", "1947–1989", 1947, 1989, poolsBetween(1947, 1989), "Set shots, showtime fast breaks and the rivalries that built the league. Bird, Magic, Kareem and the founding dynasties."), eraCard("The 90s", "1990–1999", 1990, 1999, poolsBetween(1990, 1999), "Hand-check defence, post scoring and the Bulls dynasty at full power. The hardest era to score in — and to go unbeaten in."), eraCard("The 2000s", "2000–2009", 2000, 2009, poolsBetween(2000, 2009), "ISO ball, dominant bigs and the last era before the three-point revolution changed the geometry of the floor."), eraCard("The Modern Era", "2010–2024", 2010, 2024, poolsBetween(2010, 2024), "Pace, space and pull-up threes from the logo. Superteams, unicorns and the deepest talent pools in the registry.")], ["children", reactApi.Children.toArray(Array.from(elems_318))])]))), createElement("div", createObj(ofArray([["className", "w-full bg-zinc-900/40 border border-amber-900/40 rounded-2xl p-5 text-left mb-6 flex flex-col gap-2"], (elems_319 = [createElement("span", {
        className: "text-white text-sm font-black tracking-tight block",
        children: "Win the era. Keep the trophy.",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-400 text-[11px] leading-relaxed font-medium block"], (value_3466 = "🏆 Go unbeaten inside one era and the standard cabinet is yours to raid — an era-exclusive trophy is on the roadmap", ["children", value_3466])]))), createElement("span", {
        className: "text-zinc-400 text-[11px] leading-relaxed font-medium block",
        children: "💾 Save the run and track your era stats in your profile",
    }), createElement("span", {
        className: "text-zinc-400 text-[11px] leading-relaxed font-medium block",
        children: "⏳ Limited time: only while the Era Challenge is on",
    }), createElement("button", createObj(ofArray([(value_3476 = "text-orange-400 hover:text-orange-300 text-[11px] font-bold text-left transition-colors cursor-pointer mt-1 w-fit", ["className", value_3476]), ["onClick", (_arg_127) => {
        Actions_navigateToProfile(setState);
    }], ["children", "Sign in on your profile to keep trophies across sessions →"]])))], ["children", reactApi.Children.toArray(Array.from(elems_319))])]))), createElement("span", {
        className: "text-zinc-600 text-[10px] font-medium tracking-wide mt-3 mb-6 block select-none",
        children: "Pick an era above — the wheel locks to its seasons and the full Game Setup is yours before tip-off.",
    }), createElement("button", createObj(ofArray([(value_3486 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3486]), ["onClick", (_arg_128) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Home"]])))], ["children", reactApi.Children.toArray(Array.from(elems_320))])])));
    let leaderboardPage;
    const patternInput_50 = reactApi.useState(false);
    const showGlobal = patternInput_50[0];
    const setShowGlobal = patternInput_50[1];
    const patternInput_51 = reactApi.useState("All");
    const setFranchiseFilter = patternInput_51[1];
    const franchiseFilter = patternInput_51[0];
    const patternInput_52 = reactApi.useState(new Backend_BoardState(0, []));
    const setGlobalBoard = patternInput_52[1];
    const patternInput_53 = reactApi.useState(0);
    const retryTick = patternInput_53[0] | 0;
    const fetchSeq = reactApi.useRef(0);
    const onLeaderboard = equals(state.Phase, new ConsolePhase(35, []));
    const dependencies_25 = [onLeaderboard, showGlobal, franchiseFilter, retryTick];
    reactApi.useEffect(() => {
        if ((onLeaderboard && showGlobal) && Backend_isConfigured) {
            fetchSeq.current = (fetchSeq.current + 1);
            const ticket_1 = fetchSeq.current | 0;
            setGlobalBoard(new Backend_BoardState(1, []));
            Backend_fetchGlobal((franchiseFilter === "All") ? undefined : map_2((f_1) => f_1.PoolIds, tryFind((f) => (f.Name === franchiseFilter), franchises)), (result_8) => {
                if (fetchSeq.current === ticket_1) {
                    setGlobalBoard(result_8);
                }
            });
        }
    }, dependencies_25);
    const franchiseNameOf = (run_2) => defaultArg(map_2((f_2) => f_2.Name, franchiseOfPool(run_2.FranchiseId)), "");
    const filterChoices = sort(List_distinct(filter((name_1733) => (name_1733 !== ""), map(franchiseNameOf, state.UserRuns)), {
        Equals: (x_54, y_54) => (x_54 === y_54),
        GetHashCode: stringHash,
    }), {
        Compare: comparePrimitives,
    });
    const rankedRuns = sortByDescending((r_8) => [r_8.Wins, r_8.PointsPerGame], filter((r_7) => {
        if (franchiseFilter === "All") {
            return true;
        }
        else {
            return franchiseNameOf(r_7) === franchiseFilter;
        }
    }, state.UserRuns), {
        Compare: compareArrays,
    });
    const tabPill = (active_9, label_32, select_1) => createElement("button", {
        key: label_32,
        className: "px-4 py-1.5 rounded-full text-xs font-bold transition-all cursor-pointer " + (active_9 ? "bg-orange-500 text-zinc-950" : "bg-zinc-900/40 border border-zinc-800 text-zinc-400 hover:border-zinc-700"),
        onClick: (_arg_129) => {
            select_1();
        },
        children: label_32,
    });
    const boardNotice = (title_10, detail, extra_3) => {
        let elems_327;
        return createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-dashed border-zinc-800 px-6 py-10 text-center mb-6"], (elems_327 = append(ofArray([createElement("span", {
            className: "text-zinc-300 text-sm font-bold block mb-1",
            children: title_10,
        }), createElement("span", {
            className: "text-zinc-600 text-xs leading-relaxed block",
            children: detail,
        })]), extra_3), ["children", reactApi.Children.toArray(Array.from(elems_327))])])));
    };
    leaderboardPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col items-center text-center pt-8 pb-12 px-4 font-sans"], (elems_337 = toList_1(delay(() => append_1(singleton_2(createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-2",
        children: "Leaderboard",
    })), delay(() => append_1(singleton_2(createElement("span", {
        className: "text-zinc-500 text-sm font-medium leading-relaxed block mb-6",
        children: "Best all-time NBA rosters · ranked by wins.",
    })), delay(() => {
        let elems_328;
        return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center gap-2 mb-4"], (elems_328 = [tabPill(!showGlobal, "This device", () => {
            setShowGlobal(false);
            setFranchiseFilter("All");
        }), tabPill(showGlobal, "Global", () => {
            setShowGlobal(true);
            setFranchiseFilter("All");
        })], ["children", reactApi.Children.toArray(Array.from(elems_328))])])))), delay(() => {
            let value_3594, elems_329;
            const filterableNames = showGlobal ? (Backend_isConfigured ? sort(map((f_3) => f_3.Name, franchises), {
                Compare: comparePrimitives,
            }) : empty_1()) : filterChoices;
            return append_1(!isEmpty(filterableNames) ? singleton_2(createElement("select", createObj(ofArray([(value_3594 = "mb-6 rounded-xl border border-zinc-800 bg-zinc-900/60 px-3 py-2 text-xs font-semibold text-zinc-300 cursor-pointer", ["className", value_3594]), ["value", franchiseFilter], ["onChange", (ev_17) => {
                setFranchiseFilter(ev_17.target.value);
            }], (elems_329 = cons(createElement("option", {
                value: "All",
                children: "All franchises",
            }), map((name_1786) => createElement("option", {
                key: name_1786,
                value: name_1786,
                children: name_1786,
            }), filterableNames)), ["children", reactApi.Children.toArray(Array.from(elems_329))])])))) : empty_2(), delay(() => {
                let matchValue_112, value_3611, elems_332, value_3618, elems_330, elems_331, elems_333, elems_336, value_3654, elems_334, elems_335;
                return append_1(showGlobal ? (!Backend_isConfigured ? singleton_2(boardNotice("The global board isn\'t connected on this build", "This copy of the game has no leaderboard server behind it, so every season you simulate is ranked on the This device board. (Site owner: SUPABASE-SETUP.md walks through connecting one.)", empty_1())) : ((matchValue_112 = patternInput_52[0], (matchValue_112.tag === 1) ? singleton_2(boardNotice("Loading the global board…", "Fetching the best seasons posted by players everywhere.", empty_1())) : ((matchValue_112.tag === 3) ? singleton_2(boardNotice("Couldn\'t reach the leaderboard", matchValue_112.fields[0], singleton(createElement("button", createObj(ofArray([(value_3611 = "mt-4 inline-block rounded-full bg-orange-500 px-5 py-2 text-xs font-black text-zinc-950 cursor-pointer hover:bg-orange-400 transition-all", ["className", value_3611]), ["onClick", (_arg_130) => {
                    patternInput_53[1](retryTick + 1);
                }], ["children", "Retry"]])))))) : ((matchValue_112.tag === 2) ? (isEmpty(matchValue_112.fields[0]) ? singleton_2(boardNotice("No seasons posted here yet", "Finish a run and post it from the season screen — you\'d be first on this board.", empty_1())) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full overflow-hidden rounded-xl border border-zinc-800 mb-6"], (elems_332 = [createElement("div", createObj(ofArray([(value_3618 = "flex items-center gap-4 bg-zinc-900/70 px-4 py-3 text-[10px] font-bold tracking-widest text-zinc-500", ["className", value_3618]), (elems_330 = [createElement("span", {
                    className: "w-6 shrink-0 text-center",
                    children: "#",
                }), createElement("span", {
                    className: "flex-1 text-left",
                    children: "PLAYER",
                }), createElement("span", {
                    className: "shrink-0",
                    children: "RESULT",
                }), createElement("span", {
                    className: "w-10 shrink-0 text-right",
                    children: "W",
                })], ["children", reactApi.Children.toArray(Array.from(elems_330))])]))), createElement("div", createObj(ofArray([["className", "divide-y divide-zinc-900"], (elems_331 = mapIndexed((i_11, row_2) => {
                    let elems_326, elems_325, elems_324, ppg_2;
                    const rank_3 = (i_11 + 1) | 0;
                    const row_1 = row_2;
                    return createElement("div", createObj(ofArray([["key", `${row_1.Handle}-${rank_3}`], ["className", "flex items-center gap-4 px-4 py-3"], (elems_326 = [createElement("span", {
                        className: "w-6 shrink-0 text-center font-mono text-xs font-bold text-zinc-500",
                        children: int32ToString(rank_3),
                    }), createElement("div", createObj(ofArray([["className", "min-w-0 flex-1"], (elems_325 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-2 min-w-0"], (elems_324 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                        className: "text-sm font-bold text-zinc-100 truncate",
                        children: row_1.Handle,
                    })), delay(() => {
                        let value_3551;
                        return (row_1.Difficulty !== "") ? singleton_2(createElement("span", createObj(ofArray([(value_3551 = "shrink-0 rounded-full border border-zinc-800 bg-zinc-900 px-2 py-0.5 text-[8px] font-black uppercase tracking-wider text-zinc-500", ["className", value_3551]), ["children", row_1.Difficulty]])))) : empty_2();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_324))])]))), createElement("div", {
                        className: "text-[10px] text-zinc-600 font-medium truncate",
                        children: (ppg_2 = ((row_1.PointsPerGame > 0) ? toText(interpolate(" · %.1f%P() PPG", [row_1.PointsPerGame])) : ""), (row_1.Blueprint !== "") ? (`${row_1.TeamName} · ${row_1.Ovr} rated · ${row_1.Blueprint}${ppg_2}`) : (`${row_1.TeamName} · ${row_1.Ovr} rated${ppg_2}`)),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_325))])]))), createElement("span", {
                        className: "shrink-0 font-mono text-sm font-black " + (row_1.Perfect ? "text-orange-400" : "text-zinc-300"),
                        children: row_1.Perfect ? (`${row_1.Wins}-${row_1.Losses} ✨`) : (`${row_1.Wins}-${row_1.Losses}`),
                    }), createElement("span", {
                        className: "w-10 shrink-0 text-right font-mono text-sm font-black text-zinc-100",
                        children: int32ToString(row_1.Wins),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_326))])])));
                }, matchValue_112.fields[0]), ["children", reactApi.Children.toArray(Array.from(elems_331))])])))], ["children", reactApi.Children.toArray(Array.from(elems_332))])]))))) : singleton_2(boardNotice("Loading the global board…", "Fetching the best seasons posted by players everywhere.", empty_1()))))))) : (isEmpty(rankedRuns) ? singleton_2(createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-dashed border-zinc-800 px-6 py-10 text-center mb-6"], (elems_333 = [createElement("span", {
                    className: "text-zinc-300 text-sm font-bold block mb-1",
                    children: "No seasons on the board yet",
                }), createElement("span", {
                    className: "text-zinc-600 text-xs leading-relaxed block",
                    children: "Finish a run and it lands here, ranked by wins with ties broken on scoring.",
                })], ["children", reactApi.Children.toArray(Array.from(elems_333))])])))) : singleton_2(createElement("div", createObj(ofArray([["className", "w-full overflow-hidden rounded-xl border border-zinc-800 mb-6"], (elems_336 = [createElement("div", createObj(ofArray([(value_3654 = "flex items-center gap-4 bg-zinc-900/70 px-4 py-3 text-[10px] font-bold tracking-widest text-zinc-500", ["className", value_3654]), (elems_334 = [createElement("span", {
                    className: "w-6 shrink-0 text-center",
                    children: "#",
                }), createElement("span", {
                    className: "flex-1 text-left",
                    children: "ROSTER",
                }), createElement("span", {
                    className: "shrink-0",
                    children: "RESULT",
                }), createElement("span", {
                    className: "w-10 shrink-0 text-right",
                    children: "W",
                })], ["children", reactApi.Children.toArray(Array.from(elems_334))])]))), createElement("div", createObj(ofArray([["className", "divide-y divide-zinc-900"], (elems_335 = mapIndexed((i_12, run_4) => {
                    let elems_323, elems_322, elems_321, ppg_1;
                    const rank_2 = (i_12 + 1) | 0;
                    const run_3 = run_4;
                    const perfect = (run_3.Losses === 0) && (run_3.Wins === 82);
                    return createElement("div", createObj(ofArray([["key", `${run_3.Date}-${rank_2}`], ["className", "flex items-center gap-4 px-4 py-3"], (elems_323 = [createElement("span", {
                        className: "w-6 shrink-0 text-center font-mono text-xs font-bold text-zinc-500",
                        children: int32ToString(rank_2),
                    }), createElement("div", createObj(ofArray([["className", "min-w-0 flex-1"], (elems_322 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-2 min-w-0"], (elems_321 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                        className: "text-sm font-bold text-zinc-100 truncate",
                        children: run_3.TeamName,
                    })), delay(() => {
                        let value_3516;
                        return (run_3.Difficulty !== "") ? singleton_2(createElement("span", createObj(ofArray([(value_3516 = "shrink-0 rounded-full border border-zinc-800 bg-zinc-900 px-2 py-0.5 text-[8px] font-black uppercase tracking-wider text-zinc-500", ["className", value_3516]), ["children", run_3.Difficulty]])))) : empty_2();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_321))])]))), createElement("div", {
                        className: "text-[10px] text-zinc-600 font-medium truncate",
                        children: (ppg_1 = ((run_3.PointsPerGame > 0) ? toText(interpolate(" · %.1f%P() PPG", [run_3.PointsPerGame])) : ""), (run_3.Blueprint !== "") ? (`${run_3.Blueprint} · ${run_3.Ovr} rated · ${run_3.RatingMode} ratings${ppg_1}`) : (`${run_3.Ovr} rated · ${run_3.Date}${ppg_1}`)),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_322))])]))), createElement("span", {
                        className: "shrink-0 font-mono text-sm font-black " + (perfect ? "text-orange-400" : "text-zinc-300"),
                        children: perfect ? (`${run_3.Record} ✨`) : run_3.Record,
                    }), createElement("span", {
                        className: "w-10 shrink-0 text-right font-mono text-sm font-black text-zinc-100",
                        children: int32ToString(run_3.Wins),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_323))])])));
                }, rankedRuns), ["children", reactApi.Children.toArray(Array.from(elems_335))])])))], ["children", reactApi.Children.toArray(Array.from(elems_336))])]))))), delay(() => {
                    let value_3677;
                    return append_1(singleton_2(createElement("button", createObj(ofArray([(value_3677 = "w-full bg-orange-500 hover:bg-orange-400 text-zinc-950 font-bold text-sm py-3.5 rounded-xl transition-colors cursor-pointer mb-4", ["className", value_3677]), ["onClick", (_arg_131) => {
                        Actions_beginRunSetup(setState);
                    }], ["children", "Build your roster →"]])))), delay(() => {
                        let value_3682;
                        return singleton_2(createElement("button", createObj(ofArray([(value_3682 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3682]), ["onClick", (_arg_132) => {
                            Actions_navigateToHome(setState);
                        }], ["children", "← Home"]]))));
                    }));
                }));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_337))])])));
    let storyPage;
    const numberCell = (figure, label_33) => {
        let elems_338;
        return createElement("div", createObj(ofArray([["key", label_33], ["className", "flex flex-col items-center gap-1 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-5"], (elems_338 = [createElement("span", {
            className: "font-mono text-2xl font-black tracking-tight text-orange-400",
            children: figure,
        }), createElement("span", {
            className: "text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500 text-center",
            children: label_33,
        })], ["children", reactApi.Children.toArray(Array.from(elems_338))])])));
    };
    const milestone = (tag_2, body_8) => {
        let elems_339, value_3705;
        return createElement("div", createObj(ofArray([["key", tag_2], ["className", "flex items-start gap-4"], (elems_339 = [createElement("span", createObj(ofArray([(value_3705 = "shrink-0 rounded-md bg-orange-500/10 border border-orange-500/20 px-2 py-0.5 font-mono text-[9px] font-black tracking-wider text-orange-400 uppercase mt-0.5", ["className", value_3705]), ["children", tag_2]]))), createElement("span", {
            className: "text-xs leading-relaxed text-zinc-400 font-medium",
            children: body_8,
        })], ["children", reactApi.Children.toArray(Array.from(elems_339))])])));
    };
    const storyParagraph = (body_9) => createElement("p", {
        className: "text-sm leading-relaxed text-zinc-400 text-left",
        children: body_9,
    });
    const storyHeading = (heading_6) => createElement("h2", {
        className: "text-xl font-black tracking-tight text-zinc-50 text-left mt-6",
        children: heading_6,
    });
    storyPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col pt-8 pb-12 px-4 font-sans gap-4"], (elems_342 = [createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight text-center mb-1",
        children: "Our Story",
    }), createElement("span", {
        className: "text-zinc-500 text-sm font-medium text-center block mb-6",
        children: "Built by basketball fans, not a studio.",
    }), createElement("span", {
        className: "text-zinc-600 text-[10px] font-black tracking-widest uppercase block",
        children: "By the numbers",
    }), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-3"], (elems_340 = [numberCell(int32ToString(totalPlayerSeasons), "Player seasons"), numberCell(int32ToString(totalFranchises), "Historic team pools"), numberCell("82", "Games a season")], ["children", reactApi.Children.toArray(Array.from(elems_340))])]))), storyHeading("It started as a game for us and our mates"), storyParagraph("Banner Season began over a single weekend. We are basketball obsessives, the kind who argue for hours about whether a prime superstar walks into any all-time starting five, so we built the game we wanted to play ourselves: spin a real franchise and season, draft an all-time NBA roster, and find out if it could win every game on the schedule. The seasons worth remembering are the ones that end with a banner in the rafters — that is where the name comes from."), storyParagraph("We wanted to do it properly: real franchises, real seasons, real player ratings, and a simulation that actually feels right. We shared it with a few friends first. Now we are sharing it with everyone."), storyHeading("How the game grew"), createElement("div", createObj(ofArray([["className", "flex flex-col gap-3 mt-1"], (elems_341 = [milestone("LAUNCH", "The first version of Banner Season goes live: the wheel, the draft, and the 82-game ticker."), milestone("COACHES", "Head coaches arrive. Every roster can appoint a system gaffer for a synergy edge."), milestone("DEADLINE", "The February trade deadline goes in: a blind mid-season market with no undo."), milestone("PLAYOFFS", "Top-eight finishes unlock the postseason gateway on the season summary."), milestone("MULTIPLAYER", "The multiplayer hub opens: live drafts and leagues get their home."), milestone("MODES", "One-Franchise Roster, the Daily Challenge and the Era Challenge join the mode stack.")], ["children", reactApi.Children.toArray(Array.from(elems_341))])]))), storyHeading("The people behind it"), storyParagraph("Banner Season is built by a small group of basketball fans, not a studio or a publisher. We play the game ourselves, we read every piece of feedback, and we are still building it in the open."), storyHeading("Why Banner Season"), storyParagraph(`Banner Season is built on ${totalPlayerSeasons} real player seasons across ${totalFranchises} historic NBA squads spanning ${landingSeasonRange}, with manual review, correction and testing. The depth, the accuracy and the feel are the work, and they are what took the time.`), storyParagraph("What started as a game shared with friends is now live for everyone. And we\'re only just getting started."), createElement("button", createObj(ofArray([(value_3742 = "w-full bg-orange-500 hover:bg-orange-400 text-zinc-950 font-bold text-sm py-3.5 rounded-xl transition-colors cursor-pointer mt-4", ["className", value_3742]), ["onClick", (_arg_133) => {
        Actions_beginRunSetup(setState);
    }], ["children", "Build your own all-time roster"]]))), createElement("button", createObj(ofArray([(value_3747 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3747]), ["onClick", (_arg_134) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Back to Banner Season"]])))], ["children", reactApi.Children.toArray(Array.from(elems_342))])])));
    let getAppPage;
    const platformPanel = (icon_3, title_11, steps) => {
        let elems_345, elems_344;
        return createElement("div", createObj(ofArray([["key", title_11], ["className", "w-full rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5 text-left flex flex-col gap-3"], (elems_345 = [createElement("div", {
            className: "text-sm font-black text-zinc-100",
            children: `${icon_3} ${title_11}`,
        }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2.5"], (elems_344 = mapIndexed((i_13, step) => {
            let elems_343, value_3757;
            const n_2 = (i_13 + 1) | 0;
            const body_10 = step;
            return createElement("div", createObj(ofArray([["key", `step-${n_2}-${body_10}`], ["className", "flex items-start gap-3"], (elems_343 = [createElement("span", createObj(ofArray([(value_3757 = "flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-orange-500/10 text-[11px] font-black text-orange-400 ring-1 ring-orange-500/20", ["className", value_3757]), ["children", int32ToString(n_2)]]))), createElement("span", {
                className: "text-xs leading-relaxed text-zinc-400 font-medium pt-1",
                children: body_10,
            })], ["children", reactApi.Children.toArray(Array.from(elems_343))])])));
        }, steps), ["children", reactApi.Children.toArray(Array.from(elems_344))])])))], ["children", reactApi.Children.toArray(Array.from(elems_345))])])));
    };
    const troubleRow = (heading_7, body_11) => {
        let elems_346;
        return createElement("div", createObj(ofArray([["key", heading_7], ["className", "w-full rounded-xl border border-zinc-900 bg-zinc-900/20 p-4 text-left"], (elems_346 = [createElement("span", {
            className: "text-xs font-bold text-zinc-200 block mb-1",
            children: heading_7,
        }), createElement("span", {
            className: "text-[11px] leading-relaxed text-zinc-500 font-medium block",
            children: body_11,
        })], ["children", reactApi.Children.toArray(Array.from(elems_346))])])));
    };
    getAppPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col items-center text-center pt-8 pb-12 px-4 font-sans gap-4"], (elems_348 = [createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-1",
        children: "Get Banner Season on your phone",
    }), createElement("span", createObj(ofArray([["className", "text-zinc-500 text-sm font-medium leading-relaxed block mb-4"], (value_3799 = "Add Banner Season to your Home Screen in a few taps so it opens full-screen and plays just like an app. Free, no install, nothing to update.", ["children", value_3799])]))), platformPanel("📱", "On iPhone & iPad", ofArray(["Open Banner Season in Safari (you\'re probably already here).", "Tap the Share button: the square with an arrow pointing up, usually at the bottom of the screen.", "Swipe down the menu a little and tap Add to Home Screen.", "Tap Add in the top-right corner."])), platformPanel("🤖", "On Android", ofArray(["Open Banner Season in Chrome.", "Tap the ⋮ menu in the top-right corner.", "Tap Add to Home screen (or Install app if you see it).", "Tap Add to confirm."])), createElement("div", createObj(ofArray([["className", "w-full rounded-xl border border-emerald-900/60 bg-emerald-950/20 p-4 text-left"], (elems_347 = [createElement("span", {
        className: "text-emerald-400 text-xs font-bold block",
        children: "✓ That\'s it. The Banner Season badge lands on your Home Screen. Tap it any time to play.",
    })], ["children", reactApi.Children.toArray(Array.from(elems_347))])]))), createElement("span", createObj(ofArray([(value_3808 = "text-zinc-600 text-[10px] font-black tracking-widest uppercase block mt-4 mb-1 text-left w-full pl-1", ["className", value_3808]), ["children", "Having trouble?"]]))), troubleRow("A button won\'t tap, or the app looks out of date?", "The Home Screen app keeps the last version open until you fully close it. Swipe it off the app switcher, then open Banner Season again from your Home Screen — it loads the latest version."), troubleRow("Still stuck? Re-add it (you won\'t lose anything)", "Press and hold the Banner Season icon, remove it from your Home Screen, then add it again from your browser. This only removes the shortcut — your teams and history stay on this device."), troubleRow("Can\'t get back or refresh inside the app?", "Home Screen apps hide the browser\'s back and refresh buttons. Use the ← links inside Banner Season to move around, and the close-and-reopen trick above whenever you\'d normally refresh."), createElement("button", createObj(ofArray([(value_3812 = "w-full bg-orange-500 hover:bg-orange-400 text-zinc-950 font-bold text-sm py-3.5 rounded-xl transition-colors cursor-pointer mt-4", ["className", value_3812]), ["onClick", (_arg_135) => {
        Actions_beginRunSetup(setState);
    }], ["children", "Play Banner Season now →"]]))), createElement("button", createObj(ofArray([(value_3817 = "text-zinc-500 hover:text-orange-500 text-xs font-semibold py-2 transition-colors cursor-pointer select-none font-sans block w-fit mx-auto", ["className", value_3817]), ["onClick", (_arg_136) => {
        Actions_navigateToHome(setState);
    }], ["children", "← Back to Banner Season"]])))], ["children", reactApi.Children.toArray(Array.from(elems_348))])])));
    const legalHeading = (heading_8) => createElement("h2", {
        key: heading_8,
        className: "text-lg font-black tracking-tight text-zinc-50 text-left mt-6 mb-1",
        children: heading_8,
    });
    const legalParagraph = (body_12) => createElement("p", {
        key: substring(body_12, 0, min(40, body_12.length)),
        className: "text-sm leading-relaxed text-zinc-400 text-left",
        children: body_12,
    });
    let discordPage;
    const sending = equals(discordStatus, new Backend_WaitlistStatus(1, []));
    const checkboxRow = (checked$0027, toggle, copy) => {
        let elems_349;
        return createElement("label", createObj(ofArray([["key", copy], ["className", "flex cursor-pointer items-start gap-3 text-left"], (elems_349 = [createElement("input", {
            type: "checkbox",
            checked: checked$0027,
            onChange: (ev_18) => {
                toggle(ev_18.target.checked);
            },
            className: "mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-orange-500",
        }), createElement("span", {
            className: "text-xs leading-relaxed text-zinc-400",
            children: copy,
        })], ["children", reactApi.Children.toArray(Array.from(elems_349))])])));
    };
    discordPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col pt-8 pb-12 px-4 font-sans gap-4"], (elems_352 = toList_1(delay(() => append_1(singleton_2(guideBreadcrumb("Discord")), delay(() => append_1(singleton_2(createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-1",
        children: "The Banner Season Discord",
    })), delay(() => append_1(singleton_2(legalParagraph("One room for everyone who takes this game a little too seriously.")), delay(() => append_1(singleton_2(legalParagraph("Roster debates, feature ideas, the ratings we got wrong, and a hand in what gets built next. If you have ever finished a season and needed to show somebody the record, this is where that will go.")), delay(() => append_1(singleton_2(legalParagraph("We are also after a few people to help run it.")), delay(() => append_1(singleton_2(legalParagraph("It is not open yet. Leave your email and we will let you know the day the doors open.")), delay(() => {
        let value_3858, elems_350;
        return append_1((discordStatus.tag === 2) ? singleton_2(createElement("div", createObj(ofArray([(value_3858 = "mt-2 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-4 text-sm font-bold text-emerald-400 text-left", ["className", value_3858]), ["children", Backend_isConfigured ? "You\'re on the list. We will email you the day the Banner Season Discord opens — and thank you if you offered to help run it." : "Almost there — your email app just opened with a ready-made signup note. Hit send and you\'re on the list."]])))) : singleton_2(createElement("div", createObj(ofArray([["className", "mt-2 flex flex-col gap-3"], (elems_350 = toList_1(delay(() => append_1(singleton_2(createElement("label", {
            className: "text-left text-xs font-black uppercase tracking-widest text-zinc-500",
            children: "Email",
        })), delay(() => {
            let value_3876;
            return append_1(singleton_2(createElement("input", createObj(ofArray([["type", "email"], ["value", discordEmail], ["onChange", (ev_19) => {
                patternInput_15[1](ev_19.target.value);
            }], ["placeholder", "you@example.com"], (value_3876 = "w-full rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-3 text-sm text-zinc-200 placeholder:text-zinc-600 focus:border-orange-500/50 focus:outline-none", ["className", value_3876])])))), delay(() => append_1(singleton_2(createElement("span", {
                className: "text-left text-[10px] text-zinc-600",
                children: "Only used to let you know when the Discord opens.",
            })), delay(() => append_1(singleton_2(checkboxRow(discordNews, patternInput_16[1], "Email me about Banner Season too. New modes, the occasional bit of news — rarely, and you can stop whenever you like.")), delay(() => append_1(singleton_2(checkboxRow(discordMod, patternInput_17[1], "I would be up for helping moderate it.")), delay(() => {
                let value_3882;
                return append_1(singleton_2(createElement("button", createObj(ofArray([(value_3882 = "mt-1 w-full rounded-xl bg-orange-500 py-3.5 text-sm font-black uppercase tracking-widest text-zinc-950 cursor-pointer transition-all hover:bg-orange-400 disabled:cursor-not-allowed disabled:opacity-50", ["className", value_3882]), ["disabled", sending ? true : !Backend_isValidEmail(discordEmail.trim())], ["onClick", (_arg_137) => {
                    if (!sending) {
                        if (Backend_isConfigured) {
                            setDiscordStatus(new Backend_WaitlistStatus(1, []));
                            Backend_joinDiscordWaitlist(discordEmail, discordNews, discordMod, setDiscordStatus);
                        }
                        else {
                            const body_13 = (`Please add me to the Discord waitlist: ${discordEmail.trim()}`) + (discordMod ? " — happy to help moderate." : "");
                            window.location.href = ("mailto:rifaeyah@bannerseason.app?subject=Discord%20waitlist&body=" + encodeURIComponent(body_13));
                            setDiscordStatus(new Backend_WaitlistStatus(2, []));
                        }
                    }
                }], ["children", sending ? "Joining…" : "Join the waitlist"]])))), delay(() => {
                    const matchValue_114 = discordStatus;
                    return (matchValue_114.tag === 3) ? singleton_2(createElement("span", {
                        className: "text-left text-[11px] font-semibold text-red-400",
                        children: matchValue_114.fields[0],
                    })) : singleton_2(defaultOf_1());
                }));
            }))))))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_350))])])))), delay(() => {
            let elems_351;
            return singleton_2(createElement("div", createObj(ofArray([["className", "mt-1 flex items-center gap-1 text-left text-[10px] text-zinc-600"], (elems_351 = [createElement("span", {
                children: "We will not pass your email to anyone else. See the",
            }), createElement("button", {
                className: "cursor-pointer underline transition-colors hover:text-orange-500",
                onClick: (_arg_138) => {
                    Actions_navigateToPrivacyPolicy(setState);
                },
                children: "privacy policy",
            }), createElement("span", {
                children: ".",
            })], ["children", reactApi.Children.toArray(Array.from(elems_351))])]))));
        }));
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_352))])])));
    let partnersPage;
    const statCellLocal = (figure_1, label_34) => {
        let elems_353;
        return createElement("div", createObj(ofArray([["key", label_34], ["className", "flex flex-col items-center gap-1 rounded-xl border border-zinc-800 bg-zinc-900/40 px-4 py-5"], (elems_353 = [createElement("span", {
            className: "font-mono text-2xl font-black tracking-tight text-orange-400",
            children: figure_1,
        }), createElement("span", {
            className: "text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500 text-center",
            children: label_34,
        })], ["children", reactApi.Children.toArray(Array.from(elems_353))])])));
    };
    const formatCard = (title_12, body_14) => {
        let elems_354;
        return createElement("div", createObj(ofArray([["key", title_12], ["className", "rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5 text-left"], (elems_354 = [createElement("span", {
            className: "text-white text-sm font-black tracking-tight block mb-1",
            children: title_12,
        }), createElement("span", {
            className: "text-zinc-400 text-xs leading-relaxed block",
            children: body_14,
        })], ["children", reactApi.Children.toArray(Array.from(elems_354))])])));
    };
    partnersPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col pt-8 pb-12 px-4 font-sans gap-4"], (elems_357 = [guideBreadcrumb("Partners"), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-1",
        children: "Partner with Banner Season",
    }), createElement("span", {
        className: "text-zinc-500 text-sm font-medium block mb-4",
        children: "Sponsorship, advertising & partnerships",
    }), legalHeading("The opportunity"), legalParagraph("Banner Season is the basketball game the group chats argue about: spin a franchise and a season, draft an all-time roster, and try to win every game on the schedule. Won 82, lost none. It taps straight into basketball nostalgia, debate and tribalism. If you want to reach genuinely engaged basketball fans, now is the moment."), legalHeading("The audience"), createElement("div", createObj(ofArray([["className", "grid grid-cols-3 gap-3"], (elems_355 = [statCellLocal("2026", "Launched"), statCellLocal(int32ToString(totalPlayerSeasons), "Player seasons"), statCellLocal("Free", "In every browser")], ["children", reactApi.Children.toArray(Array.from(elems_355))])]))), legalParagraph("Banner Season is newly launched and growing. A basketball-first crowd that drafts, replays, argues over ratings, and shares its results. We quote only real, current audience figures — ask us and we will share exactly where the numbers stand."), legalHeading("Ways to partner"), createElement("div", createObj(ofArray([["className", "grid grid-cols-1 sm:grid-cols-2 gap-3"], (elems_356 = [formatCard("Title & site sponsorship", "Your brand presented tastefully across the game: a header presence and a \"powered by\" on the moments that matter, without getting in the way of the fun."), formatCard("Sponsor a game mode", "Own a named, shareable experience: your brand on a mode fans come back to, and on the share cards it generates."), formatCard("Branded shareable moments", "Every finished season produces a share card fans post to group chats and social. A light, well-placed brand presence rides along."), formatCard("Media & data partnerships", "Co-created content, challenges and talking points for publishers and broadcasters around big basketball moments.")], ["children", reactApi.Children.toArray(Array.from(elems_356))])]))), legalHeading("Why it works"), legalParagraph("Banner Season was built by basketball fans, for basketball fans, and it shows. The game creates the three things brands struggle to buy: genuine engagement, organic sharing, and real emotional connection. A partner who fits that spirit becomes part of the conversation rather than an interruption to it."), legalHeading("Let\'s talk"), legalParagraph("Tell us about your brand and what you\'re looking for. We\'ll come back quickly with options and current audience figures."), createElement("span", {
        className: "text-orange-400 text-sm font-bold",
        children: "hello@bannerseason.app",
    }), createElement("p", createObj(ofArray([["className", "text-zinc-700 text-[10px] leading-relaxed mt-6"], (value_3955 = "Banner Season is an independent, fan-made game. It is not affiliated with, endorsed by, sponsored by, or associated with the NBA or any basketball league, competition, club, governing body or organization, or with any game, publisher or ratings provider. All trademarks and other intellectual property remain the property of their respective owners. Partnership and sponsorship opportunities relate solely to the Banner Season product itself.", ["children", value_3955])])))], ["children", reactApi.Children.toArray(Array.from(elems_357))])])));
    const privacyPolicyPage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col pt-8 pb-12 px-4 font-sans gap-2"], (elems_358 = [guideBreadcrumb("Privacy & Cookies Policy"), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-4",
        children: "Privacy & Cookies Policy",
    }), legalHeading("Game Progress (Stored on Your Device)"), legalParagraph("Banner Season saves your runs, trophies, streaks, daily-challenge progress and any in-progress draft in your browser\'s local storage, on your device. That data never leaves your browser: there is no server copy, and clearing your browser data removes it permanently."), legalHeading("Accounts and Sign-In"), legalParagraph("The current build\'s sign-in is a local demonstration only. It creates a local identity on your device and sends nothing anywhere. When real accounts arrive, this policy will be updated before anything changes."), legalHeading("Analytics"), legalParagraph("Banner Season currently runs no analytics. No page views, clicks or play sessions are measured or reported to anyone."), legalHeading("Advertising"), legalParagraph("Banner Season currently shows no advertising and uses no advertising cookies, identifiers or tracking of any kind."), legalHeading("Cookie Preferences"), legalParagraph("Because the game only uses essential local storage, there is nothing optional to consent to. The Cookie Preferences control in the footer shows you exactly what is stored and lets you record that choice."), legalHeading("Marketing Communications"), legalParagraph("We only email people who explicitly opt in, and every message includes a working unsubscribe."), legalHeading("If You Contact Us"), legalParagraph("If you email us, we use your address to reply and keep the thread for as long as the conversation is useful. We don\'t add you to any list."), legalHeading("Data Retention and Deletion"), legalParagraph("Your game data lives only on your device, so you are always in control: clear the site\'s browser storage and everything is gone. There is nothing for us to delete on a server."), legalHeading("Your Rights"), legalParagraph("Depending on where you live, you may have rights of access, correction, deletion and portability over personal data. Since this build stores nothing about you server-side, exercising them is as simple as managing your own browser storage — but you can always contact us with questions."), legalHeading("Children"), legalParagraph("Banner Season is a general-audience game about basketball history. It does not knowingly collect personal information from anyone, children included."), legalHeading("Changes to This Policy"), legalParagraph("If the game gains accounts, analytics or anything else this policy covers, we will update it and date the change before the feature ships."), legalHeading("Contact"), legalParagraph("Questions about privacy: hello@bannerseason.app.")], ["children", reactApi.Children.toArray(Array.from(elems_358))])])));
    const termsOfUsePage = createElement("div", createObj(ofArray([["className", "w-full max-w-xl mx-auto flex flex-col pt-8 pb-12 px-4 font-sans gap-2"], (elems_359 = [guideBreadcrumb("Terms of Use"), createElement("h1", {
        className: "text-white text-4xl font-black tracking-tight mb-4",
        children: "Terms of Use",
    }), legalHeading("About These Terms"), legalParagraph("These terms govern your use of Banner Season, an independent fan-made basketball draft and season simulator. By using the site you accept them; if you don\'t accept them, don\'t use the site."), legalHeading("Use of the Website"), legalParagraph("Banner Season is provided for personal, non-commercial entertainment. Don\'t abuse it: no scraping at scale, no attempting to break or overload it, no using it to harass anyone, and no passing its output off as officially licensed material."), legalHeading("Accounts"), legalParagraph("The current sign-in is a local demonstration and creates no server account. When real accounts launch, additional terms will apply and be presented before you create one."), legalHeading("User-Submitted Names and Content"), legalParagraph("Where the game lets you enter a handle or name, keep it clean: nothing unlawful, hateful, or impersonating someone else. We may refuse or remove anything that isn\'t."), legalHeading("Intellectual Property"), legalParagraph("The Banner Season site design, code, editorial text and generated artwork belong to Banner Season. Club names, player names, ratings, statistics and season data are used editorially and descriptively; all trademarks and other intellectual property remain the property of their respective owners."), legalHeading("Data and Third-Party Rights"), legalParagraph("Banner Season is not affiliated with, endorsed by, or associated with the NBA, any club, league, player association, governing body, game publisher or ratings provider. Nothing on the site implies otherwise."), legalHeading("Availability"), legalParagraph("The game is provided as a hobby project. It may change, break, or go away at any time, without notice."), legalHeading("No Warranty"), legalParagraph("Banner Season is provided \"as is\", without warranties of any kind. Simulated seasons are entertainment, not statements of fact about any real player or team."), legalHeading("Limitation of Liability"), legalParagraph("To the maximum extent the law allows, Banner Season is not liable for any loss arising from your use of the site — including lost save data, since it lives entirely in your own browser."), legalHeading("Suspension and Termination"), legalParagraph("We may block access that violates these terms or threatens the service."), legalHeading("Privacy and Cookies"), legalParagraph("How data is (and isn\'t) handled is covered by the Privacy & Cookies Policy, which forms part of these terms."), legalHeading("Changes to These Terms"), legalParagraph("We may update these terms as the game evolves; the current version always lives on this page."), legalHeading("Contact"), legalParagraph("Questions about these terms: hello@bannerseason.app.")], ["children", reactApi.Children.toArray(Array.from(elems_359))])])));
    let cookiePrefsModal;
    if (!patternInput_12[0]) {
        cookiePrefsModal = defaultOf_1();
    }
    else {
        const prefRow = (title_13, status, body_15) => {
            let elems_361, elems_360, value_3982;
            return createElement("div", createObj(ofArray([["key", title_13], ["className", "rounded-xl border border-zinc-800 bg-zinc-950/80 p-4 text-left"], (elems_361 = [createElement("div", createObj(ofArray([["className", "flex items-center justify-between gap-3 mb-1"], (elems_360 = [createElement("span", {
                className: "text-white text-sm font-bold",
                children: title_13,
            }), createElement("span", createObj(ofArray([(value_3982 = "shrink-0 rounded-full border border-zinc-700 px-2.5 py-0.5 text-[9px] font-black uppercase tracking-wider text-zinc-400", ["className", value_3982]), ["children", status]])))], ["children", reactApi.Children.toArray(Array.from(elems_360))])]))), createElement("span", {
                className: "text-zinc-500 text-[11px] leading-relaxed block",
                children: body_15,
            })], ["children", reactApi.Children.toArray(Array.from(elems_361))])])));
        };
        cookiePrefsModal = createElement("div", createObj(ofArray([["className", "fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"], ["onClick", (_arg_139) => {
            setCookiePrefsOpen(false);
        }], (elems_364 = [createElement("div", createObj(ofArray([["className", "w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl"], ["onClick", (ev_20) => {
            ev_20.stopPropagation();
        }], (elems_363 = [createElement("h2", {
            className: "text-white text-xl font-black tracking-tight mb-2",
            children: "We value your privacy",
        }), createElement("p", createObj(ofArray([["className", "text-zinc-400 text-xs leading-relaxed mb-4"], (value_4004 = "Banner Season keeps your game progress in your browser\'s local storage and nothing more. There are no advertising partners, no analytics, and no tracking cookies — so there is refreshingly little to configure.", ["children", value_4004])]))), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2 mb-5"], (elems_362 = [prefRow("Essential storage", "Always on", "Your runs, trophies, streaks and in-progress drafts, saved on this device so the game works at all."), prefRow("Analytics & advertising", "Not used", "Banner Season runs none. If that ever changes, this panel will ask first.")], ["children", reactApi.Children.toArray(Array.from(elems_362))])]))), createElement("button", createObj(ofArray([(value_4009 = "w-full bg-orange-500 hover:bg-orange-600 text-black font-black uppercase text-xs tracking-widest py-3.5 rounded-xl transition-all cursor-pointer", ["className", value_4009]), ["onClick", (_arg_140) => {
            Store_saveConsentAcknowledged();
            setCookiePrefsOpen(false);
        }], ["children", "Got it — close"]])))], ["children", reactApi.Children.toArray(Array.from(elems_363))])])))], ["children", reactApi.Children.toArray(Array.from(elems_364))])])));
    }
    const footerGo = (label_35) => {
        const matchValue_116 = ((state.Phase.tag === 20) && (label_35 !== "Home")) ? "🔒" : label_35;
        switch (matchValue_116) {
            case "Home": {
                Actions_navigateToHome(setState);
                break;
            }
            case "Play": {
                Actions_beginRunSetup(setState);
                break;
            }
            case "Multiplayer": {
                Actions_navigateToMultiplayerHub(setState);
                break;
            }
            case "How to Play": {
                Actions_navigateToHowToPlayGuide(setState);
                break;
            }
            case "Greatest Lineup": {
                Actions_navigateToGreatestLineupGuide(setState);
                break;
            }
            case "How It Works": {
                Actions_navigateToHome(setState);
                break;
            }
            case "Draft Game": {
                Actions_navigateToDraftGuide(setState);
                break;
            }
            case "Lineup Builder": {
                Actions_navigateToLineupBuilderGuide(setState);
                break;
            }
            case "Season Simulator": {
                Actions_navigateToSeasonSimulatorGuide(setState);
                break;
            }
            case "Leaderboard": {
                Actions_navigateToLeaderboard(setState);
                break;
            }
            case "Story": {
                Actions_navigateToStory(setState);
                break;
            }
            case "Get the App": {
                Actions_navigateToGetApp(setState);
                break;
            }
            case "Discord": {
                Actions_navigateToDiscord(setState);
                break;
            }
            case "Partners": {
                Actions_navigateToPartners(setState);
                break;
            }
            case "Privacy & Cookies Policy": {
                Actions_navigateToPrivacyPolicy(setState);
                break;
            }
            case "Terms of Use": {
                Actions_navigateToTermsOfUse(setState);
                break;
            }
            case "Cookie Preferences": {
                setCookiePrefsOpen(true);
                break;
            }
            default:
                undefined;
        }
    };
    let playoffCanvas;
    const shell = (stage_1, allowExit, children_1) => {
        let elems_368, elems_367;
        return createElement("div", createObj(ofArray([["className", "min-h-screen w-full bg-gradient-to-b from-zinc-950 via-amber-950/10 to-zinc-950 px-4 py-10"], (elems_368 = [createElement("div", createObj(ofArray([["className", "mx-auto w-full max-w-2xl flex flex-col gap-6"], (elems_367 = toList_1(delay(() => {
            let elems_366;
            return append_1(singleton_2(createElement("div", createObj(ofArray([["className", "flex items-center justify-between"], (elems_366 = toList_1(delay(() => {
                let elems_365;
                return append_1(singleton_2(createElement("div", createObj(singleton((elems_365 = [createElement("span", {
                    className: "text-amber-500 text-[10px] font-black tracking-[0.25em] uppercase block",
                    children: "The Postseason",
                }), createElement("span", {
                    className: "text-white text-xl font-black tracking-tight",
                    children: stage_1,
                })], ["children", reactApi.Children.toArray(Array.from(elems_365))]))))), delay(() => {
                    let value_4031;
                    return allowExit ? singleton_2(createElement("button", createObj(ofArray([(value_4031 = "rounded-xl border border-zinc-800 bg-zinc-900/60 px-3 py-1.5 text-xs font-bold text-zinc-400 transition-colors hover:border-red-500/40 hover:text-red-400 cursor-pointer", ["className", value_4031]), ["onClick", (_arg_141) => {
                        Actions_exitPlayoffs(setState);
                    }], ["children", "✕ Exit"]])))) : empty_2();
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_366))])])))), delay(() => children_1));
        })), ["children", reactApi.Children.toArray(Array.from(elems_367))])])))], ["children", reactApi.Children.toArray(Array.from(elems_368))])])));
    };
    const goldPanel = (extra_4, children_2) => createElement("div", {
        className: "w-full rounded-2xl border border-amber-900/40 bg-zinc-900/40 " + extra_4,
        children: reactApi.Children.toArray(Array.from(children_2)),
    });
    const seriesScore = (s_1) => (`${s_1.MyWins}-${s_1.OppWins}`);
    const seriesDots = (winsFor) => {
        let elems_370;
        return createElement("div", createObj(ofArray([["className", "flex gap-1.5"], (elems_370 = toList_1(delay(() => map_1((i_14) => createElement("span", {
            key: i_14,
            className: "h-2 w-2 rounded-full " + ((i_14 <= winsFor) ? "bg-amber-400" : "bg-zinc-800"),
        }), rangeDouble(1, 1, 4)))), ["children", reactApi.Children.toArray(Array.from(elems_370))])])));
    };
    const matchValue_117 = state.Phase;
    switch (matchValue_117.tag) {
        case 9: {
            const mySeed = matchValue_117.fields[0] | 0;
            const field = matchValue_117.fields[1];
            const firstOpp = tryFind((tupledArg_32) => (tupledArg_32[0] === (9 - mySeed)), field);
            playoffCanvas = shell("The Field Is Set", true, ofArray([goldPanel("p-6", ofArray([createElement("span", {
                className: "text-amber-400 text-[10px] font-black tracking-widest uppercase block mb-1",
                children: "Eight seeds, one ring",
            }), createElement("p", createObj(ofArray([["className", "text-zinc-400 text-[11px] leading-relaxed mb-4"], (value_4055 = "Seeded off the final table. Best-of-seven all the way — the ladder only ever shows you the next fight.", ["children", value_4055])]))), createElement("div", createObj(ofArray([["className", "flex flex-col gap-1.5"], (elems_372 = toList_1(delay(() => collect_1((matchValue_118) => {
                let isMe, elems_371;
                const seed_1 = matchValue_118[0] | 0;
                const name_2015 = matchValue_118[1];
                return singleton_2((isMe = (name_2015 === Actions_playoffYou), createElement("div", createObj(ofArray([["key", int32ToString(seed_1)], ["className", "flex items-center justify-between rounded-xl border px-3 py-2 text-xs " + (isMe ? "border-amber-500/60 bg-amber-500/10 text-amber-300 font-black" : "border-zinc-900 bg-zinc-950/60 text-zinc-400 font-semibold")], (elems_371 = toList_1(delay(() => append_1(singleton_2(createElement("span", {
                    children: `${seed_1} · ${isMe ? "★ " : ""}${name_2015}`,
                })), delay(() => singleton_2(createElement("span", {
                    className: "font-mono",
                    children: `${matchValue_118[2]}W`,
                })))))), ["children", reactApi.Children.toArray(Array.from(elems_371))])])))));
            }, field))), ["children", reactApi.Children.toArray(Array.from(elems_372))])])))])), goldPanel("p-6", ofArray([createElement("span", {
                className: "text-amber-400 text-[10px] font-black tracking-widest uppercase block mb-3",
                children: "The road to the ring",
            }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-2 text-xs font-semibold"], (elems_373 = [createElement("div", {
                className: "text-zinc-300",
                children: (firstOpp == null) ? "First Round" : (`First Round · (${firstOpp[0]}) ${firstOpp[1]}`),
            }), createElement("div", {
                className: "text-zinc-600",
                children: "Semifinals · to be decided",
            }), createElement("div", {
                className: "text-zinc-600",
                children: "🏆 The Finals · The Banner Arena",
            })], ["children", reactApi.Children.toArray(Array.from(elems_373))])])))])), createElement("button", createObj(ofArray([(value_4090 = "w-full bg-amber-500 hover:bg-amber-400 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl shadow-lg shadow-amber-500/20 transition-all cursor-pointer", ["className", value_4090]), ["onClick", (_arg_144) => {
                Actions_tipOffFirstRound(setState, state.Roster, state.SystemArchetype, state.SelectedCoach, state.SeasonLuck, mySeed, field);
            }], ["children", "Tip off the First Round ➔"]])))]));
            break;
        }
        case 10: {
            const series = matchValue_117.fields[0];
            const quarters = matchValue_117.fields[2];
            const game_2 = ((series.MyWins + series.OppWins) + 1) | 0;
            const home = Actions_hostsGame(series.MySeed, series.OpponentSeed, game_2);
            let patternInput_54;
            const matchValue_119 = tryLast(quarters);
            patternInput_54 = ((matchValue_119 == null) ? [0, 0] : [matchValue_119[0], matchValue_119[1]]);
            playoffCanvas = shell(Actions_roundName(series.Round), true, toList_1(delay(() => {
                let elems_376, elems_374, elems_375, elems_377, value_4137;
                return append_1(singleton_2(goldPanel("p-6 text-center", ofArray([createElement("span", {
                    className: "text-amber-400 text-[10px] font-black tracking-widest uppercase block mb-3",
                    children: `Game ${game_2} · ${home ? "The Banner Arena" : "on the road"} · series ${seriesScore(series)}`,
                }), createElement("div", createObj(ofArray([["className", "flex items-center justify-center gap-6"], (elems_376 = [createElement("div", createObj(ofArray([["className", "flex flex-col items-center gap-2"], (elems_374 = [createElement("span", {
                    className: "text-zinc-400 text-[10px] font-black uppercase tracking-widest",
                    children: "You",
                }), createElement("span", {
                    className: "text-white text-4xl font-black font-mono",
                    children: int32ToString(patternInput_54[0]),
                }), seriesDots(series.MyWins)], ["children", reactApi.Children.toArray(Array.from(elems_374))])]))), createElement("span", {
                    className: "text-zinc-700 text-xl font-black",
                    children: "–",
                }), createElement("div", createObj(ofArray([["className", "flex flex-col items-center gap-2"], (elems_375 = [createElement("span", {
                    className: "text-zinc-400 text-[10px] font-black uppercase tracking-widest",
                    children: `(${series.OpponentSeed}) ${series.Opponent}`,
                }), createElement("span", {
                    className: "text-white text-4xl font-black font-mono",
                    children: int32ToString(patternInput_54[1]),
                }), seriesDots(series.OppWins)], ["children", reactApi.Children.toArray(Array.from(elems_375))])])))], ["children", reactApi.Children.toArray(Array.from(elems_376))])]))), createElement("div", createObj(ofArray([["className", "mt-4 flex justify-center gap-2"], (elems_377 = toList_1(delay(() => map_1((q_3) => {
                    let patternInput_55, patternInput_56;
                    const played_3 = length(quarters) >= q_3;
                    return createElement("span", {
                        key: q_3,
                        className: "rounded-lg border px-2 py-1 text-[10px] font-mono font-bold " + (played_3 ? "border-amber-900/60 bg-amber-500/10 text-amber-300" : "border-zinc-900 bg-zinc-950 text-zinc-700"),
                        children: !played_3 ? (`Q${q_3}`) : ((patternInput_55 = item(q_3 - 1, quarters), (patternInput_56 = ((q_3 === 1) ? [0, 0] : item(q_3 - 2, quarters)), `Q${q_3} ${patternInput_55[0] - patternInput_56[0]}-${patternInput_55[1] - patternInput_56[1]}`))),
                    });
                }, rangeDouble(1, 1, 4)))), ["children", reactApi.Children.toArray(Array.from(elems_377))])]))), createElement("button", createObj(ofArray([(value_4137 = "mt-4 text-zinc-500 hover:text-amber-400 text-xs font-mono font-bold tracking-wide transition-colors cursor-pointer select-none", ["className", value_4137]), ["onClick", (_arg_145) => {
                    setTickSpeed(Actions_cycleTickSpeed());
                }], ["children", `⏩ ${tickSpeed}x`]])))]))), delay(() => {
                    let elems_380;
                    return !isEmpty(series.Games) ? singleton_2(goldPanel("p-4", singleton(createElement("div", createObj(ofArray([["className", "flex flex-col gap-2"], (elems_380 = toList_1(delay(() => map_1((g_13) => {
                        let elems_379, elems_378;
                        return createElement("div", createObj(ofArray([["key", g_13.Game], ["className", "flex items-start justify-between gap-3 rounded-xl border border-zinc-900 bg-zinc-950/60 px-3 py-2"], (elems_379 = [createElement("div", createObj(singleton((elems_378 = [createElement("span", {
                            className: "text-xs font-black " + (g_13.Won ? "text-emerald-400" : "text-red-400"),
                            children: `GM${g_13.Game} ${g_13.Won ? "W" : "L"} ${g_13.TeamScore}-${g_13.OppScore} ${g_13.HomeCourt ? "(H)" : "(A)"}`,
                        }), createElement("span", {
                            className: "block text-[10px] text-zinc-500",
                            children: g_13.Standout,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_378))]))))], ["children", reactApi.Children.toArray(Array.from(elems_379))])])));
                    }, series.Games))), ["children", reactApi.Children.toArray(Array.from(elems_380))])])))))) : empty_2();
                }));
            })));
            break;
        }
        case 11: {
            const series_1 = matchValue_117.fields[0];
            const next_4 = matchValue_117.fields[3];
            const flavor = matchValue_117.fields[2];
            playoffCanvas = shell(`${Actions_roundName(series_1.Round)} · Series Won`, false, toList_1(delay(() => append_1(singleton_2(goldPanel("p-6 text-center", ofArray([createElement("div", {
                className: "text-white text-2xl font-black mb-1",
                children: `Series won ${seriesScore(series_1)}`,
            }), createElement("p", {
                className: "text-zinc-400 text-[11px] leading-relaxed",
                children: `(${series_1.OpponentSeed}) ${series_1.Opponent} shake hands and go home. The run rolls on.`,
            })]))), delay(() => {
                let elems_381;
                return append_1(!isEmpty(flavor) ? singleton_2(goldPanel("p-5", ofArray([createElement("span", {
                    className: "text-amber-400 text-[10px] font-black tracking-widest uppercase block mb-2",
                    children: "Around the bracket",
                }), createElement("div", createObj(ofArray([["className", "flex flex-col gap-1 text-[11px] text-zinc-400 font-medium"], (elems_381 = toList_1(delay(() => map_1((line_15) => createElement("div", {
                    key: line_15,
                    children: line_15,
                }), flavor))), ["children", reactApi.Children.toArray(Array.from(elems_381))])])))]))) : empty_2(), delay(() => append_1(singleton_2(goldPanel("p-5 text-center", ofArray([createElement("span", {
                    className: "text-amber-400 text-[10px] font-black tracking-widest uppercase block mb-1",
                    children: `Next · ${Actions_roundName(series_1.Round + 1)}`,
                }), createElement("div", {
                    className: "text-white text-lg font-black",
                    children: `(${next_4[0]}) ${next_4[1]} · ${next_4[2]}W`,
                })]))), delay(() => {
                    let value_4186;
                    return singleton_2(createElement("button", createObj(ofArray([(value_4186 = "w-full bg-amber-500 hover:bg-amber-400 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl shadow-lg shadow-amber-500/20 transition-all cursor-pointer", ["className", value_4186]), ["onClick", (_arg_146) => {
                        Actions_continuePlayoffs(setState, state.Roster, state.SystemArchetype, state.SelectedCoach, state.SeasonLuck, series_1, matchValue_117.fields[1], next_4[0], next_4[1], next_4[2]);
                    }], ["children", `On to ${Actions_roundName(series_1.Round + 1)} ➔`]]))));
                }))));
            })))));
            break;
        }
        case 12: {
            playoffCanvas = shell("The Banner Arena", false, ofArray([createElement(ConfettiBurst, null), goldPanel("p-8 text-center border-amber-500/60", ofArray([createElement("div", {
                className: "text-5xl mb-3",
                children: "🏆",
            }), createElement("div", {
                className: "text-white text-3xl font-black tracking-tight mb-2",
                children: "PLAYOFF CHAMPIONS",
            }), createElement("p", createObj(ofArray([["className", "text-zinc-400 text-[11px] leading-relaxed mb-4"], (value_4201 = "Twelve wins in the crucible. The ring is real, the banner goes up, and The Playoff Gauntlet joins your trophy room.", ["children", value_4201])]))), createElement("div", createObj(ofArray([["className", "text-[11px] font-mono leading-relaxed text-zinc-400"], (elems_382 = toList_1(delay(() => collect_1((matchValue_120) => {
                const round_1 = matchValue_120[0] | 0;
                const opp_1 = matchValue_120[1];
                return singleton_2(createElement("div", {
                    key: `${round_1}${opp_1}`,
                    children: `${Actions_roundName(round_1)}: beat ${opp_1} ${matchValue_120[2]}-${matchValue_120[3]}`,
                }));
            }, matchValue_117.fields[0].Records))), ["children", reactApi.Children.toArray(Array.from(elems_382))])])))])), createElement("button", createObj(ofArray([(value_4210 = "w-full bg-amber-500 hover:bg-amber-400 text-black font-black uppercase text-xs tracking-widest py-4 rounded-xl shadow-lg shadow-amber-500/20 transition-all cursor-pointer", ["className", value_4210]), ["onClick", (_arg_147) => {
                Actions_closePlayoffs(setState);
            }], ["children", "Back to your season ➔"]])))]));
            break;
        }
        case 13: {
            const series_2 = matchValue_117.fields[0];
            const outcome_4 = matchValue_117.fields[1];
            let exitLine;
            const matchValue_121 = outcome_4.ExitRound | 0;
            exitLine = ((matchValue_121 === 1) ? "One and done. The seed said contender; the spring said otherwise." : ((matchValue_121 === 2) ? "Two rounds deep and the tank hit empty. Closer than the scoreboard admits." : "Four wins from immortality. The Finals don\'t give refunds."));
            playoffCanvas = shell(`Out in ${Actions_roundName(outcome_4.ExitRound)}`, false, ofArray([goldPanel("p-6 text-center", ofArray([createElement("div", {
                className: "text-white text-2xl font-black mb-1",
                children: `Series lost ${seriesScore(series_2)}`,
            }), createElement("p", {
                className: "text-zinc-400 text-[11px] leading-relaxed mb-4",
                children: `(${series_2.OpponentSeed}) ${series_2.Opponent} end the run. ${exitLine}`,
            }), createElement("div", createObj(ofArray([["className", "text-[11px] font-mono leading-relaxed text-zinc-500"], (elems_383 = toList_1(delay(() => collect_1((matchValue_122) => {
                let verb_1;
                const round_2 = matchValue_122[0] | 0;
                const ow_2 = matchValue_122[3] | 0;
                const opp_2 = matchValue_122[1];
                const mw_2 = matchValue_122[2] | 0;
                return singleton_2(createElement("div", {
                    key: `${round_2}${opp_2}`,
                    children: (verb_1 = ((mw_2 > ow_2) ? "beat" : "lost to"), `${Actions_roundName(round_2)}: ${verb_1} ${opp_2} ${mw_2}-${ow_2}`),
                }));
            }, outcome_4.Records))), ["children", reactApi.Children.toArray(Array.from(elems_383))])])))])), createElement("button", createObj(ofArray([(value_4230 = "w-full border border-zinc-800 bg-zinc-900/40 hover:border-zinc-700 text-zinc-300 font-black uppercase text-xs tracking-widest py-4 rounded-xl transition-all cursor-pointer", ["className", value_4230]), ["onClick", (_arg_148) => {
                Actions_closePlayoffs(setState);
            }], ["children", "Back to your season ➔"]])))]));
            break;
        }
        default:
            playoffCanvas = defaultOf_1();
    }
    let canvas;
    const matchValue_123 = state.Phase;
    switch (matchValue_123.tag) {
        case 22: {
            canvas = ofArray([profilePage, pageFooter(footerGo)]);
            break;
        }
        case 23: {
            canvas = ofArray([draftGameGuidePage, pageFooter(footerGo)]);
            break;
        }
        case 24: {
            canvas = ofArray([lineupBuilderGuidePage, pageFooter(footerGo)]);
            break;
        }
        case 25: {
            canvas = ofArray([seasonSimulatorGuidePage, pageFooter(footerGo)]);
            break;
        }
        case 26: {
            canvas = ofArray([greatestLineupGuidePage, pageFooter(footerGo)]);
            break;
        }
        case 27: {
            canvas = ofArray([howToPlayGuidePage, pageFooter(footerGo)]);
            break;
        }
        case 28: {
            canvas = ofArray([multiplayerHubPage, pageFooter(footerGo)]);
            break;
        }
        case 29: {
            canvas = ofArray([liveDraftSetupPage, pageFooter(footerGo)]);
            break;
        }
        case 30: {
            canvas = ofArray([leaguesSetupPage, pageFooter(footerGo)]);
            break;
        }
        case 31: {
            canvas = ofArray([leagueRulesConfigPage, pageFooter(footerGo)]);
            break;
        }
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
            canvas = singleton(playoffCanvas);
            break;
        }
        case 32: {
            canvas = ofArray([franchiseModePage, pageFooter(footerGo)]);
            break;
        }
        case 33: {
            canvas = ofArray([dailyChallengePage, pageFooter(footerGo)]);
            break;
        }
        case 34: {
            canvas = ofArray([eraChallengePage, pageFooter(footerGo)]);
            break;
        }
        case 35: {
            canvas = ofArray([leaderboardPage, pageFooter(footerGo)]);
            break;
        }
        case 36: {
            canvas = ofArray([storyPage, pageFooter(footerGo)]);
            break;
        }
        case 37: {
            canvas = ofArray([getAppPage, pageFooter(footerGo)]);
            break;
        }
        case 38: {
            canvas = ofArray([partnersPage, pageFooter(footerGo)]);
            break;
        }
        case 39: {
            canvas = ofArray([privacyPolicyPage, pageFooter(footerGo)]);
            break;
        }
        case 40: {
            canvas = ofArray([termsOfUsePage, pageFooter(footerGo)]);
            break;
        }
        case 41: {
            canvas = ofArray([discordPage, pageFooter(footerGo)]);
            break;
        }
        case 0: {
            canvas = ofArray([createElement(LandingView, {
                setState: setState,
                liveNow: liveNow,
                seasonsTotal: patternInput_20[0],
            }), pageFooter(footerGo)]);
            break;
        }
        default:
            canvas = ofArray([simulatorGrid, pageFooter(footerGo)]);
    }
    return createElement("div", createObj(ofArray([["className", "min-h-screen bg-zinc-950 text-zinc-100"], (elems_385 = [headerBar, createElement("div", {
        className: (matchValue_124 = state.Phase, (matchValue_124.tag === 0) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 23) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 24) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 25) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 26) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 27) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 28) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 29) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 30) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 31) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 32) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 33) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 34) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 35) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 36) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 37) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 38) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 39) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : ((matchValue_124.tag === 40) ? "mx-auto max-w-3xl px-4 py-6 md:py-10" : "mx-auto max-w-6xl px-4 py-6 md:py-10"))))))))))))))))))),
        children: reactApi.Children.toArray(Array.from(canvas)),
    }), cookiePrefsModal], ["children", reactApi.Children.toArray(Array.from(elems_385))])])));
}

